/* 省份 */
module.exports = {
  "provinces": [
    {
      "code": "110000",
      "alevel": 1,
      "sub": [{
        "code": "110100",
        "alevel": 2,
        "sub": [{
          "code": "110101",
          "alevel": 3,
          "name": "东城区",
          "nickname": "",
          "pid": "110100"
        }, {
          "code": "110102",
          "alevel": 3,
          "name": "西城区",
          "nickname": "",
          "pid": "110100"
        }, {
          "code": "110105",
          "alevel": 3,
          "name": "朝阳区",
          "nickname": "",
          "pid": "110100"
        }, {
          "code": "110106",
          "alevel": 3,
          "name": "丰台区",
          "nickname": "",
          "pid": "110100"
        }, {
          "code": "110107",
          "alevel": 3,
          "name": "石景山区",
          "nickname": "",
          "pid": "110100"
        }, {
          "code": "110108",
          "alevel": 3,
          "name": "海淀区",
          "nickname": "",
          "pid": "110100"
        }, {
          "code": "110109",
          "alevel": 3,
          "name": "门头沟区",
          "nickname": "",
          "pid": "110100"
        }, {
          "code": "110111",
          "alevel": 3,
          "name": "房山区",
          "nickname": "",
          "pid": "110100"
        }, {
          "code": "110112",
          "alevel": 3,
          "name": "通州区",
          "nickname": "",
          "pid": "110100"
        }, {
          "code": "110113",
          "alevel": 3,
          "name": "顺义区",
          "nickname": "",
          "pid": "110100"
        }, {
          "code": "110114",
          "alevel": 3,
          "name": "昌平区",
          "nickname": "",
          "pid": "110100"
        }, {
          "code": "110115",
          "alevel": 3,
          "name": "大兴区",
          "nickname": "",
          "pid": "110100"
        }, {
          "code": "110116",
          "alevel": 3,
          "name": "怀柔区",
          "nickname": "",
          "pid": "110100"
        }, {
          "code": "110117",
          "alevel": 3,
          "name": "平谷区",
          "nickname": "",
          "pid": "110100"
        }, {
          "code": "110118",
          "alevel": 3,
          "name": "密云区",
          "nickname": "",
          "pid": "110100"
        }, {
          "code": "110119",
          "alevel": 3,
          "name": "延庆区",
          "nickname": "",
          "pid": "110100"
        }],
        "name": "北京市",
        "nickname": "",
        "pid": "110000"
      }],
      "name": "北京市",
      "nickname": "京",
      "pid": ""
    }, {
      "code": "120000",
      "alevel": 1,
      "sub": [{
        "code": "120100",
        "alevel": 2,
        "sub": [{
          "code": "120101",
          "alevel": 3,
          "name": "和平区",
          "nickname": "",
          "pid": "120100"
        }, {
          "code": "120102",
          "alevel": 3,
          "name": "河东区",
          "nickname": "",
          "pid": "120100"
        }, {
          "code": "120103",
          "alevel": 3,
          "name": "河西区",
          "nickname": "",
          "pid": "120100"
        }, {
          "code": "120104",
          "alevel": 3,
          "name": "南开区",
          "nickname": "",
          "pid": "120100"
        }, {
          "code": "120105",
          "alevel": 3,
          "name": "河北区",
          "nickname": "",
          "pid": "120100"
        }, {
          "code": "120106",
          "alevel": 3,
          "name": "红桥区",
          "nickname": "",
          "pid": "120100"
        }, {
          "code": "120110",
          "alevel": 3,
          "name": "东丽区",
          "nickname": "",
          "pid": "120100"
        }, {
          "code": "120111",
          "alevel": 3,
          "name": "西青区",
          "nickname": "",
          "pid": "120100"
        }, {
          "code": "120112",
          "alevel": 3,
          "name": "津南区",
          "nickname": "",
          "pid": "120100"
        }, {
          "code": "120113",
          "alevel": 3,
          "name": "北辰区",
          "nickname": "",
          "pid": "120100"
        }, {
          "code": "120114",
          "alevel": 3,
          "name": "武清区",
          "nickname": "",
          "pid": "120100"
        }, {
          "code": "120115",
          "alevel": 3,
          "name": "宝坻区",
          "nickname": "",
          "pid": "120100"
        }, {
          "code": "120116",
          "alevel": 3,
          "name": "滨海新区",
          "nickname": "",
          "pid": "120100"
        }, {
          "code": "120117",
          "alevel": 3,
          "name": "宁河区",
          "nickname": "",
          "pid": "120100"
        }, {
          "code": "120118",
          "alevel": 3,
          "name": "静海区",
          "nickname": "",
          "pid": "120100"
        }, {
          "code": "120119",
          "alevel": 3,
          "name": "蓟州区",
          "nickname": "",
          "pid": "120100"
        }],
        "name": "天津市",
        "nickname": "",
        "pid": "120000"
      }],
      "name": "天津市",
      "nickname": "津",
      "pid": ""
    }, {
      "code": "130000",
      "alevel": 1,
      "sub": [{
        "code": "130100",
        "alevel": 2,
        "sub": [{
          "code": "130101",
          "alevel": 3,
          "name": "市辖区",
          "nickname": "",
          "pid": "130100"
        }, {
          "code": "130102",
          "alevel": 3,
          "name": "长安区",
          "nickname": "",
          "pid": "130100"
        }, {
          "code": "130104",
          "alevel": 3,
          "name": "桥西区",
          "nickname": "",
          "pid": "130100"
        }, {
          "code": "130105",
          "alevel": 3,
          "name": "新华区",
          "nickname": "",
          "pid": "130100"
        }, {
          "code": "130107",
          "alevel": 3,
          "name": "井陉矿区",
          "nickname": "",
          "pid": "130100"
        }, {
          "code": "130108",
          "alevel": 3,
          "name": "裕华区",
          "nickname": "",
          "pid": "130100"
        }, {
          "code": "130109",
          "alevel": 3,
          "name": "藁城区",
          "nickname": "",
          "pid": "130100"
        }, {
          "code": "130110",
          "alevel": 3,
          "name": "鹿泉区",
          "nickname": "",
          "pid": "130100"
        }, {
          "code": "130111",
          "alevel": 3,
          "name": "栾城区",
          "nickname": "",
          "pid": "130100"
        }, {
          "code": "130121",
          "alevel": 3,
          "name": "井陉县",
          "nickname": "",
          "pid": "130100"
        }, {
          "code": "130123",
          "alevel": 3,
          "name": "正定县",
          "nickname": "",
          "pid": "130100"
        }, {
          "code": "130125",
          "alevel": 3,
          "name": "行唐县",
          "nickname": "",
          "pid": "130100"
        }, {
          "code": "130126",
          "alevel": 3,
          "name": "灵寿县",
          "nickname": "",
          "pid": "130100"
        }, {
          "code": "130127",
          "alevel": 3,
          "name": "高邑县",
          "nickname": "",
          "pid": "130100"
        }, {
          "code": "130128",
          "alevel": 3,
          "name": "深泽县",
          "nickname": "",
          "pid": "130100"
        }, {
          "code": "130129",
          "alevel": 3,
          "name": "赞皇县",
          "nickname": "",
          "pid": "130100"
        }, {
          "code": "130130",
          "alevel": 3,
          "name": "无极县",
          "nickname": "",
          "pid": "130100"
        }, {
          "code": "130131",
          "alevel": 3,
          "name": "平山县",
          "nickname": "",
          "pid": "130100"
        }, {
          "code": "130132",
          "alevel": 3,
          "name": "元氏县",
          "nickname": "",
          "pid": "130100"
        }, {
          "code": "130133",
          "alevel": 3,
          "name": "赵县",
          "nickname": "",
          "pid": "130100"
        }, {
          "code": "130181",
          "alevel": 3,
          "name": "辛集市",
          "nickname": "",
          "pid": "130100"
        }, {
          "code": "130183",
          "alevel": 3,
          "name": "晋州市",
          "nickname": "",
          "pid": "130100"
        }, {
          "code": "130184",
          "alevel": 3,
          "name": "新乐市",
          "nickname": "",
          "pid": "130100"
        }],
        "name": "石家庄市",
        "nickname": "",
        "pid": "130000"
      }, {
        "code": "130200",
        "alevel": 2,
        "sub": [{
          "code": "130201",
          "alevel": 3,
          "name": "市辖区",
          "nickname": "",
          "pid": "130200"
        }, {
          "code": "130202",
          "alevel": 3,
          "name": "路南区",
          "nickname": "",
          "pid": "130200"
        }, {
          "code": "130203",
          "alevel": 3,
          "name": "路北区",
          "nickname": "",
          "pid": "130200"
        }, {
          "code": "130204",
          "alevel": 3,
          "name": "古冶区",
          "nickname": "",
          "pid": "130200"
        }, {
          "code": "130205",
          "alevel": 3,
          "name": "开平区",
          "nickname": "",
          "pid": "130200"
        }, {
          "code": "130207",
          "alevel": 3,
          "name": "丰南区",
          "nickname": "",
          "pid": "130200"
        }, {
          "code": "130208",
          "alevel": 3,
          "name": "丰润区",
          "nickname": "",
          "pid": "130200"
        }, {
          "code": "130209",
          "alevel": 3,
          "name": "曹妃甸区",
          "nickname": "",
          "pid": "130200"
        }, {
          "code": "130223",
          "alevel": 3,
          "name": "滦县",
          "nickname": "",
          "pid": "130200"
        }, {
          "code": "130224",
          "alevel": 3,
          "name": "滦南县",
          "nickname": "",
          "pid": "130200"
        }, {
          "code": "130225",
          "alevel": 3,
          "name": "乐亭县",
          "nickname": "",
          "pid": "130200"
        }, {
          "code": "130227",
          "alevel": 3,
          "name": "迁西县",
          "nickname": "",
          "pid": "130200"
        }, {
          "code": "130229",
          "alevel": 3,
          "name": "玉田县",
          "nickname": "",
          "pid": "130200"
        }, {
          "code": "130281",
          "alevel": 3,
          "name": "遵化市",
          "nickname": "",
          "pid": "130200"
        }, {
          "code": "130283",
          "alevel": 3,
          "name": "迁安市",
          "nickname": "",
          "pid": "130200"
        }, {
          "code": "130284",
          "alevel": 3,
          "name": "滦州市",
          "nickname": "",
          "pid": "130200"
        }],
        "name": "唐山市",
        "nickname": "",
        "pid": "130000"
      }, {
        "code": "130300",
        "alevel": 2,
        "sub": [{
          "code": "130301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "130300"
        }, {
          "code": "130302",
          "alevel": 3,
          "name": "海港区",
          "nickname": "",
          "pid": "130300"
        }, {
          "code": "130303",
          "alevel": 3,
          "name": "山海关区",
          "nickname": "",
          "pid": "130300"
        }, {
          "code": "130304",
          "alevel": 3,
          "name": "北戴河区",
          "nickname": "",
          "pid": "130300"
        }, {
          "code": "130306",
          "alevel": 3,
          "name": "抚宁区",
          "nickname": "",
          "pid": "130300"
        }, {
          "code": "130321",
          "alevel": 3,
          "name": "青龙满族自治县",
          "nickname": "",
          "pid": "130300"
        }, {
          "code": "130322",
          "alevel": 3,
          "name": "昌黎县",
          "nickname": "",
          "pid": "130300"
        }, {
          "code": "130324",
          "alevel": 3,
          "name": "卢龙县",
          "nickname": "",
          "pid": "130300"
        }],
        "name": "秦皇岛市",
        "nickname": "",
        "pid": "130000"
      }, {
        "code": "130400",
        "alevel": 2,
        "sub": [{
          "code": "130401",
          "alevel": 3,
          "name": "市辖区",
          "nickname": "",
          "pid": "130400"
        }, {
          "code": "130402",
          "alevel": 3,
          "name": "邯山区",
          "nickname": "",
          "pid": "130400"
        }, {
          "code": "130403",
          "alevel": 3,
          "name": "丛台区",
          "nickname": "",
          "pid": "130400"
        }, {
          "code": "130404",
          "alevel": 3,
          "name": "复兴区",
          "nickname": "",
          "pid": "130400"
        }, {
          "code": "130406",
          "alevel": 3,
          "name": "峰峰矿区",
          "nickname": "",
          "pid": "130400"
        }, {
          "code": "130407",
          "alevel": 3,
          "name": "肥乡区",
          "nickname": "",
          "pid": "130400"
        }, {
          "code": "130408",
          "alevel": 3,
          "name": "永年区",
          "nickname": "",
          "pid": "130400"
        }, {
          "code": "130421",
          "alevel": 3,
          "name": "邯郸县",
          "nickname": "",
          "pid": "130400"
        }, {
          "code": "130423",
          "alevel": 3,
          "name": "临漳县",
          "nickname": "",
          "pid": "130400"
        }, {
          "code": "130424",
          "alevel": 3,
          "name": "成安县",
          "nickname": "",
          "pid": "130400"
        }, {
          "code": "130425",
          "alevel": 3,
          "name": "大名县",
          "nickname": "",
          "pid": "130400"
        }, {
          "code": "130426",
          "alevel": 3,
          "name": "涉县",
          "nickname": "",
          "pid": "130400"
        }, {
          "code": "130427",
          "alevel": 3,
          "name": "磁县",
          "nickname": "",
          "pid": "130400"
        }, {
          "code": "130428",
          "alevel": 3,
          "name": "肥乡县",
          "nickname": "",
          "pid": "130400"
        }, {
          "code": "130429",
          "alevel": 3,
          "name": "永年县",
          "nickname": "",
          "pid": "130400"
        }, {
          "code": "130430",
          "alevel": 3,
          "name": "邱县",
          "nickname": "",
          "pid": "130400"
        }, {
          "code": "130431",
          "alevel": 3,
          "name": "鸡泽县",
          "nickname": "",
          "pid": "130400"
        }, {
          "code": "130432",
          "alevel": 3,
          "name": "广平县",
          "nickname": "",
          "pid": "130400"
        }, {
          "code": "130433",
          "alevel": 3,
          "name": "馆陶县",
          "nickname": "",
          "pid": "130400"
        }, {
          "code": "130434",
          "alevel": 3,
          "name": "魏县",
          "nickname": "",
          "pid": "130400"
        }, {
          "code": "130435",
          "alevel": 3,
          "name": "曲周县",
          "nickname": "",
          "pid": "130400"
        }, {
          "code": "130481",
          "alevel": 3,
          "name": "武安市",
          "nickname": "",
          "pid": "130400"
        }],
        "name": "邯郸市",
        "nickname": "",
        "pid": "130000"
      }, {
        "code": "130500",
        "alevel": 2,
        "sub": [{
          "code": "130501",
          "alevel": 3,
          "name": "市辖区",
          "nickname": "",
          "pid": "130500"
        }, {
          "code": "130502",
          "alevel": 3,
          "name": "桥东区",
          "nickname": "",
          "pid": "130500"
        }, {
          "code": "130503",
          "alevel": 3,
          "name": "桥西区",
          "nickname": "",
          "pid": "130500"
        }, {
          "code": "130521",
          "alevel": 3,
          "name": "邢台县",
          "nickname": "",
          "pid": "130500"
        }, {
          "code": "130522",
          "alevel": 3,
          "name": "临城县",
          "nickname": "",
          "pid": "130500"
        }, {
          "code": "130523",
          "alevel": 3,
          "name": "内丘县",
          "nickname": "",
          "pid": "130500"
        }, {
          "code": "130524",
          "alevel": 3,
          "name": "柏乡县",
          "nickname": "",
          "pid": "130500"
        }, {
          "code": "130525",
          "alevel": 3,
          "name": "隆尧县",
          "nickname": "",
          "pid": "130500"
        }, {
          "code": "130526",
          "alevel": 3,
          "name": "任县",
          "nickname": "",
          "pid": "130500"
        }, {
          "code": "130527",
          "alevel": 3,
          "name": "南和县",
          "nickname": "",
          "pid": "130500"
        }, {
          "code": "130528",
          "alevel": 3,
          "name": "宁晋县",
          "nickname": "",
          "pid": "130500"
        }, {
          "code": "130529",
          "alevel": 3,
          "name": "巨鹿县",
          "nickname": "",
          "pid": "130500"
        }, {
          "code": "130530",
          "alevel": 3,
          "name": "新河县",
          "nickname": "",
          "pid": "130500"
        }, {
          "code": "130531",
          "alevel": 3,
          "name": "广宗县",
          "nickname": "",
          "pid": "130500"
        }, {
          "code": "130532",
          "alevel": 3,
          "name": "平乡县",
          "nickname": "",
          "pid": "130500"
        }, {
          "code": "130533",
          "alevel": 3,

          "name": "威县",
          "nickname": "",
          "pid": "130500"
        }, {
          "code": "130534",
          "alevel": 3,

          "name": "清河县",
          "nickname": "",
          "pid": "130500"
        }, {
          "code": "130535",
          "alevel": 3,

          "name": "临西县",
          "nickname": "",
          "pid": "130500"
        }, {
          "code": "130581",
          "alevel": 3,

          "name": "南宫市",
          "nickname": "",
          "pid": "130500"
        }, {
          "code": "130582",
          "alevel": 3,

          "name": "沙河市",
          "nickname": "",
          "pid": "130500"
        }],
        "name": "邢台市",
        "nickname": "",
        "pid": "130000"
      }, {
        "code": "130600",
        "alevel": 2,
        "sub": [{
          "code": "130601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "130600"
        }, {
          "code": "130602",
          "alevel": 3,

          "name": "竞秀区",
          "nickname": "",
          "pid": "130600"
        }, {
          "code": "130606",
          "alevel": 3,

          "name": "莲池区",
          "nickname": "",
          "pid": "130600"
        }, {
          "code": "130607",
          "alevel": 3,

          "name": "满城区",
          "nickname": "",
          "pid": "130600"
        }, {
          "code": "130608",
          "alevel": 3,

          "name": "清苑区",
          "nickname": "",
          "pid": "130600"
        }, {
          "code": "130609",
          "alevel": 3,

          "name": "徐水区",
          "nickname": "",
          "pid": "130600"
        }, {
          "code": "130623",
          "alevel": 3,

          "name": "涞水县",
          "nickname": "",
          "pid": "130600"
        }, {
          "code": "130624",
          "alevel": 3,

          "name": "阜平县",
          "nickname": "",
          "pid": "130600"
        }, {
          "code": "130626",
          "alevel": 3,

          "name": "定兴县",
          "nickname": "",
          "pid": "130600"
        }, {
          "code": "130627",
          "alevel": 3,

          "name": "唐县",
          "nickname": "",
          "pid": "130600"
        }, {
          "code": "130628",
          "alevel": 3,

          "name": "高阳县",
          "nickname": "",
          "pid": "130600"
        }, {
          "code": "130629",
          "alevel": 3,

          "name": "容城县",
          "nickname": "",
          "pid": "130600"
        }, {
          "code": "130630",
          "alevel": 3,

          "name": "涞源县",
          "nickname": "",
          "pid": "130600"
        }, {
          "code": "130631",
          "alevel": 3,

          "name": "望都县",
          "nickname": "",
          "pid": "130600"
        }, {
          "code": "130632",
          "alevel": 3,

          "name": "安新县",
          "nickname": "",
          "pid": "130600"
        }, {
          "code": "130633",
          "alevel": 3,

          "name": "易县",
          "nickname": "",
          "pid": "130600"
        }, {
          "code": "130634",
          "alevel": 3,

          "name": "曲阳县",
          "nickname": "",
          "pid": "130600"
        }, {
          "code": "130635",
          "alevel": 3,

          "name": "蠡县",
          "nickname": "",
          "pid": "130600"
        }, {
          "code": "130636",
          "alevel": 3,

          "name": "顺平县",
          "nickname": "",
          "pid": "130600"
        }, {
          "code": "130637",
          "alevel": 3,

          "name": "博野县",
          "nickname": "",
          "pid": "130600"
        }, {
          "code": "130638",
          "alevel": 3,

          "name": "雄县",
          "nickname": "",
          "pid": "130600"
        }, {
          "code": "130681",
          "alevel": 3,

          "name": "涿州市",
          "nickname": "",
          "pid": "130600"
        }, {
          "code": "130682",
          "alevel": 3,

          "name": "定州市",
          "nickname": "",
          "pid": "130600"
        }, {
          "code": "130683",
          "alevel": 3,

          "name": "安国市",
          "nickname": "",
          "pid": "130600"
        }, {
          "code": "130684",
          "alevel": 3,

          "name": "高碑店市",
          "nickname": "",
          "pid": "130600"
        }],
        "name": "保定市",
        "nickname": "",
        "pid": "130000"
      }, {
        "code": "130700",
        "alevel": 2,
        "sub": [{
          "code": "130701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "130700"
        }, {
          "code": "130702",
          "alevel": 3,

          "name": "桥东区",
          "nickname": "",
          "pid": "130700"
        }, {
          "code": "130703",
          "alevel": 3,

          "name": "桥西区",
          "nickname": "",
          "pid": "130700"
        }, {
          "code": "130705",
          "alevel": 3,

          "name": "宣化区",
          "nickname": "",
          "pid": "130700"
        }, {
          "code": "130706",
          "alevel": 3,

          "name": "下花园区",
          "nickname": "",
          "pid": "130700"
        }, {
          "code": "130708",
          "alevel": 3,

          "name": "万全区",
          "nickname": "",
          "pid": "130700"
        }, {
          "code": "130709",
          "alevel": 3,

          "name": "崇礼区",
          "nickname": "",
          "pid": "130700"
        }, {
          "code": "130722",
          "alevel": 3,

          "name": "张北县",
          "nickname": "",
          "pid": "130700"
        }, {
          "code": "130723",
          "alevel": 3,

          "name": "康保县",
          "nickname": "",
          "pid": "130700"
        }, {
          "code": "130724",
          "alevel": 3,

          "name": "沽源县",
          "nickname": "",
          "pid": "130700"
        }, {
          "code": "130725",
          "alevel": 3,

          "name": "尚义县",
          "nickname": "",
          "pid": "130700"
        }, {
          "code": "130726",
          "alevel": 3,

          "name": "蔚县",
          "nickname": "",
          "pid": "130700"
        }, {
          "code": "130727",
          "alevel": 3,

          "name": "阳原县",
          "nickname": "",
          "pid": "130700"
        }, {
          "code": "130728",
          "alevel": 3,

          "name": "怀安县",
          "nickname": "",
          "pid": "130700"
        }, {
          "code": "130730",
          "alevel": 3,

          "name": "怀来县",
          "nickname": "",
          "pid": "130700"
        }, {
          "code": "130731",
          "alevel": 3,

          "name": "涿鹿县",
          "nickname": "",
          "pid": "130700"
        }, {
          "code": "130732",
          "alevel": 3,

          "name": "赤城县",
          "nickname": "",
          "pid": "130700"
        }],
        "name": "张家口市",
        "nickname": "",
        "pid": "130000"
      }, {
        "code": "130800",
        "alevel": 2,
        "sub": [{
          "code": "130801",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "130800"
        }, {
          "code": "130802",
          "alevel": 3,

          "name": "双桥区",
          "nickname": "",
          "pid": "130800"
        }, {
          "code": "130803",
          "alevel": 3,

          "name": "双滦区",
          "nickname": "",
          "pid": "130800"
        }, {
          "code": "130804",
          "alevel": 3,

          "name": "鹰手营子矿区",
          "nickname": "",
          "pid": "130800"
        }, {
          "code": "130821",
          "alevel": 3,

          "name": "承德县",
          "nickname": "",
          "pid": "130800"
        }, {
          "code": "130822",
          "alevel": 3,

          "name": "兴隆县",
          "nickname": "",
          "pid": "130800"
        }, {
          "code": "130823",
          "alevel": 3,

          "name": "平泉县",
          "nickname": "",
          "pid": "130800"
        }, {
          "code": "130824",
          "alevel": 3,

          "name": "滦平县",
          "nickname": "",
          "pid": "130800"
        }, {
          "code": "130825",
          "alevel": 3,

          "name": "隆化县",
          "nickname": "",
          "pid": "130800"
        }, {
          "code": "130826",
          "alevel": 3,

          "name": "丰宁满族自治县",
          "nickname": "",
          "pid": "130800"
        }, {
          "code": "130827",
          "alevel": 3,

          "name": "宽城满族自治县",
          "nickname": "",
          "pid": "130800"
        }, {
          "code": "130828",
          "alevel": 3,

          "name": "围场满族蒙古族自治县",
          "nickname": "",
          "pid": "130800"
        }, {
          "code": "130881",
          "alevel": 3,

          "name": "平泉市",
          "nickname": "",
          "pid": "130800"
        }],
        "name": "承德市",
        "nickname": "",
        "pid": "130000"
      }, {
        "code": "130900",
        "alevel": 2,
        "sub": [{
          "code": "130901",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "130900"
        }, {
          "code": "130902",
          "alevel": 3,

          "name": "新华区",
          "nickname": "",
          "pid": "130900"
        }, {
          "code": "130903",
          "alevel": 3,

          "name": "运河区",
          "nickname": "",
          "pid": "130900"
        }, {
          "code": "130921",
          "alevel": 3,

          "name": "沧县",
          "nickname": "",
          "pid": "130900"
        }, {
          "code": "130922",
          "alevel": 3,

          "name": "青县",
          "nickname": "",
          "pid": "130900"
        }, {
          "code": "130923",
          "alevel": 3,

          "name": "东光县",
          "nickname": "",
          "pid": "130900"
        }, {
          "code": "130924",
          "alevel": 3,

          "name": "海兴县",
          "nickname": "",
          "pid": "130900"
        }, {
          "code": "130925",
          "alevel": 3,

          "name": "盐山县",
          "nickname": "",
          "pid": "130900"
        }, {
          "code": "130926",
          "alevel": 3,

          "name": "肃宁县",
          "nickname": "",
          "pid": "130900"
        }, {
          "code": "130927",
          "alevel": 3,

          "name": "南皮县",
          "nickname": "",
          "pid": "130900"
        }, {
          "code": "130928",
          "alevel": 3,

          "name": "吴桥县",
          "nickname": "",
          "pid": "130900"
        }, {
          "code": "130929",
          "alevel": 3,

          "name": "献县",
          "nickname": "",
          "pid": "130900"
        }, {
          "code": "130930",
          "alevel": 3,

          "name": "孟村回族自治县",
          "nickname": "",
          "pid": "130900"
        }, {
          "code": "130981",
          "alevel": 3,

          "name": "泊头市",
          "nickname": "",
          "pid": "130900"
        }, {
          "code": "130982",
          "alevel": 3,

          "name": "任丘市",
          "nickname": "",
          "pid": "130900"
        }, {
          "code": "130983",
          "alevel": 3,

          "name": "黄骅市",
          "nickname": "",
          "pid": "130900"
        }, {
          "code": "130984",
          "alevel": 3,

          "name": "河间市",
          "nickname": "",
          "pid": "130900"
        }],
        "name": "沧州市",
        "nickname": "",
        "pid": "130000"
      }, {
        "code": "131000",
        "alevel": 2,
        "sub": [{
          "code": "131001",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "131000"
        }, {
          "code": "131002",
          "alevel": 3,

          "name": "安次区",
          "nickname": "",
          "pid": "131000"
        }, {
          "code": "131003",
          "alevel": 3,

          "name": "广阳区",
          "nickname": "",
          "pid": "131000"
        }, {
          "code": "131022",
          "alevel": 3,

          "name": "固安县",
          "nickname": "",
          "pid": "131000"
        }, {
          "code": "131023",
          "alevel": 3,

          "name": "永清县",
          "nickname": "",
          "pid": "131000"
        }, {
          "code": "131024",
          "alevel": 3,

          "name": "香河县",
          "nickname": "",
          "pid": "131000"
        }, {
          "code": "131025",
          "alevel": 3,

          "name": "大城县",
          "nickname": "",
          "pid": "131000"
        }, {
          "code": "131026",
          "alevel": 3,

          "name": "文安县",
          "nickname": "",
          "pid": "131000"
        }, {
          "code": "131028",
          "alevel": 3,

          "name": "大厂回族自治县",
          "nickname": "",
          "pid": "131000"
        }, {
          "code": "131081",
          "alevel": 3,

          "name": "霸州市",
          "nickname": "",
          "pid": "131000"
        }, {
          "code": "131082",
          "alevel": 3,

          "name": "三河市",
          "nickname": "",
          "pid": "131000"
        }],
        "name": "廊坊市",
        "nickname": "",
        "pid": "130000"
      }, {
        "code": "131100",
        "alevel": 2,
        "sub": [{
          "code": "131101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "131100"
        }, {
          "code": "131102",
          "alevel": 3,

          "name": "桃城区",
          "nickname": "",
          "pid": "131100"
        }, {
          "code": "131103",
          "alevel": 3,

          "name": "冀州区",
          "nickname": "",
          "pid": "131100"
        }, {
          "code": "131121",
          "alevel": 3,

          "name": "枣强县",
          "nickname": "",
          "pid": "131100"
        }, {
          "code": "131122",
          "alevel": 3,

          "name": "武邑县",
          "nickname": "",
          "pid": "131100"
        }, {
          "code": "131123",
          "alevel": 3,

          "name": "武强县",
          "nickname": "",
          "pid": "131100"
        }, {
          "code": "131124",
          "alevel": 3,

          "name": "饶阳县",
          "nickname": "",
          "pid": "131100"
        }, {
          "code": "131125",
          "alevel": 3,

          "name": "安平县",
          "nickname": "",
          "pid": "131100"
        }, {
          "code": "131126",
          "alevel": 3,

          "name": "故城县",
          "nickname": "",
          "pid": "131100"
        }, {
          "code": "131127",
          "alevel": 3,

          "name": "景县",
          "nickname": "",
          "pid": "131100"
        }, {
          "code": "131128",
          "alevel": 3,

          "name": "阜城县",
          "nickname": "",
          "pid": "131100"
        }, {
          "code": "131182",
          "alevel": 3,

          "name": "深州市",
          "nickname": "",
          "pid": "131100"
        }],
        "name": "衡水市",
        "nickname": "",
        "pid": "130000"
      }, {
        "code": "139000",
        "alevel": 2,
        "sub": [{
          "code": "139001",
          "alevel": 3,

          "name": "定州市",
          "nickname": "",
          "pid": "139000"
        }, {
          "code": "139002",
          "alevel": 3,

          "name": "辛集市",
          "nickname": "",
          "pid": "139000"
        }],
        "name": "省直辖县级行政区划",
        "nickname": "",
        "pid": "130000"
      }],
      "name": "河北省",
      "nickname": "冀",
      "pid": ""
    }, {
      "code": "140000",
      "alevel": 1,
      "sub": [{
        "code": "140100",
        "alevel": 2,
        "sub": [{
          "code": "140101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "140100"
        }, {
          "code": "140105",
          "alevel": 3,

          "name": "小店区",
          "nickname": "",
          "pid": "140100"
        }, {
          "code": "140106",
          "alevel": 3,

          "name": "迎泽区",
          "nickname": "",
          "pid": "140100"
        }, {
          "code": "140107",
          "alevel": 3,

          "name": "杏花岭区",
          "nickname": "",
          "pid": "140100"
        }, {
          "code": "140108",
          "alevel": 3,

          "name": "尖草坪区",
          "nickname": "",
          "pid": "140100"
        }, {
          "code": "140109",
          "alevel": 3,

          "name": "万柏林区",
          "nickname": "",
          "pid": "140100"
        }, {
          "code": "140110",
          "alevel": 3,

          "name": "晋源区",
          "nickname": "",
          "pid": "140100"
        }, {
          "code": "140121",
          "alevel": 3,

          "name": "清徐县",
          "nickname": "",
          "pid": "140100"
        }, {
          "code": "140122",
          "alevel": 3,

          "name": "阳曲县",
          "nickname": "",
          "pid": "140100"
        }, {
          "code": "140123",
          "alevel": 3,

          "name": "娄烦县",
          "nickname": "",
          "pid": "140100"
        }, {
          "code": "140181",
          "alevel": 3,

          "name": "古交市",
          "nickname": "",
          "pid": "140100"
        }],
        "name": "太原市",
        "nickname": "",
        "pid": "140000"
      }, {
        "code": "140200",
        "alevel": 2,
        "sub": [{
          "code": "140201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "140200"
        }, {
          "code": "140202",
          "alevel": 3,

          "name": "城区",
          "nickname": "",
          "pid": "140200"
        }, {
          "code": "140203",
          "alevel": 3,

          "name": "矿区",
          "nickname": "",
          "pid": "140200"
        }, {
          "code": "140211",
          "alevel": 3,

          "name": "南郊区",
          "nickname": "",
          "pid": "140200"
        }, {
          "code": "140212",
          "alevel": 3,

          "name": "新荣区",
          "nickname": "",
          "pid": "140200"
        }, {
          "code": "140213",
          "alevel": 3,

          "name": "平城区",
          "nickname": "",
          "pid": "140200"
        }, {
          "code": "140214",
          "alevel": 3,

          "name": "云冈区",
          "nickname": "",
          "pid": "140200"
        }, {
          "code": "140215",
          "alevel": 3,

          "name": "云州区",
          "nickname": "",
          "pid": "140200"
        }, {
          "code": "140221",
          "alevel": 3,

          "name": "阳高县",
          "nickname": "",
          "pid": "140200"
        }, {
          "code": "140222",
          "alevel": 3,

          "name": "天镇县",
          "nickname": "",
          "pid": "140200"
        }, {
          "code": "140223",
          "alevel": 3,

          "name": "广灵县",
          "nickname": "",
          "pid": "140200"
        }, {
          "code": "140224",
          "alevel": 3,

          "name": "灵丘县",
          "nickname": "",
          "pid": "140200"
        }, {
          "code": "140225",
          "alevel": 3,

          "name": "浑源县",
          "nickname": "",
          "pid": "140200"
        }, {
          "code": "140226",
          "alevel": 3,

          "name": "左云县",
          "nickname": "",
          "pid": "140200"
        }, {
          "code": "140227",
          "alevel": 3,

          "name": "大同县",
          "nickname": "",
          "pid": "140200"
        }],
        "name": "大同市",
        "nickname": "",
        "pid": "140000"
      }, {
        "code": "140300",
        "alevel": 2,
        "sub": [{
          "code": "140301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "140300"
        }, {
          "code": "140302",
          "alevel": 3,

          "name": "城区",
          "nickname": "",
          "pid": "140300"
        }, {
          "code": "140303",
          "alevel": 3,

          "name": "矿区",
          "nickname": "",
          "pid": "140300"
        }, {
          "code": "140311",
          "alevel": 3,

          "name": "郊区",
          "nickname": "",
          "pid": "140300"
        }, {
          "code": "140321",
          "alevel": 3,

          "name": "平定县",
          "nickname": "",
          "pid": "140300"
        }, {
          "code": "140322",
          "alevel": 3,

          "name": "盂县",
          "nickname": "",
          "pid": "140300"
        }],
        "name": "阳泉市",
        "nickname": "",
        "pid": "140000"
      }, {
        "code": "140400",
        "alevel": 2,
        "sub": [{
          "code": "140401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "140400"
        }, {
          "code": "140402",
          "alevel": 3,

          "name": "城区",
          "nickname": "",
          "pid": "140400"
        }, {
          "code": "140403",
          "alevel": 3,

          "name": "潞州区",
          "nickname": "",
          "pid": "140400"
        }, {
          "code": "140404",
          "alevel": 3,

          "name": "上党区",
          "nickname": "",
          "pid": "140400"
        }, {
          "code": "140405",
          "alevel": 3,

          "name": "屯留区",
          "nickname": "",
          "pid": "140400"
        }, {
          "code": "140406",
          "alevel": 3,

          "name": "潞城区",
          "nickname": "",
          "pid": "140400"
        }, {
          "code": "140411",
          "alevel": 3,

          "name": "郊区",
          "nickname": "",
          "pid": "140400"
        }, {
          "code": "140421",
          "alevel": 3,

          "name": "长治县",
          "nickname": "",
          "pid": "140400"
        }, {
          "code": "140423",
          "alevel": 3,

          "name": "襄垣县",
          "nickname": "",
          "pid": "140400"
        }, {
          "code": "140424",
          "alevel": 3,

          "name": "屯留县",
          "nickname": "",
          "pid": "140400"
        }, {
          "code": "140425",
          "alevel": 3,

          "name": "平顺县",
          "nickname": "",
          "pid": "140400"
        }, {
          "code": "140426",
          "alevel": 3,

          "name": "黎城县",
          "nickname": "",
          "pid": "140400"
        }, {
          "code": "140427",
          "alevel": 3,

          "name": "壶关县",
          "nickname": "",
          "pid": "140400"
        }, {
          "code": "140428",
          "alevel": 3,

          "name": "长子县",
          "nickname": "",
          "pid": "140400"
        }, {
          "code": "140429",
          "alevel": 3,

          "name": "武乡县",
          "nickname": "",
          "pid": "140400"
        }, {
          "code": "140430",
          "alevel": 3,

          "name": "沁县",
          "nickname": "",
          "pid": "140400"
        }, {
          "code": "140431",
          "alevel": 3,

          "name": "沁源县",
          "nickname": "",
          "pid": "140400"
        }, {
          "code": "140481",
          "alevel": 3,

          "name": "潞城市",
          "nickname": "",
          "pid": "140400"
        }],
        "name": "长治市",
        "nickname": "",
        "pid": "140000"
      }, {
        "code": "140500",
        "alevel": 2,
        "sub": [{
          "code": "140501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "140500"
        }, {
          "code": "140502",
          "alevel": 3,

          "name": "城区",
          "nickname": "",
          "pid": "140500"
        }, {
          "code": "140521",
          "alevel": 3,

          "name": "沁水县",
          "nickname": "",
          "pid": "140500"
        }, {
          "code": "140522",
          "alevel": 3,

          "name": "阳城县",
          "nickname": "",
          "pid": "140500"
        }, {
          "code": "140524",
          "alevel": 3,

          "name": "陵川县",
          "nickname": "",
          "pid": "140500"
        }, {
          "code": "140525",
          "alevel": 3,

          "name": "泽州县",
          "nickname": "",
          "pid": "140500"
        }, {
          "code": "140581",
          "alevel": 3,

          "name": "高平市",
          "nickname": "",
          "pid": "140500"
        }],
        "name": "晋城市",
        "nickname": "",
        "pid": "140000"
      }, {
        "code": "140600",
        "alevel": 2,
        "sub": [{
          "code": "140601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "140600"
        }, {
          "code": "140602",
          "alevel": 3,

          "name": "朔城区",
          "nickname": "",
          "pid": "140600"
        }, {
          "code": "140603",
          "alevel": 3,

          "name": "平鲁区",
          "nickname": "",
          "pid": "140600"
        }, {
          "code": "140621",
          "alevel": 3,

          "name": "山阴县",
          "nickname": "",
          "pid": "140600"
        }, {
          "code": "140622",
          "alevel": 3,

          "name": "应县",
          "nickname": "",
          "pid": "140600"
        }, {
          "code": "140623",
          "alevel": 3,

          "name": "右玉县",
          "nickname": "",
          "pid": "140600"
        }, {
          "code": "140624",
          "alevel": 3,

          "name": "怀仁县",
          "nickname": "",
          "pid": "140600"
        }, {
          "code": "140681",
          "alevel": 3,

          "name": "怀仁市",
          "nickname": "",
          "pid": "140600"
        }],
        "name": "朔州市",
        "nickname": "",
        "pid": "140000"
      }, {
        "code": "140700",
        "alevel": 2,
        "sub": [{
          "code": "140701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "140700"
        }, {
          "code": "140702",
          "alevel": 3,

          "name": "榆次区",
          "nickname": "",
          "pid": "140700"
        }, {
          "code": "140703",
          "alevel": 3,

          "name": "太谷区",
          "nickname": "",
          "pid": "140700"
        }, {
          "code": "140721",
          "alevel": 3,

          "name": "榆社县",
          "nickname": "",
          "pid": "140700"
        }, {
          "code": "140722",
          "alevel": 3,

          "name": "左权县",
          "nickname": "",
          "pid": "140700"
        }, {
          "code": "140723",
          "alevel": 3,

          "name": "和顺县",
          "nickname": "",
          "pid": "140700"
        }, {
          "code": "140724",
          "alevel": 3,

          "name": "昔阳县",
          "nickname": "",
          "pid": "140700"
        }, {
          "code": "140725",
          "alevel": 3,

          "name": "寿阳县",
          "nickname": "",
          "pid": "140700"
        }, {
          "code": "140726",
          "alevel": 3,

          "name": "太谷县",
          "nickname": "",
          "pid": "140700"
        }, {
          "code": "140727",
          "alevel": 3,

          "name": "祁县",
          "nickname": "",
          "pid": "140700"
        }, {
          "code": "140728",
          "alevel": 3,

          "name": "平遥县",
          "nickname": "",
          "pid": "140700"
        }, {
          "code": "140729",
          "alevel": 3,

          "name": "灵石县",
          "nickname": "",
          "pid": "140700"
        }, {
          "code": "140781",
          "alevel": 3,

          "name": "介休市",
          "nickname": "",
          "pid": "140700"
        }],
        "name": "晋中市",
        "nickname": "",
        "pid": "140000"
      }, {
        "code": "140800",
        "alevel": 2,
        "sub": [{
          "code": "140801",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "140800"
        }, {
          "code": "140802",
          "alevel": 3,

          "name": "盐湖区",
          "nickname": "",
          "pid": "140800"
        }, {
          "code": "140821",
          "alevel": 3,

          "name": "临猗县",
          "nickname": "",
          "pid": "140800"
        }, {
          "code": "140822",
          "alevel": 3,

          "name": "万荣县",
          "nickname": "",
          "pid": "140800"
        }, {
          "code": "140823",
          "alevel": 3,

          "name": "闻喜县",
          "nickname": "",
          "pid": "140800"
        }, {
          "code": "140824",
          "alevel": 3,

          "name": "稷山县",
          "nickname": "",
          "pid": "140800"
        }, {
          "code": "140825",
          "alevel": 3,

          "name": "新绛县",
          "nickname": "",
          "pid": "140800"
        }, {
          "code": "140826",
          "alevel": 3,

          "name": "绛县",
          "nickname": "",
          "pid": "140800"
        }, {
          "code": "140827",
          "alevel": 3,

          "name": "垣曲县",
          "nickname": "",
          "pid": "140800"
        }, {
          "code": "140828",
          "alevel": 3,

          "name": "夏县",
          "nickname": "",
          "pid": "140800"
        }, {
          "code": "140829",
          "alevel": 3,

          "name": "平陆县",
          "nickname": "",
          "pid": "140800"
        }, {
          "code": "140830",
          "alevel": 3,

          "name": "芮城县",
          "nickname": "",
          "pid": "140800"
        }, {
          "code": "140881",
          "alevel": 3,

          "name": "永济市",
          "nickname": "",
          "pid": "140800"
        }, {
          "code": "140882",
          "alevel": 3,

          "name": "河津市",
          "nickname": "",
          "pid": "140800"
        }],
        "name": "运城市",
        "nickname": "",
        "pid": "140000"
      }, {
        "code": "140900",
        "alevel": 2,
        "sub": [{
          "code": "140901",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "140900"
        }, {
          "code": "140902",
          "alevel": 3,

          "name": "忻府区",
          "nickname": "",
          "pid": "140900"
        }, {
          "code": "140921",
          "alevel": 3,

          "name": "定襄县",
          "nickname": "",
          "pid": "140900"
        }, {
          "code": "140922",
          "alevel": 3,

          "name": "五台县",
          "nickname": "",
          "pid": "140900"
        }, {
          "code": "140923",
          "alevel": 3,

          "name": "代县",
          "nickname": "",
          "pid": "140900"
        }, {
          "code": "140924",
          "alevel": 3,

          "name": "繁峙县",
          "nickname": "",
          "pid": "140900"
        }, {
          "code": "140925",
          "alevel": 3,

          "name": "宁武县",
          "nickname": "",
          "pid": "140900"
        }, {
          "code": "140926",
          "alevel": 3,

          "name": "静乐县",
          "nickname": "",
          "pid": "140900"
        }, {
          "code": "140927",
          "alevel": 3,

          "name": "神池县",
          "nickname": "",
          "pid": "140900"
        }, {
          "code": "140928",
          "alevel": 3,

          "name": "五寨县",
          "nickname": "",
          "pid": "140900"
        }, {
          "code": "140929",
          "alevel": 3,

          "name": "岢岚县",
          "nickname": "",
          "pid": "140900"
        }, {
          "code": "140930",
          "alevel": 3,

          "name": "河曲县",
          "nickname": "",
          "pid": "140900"
        }, {
          "code": "140931",
          "alevel": 3,

          "name": "保德县",
          "nickname": "",
          "pid": "140900"
        }, {
          "code": "140932",
          "alevel": 3,

          "name": "偏关县",
          "nickname": "",
          "pid": "140900"
        }, {
          "code": "140981",
          "alevel": 3,

          "name": "原平市",
          "nickname": "",
          "pid": "140900"
        }],
        "name": "忻州市",
        "nickname": "",
        "pid": "140000"
      }, {
        "code": "141000",
        "alevel": 2,
        "sub": [{
          "code": "141001",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "141000"
        }, {
          "code": "141002",
          "alevel": 3,

          "name": "尧都区",
          "nickname": "",
          "pid": "141000"
        }, {
          "code": "141021",
          "alevel": 3,

          "name": "曲沃县",
          "nickname": "",
          "pid": "141000"
        }, {
          "code": "141022",
          "alevel": 3,

          "name": "翼城县",
          "nickname": "",
          "pid": "141000"
        }, {
          "code": "141023",
          "alevel": 3,

          "name": "襄汾县",
          "nickname": "",
          "pid": "141000"
        }, {
          "code": "141024",
          "alevel": 3,

          "name": "洪洞县",
          "nickname": "",
          "pid": "141000"
        }, {
          "code": "141025",
          "alevel": 3,

          "name": "古县",
          "nickname": "",
          "pid": "141000"
        }, {
          "code": "141026",
          "alevel": 3,

          "name": "安泽县",
          "nickname": "",
          "pid": "141000"
        }, {
          "code": "141027",
          "alevel": 3,

          "name": "浮山县",
          "nickname": "",
          "pid": "141000"
        }, {
          "code": "141028",
          "alevel": 3,

          "name": "吉县",
          "nickname": "",
          "pid": "141000"
        }, {
          "code": "141029",
          "alevel": 3,

          "name": "乡宁县",
          "nickname": "",
          "pid": "141000"
        }, {
          "code": "141030",
          "alevel": 3,

          "name": "大宁县",
          "nickname": "",
          "pid": "141000"
        }, {
          "code": "141031",
          "alevel": 3,

          "name": "隰县",
          "nickname": "",
          "pid": "141000"
        }, {
          "code": "141032",
          "alevel": 3,

          "name": "永和县",
          "nickname": "",
          "pid": "141000"
        }, {
          "code": "141033",
          "alevel": 3,

          "name": "蒲县",
          "nickname": "",
          "pid": "141000"
        }, {
          "code": "141034",
          "alevel": 3,

          "name": "汾西县",
          "nickname": "",
          "pid": "141000"
        }, {
          "code": "141081",
          "alevel": 3,

          "name": "侯马市",
          "nickname": "",
          "pid": "141000"
        }, {
          "code": "141082",
          "alevel": 3,

          "name": "霍州市",
          "nickname": "",
          "pid": "141000"
        }],
        "name": "临汾市",
        "nickname": "",
        "pid": "140000"
      }, {
        "code": "141100",
        "alevel": 2,
        "sub": [{
          "code": "141101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "141100"
        }, {
          "code": "141102",
          "alevel": 3,

          "name": "离石区",
          "nickname": "",
          "pid": "141100"
        }, {
          "code": "141121",
          "alevel": 3,

          "name": "文水县",
          "nickname": "",
          "pid": "141100"
        }, {
          "code": "141122",
          "alevel": 3,

          "name": "交城县",
          "nickname": "",
          "pid": "141100"
        }, {
          "code": "141123",
          "alevel": 3,

          "name": "兴县",
          "nickname": "",
          "pid": "141100"
        }, {
          "code": "141124",
          "alevel": 3,

          "name": "临县",
          "nickname": "",
          "pid": "141100"
        }, {
          "code": "141125",
          "alevel": 3,

          "name": "柳林县",
          "nickname": "",
          "pid": "141100"
        }, {
          "code": "141126",
          "alevel": 3,

          "name": "石楼县",
          "nickname": "",
          "pid": "141100"
        }, {
          "code": "141127",
          "alevel": 3,

          "name": "岚县",
          "nickname": "",
          "pid": "141100"
        }, {
          "code": "141128",
          "alevel": 3,

          "name": "方山县",
          "nickname": "",
          "pid": "141100"
        }, {
          "code": "141129",
          "alevel": 3,

          "name": "中阳县",
          "nickname": "",
          "pid": "141100"
        }, {
          "code": "141130",
          "alevel": 3,

          "name": "交口县",
          "nickname": "",
          "pid": "141100"
        }, {
          "code": "141181",
          "alevel": 3,

          "name": "孝义市",
          "nickname": "",
          "pid": "141100"
        }, {
          "code": "141182",
          "alevel": 3,

          "name": "汾阳市",
          "nickname": "",
          "pid": "141100"
        }],
        "name": "吕梁市",
        "nickname": "",
        "pid": "140000"
      }],
      "name": "山西省",
      "nickname": "晋",
      "pid": ""
    }, {
      "code": "150000",
      "alevel": 1,
      "sub": [{
        "code": "150100",
        "alevel": 2,
        "sub": [{
          "code": "150101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "150100"
        }, {
          "code": "150102",
          "alevel": 3,

          "name": "新城区",
          "nickname": "",
          "pid": "150100"
        }, {
          "code": "150103",
          "alevel": 3,

          "name": "回民区",
          "nickname": "",
          "pid": "150100"
        }, {
          "code": "150104",
          "alevel": 3,

          "name": "玉泉区",
          "nickname": "",
          "pid": "150100"
        }, {
          "code": "150105",
          "alevel": 3,

          "name": "赛罕区",
          "nickname": "",
          "pid": "150100"
        }, {
          "code": "150121",
          "alevel": 3,

          "name": "土默特左旗",
          "nickname": "",
          "pid": "150100"
        }, {
          "code": "150122",
          "alevel": 3,

          "name": "托克托县",
          "nickname": "",
          "pid": "150100"
        }, {
          "code": "150123",
          "alevel": 3,

          "name": "和林格尔县",
          "nickname": "",
          "pid": "150100"
        }, {
          "code": "150124",
          "alevel": 3,

          "name": "清水河县",
          "nickname": "",
          "pid": "150100"
        }, {
          "code": "150125",
          "alevel": 3,

          "name": "武川县",
          "nickname": "",
          "pid": "150100"
        }],
        "name": "呼和浩特市",
        "nickname": "",
        "pid": "150000"
      }, {
        "code": "150200",
        "alevel": 2,
        "sub": [{
          "code": "150201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "150200"
        }, {
          "code": "150202",
          "alevel": 3,

          "name": "东河区",
          "nickname": "",
          "pid": "150200"
        }, {
          "code": "150203",
          "alevel": 3,

          "name": "昆都仑区",
          "nickname": "",
          "pid": "150200"
        }, {
          "code": "150204",
          "alevel": 3,

          "name": "青山区",
          "nickname": "",
          "pid": "150200"
        }, {
          "code": "150205",
          "alevel": 3,

          "name": "石拐区",
          "nickname": "",
          "pid": "150200"
        }, {
          "code": "150206",
          "alevel": 3,

          "name": "白云鄂博矿区",
          "nickname": "",
          "pid": "150200"
        }, {
          "code": "150207",
          "alevel": 3,

          "name": "九原区",
          "nickname": "",
          "pid": "150200"
        }, {
          "code": "150221",
          "alevel": 3,

          "name": "土默特右旗",
          "nickname": "",
          "pid": "150200"
        }, {
          "code": "150222",
          "alevel": 3,

          "name": "固阳县",
          "nickname": "",
          "pid": "150200"
        }, {
          "code": "150223",
          "alevel": 3,

          "name": "达尔罕茂明安联合旗",
          "nickname": "",
          "pid": "150200"
        }],
        "name": "包头市",
        "nickname": "",
        "pid": "150000"
      }, {
        "code": "150300",
        "alevel": 2,
        "sub": [{
          "code": "150301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "150300"
        }, {
          "code": "150302",
          "alevel": 3,

          "name": "海勃湾区",
          "nickname": "",
          "pid": "150300"
        }, {
          "code": "150303",
          "alevel": 3,

          "name": "海南区",
          "nickname": "",
          "pid": "150300"
        }, {
          "code": "150304",
          "alevel": 3,

          "name": "乌达区",
          "nickname": "",
          "pid": "150300"
        }],
        "name": "乌海市",
        "nickname": "",
        "pid": "150000"
      }, {
        "code": "150400",
        "alevel": 2,
        "sub": [{
          "code": "150401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "150400"
        }, {
          "code": "150402",
          "alevel": 3,

          "name": "红山区",
          "nickname": "",
          "pid": "150400"
        }, {
          "code": "150403",
          "alevel": 3,

          "name": "元宝山区",
          "nickname": "",
          "pid": "150400"
        }, {
          "code": "150404",
          "alevel": 3,

          "name": "松山区",
          "nickname": "",
          "pid": "150400"
        }, {
          "code": "150421",
          "alevel": 3,

          "name": "阿鲁科尔沁旗",
          "nickname": "",
          "pid": "150400"
        }, {
          "code": "150422",
          "alevel": 3,

          "name": "巴林左旗",
          "nickname": "",
          "pid": "150400"
        }, {
          "code": "150423",
          "alevel": 3,

          "name": "巴林右旗",
          "nickname": "",
          "pid": "150400"
        }, {
          "code": "150424",
          "alevel": 3,

          "name": "林西县",
          "nickname": "",
          "pid": "150400"
        }, {
          "code": "150425",
          "alevel": 3,

          "name": "克什克腾旗",
          "nickname": "",
          "pid": "150400"
        }, {
          "code": "150426",
          "alevel": 3,

          "name": "翁牛特旗",
          "nickname": "",
          "pid": "150400"
        }, {
          "code": "150428",
          "alevel": 3,

          "name": "喀喇沁旗",
          "nickname": "",
          "pid": "150400"
        }, {
          "code": "150429",
          "alevel": 3,

          "name": "宁城县",
          "nickname": "",
          "pid": "150400"
        }, {
          "code": "150430",
          "alevel": 3,

          "name": "敖汉旗",
          "nickname": "",
          "pid": "150400"
        }],
        "name": "赤峰市",
        "nickname": "",
        "pid": "150000"
      }, {
        "code": "150500",
        "alevel": 2,
        "sub": [{
          "code": "150501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "150500"
        }, {
          "code": "150502",
          "alevel": 3,

          "name": "科尔沁区",
          "nickname": "",
          "pid": "150500"
        }, {
          "code": "150521",
          "alevel": 3,

          "name": "科尔沁左翼中旗",
          "nickname": "",
          "pid": "150500"
        }, {
          "code": "150522",
          "alevel": 3,

          "name": "科尔沁左翼后旗",
          "nickname": "",
          "pid": "150500"
        }, {
          "code": "150523",
          "alevel": 3,

          "name": "开鲁县",
          "nickname": "",
          "pid": "150500"
        }, {
          "code": "150524",
          "alevel": 3,

          "name": "库伦旗",
          "nickname": "",
          "pid": "150500"
        }, {
          "code": "150525",
          "alevel": 3,

          "name": "奈曼旗",
          "nickname": "",
          "pid": "150500"
        }, {
          "code": "150526",
          "alevel": 3,

          "name": "扎鲁特旗",
          "nickname": "",
          "pid": "150500"
        }, {
          "code": "150581",
          "alevel": 3,

          "name": "霍林郭勒市",
          "nickname": "",
          "pid": "150500"
        }],
        "name": "通辽市",
        "nickname": "",
        "pid": "150000"
      }, {
        "code": "150600",
        "alevel": 2,
        "sub": [{
          "code": "150601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "150600"
        }, {
          "code": "150602",
          "alevel": 3,

          "name": "东胜区",
          "nickname": "",
          "pid": "150600"
        }, {
          "code": "150603",
          "alevel": 3,

          "name": "康巴什区",
          "nickname": "",
          "pid": "150600"
        }, {
          "code": "150621",
          "alevel": 3,

          "name": "达拉特旗",
          "nickname": "",
          "pid": "150600"
        }, {
          "code": "150622",
          "alevel": 3,

          "name": "准格尔旗",
          "nickname": "",
          "pid": "150600"
        }, {
          "code": "150623",
          "alevel": 3,

          "name": "鄂托克前旗",
          "nickname": "",
          "pid": "150600"
        }, {
          "code": "150624",
          "alevel": 3,

          "name": "鄂托克旗",
          "nickname": "",
          "pid": "150600"
        }, {
          "code": "150625",
          "alevel": 3,

          "name": "杭锦旗",
          "nickname": "",
          "pid": "150600"
        }, {
          "code": "150626",
          "alevel": 3,

          "name": "乌审旗",
          "nickname": "",
          "pid": "150600"
        }, {
          "code": "150627",
          "alevel": 3,

          "name": "伊金霍洛旗",
          "nickname": "",
          "pid": "150600"
        }],
        "name": "鄂尔多斯市",
        "nickname": "",
        "pid": "150000"
      }, {
        "code": "150700",
        "alevel": 2,
        "sub": [{
          "code": "150701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "150700"
        }, {
          "code": "150702",
          "alevel": 3,

          "name": "海拉尔区",
          "nickname": "",
          "pid": "150700"
        }, {
          "code": "150703",
          "alevel": 3,

          "name": "扎赉诺尔区",
          "nickname": "",
          "pid": "150700"
        }, {
          "code": "150721",
          "alevel": 3,

          "name": "阿荣旗",
          "nickname": "",
          "pid": "150700"
        }, {
          "code": "150722",
          "alevel": 3,

          "name": "莫力达瓦达斡尔族自治旗",
          "nickname": "",
          "pid": "150700"
        }, {
          "code": "150723",
          "alevel": 3,

          "name": "鄂伦春自治旗",
          "nickname": "",
          "pid": "150700"
        }, {
          "code": "150724",
          "alevel": 3,

          "name": "鄂温克族自治旗",
          "nickname": "",
          "pid": "150700"
        }, {
          "code": "150725",
          "alevel": 3,

          "name": "陈巴尔虎旗",
          "nickname": "",
          "pid": "150700"
        }, {
          "code": "150726",
          "alevel": 3,

          "name": "新巴尔虎左旗",
          "nickname": "",
          "pid": "150700"
        }, {
          "code": "150727",
          "alevel": 3,

          "name": "新巴尔虎右旗",
          "nickname": "",
          "pid": "150700"
        }, {
          "code": "150781",
          "alevel": 3,

          "name": "满洲里市",
          "nickname": "",
          "pid": "150700"
        }, {
          "code": "150782",
          "alevel": 3,

          "name": "牙克石市",
          "nickname": "",
          "pid": "150700"
        }, {
          "code": "150783",
          "alevel": 3,

          "name": "扎兰屯市",
          "nickname": "",
          "pid": "150700"
        }, {
          "code": "150784",
          "alevel": 3,

          "name": "额尔古纳市",
          "nickname": "",
          "pid": "150700"
        }, {
          "code": "150785",
          "alevel": 3,

          "name": "根河市",
          "nickname": "",
          "pid": "150700"
        }],
        "name": "呼伦贝尔市",
        "nickname": "",
        "pid": "150000"
      }, {
        "code": "150800",
        "alevel": 2,
        "sub": [{
          "code": "150801",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "150800"
        }, {
          "code": "150802",
          "alevel": 3,

          "name": "临河区",
          "nickname": "",
          "pid": "150800"
        }, {
          "code": "150821",
          "alevel": 3,

          "name": "五原县",
          "nickname": "",
          "pid": "150800"
        }, {
          "code": "150822",
          "alevel": 3,

          "name": "磴口县",
          "nickname": "",
          "pid": "150800"
        }, {
          "code": "150823",
          "alevel": 3,

          "name": "乌拉特前旗",
          "nickname": "",
          "pid": "150800"
        }, {
          "code": "150824",
          "alevel": 3,

          "name": "乌拉特中旗",
          "nickname": "",
          "pid": "150800"
        }, {
          "code": "150825",
          "alevel": 3,

          "name": "乌拉特后旗",
          "nickname": "",
          "pid": "150800"
        }, {
          "code": "150826",
          "alevel": 3,

          "name": "杭锦后旗",
          "nickname": "",
          "pid": "150800"
        }],
        "name": "巴彦淖尔市",
        "nickname": "",
        "pid": "150000"
      }, {
        "code": "150900",
        "alevel": 2,
        "sub": [{
          "code": "150901",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "150900"
        }, {
          "code": "150902",
          "alevel": 3,

          "name": "集宁区",
          "nickname": "",
          "pid": "150900"
        }, {
          "code": "150921",
          "alevel": 3,

          "name": "卓资县",
          "nickname": "",
          "pid": "150900"
        }, {
          "code": "150922",
          "alevel": 3,

          "name": "化德县",
          "nickname": "",
          "pid": "150900"
        }, {
          "code": "150923",
          "alevel": 3,

          "name": "商都县",
          "nickname": "",
          "pid": "150900"
        }, {
          "code": "150924",
          "alevel": 3,

          "name": "兴和县",
          "nickname": "",
          "pid": "150900"
        }, {
          "code": "150925",
          "alevel": 3,

          "name": "凉城县",
          "nickname": "",
          "pid": "150900"
        }, {
          "code": "150926",
          "alevel": 3,

          "name": "察哈尔右翼前旗",
          "nickname": "",
          "pid": "150900"
        }, {
          "code": "150927",
          "alevel": 3,

          "name": "察哈尔右翼中旗",
          "nickname": "",
          "pid": "150900"
        }, {
          "code": "150928",
          "alevel": 3,

          "name": "察哈尔右翼后旗",
          "nickname": "",
          "pid": "150900"
        }, {
          "code": "150929",
          "alevel": 3,

          "name": "四子王旗",
          "nickname": "",
          "pid": "150900"
        }, {
          "code": "150981",
          "alevel": 3,

          "name": "丰镇市",
          "nickname": "",
          "pid": "150900"
        }],
        "name": "乌兰察布市",
        "nickname": "",
        "pid": "150000"
      }, {
        "code": "152200",
        "alevel": 2,
        "sub": [{
          "code": "152201",
          "alevel": 3,

          "name": "乌兰浩特市",
          "nickname": "",
          "pid": "152200"
        }, {
          "code": "152202",
          "alevel": 3,

          "name": "阿尔山市",
          "nickname": "",
          "pid": "152200"
        }, {
          "code": "152221",
          "alevel": 3,

          "name": "科尔沁右翼前旗",
          "nickname": "",
          "pid": "152200"
        }, {
          "code": "152222",
          "alevel": 3,

          "name": "科尔沁右翼中旗",
          "nickname": "",
          "pid": "152200"
        }, {
          "code": "152223",
          "alevel": 3,

          "name": "扎赉特旗",
          "nickname": "",
          "pid": "152200"
        }, {
          "code": "152224",
          "alevel": 3,

          "name": "突泉县",
          "nickname": "",
          "pid": "152200"
        }],
        "name": "兴安盟",
        "nickname": "",
        "pid": "150000"
      }, {
        "code": "152500",
        "alevel": 2,
        "sub": [{
          "code": "152501",
          "alevel": 3,

          "name": "二连浩特市",
          "nickname": "",
          "pid": "152500"
        }, {
          "code": "152502",
          "alevel": 3,

          "name": "锡林浩特市",
          "nickname": "",
          "pid": "152500"
        }, {
          "code": "152522",
          "alevel": 3,

          "name": "阿巴嘎旗",
          "nickname": "",
          "pid": "152500"
        }, {
          "code": "152523",
          "alevel": 3,

          "name": "苏尼特左旗",
          "nickname": "",
          "pid": "152500"
        }, {
          "code": "152524",
          "alevel": 3,

          "name": "苏尼特右旗",
          "nickname": "",
          "pid": "152500"
        }, {
          "code": "152525",
          "alevel": 3,

          "name": "东乌珠穆沁旗",
          "nickname": "",
          "pid": "152500"
        }, {
          "code": "152526",
          "alevel": 3,

          "name": "西乌珠穆沁旗",
          "nickname": "",
          "pid": "152500"
        }, {
          "code": "152527",
          "alevel": 3,

          "name": "太仆寺旗",
          "nickname": "",
          "pid": "152500"
        }, {
          "code": "152528",
          "alevel": 3,

          "name": "镶黄旗",
          "nickname": "",
          "pid": "152500"
        }, {
          "code": "152529",
          "alevel": 3,

          "name": "正镶白旗",
          "nickname": "",
          "pid": "152500"
        }, {
          "code": "152530",
          "alevel": 3,

          "name": "正蓝旗",
          "nickname": "",
          "pid": "152500"
        }, {
          "code": "152531",
          "alevel": 3,

          "name": "多伦县",
          "nickname": "",
          "pid": "152500"
        }],
        "name": "锡林郭勒盟",
        "nickname": "",
        "pid": "150000"
      }, {
        "code": "152900",
        "alevel": 2,
        "sub": [{
          "code": "152921",
          "alevel": 3,

          "name": "阿拉善左旗",
          "nickname": "",
          "pid": "152900"
        }, {
          "code": "152922",
          "alevel": 3,

          "name": "阿拉善右旗",
          "nickname": "",
          "pid": "152900"
        }, {
          "code": "152923",
          "alevel": 3,

          "name": "额济纳旗",
          "nickname": "",
          "pid": "152900"
        }],
        "name": "阿拉善盟",
        "nickname": "",
        "pid": "150000"
      }],
      "name": "内蒙古自治区",
      "nickname": "内蒙古",
      "pid": ""
    }, {
      "code": "210000",
      "alevel": 1,
      "sub": [{
        "code": "210100",
        "alevel": 2,
        "sub": [{
          "code": "210101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "210100"
        }, {
          "code": "210102",
          "alevel": 3,

          "name": "和平区",
          "nickname": "",
          "pid": "210100"
        }, {
          "code": "210103",
          "alevel": 3,

          "name": "沈河区",
          "nickname": "",
          "pid": "210100"
        }, {
          "code": "210104",
          "alevel": 3,

          "name": "大东区",
          "nickname": "",
          "pid": "210100"
        }, {
          "code": "210105",
          "alevel": 3,

          "name": "皇姑区",
          "nickname": "",
          "pid": "210100"
        }, {
          "code": "210106",
          "alevel": 3,

          "name": "铁西区",
          "nickname": "",
          "pid": "210100"
        }, {
          "code": "210111",
          "alevel": 3,

          "name": "苏家屯区",
          "nickname": "",
          "pid": "210100"
        }, {
          "code": "210112",
          "alevel": 3,

          "name": "浑南区",
          "nickname": "",
          "pid": "210100"
        }, {
          "code": "210113",
          "alevel": 3,

          "name": "沈北新区",
          "nickname": "",
          "pid": "210100"
        }, {
          "code": "210114",
          "alevel": 3,

          "name": "于洪区",
          "nickname": "",
          "pid": "210100"
        }, {
          "code": "210115",
          "alevel": 3,

          "name": "辽中区",
          "nickname": "",
          "pid": "210100"
        }, {
          "code": "210123",
          "alevel": 3,

          "name": "康平县",
          "nickname": "",
          "pid": "210100"
        }, {
          "code": "210124",
          "alevel": 3,

          "name": "法库县",
          "nickname": "",
          "pid": "210100"
        }, {
          "code": "210181",
          "alevel": 3,

          "name": "新民市",
          "nickname": "",
          "pid": "210100"
        }],
        "name": "沈阳市",
        "nickname": "",
        "pid": "210000"
      }, {
        "code": "210200",
        "alevel": 2,
        "sub": [{
          "code": "210201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "210200"
        }, {
          "code": "210202",
          "alevel": 3,

          "name": "中山区",
          "nickname": "",
          "pid": "210200"
        }, {
          "code": "210203",
          "alevel": 3,

          "name": "西岗区",
          "nickname": "",
          "pid": "210200"
        }, {
          "code": "210204",
          "alevel": 3,

          "name": "沙河口区",
          "nickname": "",
          "pid": "210200"
        }, {
          "code": "210211",
          "alevel": 3,

          "name": "甘井子区",
          "nickname": "",
          "pid": "210200"
        }, {
          "code": "210212",
          "alevel": 3,

          "name": "旅顺口区",
          "nickname": "",
          "pid": "210200"
        }, {
          "code": "210213",
          "alevel": 3,

          "name": "金州区",
          "nickname": "",
          "pid": "210200"
        }, {
          "code": "210214",
          "alevel": 3,

          "name": "普兰店区",
          "nickname": "",
          "pid": "210200"
        }, {
          "code": "210224",
          "alevel": 3,

          "name": "长海县",
          "nickname": "",
          "pid": "210200"
        }, {
          "code": "210281",
          "alevel": 3,

          "name": "瓦房店市",
          "nickname": "",
          "pid": "210200"
        }, {
          "code": "210283",
          "alevel": 3,

          "name": "庄河市",
          "nickname": "",
          "pid": "210200"
        }],
        "name": "大连市",
        "nickname": "",
        "pid": "210000"
      }, {
        "code": "210300",
        "alevel": 2,
        "sub": [{
          "code": "210301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "210300"
        }, {
          "code": "210302",
          "alevel": 3,

          "name": "铁东区",
          "nickname": "",
          "pid": "210300"
        }, {
          "code": "210303",
          "alevel": 3,

          "name": "铁西区",
          "nickname": "",
          "pid": "210300"
        }, {
          "code": "210304",
          "alevel": 3,

          "name": "立山区",
          "nickname": "",
          "pid": "210300"
        }, {
          "code": "210311",
          "alevel": 3,

          "name": "千山区",
          "nickname": "",
          "pid": "210300"
        }, {
          "code": "210321",
          "alevel": 3,

          "name": "台安县",
          "nickname": "",
          "pid": "210300"
        }, {
          "code": "210323",
          "alevel": 3,

          "name": "岫岩满族自治县",
          "nickname": "",
          "pid": "210300"
        }, {
          "code": "210381",
          "alevel": 3,

          "name": "海城市",
          "nickname": "",
          "pid": "210300"
        }],
        "name": "鞍山市",
        "nickname": "",
        "pid": "210000"
      }, {
        "code": "210400",
        "alevel": 2,
        "sub": [{
          "code": "210401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "210400"
        }, {
          "code": "210402",
          "alevel": 3,

          "name": "新抚区",
          "nickname": "",
          "pid": "210400"
        }, {
          "code": "210403",
          "alevel": 3,

          "name": "东洲区",
          "nickname": "",
          "pid": "210400"
        }, {
          "code": "210404",
          "alevel": 3,

          "name": "望花区",
          "nickname": "",
          "pid": "210400"
        }, {
          "code": "210411",
          "alevel": 3,

          "name": "顺城区",
          "nickname": "",
          "pid": "210400"
        }, {
          "code": "210421",
          "alevel": 3,

          "name": "抚顺县",
          "nickname": "",
          "pid": "210400"
        }, {
          "code": "210422",
          "alevel": 3,

          "name": "新宾满族自治县",
          "nickname": "",
          "pid": "210400"
        }, {
          "code": "210423",
          "alevel": 3,

          "name": "清原满族自治县",
          "nickname": "",
          "pid": "210400"
        }],
        "name": "抚顺市",
        "nickname": "",
        "pid": "210000"
      }, {
        "code": "210500",
        "alevel": 2,
        "sub": [{
          "code": "210501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "210500"
        }, {
          "code": "210502",
          "alevel": 3,

          "name": "平山区",
          "nickname": "",
          "pid": "210500"
        }, {
          "code": "210503",
          "alevel": 3,

          "name": "溪湖区",
          "nickname": "",
          "pid": "210500"
        }, {
          "code": "210504",
          "alevel": 3,

          "name": "明山区",
          "nickname": "",
          "pid": "210500"
        }, {
          "code": "210505",
          "alevel": 3,

          "name": "南芬区",
          "nickname": "",
          "pid": "210500"
        }, {
          "code": "210521",
          "alevel": 3,

          "name": "本溪满族自治县",
          "nickname": "",
          "pid": "210500"
        }, {
          "code": "210522",
          "alevel": 3,

          "name": "桓仁满族自治县",
          "nickname": "",
          "pid": "210500"
        }],
        "name": "本溪市",
        "nickname": "",
        "pid": "210000"
      }, {
        "code": "210600",
        "alevel": 2,
        "sub": [{
          "code": "210601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "210600"
        }, {
          "code": "210602",
          "alevel": 3,

          "name": "元宝区",
          "nickname": "",
          "pid": "210600"
        }, {
          "code": "210603",
          "alevel": 3,

          "name": "振兴区",
          "nickname": "",
          "pid": "210600"
        }, {
          "code": "210604",
          "alevel": 3,

          "name": "振安区",
          "nickname": "",
          "pid": "210600"
        }, {
          "code": "210624",
          "alevel": 3,

          "name": "宽甸满族自治县",
          "nickname": "",
          "pid": "210600"
        }, {
          "code": "210681",
          "alevel": 3,

          "name": "东港市",
          "nickname": "",
          "pid": "210600"
        }, {
          "code": "210682",
          "alevel": 3,

          "name": "凤城市",
          "nickname": "",
          "pid": "210600"
        }],
        "name": "丹东市",
        "nickname": "",
        "pid": "210000"
      }, {
        "code": "210700",
        "alevel": 2,
        "sub": [{
          "code": "210701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "210700"
        }, {
          "code": "210702",
          "alevel": 3,

          "name": "古塔区",
          "nickname": "",
          "pid": "210700"
        }, {
          "code": "210703",
          "alevel": 3,

          "name": "凌河区",
          "nickname": "",
          "pid": "210700"
        }, {
          "code": "210711",
          "alevel": 3,

          "name": "太和区",
          "nickname": "",
          "pid": "210700"
        }, {
          "code": "210726",
          "alevel": 3,

          "name": "黑山县",
          "nickname": "",
          "pid": "210700"
        }, {
          "code": "210727",
          "alevel": 3,

          "name": "义县",
          "nickname": "",
          "pid": "210700"
        }, {
          "code": "210781",
          "alevel": 3,

          "name": "凌海市",
          "nickname": "",
          "pid": "210700"
        }, {
          "code": "210782",
          "alevel": 3,

          "name": "北镇市",
          "nickname": "",
          "pid": "210700"
        }],
        "name": "锦州市",
        "nickname": "",
        "pid": "210000"
      }, {
        "code": "210800",
        "alevel": 2,
        "sub": [{
          "code": "210801",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "210800"
        }, {
          "code": "210802",
          "alevel": 3,

          "name": "站前区",
          "nickname": "",
          "pid": "210800"
        }, {
          "code": "210803",
          "alevel": 3,

          "name": "西市区",
          "nickname": "",
          "pid": "210800"
        }, {
          "code": "210804",
          "alevel": 3,

          "name": "鲅鱼圈区",
          "nickname": "",
          "pid": "210800"
        }, {
          "code": "210811",
          "alevel": 3,

          "name": "老边区",
          "nickname": "",
          "pid": "210800"
        }, {
          "code": "210881",
          "alevel": 3,

          "name": "盖州市",
          "nickname": "",
          "pid": "210800"
        }, {
          "code": "210882",
          "alevel": 3,

          "name": "大石桥市",
          "nickname": "",
          "pid": "210800"
        }],
        "name": "营口市",
        "nickname": "",
        "pid": "210000"
      }, {
        "code": "210900",
        "alevel": 2,
        "sub": [{
          "code": "210901",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "210900"
        }, {
          "code": "210902",
          "alevel": 3,

          "name": "海州区",
          "nickname": "",
          "pid": "210900"
        }, {
          "code": "210903",
          "alevel": 3,

          "name": "新邱区",
          "nickname": "",
          "pid": "210900"
        }, {
          "code": "210904",
          "alevel": 3,

          "name": "太平区",
          "nickname": "",
          "pid": "210900"
        }, {
          "code": "210905",
          "alevel": 3,

          "name": "清河门区",
          "nickname": "",
          "pid": "210900"
        }, {
          "code": "210911",
          "alevel": 3,

          "name": "细河区",
          "nickname": "",
          "pid": "210900"
        }, {
          "code": "210921",
          "alevel": 3,

          "name": "阜新蒙古族自治县",
          "nickname": "",
          "pid": "210900"
        }, {
          "code": "210922",
          "alevel": 3,

          "name": "彰武县",
          "nickname": "",
          "pid": "210900"
        }],
        "name": "阜新市",
        "nickname": "",
        "pid": "210000"
      }, {
        "code": "211000",
        "alevel": 2,
        "sub": [{
          "code": "211001",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "211000"
        }, {
          "code": "211002",
          "alevel": 3,

          "name": "白塔区",
          "nickname": "",
          "pid": "211000"
        }, {
          "code": "211003",
          "alevel": 3,

          "name": "文圣区",
          "nickname": "",
          "pid": "211000"
        }, {
          "code": "211004",
          "alevel": 3,

          "name": "宏伟区",
          "nickname": "",
          "pid": "211000"
        }, {
          "code": "211005",
          "alevel": 3,

          "name": "弓长岭区",
          "nickname": "",
          "pid": "211000"
        }, {
          "code": "211011",
          "alevel": 3,

          "name": "太子河区",
          "nickname": "",
          "pid": "211000"
        }, {
          "code": "211021",
          "alevel": 3,

          "name": "辽阳县",
          "nickname": "",
          "pid": "211000"
        }, {
          "code": "211081",
          "alevel": 3,

          "name": "灯塔市",
          "nickname": "",
          "pid": "211000"
        }],
        "name": "辽阳市",
        "nickname": "",
        "pid": "210000"
      }, {
        "code": "211100",
        "alevel": 2,
        "sub": [{
          "code": "211101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "211100"
        }, {
          "code": "211102",
          "alevel": 3,

          "name": "双台子区",
          "nickname": "",
          "pid": "211100"
        }, {
          "code": "211103",
          "alevel": 3,

          "name": "兴隆台区",
          "nickname": "",
          "pid": "211100"
        }, {
          "code": "211104",
          "alevel": 3,

          "name": "大洼区",
          "nickname": "",
          "pid": "211100"
        }, {
          "code": "211122",
          "alevel": 3,

          "name": "盘山县",
          "nickname": "",
          "pid": "211100"
        }],
        "name": "盘锦市",
        "nickname": "",
        "pid": "210000"
      }, {
        "code": "211200",
        "alevel": 2,
        "sub": [{
          "code": "211201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "211200"
        }, {
          "code": "211202",
          "alevel": 3,

          "name": "银州区",
          "nickname": "",
          "pid": "211200"
        }, {
          "code": "211204",
          "alevel": 3,

          "name": "清河区",
          "nickname": "",
          "pid": "211200"
        }, {
          "code": "211221",
          "alevel": 3,

          "name": "铁岭县",
          "nickname": "",
          "pid": "211200"
        }, {
          "code": "211223",
          "alevel": 3,

          "name": "西丰县",
          "nickname": "",
          "pid": "211200"
        }, {
          "code": "211224",
          "alevel": 3,

          "name": "昌图县",
          "nickname": "",
          "pid": "211200"
        }, {
          "code": "211281",
          "alevel": 3,

          "name": "调兵山市",
          "nickname": "",
          "pid": "211200"
        }, {
          "code": "211282",
          "alevel": 3,

          "name": "开原市",
          "nickname": "",
          "pid": "211200"
        }],
        "name": "铁岭市",
        "nickname": "",
        "pid": "210000"
      }, {
        "code": "211300",
        "alevel": 2,
        "sub": [{
          "code": "211301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "211300"
        }, {
          "code": "211302",
          "alevel": 3,

          "name": "双塔区",
          "nickname": "",
          "pid": "211300"
        }, {
          "code": "211303",
          "alevel": 3,

          "name": "龙城区",
          "nickname": "",
          "pid": "211300"
        }, {
          "code": "211321",
          "alevel": 3,

          "name": "朝阳县",
          "nickname": "",
          "pid": "211300"
        }, {
          "code": "211322",
          "alevel": 3,

          "name": "建平县",
          "nickname": "",
          "pid": "211300"
        }, {
          "code": "211324",
          "alevel": 3,

          "name": "喀喇沁左翼蒙古族自治县",
          "nickname": "",
          "pid": "211300"
        }, {
          "code": "211381",
          "alevel": 3,

          "name": "北票市",
          "nickname": "",
          "pid": "211300"
        }, {
          "code": "211382",
          "alevel": 3,

          "name": "凌源市",
          "nickname": "",
          "pid": "211300"
        }],
        "name": "朝阳市",
        "nickname": "",
        "pid": "210000"
      }, {
        "code": "211400",
        "alevel": 2,
        "sub": [{
          "code": "211401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "211400"
        }, {
          "code": "211402",
          "alevel": 3,

          "name": "连山区",
          "nickname": "",
          "pid": "211400"
        }, {
          "code": "211403",
          "alevel": 3,

          "name": "龙港区",
          "nickname": "",
          "pid": "211400"
        }, {
          "code": "211404",
          "alevel": 3,

          "name": "南票区",
          "nickname": "",
          "pid": "211400"
        }, {
          "code": "211421",
          "alevel": 3,

          "name": "绥中县",
          "nickname": "",
          "pid": "211400"
        }, {
          "code": "211422",
          "alevel": 3,

          "name": "建昌县",
          "nickname": "",
          "pid": "211400"
        }, {
          "code": "211481",
          "alevel": 3,

          "name": "兴城市",
          "nickname": "",
          "pid": "211400"
        }],
        "name": "葫芦岛市",
        "nickname": "",
        "pid": "210000"
      }],
      "name": "辽宁省",
      "nickname": "辽",
      "pid": ""
    }, {
      "code": "220000",
      "alevel": 1,
      "sub": [{
        "code": "220100",
        "alevel": 2,
        "sub": [{
          "code": "220101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "220100"
        }, {
          "code": "220102",
          "alevel": 3,

          "name": "南关区",
          "nickname": "",
          "pid": "220100"
        }, {
          "code": "220103",
          "alevel": 3,

          "name": "宽城区",
          "nickname": "",
          "pid": "220100"
        }, {
          "code": "220104",
          "alevel": 3,

          "name": "朝阳区",
          "nickname": "",
          "pid": "220100"
        }, {
          "code": "220105",
          "alevel": 3,

          "name": "二道区",
          "nickname": "",
          "pid": "220100"
        }, {
          "code": "220106",
          "alevel": 3,

          "name": "绿园区",
          "nickname": "",
          "pid": "220100"
        }, {
          "code": "220112",
          "alevel": 3,

          "name": "双阳区",
          "nickname": "",
          "pid": "220100"
        }, {
          "code": "220113",
          "alevel": 3,

          "name": "九台区",
          "nickname": "",
          "pid": "220100"
        }, {
          "code": "220122",
          "alevel": 3,

          "name": "农安县",
          "nickname": "",
          "pid": "220100"
        }, {
          "code": "220182",
          "alevel": 3,

          "name": "榆树市",
          "nickname": "",
          "pid": "220100"
        }, {
          "code": "220183",
          "alevel": 3,

          "name": "德惠市",
          "nickname": "",
          "pid": "220100"
        }],
        "name": "长春市",
        "nickname": "",
        "pid": "220000"
      }, {
        "code": "220200",
        "alevel": 2,
        "sub": [{
          "code": "220201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "220200"
        }, {
          "code": "220202",
          "alevel": 3,

          "name": "昌邑区",
          "nickname": "",
          "pid": "220200"
        }, {
          "code": "220203",
          "alevel": 3,

          "name": "龙潭区",
          "nickname": "",
          "pid": "220200"
        }, {
          "code": "220204",
          "alevel": 3,

          "name": "船营区",
          "nickname": "",
          "pid": "220200"
        }, {
          "code": "220211",
          "alevel": 3,

          "name": "丰满区",
          "nickname": "",
          "pid": "220200"
        }, {
          "code": "220221",
          "alevel": 3,

          "name": "永吉县",
          "nickname": "",
          "pid": "220200"
        }, {
          "code": "220281",
          "alevel": 3,

          "name": "蛟河市",
          "nickname": "",
          "pid": "220200"
        }, {
          "code": "220282",
          "alevel": 3,

          "name": "桦甸市",
          "nickname": "",
          "pid": "220200"
        }, {
          "code": "220283",
          "alevel": 3,

          "name": "舒兰市",
          "nickname": "",
          "pid": "220200"
        }, {
          "code": "220284",
          "alevel": 3,

          "name": "磐石市",
          "nickname": "",
          "pid": "220200"
        }],
        "name": "吉林市",
        "nickname": "",
        "pid": "220000"
      }, {
        "code": "220300",
        "alevel": 2,
        "sub": [{
          "code": "220301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "220300"
        }, {
          "code": "220302",
          "alevel": 3,

          "name": "铁西区",
          "nickname": "",
          "pid": "220300"
        }, {
          "code": "220303",
          "alevel": 3,

          "name": "铁东区",
          "nickname": "",
          "pid": "220300"
        }, {
          "code": "220322",
          "alevel": 3,

          "name": "梨树县",
          "nickname": "",
          "pid": "220300"
        }, {
          "code": "220323",
          "alevel": 3,

          "name": "伊通满族自治县",
          "nickname": "",
          "pid": "220300"
        }, {
          "code": "220381",
          "alevel": 3,

          "name": "公主岭市",
          "nickname": "",
          "pid": "220300"
        }, {
          "code": "220382",
          "alevel": 3,

          "name": "双辽市",
          "nickname": "",
          "pid": "220300"
        }],
        "name": "四平市",
        "nickname": "",
        "pid": "220000"
      }, {
        "code": "220400",
        "alevel": 2,
        "sub": [{
          "code": "220401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "220400"
        }, {
          "code": "220402",
          "alevel": 3,

          "name": "龙山区",
          "nickname": "",
          "pid": "220400"
        }, {
          "code": "220403",
          "alevel": 3,

          "name": "西安区",
          "nickname": "",
          "pid": "220400"
        }, {
          "code": "220421",
          "alevel": 3,

          "name": "东丰县",
          "nickname": "",
          "pid": "220400"
        }, {
          "code": "220422",
          "alevel": 3,

          "name": "东辽县",
          "nickname": "",
          "pid": "220400"
        }],
        "name": "辽源市",
        "nickname": "",
        "pid": "220000"
      }, {
        "code": "220500",
        "alevel": 2,
        "sub": [{
          "code": "220501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "220500"
        }, {
          "code": "220502",
          "alevel": 3,

          "name": "东昌区",
          "nickname": "",
          "pid": "220500"
        }, {
          "code": "220503",
          "alevel": 3,

          "name": "二道江区",
          "nickname": "",
          "pid": "220500"
        }, {
          "code": "220521",
          "alevel": 3,

          "name": "通化县",
          "nickname": "",
          "pid": "220500"
        }, {
          "code": "220523",
          "alevel": 3,

          "name": "辉南县",
          "nickname": "",
          "pid": "220500"
        }, {
          "code": "220524",
          "alevel": 3,

          "name": "柳河县",
          "nickname": "",
          "pid": "220500"
        }, {
          "code": "220581",
          "alevel": 3,

          "name": "梅河口市",
          "nickname": "",
          "pid": "220500"
        }, {
          "code": "220582",
          "alevel": 3,

          "name": "集安市",
          "nickname": "",
          "pid": "220500"
        }],
        "name": "通化市",
        "nickname": "",
        "pid": "220000"
      }, {
        "code": "220600",
        "alevel": 2,
        "sub": [{
          "code": "220601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "220600"
        }, {
          "code": "220602",
          "alevel": 3,

          "name": "浑江区",
          "nickname": "",
          "pid": "220600"
        }, {
          "code": "220605",
          "alevel": 3,

          "name": "江源区",
          "nickname": "",
          "pid": "220600"
        }, {
          "code": "220621",
          "alevel": 3,

          "name": "抚松县",
          "nickname": "",
          "pid": "220600"
        }, {
          "code": "220622",
          "alevel": 3,

          "name": "靖宇县",
          "nickname": "",
          "pid": "220600"
        }, {
          "code": "220623",
          "alevel": 3,

          "name": "长白朝鲜族自治县",
          "nickname": "",
          "pid": "220600"
        }, {
          "code": "220681",
          "alevel": 3,

          "name": "临江市",
          "nickname": "",
          "pid": "220600"
        }],
        "name": "白山市",
        "nickname": "",
        "pid": "220000"
      }, {
        "code": "220700",
        "alevel": 2,
        "sub": [{
          "code": "220701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "220700"
        }, {
          "code": "220702",
          "alevel": 3,

          "name": "宁江区",
          "nickname": "",
          "pid": "220700"
        }, {
          "code": "220721",
          "alevel": 3,

          "name": "前郭尔罗斯蒙古族自治县",
          "nickname": "",
          "pid": "220700"
        }, {
          "code": "220722",
          "alevel": 3,

          "name": "长岭县",
          "nickname": "",
          "pid": "220700"
        }, {
          "code": "220723",
          "alevel": 3,

          "name": "乾安县",
          "nickname": "",
          "pid": "220700"
        }, {
          "code": "220781",
          "alevel": 3,

          "name": "扶余市",
          "nickname": "",
          "pid": "220700"
        }],
        "name": "松原市",
        "nickname": "",
        "pid": "220000"
      }, {
        "code": "220800",
        "alevel": 2,
        "sub": [{
          "code": "220801",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "220800"
        }, {
          "code": "220802",
          "alevel": 3,

          "name": "洮北区",
          "nickname": "",
          "pid": "220800"
        }, {
          "code": "220821",
          "alevel": 3,

          "name": "镇赉县",
          "nickname": "",
          "pid": "220800"
        }, {
          "code": "220822",
          "alevel": 3,

          "name": "通榆县",
          "nickname": "",
          "pid": "220800"
        }, {
          "code": "220881",
          "alevel": 3,

          "name": "洮南市",
          "nickname": "",
          "pid": "220800"
        }, {
          "code": "220882",
          "alevel": 3,

          "name": "大安市",
          "nickname": "",
          "pid": "220800"
        }],
        "name": "白城市",
        "nickname": "",
        "pid": "220000"
      }, {
        "code": "222400",
        "alevel": 2,
        "sub": [{
          "code": "222401",
          "alevel": 3,

          "name": "延吉市",
          "nickname": "",
          "pid": "222400"
        }, {
          "code": "222402",
          "alevel": 3,

          "name": "图们市",
          "nickname": "",
          "pid": "222400"
        }, {
          "code": "222403",
          "alevel": 3,

          "name": "敦化市",
          "nickname": "",
          "pid": "222400"
        }, {
          "code": "222404",
          "alevel": 3,

          "name": "珲春市",
          "nickname": "",
          "pid": "222400"
        }, {
          "code": "222405",
          "alevel": 3,

          "name": "龙井市",
          "nickname": "",
          "pid": "222400"
        }, {
          "code": "222406",
          "alevel": 3,

          "name": "和龙市",
          "nickname": "",
          "pid": "222400"
        }, {
          "code": "222424",
          "alevel": 3,

          "name": "汪清县",
          "nickname": "",
          "pid": "222400"
        }, {
          "code": "222426",
          "alevel": 3,

          "name": "安图县",
          "nickname": "",
          "pid": "222400"
        }],
        "name": "延边朝鲜族自治州",
        "nickname": "",
        "pid": "220000"
      }],
      "name": "吉林省",
      "nickname": "吉",
      "pid": ""
    }, {
      "code": "230000",
      "alevel": 1,
      "sub": [{
        "code": "230100",
        "alevel": 2,
        "sub": [{
          "code": "230101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "230100"
        }, {
          "code": "230102",
          "alevel": 3,

          "name": "道里区",
          "nickname": "",
          "pid": "230100"
        }, {
          "code": "230103",
          "alevel": 3,

          "name": "南岗区",
          "nickname": "",
          "pid": "230100"
        }, {
          "code": "230104",
          "alevel": 3,

          "name": "道外区",
          "nickname": "",
          "pid": "230100"
        }, {
          "code": "230108",
          "alevel": 3,

          "name": "平房区",
          "nickname": "",
          "pid": "230100"
        }, {
          "code": "230109",
          "alevel": 3,

          "name": "松北区",
          "nickname": "",
          "pid": "230100"
        }, {
          "code": "230110",
          "alevel": 3,

          "name": "香坊区",
          "nickname": "",
          "pid": "230100"
        }, {
          "code": "230111",
          "alevel": 3,

          "name": "呼兰区",
          "nickname": "",
          "pid": "230100"
        }, {
          "code": "230112",
          "alevel": 3,

          "name": "阿城区",
          "nickname": "",
          "pid": "230100"
        }, {
          "code": "230113",
          "alevel": 3,

          "name": "双城区",
          "nickname": "",
          "pid": "230100"
        }, {
          "code": "230123",
          "alevel": 3,

          "name": "依兰县",
          "nickname": "",
          "pid": "230100"
        }, {
          "code": "230124",
          "alevel": 3,

          "name": "方正县",
          "nickname": "",
          "pid": "230100"
        }, {
          "code": "230125",
          "alevel": 3,

          "name": "宾县",
          "nickname": "",
          "pid": "230100"
        }, {
          "code": "230126",
          "alevel": 3,

          "name": "巴彦县",
          "nickname": "",
          "pid": "230100"
        }, {
          "code": "230127",
          "alevel": 3,

          "name": "木兰县",
          "nickname": "",
          "pid": "230100"
        }, {
          "code": "230128",
          "alevel": 3,

          "name": "通河县",
          "nickname": "",
          "pid": "230100"
        }, {
          "code": "230129",
          "alevel": 3,

          "name": "延寿县",
          "nickname": "",
          "pid": "230100"
        }, {
          "code": "230183",
          "alevel": 3,

          "name": "尚志市",
          "nickname": "",
          "pid": "230100"
        }, {
          "code": "230184",
          "alevel": 3,

          "name": "五常市",
          "nickname": "",
          "pid": "230100"
        }],
        "name": "哈尔滨市",
        "nickname": "",
        "pid": "230000"
      }, {
        "code": "230200",
        "alevel": 2,
        "sub": [{
          "code": "230201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "230200"
        }, {
          "code": "230202",
          "alevel": 3,

          "name": "龙沙区",
          "nickname": "",
          "pid": "230200"
        }, {
          "code": "230203",
          "alevel": 3,

          "name": "建华区",
          "nickname": "",
          "pid": "230200"
        }, {
          "code": "230204",
          "alevel": 3,

          "name": "铁锋区",
          "nickname": "",
          "pid": "230200"
        }, {
          "code": "230205",
          "alevel": 3,

          "name": "昂昂溪区",
          "nickname": "",
          "pid": "230200"
        }, {
          "code": "230206",
          "alevel": 3,

          "name": "富拉尔基区",
          "nickname": "",
          "pid": "230200"
        }, {
          "code": "230207",
          "alevel": 3,

          "name": "碾子山区",
          "nickname": "",
          "pid": "230200"
        }, {
          "code": "230208",
          "alevel": 3,

          "name": "梅里斯达斡尔族区",
          "nickname": "",
          "pid": "230200"
        }, {
          "code": "230221",
          "alevel": 3,

          "name": "龙江县",
          "nickname": "",
          "pid": "230200"
        }, {
          "code": "230223",
          "alevel": 3,

          "name": "依安县",
          "nickname": "",
          "pid": "230200"
        }, {
          "code": "230224",
          "alevel": 3,

          "name": "泰来县",
          "nickname": "",
          "pid": "230200"
        }, {
          "code": "230225",
          "alevel": 3,

          "name": "甘南县",
          "nickname": "",
          "pid": "230200"
        }, {
          "code": "230227",
          "alevel": 3,

          "name": "富裕县",
          "nickname": "",
          "pid": "230200"
        }, {
          "code": "230229",
          "alevel": 3,

          "name": "克山县",
          "nickname": "",
          "pid": "230200"
        }, {
          "code": "230230",
          "alevel": 3,

          "name": "克东县",
          "nickname": "",
          "pid": "230200"
        }, {
          "code": "230231",
          "alevel": 3,

          "name": "拜泉县",
          "nickname": "",
          "pid": "230200"
        }, {
          "code": "230281",
          "alevel": 3,

          "name": "讷河市",
          "nickname": "",
          "pid": "230200"
        }],
        "name": "齐齐哈尔市",
        "nickname": "",
        "pid": "230000"
      }, {
        "code": "230300",
        "alevel": 2,
        "sub": [{
          "code": "230301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "230300"
        }, {
          "code": "230302",
          "alevel": 3,

          "name": "鸡冠区",
          "nickname": "",
          "pid": "230300"
        }, {
          "code": "230303",
          "alevel": 3,

          "name": "恒山区",
          "nickname": "",
          "pid": "230300"
        }, {
          "code": "230304",
          "alevel": 3,

          "name": "滴道区",
          "nickname": "",
          "pid": "230300"
        }, {
          "code": "230305",
          "alevel": 3,

          "name": "梨树区",
          "nickname": "",
          "pid": "230300"
        }, {
          "code": "230306",
          "alevel": 3,

          "name": "城子河区",
          "nickname": "",
          "pid": "230300"
        }, {
          "code": "230307",
          "alevel": 3,

          "name": "麻山区",
          "nickname": "",
          "pid": "230300"
        }, {
          "code": "230321",
          "alevel": 3,

          "name": "鸡东县",
          "nickname": "",
          "pid": "230300"
        }, {
          "code": "230381",
          "alevel": 3,

          "name": "虎林市",
          "nickname": "",
          "pid": "230300"
        }, {
          "code": "230382",
          "alevel": 3,

          "name": "密山市",
          "nickname": "",
          "pid": "230300"
        }],
        "name": "鸡西市",
        "nickname": "",
        "pid": "230000"
      }, {
        "code": "230400",
        "alevel": 2,
        "sub": [{
          "code": "230401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "230400"
        }, {
          "code": "230402",
          "alevel": 3,

          "name": "向阳区",
          "nickname": "",
          "pid": "230400"
        }, {
          "code": "230403",
          "alevel": 3,

          "name": "工农区",
          "nickname": "",
          "pid": "230400"
        }, {
          "code": "230404",
          "alevel": 3,

          "name": "南山区",
          "nickname": "",
          "pid": "230400"
        }, {
          "code": "230405",
          "alevel": 3,

          "name": "兴安区",
          "nickname": "",
          "pid": "230400"
        }, {
          "code": "230406",
          "alevel": 3,

          "name": "东山区",
          "nickname": "",
          "pid": "230400"
        }, {
          "code": "230407",
          "alevel": 3,

          "name": "兴山区",
          "nickname": "",
          "pid": "230400"
        }, {
          "code": "230421",
          "alevel": 3,

          "name": "萝北县",
          "nickname": "",
          "pid": "230400"
        }, {
          "code": "230422",
          "alevel": 3,

          "name": "绥滨县",
          "nickname": "",
          "pid": "230400"
        }],
        "name": "鹤岗市",
        "nickname": "",
        "pid": "230000"
      }, {
        "code": "230500",
        "alevel": 2,
        "sub": [{
          "code": "230501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "230500"
        }, {
          "code": "230502",
          "alevel": 3,

          "name": "尖山区",
          "nickname": "",
          "pid": "230500"
        }, {
          "code": "230503",
          "alevel": 3,

          "name": "岭东区",
          "nickname": "",
          "pid": "230500"
        }, {
          "code": "230505",
          "alevel": 3,

          "name": "四方台区",
          "nickname": "",
          "pid": "230500"
        }, {
          "code": "230506",
          "alevel": 3,

          "name": "宝山区",
          "nickname": "",
          "pid": "230500"
        }, {
          "code": "230521",
          "alevel": 3,

          "name": "集贤县",
          "nickname": "",
          "pid": "230500"
        }, {
          "code": "230522",
          "alevel": 3,

          "name": "友谊县",
          "nickname": "",
          "pid": "230500"
        }, {
          "code": "230523",
          "alevel": 3,

          "name": "宝清县",
          "nickname": "",
          "pid": "230500"
        }, {
          "code": "230524",
          "alevel": 3,

          "name": "饶河县",
          "nickname": "",
          "pid": "230500"
        }],
        "name": "双鸭山市",
        "nickname": "",
        "pid": "230000"
      }, {
        "code": "230600",
        "alevel": 2,
        "sub": [{
          "code": "230601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "230600"
        }, {
          "code": "230602",
          "alevel": 3,

          "name": "萨尔图区",
          "nickname": "",
          "pid": "230600"
        }, {
          "code": "230603",
          "alevel": 3,

          "name": "龙凤区",
          "nickname": "",
          "pid": "230600"
        }, {
          "code": "230604",
          "alevel": 3,

          "name": "让胡路区",
          "nickname": "",
          "pid": "230600"
        }, {
          "code": "230605",
          "alevel": 3,

          "name": "红岗区",
          "nickname": "",
          "pid": "230600"
        }, {
          "code": "230606",
          "alevel": 3,

          "name": "大同区",
          "nickname": "",
          "pid": "230600"
        }, {
          "code": "230621",
          "alevel": 3,

          "name": "肇州县",
          "nickname": "",
          "pid": "230600"
        }, {
          "code": "230622",
          "alevel": 3,

          "name": "肇源县",
          "nickname": "",
          "pid": "230600"
        }, {
          "code": "230623",
          "alevel": 3,

          "name": "林甸县",
          "nickname": "",
          "pid": "230600"
        }, {
          "code": "230624",
          "alevel": 3,

          "name": "杜尔伯特蒙古族自治县",
          "nickname": "",
          "pid": "230600"
        }],
        "name": "大庆市",
        "nickname": "",
        "pid": "230000"
      }, {
        "code": "230700",
        "alevel": 2,
        "sub": [{
          "code": "230701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "230700"
        }, {
          "code": "230702",
          "alevel": 3,

          "name": "伊春区",
          "nickname": "",
          "pid": "230700"
        }, {
          "code": "230703",
          "alevel": 3,

          "name": "南岔区",
          "nickname": "",
          "pid": "230700"
        }, {
          "code": "230704",
          "alevel": 3,

          "name": "友好区",
          "nickname": "",
          "pid": "230700"
        }, {
          "code": "230705",
          "alevel": 3,

          "name": "西林区",
          "nickname": "",
          "pid": "230700"
        }, {
          "code": "230706",
          "alevel": 3,

          "name": "翠峦区",
          "nickname": "",
          "pid": "230700"
        }, {
          "code": "230707",
          "alevel": 3,

          "name": "新青区",
          "nickname": "",
          "pid": "230700"
        }, {
          "code": "230708",
          "alevel": 3,

          "name": "美溪区",
          "nickname": "",
          "pid": "230700"
        }, {
          "code": "230709",
          "alevel": 3,

          "name": "金山屯区",
          "nickname": "",
          "pid": "230700"
        }, {
          "code": "230710",
          "alevel": 3,

          "name": "五营区",
          "nickname": "",
          "pid": "230700"
        }, {
          "code": "230711",
          "alevel": 3,

          "name": "乌马河区",
          "nickname": "",
          "pid": "230700"
        }, {
          "code": "230712",
          "alevel": 3,

          "name": "汤旺河区",
          "nickname": "",
          "pid": "230700"
        }, {
          "code": "230713",
          "alevel": 3,

          "name": "带岭区",
          "nickname": "",
          "pid": "230700"
        }, {
          "code": "230714",
          "alevel": 3,

          "name": "乌伊岭区",
          "nickname": "",
          "pid": "230700"
        }, {
          "code": "230715",
          "alevel": 3,

          "name": "红星区",
          "nickname": "",
          "pid": "230700"
        }, {
          "code": "230716",
          "alevel": 3,

          "name": "上甘岭区",
          "nickname": "",
          "pid": "230700"
        }, {
          "code": "230717",
          "alevel": 3,

          "name": "伊美区",
          "nickname": "",
          "pid": "230700"
        }, {
          "code": "230718",
          "alevel": 3,

          "name": "乌翠区",
          "nickname": "",
          "pid": "230700"
        }, {
          "code": "230722",
          "alevel": 3,

          "name": "嘉荫县",
          "nickname": "",
          "pid": "230700"
        }, {
          "code": "230723",
          "alevel": 3,

          "name": "汤旺县",
          "nickname": "",
          "pid": "230700"
        }, {
          "code": "230724",
          "alevel": 3,

          "name": "丰林县",
          "nickname": "",
          "pid": "230700"
        }, {
          "code": "230725",
          "alevel": 3,

          "name": "大箐山县",
          "nickname": "",
          "pid": "230700"
        }, {
          "code": "230726",
          "alevel": 3,

          "name": "南岔县",
          "nickname": "",
          "pid": "230700"
        }, {
          "code": "230751",
          "alevel": 3,

          "name": "金林区",
          "nickname": "",
          "pid": "230700"
        }, {
          "code": "230781",
          "alevel": 3,

          "name": "铁力市",
          "nickname": "",
          "pid": "230700"
        }],
        "name": "伊春市",
        "nickname": "",
        "pid": "230000"
      }, {
        "code": "230800",
        "alevel": 2,
        "sub": [{
          "code": "230801",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "230800"
        }, {
          "code": "230803",
          "alevel": 3,

          "name": "向阳区",
          "nickname": "",
          "pid": "230800"
        }, {
          "code": "230804",
          "alevel": 3,

          "name": "前进区",
          "nickname": "",
          "pid": "230800"
        }, {
          "code": "230805",
          "alevel": 3,

          "name": "东风区",
          "nickname": "",
          "pid": "230800"
        }, {
          "code": "230811",
          "alevel": 3,

          "name": "郊区",
          "nickname": "",
          "pid": "230800"
        }, {
          "code": "230822",
          "alevel": 3,

          "name": "桦南县",
          "nickname": "",
          "pid": "230800"
        }, {
          "code": "230826",
          "alevel": 3,

          "name": "桦川县",
          "nickname": "",
          "pid": "230800"
        }, {
          "code": "230828",
          "alevel": 3,

          "name": "汤原县",
          "nickname": "",
          "pid": "230800"
        }, {
          "code": "230881",
          "alevel": 3,

          "name": "同江市",
          "nickname": "",
          "pid": "230800"
        }, {
          "code": "230882",
          "alevel": 3,

          "name": "富锦市",
          "nickname": "",
          "pid": "230800"
        }, {
          "code": "230883",
          "alevel": 3,

          "name": "抚远市",
          "nickname": "",
          "pid": "230800"
        }],
        "name": "佳木斯市",
        "nickname": "",
        "pid": "230000"
      }, {
        "code": "230900",
        "alevel": 2,
        "sub": [{
          "code": "230901",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "230900"
        }, {
          "code": "230902",
          "alevel": 3,

          "name": "新兴区",
          "nickname": "",
          "pid": "230900"
        }, {
          "code": "230903",
          "alevel": 3,

          "name": "桃山区",
          "nickname": "",
          "pid": "230900"
        }, {
          "code": "230904",
          "alevel": 3,

          "name": "茄子河区",
          "nickname": "",
          "pid": "230900"
        }, {
          "code": "230921",
          "alevel": 3,

          "name": "勃利县",
          "nickname": "",
          "pid": "230900"
        }],
        "name": "七台河市",
        "nickname": "",
        "pid": "230000"
      }, {
        "code": "231000",
        "alevel": 2,
        "sub": [{
          "code": "231001",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "231000"
        }, {
          "code": "231002",
          "alevel": 3,

          "name": "东安区",
          "nickname": "",
          "pid": "231000"
        }, {
          "code": "231003",
          "alevel": 3,

          "name": "阳明区",
          "nickname": "",
          "pid": "231000"
        }, {
          "code": "231004",
          "alevel": 3,

          "name": "爱民区",
          "nickname": "",
          "pid": "231000"
        }, {
          "code": "231005",
          "alevel": 3,

          "name": "西安区",
          "nickname": "",
          "pid": "231000"
        }, {
          "code": "231025",
          "alevel": 3,

          "name": "林口县",
          "nickname": "",
          "pid": "231000"
        }, {
          "code": "231081",
          "alevel": 3,

          "name": "绥芬河市",
          "nickname": "",
          "pid": "231000"
        }, {
          "code": "231083",
          "alevel": 3,

          "name": "海林市",
          "nickname": "",
          "pid": "231000"
        }, {
          "code": "231084",
          "alevel": 3,

          "name": "宁安市",
          "nickname": "",
          "pid": "231000"
        }, {
          "code": "231085",
          "alevel": 3,

          "name": "穆棱市",
          "nickname": "",
          "pid": "231000"
        }, {
          "code": "231086",
          "alevel": 3,

          "name": "东宁市",
          "nickname": "",
          "pid": "231000"
        }],
        "name": "牡丹江市",
        "nickname": "",
        "pid": "230000"
      }, {
        "code": "231100",
        "alevel": 2,
        "sub": [{
          "code": "231101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "231100"
        }, {
          "code": "231102",
          "alevel": 3,

          "name": "爱辉区",
          "nickname": "",
          "pid": "231100"
        }, {
          "code": "231121",
          "alevel": 3,

          "name": "嫩江县",
          "nickname": "",
          "pid": "231100"
        }, {
          "code": "231123",
          "alevel": 3,

          "name": "逊克县",
          "nickname": "",
          "pid": "231100"
        }, {
          "code": "231124",
          "alevel": 3,

          "name": "孙吴县",
          "nickname": "",
          "pid": "231100"
        }, {
          "code": "231181",
          "alevel": 3,

          "name": "北安市",
          "nickname": "",
          "pid": "231100"
        }, {
          "code": "231182",
          "alevel": 3,

          "name": "五大连池市",
          "nickname": "",
          "pid": "231100"
        }, {
          "code": "231183",
          "alevel": 3,

          "name": "嫩江市",
          "nickname": "",
          "pid": "231100"
        }],
        "name": "黑河市",
        "nickname": "",
        "pid": "230000"
      }, {
        "code": "231200",
        "alevel": 2,
        "sub": [{
          "code": "231201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "231200"
        }, {
          "code": "231202",
          "alevel": 3,

          "name": "北林区",
          "nickname": "",
          "pid": "231200"
        }, {
          "code": "231221",
          "alevel": 3,

          "name": "望奎县",
          "nickname": "",
          "pid": "231200"
        }, {
          "code": "231222",
          "alevel": 3,

          "name": "兰西县",
          "nickname": "",
          "pid": "231200"
        }, {
          "code": "231223",
          "alevel": 3,

          "name": "青冈县",
          "nickname": "",
          "pid": "231200"
        }, {
          "code": "231224",
          "alevel": 3,

          "name": "庆安县",
          "nickname": "",
          "pid": "231200"
        }, {
          "code": "231225",
          "alevel": 3,

          "name": "明水县",
          "nickname": "",
          "pid": "231200"
        }, {
          "code": "231226",
          "alevel": 3,

          "name": "绥棱县",
          "nickname": "",
          "pid": "231200"
        }, {
          "code": "231281",
          "alevel": 3,

          "name": "安达市",
          "nickname": "",
          "pid": "231200"
        }, {
          "code": "231282",
          "alevel": 3,

          "name": "肇东市",
          "nickname": "",
          "pid": "231200"
        }, {
          "code": "231283",
          "alevel": 3,

          "name": "海伦市",
          "nickname": "",
          "pid": "231200"
        }],
        "name": "绥化市",
        "nickname": "",
        "pid": "230000"
      }, {
        "code": "232700",
        "alevel": 2,
        "sub": [{
          "code": "232701",
          "alevel": 3,

          "name": "漠河市",
          "nickname": "",
          "pid": "232700"
        }, {
          "code": "232721",
          "alevel": 3,

          "name": "呼玛县",
          "nickname": "",
          "pid": "232700"
        }, {
          "code": "232722",
          "alevel": 3,

          "name": "塔河县",
          "nickname": "",
          "pid": "232700"
        }, {
          "code": "232723",
          "alevel": 3,

          "name": "漠河县",
          "nickname": "",
          "pid": "232700"
        }],
        "name": "大兴安岭地区",
        "nickname": "",
        "pid": "230000"
      }],
      "name": "黑龙江省",
      "nickname": "黑",
      "pid": ""
    }, {
      "code": "310000",
      "alevel": 1,
      "sub": [{
        "code": "310100",
        "alevel": 2,
        "sub": [{
          "code": "310101",
          "alevel": 3,

          "name": "黄浦区",
          "nickname": "",
          "pid": "310100"
        }, {
          "code": "310104",
          "alevel": 3,

          "name": "徐汇区",
          "nickname": "",
          "pid": "310100"
        }, {
          "code": "310105",
          "alevel": 3,

          "name": "长宁区",
          "nickname": "",
          "pid": "310100"
        }, {
          "code": "310106",
          "alevel": 3,

          "name": "静安区",
          "nickname": "",
          "pid": "310100"
        }, {
          "code": "310107",
          "alevel": 3,

          "name": "普陀区",
          "nickname": "",
          "pid": "310100"
        }, {
          "code": "310109",
          "alevel": 3,

          "name": "虹口区",
          "nickname": "",
          "pid": "310100"
        }, {
          "code": "310110",
          "alevel": 3,

          "name": "杨浦区",
          "nickname": "",
          "pid": "310100"
        }, {
          "code": "310112",
          "alevel": 3,

          "name": "闵行区",
          "nickname": "",
          "pid": "310100"
        }, {
          "code": "310113",
          "alevel": 3,

          "name": "宝山区",
          "nickname": "",
          "pid": "310100"
        }, {
          "code": "310114",
          "alevel": 3,

          "name": "嘉定区",
          "nickname": "",
          "pid": "310100"
        }, {
          "code": "310115",
          "alevel": 3,

          "name": "浦东新区",
          "nickname": "",
          "pid": "310100"
        }, {
          "code": "310116",
          "alevel": 3,

          "name": "金山区",
          "nickname": "",
          "pid": "310100"
        }, {
          "code": "310117",
          "alevel": 3,

          "name": "松江区",
          "nickname": "",
          "pid": "310100"
        }, {
          "code": "310118",
          "alevel": 3,

          "name": "青浦区",
          "nickname": "",
          "pid": "310100"
        }, {
          "code": "310120",
          "alevel": 3,

          "name": "奉贤区",
          "nickname": "",
          "pid": "310100"
        }, {
          "code": "310151",
          "alevel": 3,

          "name": "崇明区",
          "nickname": "",
          "pid": "310100"
        }],
        "name": "上海市",
        "nickname": "",
        "pid": "310000"
      }],
      "name": "上海市",
      "nickname": "沪",
      "pid": ""
    }, {
      "code": "320000",
      "alevel": 1,
      "sub": [{
        "code": "320100",
        "alevel": 2,
        "sub": [{
          "code": "320101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "320100"
        }, {
          "code": "320102",
          "alevel": 3,

          "name": "玄武区",
          "nickname": "",
          "pid": "320100"
        }, {
          "code": "320104",
          "alevel": 3,

          "name": "秦淮区",
          "nickname": "",
          "pid": "320100"
        }, {
          "code": "320105",
          "alevel": 3,

          "name": "建邺区",
          "nickname": "",
          "pid": "320100"
        }, {
          "code": "320106",
          "alevel": 3,

          "name": "鼓楼区",
          "nickname": "",
          "pid": "320100"
        }, {
          "code": "320111",
          "alevel": 3,

          "name": "浦口区",
          "nickname": "",
          "pid": "320100"
        }, {
          "code": "320113",
          "alevel": 3,

          "name": "栖霞区",
          "nickname": "",
          "pid": "320100"
        }, {
          "code": "320114",
          "alevel": 3,

          "name": "雨花台区",
          "nickname": "",
          "pid": "320100"
        }, {
          "code": "320115",
          "alevel": 3,

          "name": "江宁区",
          "nickname": "",
          "pid": "320100"
        }, {
          "code": "320116",
          "alevel": 3,

          "name": "六合区",
          "nickname": "",
          "pid": "320100"
        }, {
          "code": "320117",
          "alevel": 3,

          "name": "溧水区",
          "nickname": "",
          "pid": "320100"
        }, {
          "code": "320118",
          "alevel": 3,

          "name": "高淳区",
          "nickname": "",
          "pid": "320100"
        }],
        "name": "南京市",
        "nickname": "",
        "pid": "320000"
      }, {
        "code": "320200",
        "alevel": 2,
        "sub": [{
          "code": "320201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "320200"
        }, {
          "code": "320205",
          "alevel": 3,

          "name": "锡山区",
          "nickname": "",
          "pid": "320200"
        }, {
          "code": "320206",
          "alevel": 3,

          "name": "惠山区",
          "nickname": "",
          "pid": "320200"
        }, {
          "code": "320211",
          "alevel": 3,

          "name": "滨湖区",
          "nickname": "",
          "pid": "320200"
        }, {
          "code": "320213",
          "alevel": 3,

          "name": "梁溪区",
          "nickname": "",
          "pid": "320200"
        }, {
          "code": "320214",
          "alevel": 3,

          "name": "新吴区",
          "nickname": "",
          "pid": "320200"
        }, {
          "code": "320281",
          "alevel": 3,

          "name": "江阴市",
          "nickname": "",
          "pid": "320200"
        }, {
          "code": "320282",
          "alevel": 3,

          "name": "宜兴市",
          "nickname": "",
          "pid": "320200"
        }],
        "name": "无锡市",
        "nickname": "",
        "pid": "320000"
      }, {
        "code": "320300",
        "alevel": 2,
        "sub": [{
          "code": "320301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "320300"
        }, {
          "code": "320302",
          "alevel": 3,

          "name": "鼓楼区",
          "nickname": "",
          "pid": "320300"
        }, {
          "code": "320303",
          "alevel": 3,

          "name": "云龙区",
          "nickname": "",
          "pid": "320300"
        }, {
          "code": "320305",
          "alevel": 3,

          "name": "贾汪区",
          "nickname": "",
          "pid": "320300"
        }, {
          "code": "320311",
          "alevel": 3,

          "name": "泉山区",
          "nickname": "",
          "pid": "320300"
        }, {
          "code": "320312",
          "alevel": 3,

          "name": "铜山区",
          "nickname": "",
          "pid": "320300"
        }, {
          "code": "320321",
          "alevel": 3,

          "name": "丰县",
          "nickname": "",
          "pid": "320300"
        }, {
          "code": "320322",
          "alevel": 3,

          "name": "沛县",
          "nickname": "",
          "pid": "320300"
        }, {
          "code": "320324",
          "alevel": 3,

          "name": "睢宁县",
          "nickname": "",
          "pid": "320300"
        }, {
          "code": "320381",
          "alevel": 3,

          "name": "新沂市",
          "nickname": "",
          "pid": "320300"
        }, {
          "code": "320382",
          "alevel": 3,

          "name": "邳州市",
          "nickname": "",
          "pid": "320300"
        }],
        "name": "徐州市",
        "nickname": "",
        "pid": "320000"
      }, {
        "code": "320400",
        "alevel": 2,
        "sub": [{
          "code": "320401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "320400"
        }, {
          "code": "320402",
          "alevel": 3,

          "name": "天宁区",
          "nickname": "",
          "pid": "320400"
        }, {
          "code": "320404",
          "alevel": 3,

          "name": "钟楼区",
          "nickname": "",
          "pid": "320400"
        }, {
          "code": "320411",
          "alevel": 3,

          "name": "新北区",
          "nickname": "",
          "pid": "320400"
        }, {
          "code": "320412",
          "alevel": 3,

          "name": "武进区",
          "nickname": "",
          "pid": "320400"
        }, {
          "code": "320413",
          "alevel": 3,

          "name": "金坛区",
          "nickname": "",
          "pid": "320400"
        }, {
          "code": "320481",
          "alevel": 3,

          "name": "溧阳市",
          "nickname": "",
          "pid": "320400"
        }],
        "name": "常州市",
        "nickname": "",
        "pid": "320000"
      }, {
        "code": "320500",
        "alevel": 2,
        "sub": [{
          "code": "320501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "320500"
        }, {
          "code": "320505",
          "alevel": 3,

          "name": "虎丘区",
          "nickname": "",
          "pid": "320500"
        }, {
          "code": "320506",
          "alevel": 3,

          "name": "吴中区",
          "nickname": "",
          "pid": "320500"
        }, {
          "code": "320507",
          "alevel": 3,

          "name": "相城区",
          "nickname": "",
          "pid": "320500"
        }, {
          "code": "320508",
          "alevel": 3,

          "name": "姑苏区",
          "nickname": "",
          "pid": "320500"
        }, {
          "code": "320509",
          "alevel": 3,

          "name": "吴江区",
          "nickname": "",
          "pid": "320500"
        }, {
          "code": "320581",
          "alevel": 3,

          "name": "常熟市",
          "nickname": "",
          "pid": "320500"
        }, {
          "code": "320582",
          "alevel": 3,

          "name": "张家港市",
          "nickname": "",
          "pid": "320500"
        }, {
          "code": "320583",
          "alevel": 3,

          "name": "昆山市",
          "nickname": "",
          "pid": "320500"
        }, {
          "code": "320585",
          "alevel": 3,

          "name": "太仓市",
          "nickname": "",
          "pid": "320500"
        }],
        "name": "苏州市",
        "nickname": "",
        "pid": "320000"
      }, {
        "code": "320600",
        "alevel": 2,
        "sub": [{
          "code": "320601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "320600"
        }, {
          "code": "320602",
          "alevel": 3,

          "name": "崇川区",
          "nickname": "",
          "pid": "320600"
        }, {
          "code": "320611",
          "alevel": 3,

          "name": "港闸区",
          "nickname": "",
          "pid": "320600"
        }, {
          "code": "320612",
          "alevel": 3,

          "name": "通州区",
          "nickname": "",
          "pid": "320600"
        }, {
          "code": "320621",
          "alevel": 3,

          "name": "海安县",
          "nickname": "",
          "pid": "320600"
        }, {
          "code": "320623",
          "alevel": 3,

          "name": "如东县",
          "nickname": "",
          "pid": "320600"
        }, {
          "code": "320681",
          "alevel": 3,

          "name": "启东市",
          "nickname": "",
          "pid": "320600"
        }, {
          "code": "320682",
          "alevel": 3,

          "name": "如皋市",
          "nickname": "",
          "pid": "320600"
        }, {
          "code": "320684",
          "alevel": 3,

          "name": "海门市",
          "nickname": "",
          "pid": "320600"
        }, {
          "code": "320685",
          "alevel": 3,

          "name": "海安市",
          "nickname": "",
          "pid": "320600"
        }],
        "name": "南通市",
        "nickname": "",
        "pid": "320000"
      }, {
        "code": "320700",
        "alevel": 2,
        "sub": [{
          "code": "320701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "320700"
        }, {
          "code": "320703",
          "alevel": 3,

          "name": "连云区",
          "nickname": "",
          "pid": "320700"
        }, {
          "code": "320706",
          "alevel": 3,

          "name": "海州区",
          "nickname": "",
          "pid": "320700"
        }, {
          "code": "320707",
          "alevel": 3,

          "name": "赣榆区",
          "nickname": "",
          "pid": "320700"
        }, {
          "code": "320722",
          "alevel": 3,

          "name": "东海县",
          "nickname": "",
          "pid": "320700"
        }, {
          "code": "320723",
          "alevel": 3,

          "name": "灌云县",
          "nickname": "",
          "pid": "320700"
        }, {
          "code": "320724",
          "alevel": 3,

          "name": "灌南县",
          "nickname": "",
          "pid": "320700"
        }],
        "name": "连云港市",
        "nickname": "",
        "pid": "320000"
      }, {
        "code": "320800",
        "alevel": 2,
        "sub": [{
          "code": "320801",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "320800"
        }, {
          "code": "320803",
          "alevel": 3,

          "name": "淮安区",
          "nickname": "",
          "pid": "320800"
        }, {
          "code": "320804",
          "alevel": 3,

          "name": "淮阴区",
          "nickname": "",
          "pid": "320800"
        }, {
          "code": "320812",
          "alevel": 3,

          "name": "清江浦区",
          "nickname": "",
          "pid": "320800"
        }, {
          "code": "320813",
          "alevel": 3,

          "name": "洪泽区",
          "nickname": "",
          "pid": "320800"
        }, {
          "code": "320826",
          "alevel": 3,

          "name": "涟水县",
          "nickname": "",
          "pid": "320800"
        }, {
          "code": "320830",
          "alevel": 3,

          "name": "盱眙县",
          "nickname": "",
          "pid": "320800"
        }, {
          "code": "320831",
          "alevel": 3,

          "name": "金湖县",
          "nickname": "",
          "pid": "320800"
        }],
        "name": "淮安市",
        "nickname": "",
        "pid": "320000"
      }, {
        "code": "320900",
        "alevel": 2,
        "sub": [{
          "code": "320901",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "320900"
        }, {
          "code": "320902",
          "alevel": 3,

          "name": "亭湖区",
          "nickname": "",
          "pid": "320900"
        }, {
          "code": "320903",
          "alevel": 3,

          "name": "盐都区",
          "nickname": "",
          "pid": "320900"
        }, {
          "code": "320904",
          "alevel": 3,

          "name": "大丰区",
          "nickname": "",
          "pid": "320900"
        }, {
          "code": "320921",
          "alevel": 3,

          "name": "响水县",
          "nickname": "",
          "pid": "320900"
        }, {
          "code": "320922",
          "alevel": 3,

          "name": "滨海县",
          "nickname": "",
          "pid": "320900"
        }, {
          "code": "320923",
          "alevel": 3,

          "name": "阜宁县",
          "nickname": "",
          "pid": "320900"
        }, {
          "code": "320924",
          "alevel": 3,

          "name": "射阳县",
          "nickname": "",
          "pid": "320900"
        }, {
          "code": "320925",
          "alevel": 3,

          "name": "建湖县",
          "nickname": "",
          "pid": "320900"
        }, {
          "code": "320981",
          "alevel": 3,

          "name": "东台市",
          "nickname": "",
          "pid": "320900"
        }],
        "name": "盐城市",
        "nickname": "",
        "pid": "320000"
      }, {
        "code": "321000",
        "alevel": 2,
        "sub": [{
          "code": "321001",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "321000"
        }, {
          "code": "321002",
          "alevel": 3,

          "name": "广陵区",
          "nickname": "",
          "pid": "321000"
        }, {
          "code": "321003",
          "alevel": 3,

          "name": "邗江区",
          "nickname": "",
          "pid": "321000"
        }, {
          "code": "321012",
          "alevel": 3,

          "name": "江都区",
          "nickname": "",
          "pid": "321000"
        }, {
          "code": "321023",
          "alevel": 3,

          "name": "宝应县",
          "nickname": "",
          "pid": "321000"
        }, {
          "code": "321081",
          "alevel": 3,

          "name": "仪征市",
          "nickname": "",
          "pid": "321000"
        }, {
          "code": "321084",
          "alevel": 3,

          "name": "高邮市",
          "nickname": "",
          "pid": "321000"
        }],
        "name": "扬州市",
        "nickname": "",
        "pid": "320000"
      }, {
        "code": "321100",
        "alevel": 2,
        "sub": [{
          "code": "321101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "321100"
        }, {
          "code": "321102",
          "alevel": 3,

          "name": "京口区",
          "nickname": "",
          "pid": "321100"
        }, {
          "code": "321111",
          "alevel": 3,

          "name": "润州区",
          "nickname": "",
          "pid": "321100"
        }, {
          "code": "321112",
          "alevel": 3,

          "name": "丹徒区",
          "nickname": "",
          "pid": "321100"
        }, {
          "code": "321181",
          "alevel": 3,

          "name": "丹阳市",
          "nickname": "",
          "pid": "321100"
        }, {
          "code": "321182",
          "alevel": 3,

          "name": "扬中市",
          "nickname": "",
          "pid": "321100"
        }, {
          "code": "321183",
          "alevel": 3,

          "name": "句容市",
          "nickname": "",
          "pid": "321100"
        }],
        "name": "镇江市",
        "nickname": "",
        "pid": "320000"
      }, {
        "code": "321200",
        "alevel": 2,
        "sub": [{
          "code": "321201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "321200"
        }, {
          "code": "321202",
          "alevel": 3,

          "name": "海陵区",
          "nickname": "",
          "pid": "321200"
        }, {
          "code": "321203",
          "alevel": 3,

          "name": "高港区",
          "nickname": "",
          "pid": "321200"
        }, {
          "code": "321204",
          "alevel": 3,

          "name": "姜堰区",
          "nickname": "",
          "pid": "321200"
        }, {
          "code": "321281",
          "alevel": 3,

          "name": "兴化市",
          "nickname": "",
          "pid": "321200"
        }, {
          "code": "321282",
          "alevel": 3,

          "name": "靖江市",
          "nickname": "",
          "pid": "321200"
        }, {
          "code": "321283",
          "alevel": 3,

          "name": "泰兴市",
          "nickname": "",
          "pid": "321200"
        }],
        "name": "泰州市",
        "nickname": "",
        "pid": "320000"
      }, {
        "code": "321300",
        "alevel": 2,
        "sub": [{
          "code": "321301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "321300"
        }, {
          "code": "321302",
          "alevel": 3,

          "name": "宿城区",
          "nickname": "",
          "pid": "321300"
        }, {
          "code": "321311",
          "alevel": 3,

          "name": "宿豫区",
          "nickname": "",
          "pid": "321300"
        }, {
          "code": "321322",
          "alevel": 3,

          "name": "沭阳县",
          "nickname": "",
          "pid": "321300"
        }, {
          "code": "321323",
          "alevel": 3,

          "name": "泗阳县",
          "nickname": "",
          "pid": "321300"
        }, {
          "code": "321324",
          "alevel": 3,

          "name": "泗洪县",
          "nickname": "",
          "pid": "321300"
        }],
        "name": "宿迁市",
        "nickname": "",
        "pid": "320000"
      }],
      "name": "江苏省",
      "nickname": "苏",
      "pid": ""
    }, {
      "code": "330000",
      "alevel": 1,
      "sub": [{
        "code": "330100",
        "alevel": 2,
        "sub": [{
          "code": "330101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "330100"
        }, {
          "code": "330102",
          "alevel": 3,

          "name": "上城区",
          "nickname": "",
          "pid": "330100"
        }, {
          "code": "330103",
          "alevel": 3,

          "name": "下城区",
          "nickname": "",
          "pid": "330100"
        }, {
          "code": "330104",
          "alevel": 3,

          "name": "江干区",
          "nickname": "",
          "pid": "330100"
        }, {
          "code": "330105",
          "alevel": 3,

          "name": "拱墅区",
          "nickname": "",
          "pid": "330100"
        }, {
          "code": "330106",
          "alevel": 3,

          "name": "西湖区",
          "nickname": "",
          "pid": "330100"
        }, {
          "code": "330108",
          "alevel": 3,

          "name": "滨江区",
          "nickname": "",
          "pid": "330100"
        }, {
          "code": "330109",
          "alevel": 3,

          "name": "萧山区",
          "nickname": "",
          "pid": "330100"
        }, {
          "code": "330110",
          "alevel": 3,

          "name": "余杭区",
          "nickname": "",
          "pid": "330100"
        }, {
          "code": "330111",
          "alevel": 3,

          "name": "富阳区",
          "nickname": "",
          "pid": "330100"
        }, {
          "code": "330112",
          "alevel": 3,

          "name": "临安区",
          "nickname": "",
          "pid": "330100"
        }, {
          "code": "330122",
          "alevel": 3,

          "name": "桐庐县",
          "nickname": "",
          "pid": "330100"
        }, {
          "code": "330127",
          "alevel": 3,

          "name": "淳安县",
          "nickname": "",
          "pid": "330100"
        }, {
          "code": "330182",
          "alevel": 3,

          "name": "建德市",
          "nickname": "",
          "pid": "330100"
        }, {
          "code": "330185",
          "alevel": 3,

          "name": "临安市",
          "nickname": "",
          "pid": "330100"
        }],
        "name": "杭州市",
        "nickname": "",
        "pid": "330000"
      }, {
        "code": "330200",
        "alevel": 2,
        "sub": [{
          "code": "330201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "330200"
        }, {
          "code": "330203",
          "alevel": 3,

          "name": "海曙区",
          "nickname": "",
          "pid": "330200"
        }, {
          "code": "330204",
          "alevel": 3,

          "name": "江东区",
          "nickname": "",
          "pid": "330200"
        }, {
          "code": "330205",
          "alevel": 3,

          "name": "江北区",
          "nickname": "",
          "pid": "330200"
        }, {
          "code": "330206",
          "alevel": 3,

          "name": "北仑区",
          "nickname": "",
          "pid": "330200"
        }, {
          "code": "330211",
          "alevel": 3,

          "name": "镇海区",
          "nickname": "",
          "pid": "330200"
        }, {
          "code": "330212",
          "alevel": 3,

          "name": "鄞州区",
          "nickname": "",
          "pid": "330200"
        }, {
          "code": "330213",
          "alevel": 3,

          "name": "奉化区",
          "nickname": "",
          "pid": "330200"
        }, {
          "code": "330225",
          "alevel": 3,

          "name": "象山县",
          "nickname": "",
          "pid": "330200"
        }, {
          "code": "330226",
          "alevel": 3,

          "name": "宁海县",
          "nickname": "",
          "pid": "330200"
        }, {
          "code": "330281",
          "alevel": 3,

          "name": "余姚市",
          "nickname": "",
          "pid": "330200"
        }, {
          "code": "330282",
          "alevel": 3,

          "name": "慈溪市",
          "nickname": "",
          "pid": "330200"
        }, {
          "code": "330283",
          "alevel": 3,

          "name": "奉化市",
          "nickname": "",
          "pid": "330200"
        }],
        "name": "宁波市",
        "nickname": "",
        "pid": "330000"
      }, {
        "code": "330300",
        "alevel": 2,
        "sub": [{
          "code": "330301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "330300"
        }, {
          "code": "330302",
          "alevel": 3,

          "name": "鹿城区",
          "nickname": "",
          "pid": "330300"
        }, {
          "code": "330303",
          "alevel": 3,

          "name": "龙湾区",
          "nickname": "",
          "pid": "330300"
        }, {
          "code": "330304",
          "alevel": 3,

          "name": "瓯海区",
          "nickname": "",
          "pid": "330300"
        }, {
          "code": "330305",
          "alevel": 3,

          "name": "洞头区",
          "nickname": "",
          "pid": "330300"
        }, {
          "code": "330324",
          "alevel": 3,

          "name": "永嘉县",
          "nickname": "",
          "pid": "330300"
        }, {
          "code": "330326",
          "alevel": 3,

          "name": "平阳县",
          "nickname": "",
          "pid": "330300"
        }, {
          "code": "330327",
          "alevel": 3,

          "name": "苍南县",
          "nickname": "",
          "pid": "330300"
        }, {
          "code": "330328",
          "alevel": 3,

          "name": "文成县",
          "nickname": "",
          "pid": "330300"
        }, {
          "code": "330329",
          "alevel": 3,

          "name": "泰顺县",
          "nickname": "",
          "pid": "330300"
        }, {
          "code": "330381",
          "alevel": 3,

          "name": "瑞安市",
          "nickname": "",
          "pid": "330300"
        }, {
          "code": "330382",
          "alevel": 3,

          "name": "乐清市",
          "nickname": "",
          "pid": "330300"
        }, {
          "code": "330383",
          "alevel": 3,

          "name": "龙港市",
          "nickname": "",
          "pid": "330300"
        }],
        "name": "温州市",
        "nickname": "",
        "pid": "330000"
      }, {
        "code": "330400",
        "alevel": 2,
        "sub": [{
          "code": "330401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "330400"
        }, {
          "code": "330402",
          "alevel": 3,

          "name": "南湖区",
          "nickname": "",
          "pid": "330400"
        }, {
          "code": "330411",
          "alevel": 3,

          "name": "秀洲区",
          "nickname": "",
          "pid": "330400"
        }, {
          "code": "330421",
          "alevel": 3,

          "name": "嘉善县",
          "nickname": "",
          "pid": "330400"
        }, {
          "code": "330424",
          "alevel": 3,

          "name": "海盐县",
          "nickname": "",
          "pid": "330400"
        }, {
          "code": "330481",
          "alevel": 3,

          "name": "海宁市",
          "nickname": "",
          "pid": "330400"
        }, {
          "code": "330482",
          "alevel": 3,

          "name": "平湖市",
          "nickname": "",
          "pid": "330400"
        }, {
          "code": "330483",
          "alevel": 3,

          "name": "桐乡市",
          "nickname": "",
          "pid": "330400"
        }],
        "name": "嘉兴市",
        "nickname": "",
        "pid": "330000"
      }, {
        "code": "330500",
        "alevel": 2,
        "sub": [{
          "code": "330501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "330500"
        }, {
          "code": "330502",
          "alevel": 3,

          "name": "吴兴区",
          "nickname": "",
          "pid": "330500"
        }, {
          "code": "330503",
          "alevel": 3,

          "name": "南浔区",
          "nickname": "",
          "pid": "330500"
        }, {
          "code": "330521",
          "alevel": 3,

          "name": "德清县",
          "nickname": "",
          "pid": "330500"
        }, {
          "code": "330522",
          "alevel": 3,

          "name": "长兴县",
          "nickname": "",
          "pid": "330500"
        }, {
          "code": "330523",
          "alevel": 3,

          "name": "安吉县",
          "nickname": "",
          "pid": "330500"
        }],
        "name": "湖州市",
        "nickname": "",
        "pid": "330000"
      }, {
        "code": "330600",
        "alevel": 2,
        "sub": [{
          "code": "330601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "330600"
        }, {
          "code": "330602",
          "alevel": 3,

          "name": "越城区",
          "nickname": "",
          "pid": "330600"
        }, {
          "code": "330603",
          "alevel": 3,

          "name": "柯桥区",
          "nickname": "",
          "pid": "330600"
        }, {
          "code": "330604",
          "alevel": 3,

          "name": "上虞区",
          "nickname": "",
          "pid": "330600"
        }, {
          "code": "330624",
          "alevel": 3,

          "name": "新昌县",
          "nickname": "",
          "pid": "330600"
        }, {
          "code": "330681",
          "alevel": 3,

          "name": "诸暨市",
          "nickname": "",
          "pid": "330600"
        }, {
          "code": "330683",
          "alevel": 3,

          "name": "嵊州市",
          "nickname": "",
          "pid": "330600"
        }],
        "name": "绍兴市",
        "nickname": "",
        "pid": "330000"
      }, {
        "code": "330700",
        "alevel": 2,
        "sub": [{
          "code": "330701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "330700"
        }, {
          "code": "330702",
          "alevel": 3,

          "name": "婺城区",
          "nickname": "",
          "pid": "330700"
        }, {
          "code": "330703",
          "alevel": 3,

          "name": "金东区",
          "nickname": "",
          "pid": "330700"
        }, {
          "code": "330723",
          "alevel": 3,

          "name": "武义县",
          "nickname": "",
          "pid": "330700"
        }, {
          "code": "330726",
          "alevel": 3,

          "name": "浦江县",
          "nickname": "",
          "pid": "330700"
        }, {
          "code": "330727",
          "alevel": 3,

          "name": "磐安县",
          "nickname": "",
          "pid": "330700"
        }, {
          "code": "330781",
          "alevel": 3,

          "name": "兰溪市",
          "nickname": "",
          "pid": "330700"
        }, {
          "code": "330782",
          "alevel": 3,

          "name": "义乌市",
          "nickname": "",
          "pid": "330700"
        }, {
          "code": "330783",
          "alevel": 3,

          "name": "东阳市",
          "nickname": "",
          "pid": "330700"
        }, {
          "code": "330784",
          "alevel": 3,

          "name": "永康市",
          "nickname": "",
          "pid": "330700"
        }],
        "name": "金华市",
        "nickname": "",
        "pid": "330000"
      }, {
        "code": "330800",
        "alevel": 2,
        "sub": [{
          "code": "330801",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "330800"
        }, {
          "code": "330802",
          "alevel": 3,

          "name": "柯城区",
          "nickname": "",
          "pid": "330800"
        }, {
          "code": "330803",
          "alevel": 3,

          "name": "衢江区",
          "nickname": "",
          "pid": "330800"
        }, {
          "code": "330822",
          "alevel": 3,

          "name": "常山县",
          "nickname": "",
          "pid": "330800"
        }, {
          "code": "330824",
          "alevel": 3,

          "name": "开化县",
          "nickname": "",
          "pid": "330800"
        }, {
          "code": "330825",
          "alevel": 3,

          "name": "龙游县",
          "nickname": "",
          "pid": "330800"
        }, {
          "code": "330881",
          "alevel": 3,

          "name": "江山市",
          "nickname": "",
          "pid": "330800"
        }],
        "name": "衢州市",
        "nickname": "",
        "pid": "330000"
      }, {
        "code": "330900",
        "alevel": 2,
        "sub": [{
          "code": "330901",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "330900"
        }, {
          "code": "330902",
          "alevel": 3,

          "name": "定海区",
          "nickname": "",
          "pid": "330900"
        }, {
          "code": "330903",
          "alevel": 3,

          "name": "普陀区",
          "nickname": "",
          "pid": "330900"
        }, {
          "code": "330921",
          "alevel": 3,

          "name": "岱山县",
          "nickname": "",
          "pid": "330900"
        }, {
          "code": "330922",
          "alevel": 3,

          "name": "嵊泗县",
          "nickname": "",
          "pid": "330900"
        }],
        "name": "舟山市",
        "nickname": "",
        "pid": "330000"
      }, {
        "code": "331000",
        "alevel": 2,
        "sub": [{
          "code": "331001",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "331000"
        }, {
          "code": "331002",
          "alevel": 3,

          "name": "椒江区",
          "nickname": "",
          "pid": "331000"
        }, {
          "code": "331003",
          "alevel": 3,

          "name": "黄岩区",
          "nickname": "",
          "pid": "331000"
        }, {
          "code": "331004",
          "alevel": 3,

          "name": "路桥区",
          "nickname": "",
          "pid": "331000"
        }, {
          "code": "331021",
          "alevel": 3,

          "name": "玉环县",
          "nickname": "",
          "pid": "331000"
        }, {
          "code": "331022",
          "alevel": 3,

          "name": "三门县",
          "nickname": "",
          "pid": "331000"
        }, {
          "code": "331023",
          "alevel": 3,

          "name": "天台县",
          "nickname": "",
          "pid": "331000"
        }, {
          "code": "331024",
          "alevel": 3,

          "name": "仙居县",
          "nickname": "",
          "pid": "331000"
        }, {
          "code": "331081",
          "alevel": 3,

          "name": "温岭市",
          "nickname": "",
          "pid": "331000"
        }, {
          "code": "331082",
          "alevel": 3,

          "name": "临海市",
          "nickname": "",
          "pid": "331000"
        }, {
          "code": "331083",
          "alevel": 3,

          "name": "玉环市",
          "nickname": "",
          "pid": "331000"
        }],
        "name": "台州市",
        "nickname": "",
        "pid": "330000"
      }, {
        "code": "331100",
        "alevel": 2,
        "sub": [{
          "code": "331101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "331100"
        }, {
          "code": "331102",
          "alevel": 3,

          "name": "莲都区",
          "nickname": "",
          "pid": "331100"
        }, {
          "code": "331121",
          "alevel": 3,

          "name": "青田县",
          "nickname": "",
          "pid": "331100"
        }, {
          "code": "331122",
          "alevel": 3,

          "name": "缙云县",
          "nickname": "",
          "pid": "331100"
        }, {
          "code": "331123",
          "alevel": 3,

          "name": "遂昌县",
          "nickname": "",
          "pid": "331100"
        }, {
          "code": "331124",
          "alevel": 3,

          "name": "松阳县",
          "nickname": "",
          "pid": "331100"
        }, {
          "code": "331125",
          "alevel": 3,

          "name": "云和县",
          "nickname": "",
          "pid": "331100"
        }, {
          "code": "331126",
          "alevel": 3,

          "name": "庆元县",
          "nickname": "",
          "pid": "331100"
        }, {
          "code": "331127",
          "alevel": 3,

          "name": "景宁畲族自治县",
          "nickname": "",
          "pid": "331100"
        }, {
          "code": "331181",
          "alevel": 3,

          "name": "龙泉市",
          "nickname": "",
          "pid": "331100"
        }],
        "name": "丽水市",
        "nickname": "",
        "pid": "330000"
      }],
      "name": "浙江省",
      "nickname": "浙",
      "pid": ""
    }, {
      "code": "340000",
      "alevel": 1,
      "sub": [{
        "code": "340100",
        "alevel": 2,
        "sub": [{
          "code": "340101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "340100"
        }, {
          "code": "340102",
          "alevel": 3,

          "name": "瑶海区",
          "nickname": "",
          "pid": "340100"
        }, {
          "code": "340103",
          "alevel": 3,

          "name": "庐阳区",
          "nickname": "",
          "pid": "340100"
        }, {
          "code": "340104",
          "alevel": 3,

          "name": "蜀山区",
          "nickname": "",
          "pid": "340100"
        }, {
          "code": "340111",
          "alevel": 3,

          "name": "包河区",
          "nickname": "",
          "pid": "340100"
        }, {
          "code": "340121",
          "alevel": 3,

          "name": "长丰县",
          "nickname": "",
          "pid": "340100"
        }, {
          "code": "340122",
          "alevel": 3,

          "name": "肥东县",
          "nickname": "",
          "pid": "340100"
        }, {
          "code": "340123",
          "alevel": 3,

          "name": "肥西县",
          "nickname": "",
          "pid": "340100"
        }, {
          "code": "340124",
          "alevel": 3,

          "name": "庐江县",
          "nickname": "",
          "pid": "340100"
        }, {
          "code": "340181",
          "alevel": 3,

          "name": "巢湖市",
          "nickname": "",
          "pid": "340100"
        }],
        "name": "合肥市",
        "nickname": "",
        "pid": "340000"
      }, {
        "code": "340200",
        "alevel": 2,
        "sub": [{
          "code": "340201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "340200"
        }, {
          "code": "340202",
          "alevel": 3,

          "name": "镜湖区",
          "nickname": "",
          "pid": "340200"
        }, {
          "code": "340203",
          "alevel": 3,

          "name": "弋江区",
          "nickname": "",
          "pid": "340200"
        }, {
          "code": "340207",
          "alevel": 3,

          "name": "鸠江区",
          "nickname": "",
          "pid": "340200"
        }, {
          "code": "340208",
          "alevel": 3,

          "name": "三山区",
          "nickname": "",
          "pid": "340200"
        }, {
          "code": "340221",
          "alevel": 3,

          "name": "芜湖县",
          "nickname": "",
          "pid": "340200"
        }, {
          "code": "340222",
          "alevel": 3,

          "name": "繁昌县",
          "nickname": "",
          "pid": "340200"
        }, {
          "code": "340223",
          "alevel": 3,

          "name": "南陵县",
          "nickname": "",
          "pid": "340200"
        }, {
          "code": "340225",
          "alevel": 3,

          "name": "无为县",
          "nickname": "",
          "pid": "340200"
        }, {
          "code": "340281",
          "alevel": 3,

          "name": "无为市",
          "nickname": "",
          "pid": "340200"
        }],
        "name": "芜湖市",
        "nickname": "",
        "pid": "340000"
      }, {
        "code": "340300",
        "alevel": 2,
        "sub": [{
          "code": "340301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "340300"
        }, {
          "code": "340302",
          "alevel": 3,

          "name": "龙子湖区",
          "nickname": "",
          "pid": "340300"
        }, {
          "code": "340303",
          "alevel": 3,

          "name": "蚌山区",
          "nickname": "",
          "pid": "340300"
        }, {
          "code": "340304",
          "alevel": 3,

          "name": "禹会区",
          "nickname": "",
          "pid": "340300"
        }, {
          "code": "340311",
          "alevel": 3,

          "name": "淮上区",
          "nickname": "",
          "pid": "340300"
        }, {
          "code": "340321",
          "alevel": 3,

          "name": "怀远县",
          "nickname": "",
          "pid": "340300"
        }, {
          "code": "340322",
          "alevel": 3,

          "name": "五河县",
          "nickname": "",
          "pid": "340300"
        }, {
          "code": "340323",
          "alevel": 3,

          "name": "固镇县",
          "nickname": "",
          "pid": "340300"
        }],
        "name": "蚌埠市",
        "nickname": "",
        "pid": "340000"
      }, {
        "code": "340400",
        "alevel": 2,
        "sub": [{
          "code": "340401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "340400"
        }, {
          "code": "340402",
          "alevel": 3,

          "name": "大通区",
          "nickname": "",
          "pid": "340400"
        }, {
          "code": "340403",
          "alevel": 3,

          "name": "田家庵区",
          "nickname": "",
          "pid": "340400"
        }, {
          "code": "340404",
          "alevel": 3,

          "name": "谢家集区",
          "nickname": "",
          "pid": "340400"
        }, {
          "code": "340405",
          "alevel": 3,

          "name": "八公山区",
          "nickname": "",
          "pid": "340400"
        }, {
          "code": "340406",
          "alevel": 3,

          "name": "潘集区",
          "nickname": "",
          "pid": "340400"
        }, {
          "code": "340421",
          "alevel": 3,

          "name": "凤台县",
          "nickname": "",
          "pid": "340400"
        }, {
          "code": "340422",
          "alevel": 3,

          "name": "寿县",
          "nickname": "",
          "pid": "340400"
        }],
        "name": "淮南市",
        "nickname": "",
        "pid": "340000"
      }, {
        "code": "340500",
        "alevel": 2,
        "sub": [{
          "code": "340501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "340500"
        }, {
          "code": "340503",
          "alevel": 3,

          "name": "花山区",
          "nickname": "",
          "pid": "340500"
        }, {
          "code": "340504",
          "alevel": 3,

          "name": "雨山区",
          "nickname": "",
          "pid": "340500"
        }, {
          "code": "340506",
          "alevel": 3,

          "name": "博望区",
          "nickname": "",
          "pid": "340500"
        }, {
          "code": "340521",
          "alevel": 3,

          "name": "当涂县",
          "nickname": "",
          "pid": "340500"
        }, {
          "code": "340522",
          "alevel": 3,

          "name": "含山县",
          "nickname": "",
          "pid": "340500"
        }, {
          "code": "340523",
          "alevel": 3,

          "name": "和县",
          "nickname": "",
          "pid": "340500"
        }],
        "name": "马鞍山市",
        "nickname": "",
        "pid": "340000"
      }, {
        "code": "340600",
        "alevel": 2,
        "sub": [{
          "code": "340601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "340600"
        }, {
          "code": "340602",
          "alevel": 3,

          "name": "杜集区",
          "nickname": "",
          "pid": "340600"
        }, {
          "code": "340603",
          "alevel": 3,

          "name": "相山区",
          "nickname": "",
          "pid": "340600"
        }, {
          "code": "340604",
          "alevel": 3,

          "name": "烈山区",
          "nickname": "",
          "pid": "340600"
        }, {
          "code": "340621",
          "alevel": 3,

          "name": "濉溪县",
          "nickname": "",
          "pid": "340600"
        }],
        "name": "淮北市",
        "nickname": "",
        "pid": "340000"
      }, {
        "code": "340700",
        "alevel": 2,
        "sub": [{
          "code": "340701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "340700"
        }, {
          "code": "340705",
          "alevel": 3,

          "name": "铜官区",
          "nickname": "",
          "pid": "340700"
        }, {
          "code": "340706",
          "alevel": 3,

          "name": "义安区",
          "nickname": "",
          "pid": "340700"
        }, {
          "code": "340711",
          "alevel": 3,

          "name": "郊区",
          "nickname": "",
          "pid": "340700"
        }, {
          "code": "340722",
          "alevel": 3,

          "name": "枞阳县",
          "nickname": "",
          "pid": "340700"
        }],
        "name": "铜陵市",
        "nickname": "",
        "pid": "340000"
      }, {
        "code": "340800",
        "alevel": 2,
        "sub": [{
          "code": "340801",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "340800"
        }, {
          "code": "340802",
          "alevel": 3,

          "name": "迎江区",
          "nickname": "",
          "pid": "340800"
        }, {
          "code": "340803",
          "alevel": 3,

          "name": "大观区",
          "nickname": "",
          "pid": "340800"
        }, {
          "code": "340811",
          "alevel": 3,

          "name": "宜秀区",
          "nickname": "",
          "pid": "340800"
        }, {
          "code": "340822",
          "alevel": 3,

          "name": "怀宁县",
          "nickname": "",
          "pid": "340800"
        }, {
          "code": "340824",
          "alevel": 3,

          "name": "潜山县",
          "nickname": "",
          "pid": "340800"
        }, {
          "code": "340825",
          "alevel": 3,

          "name": "太湖县",
          "nickname": "",
          "pid": "340800"
        }, {
          "code": "340826",
          "alevel": 3,

          "name": "宿松县",
          "nickname": "",
          "pid": "340800"
        }, {
          "code": "340827",
          "alevel": 3,

          "name": "望江县",
          "nickname": "",
          "pid": "340800"
        }, {
          "code": "340828",
          "alevel": 3,

          "name": "岳西县",
          "nickname": "",
          "pid": "340800"
        }, {
          "code": "340881",
          "alevel": 3,

          "name": "桐城市",
          "nickname": "",
          "pid": "340800"
        }, {
          "code": "340882",
          "alevel": 3,

          "name": "潜山市",
          "nickname": "",
          "pid": "340800"
        }],
        "name": "安庆市",
        "nickname": "",
        "pid": "340000"
      }, {
        "code": "341000",
        "alevel": 2,
        "sub": [{
          "code": "341001",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "341000"
        }, {
          "code": "341002",
          "alevel": 3,

          "name": "屯溪区",
          "nickname": "",
          "pid": "341000"
        }, {
          "code": "341003",
          "alevel": 3,

          "name": "黄山区",
          "nickname": "",
          "pid": "341000"
        }, {
          "code": "341004",
          "alevel": 3,

          "name": "徽州区",
          "nickname": "",
          "pid": "341000"
        }, {
          "code": "341021",
          "alevel": 3,

          "name": "歙县",
          "nickname": "",
          "pid": "341000"
        }, {
          "code": "341022",
          "alevel": 3,

          "name": "休宁县",
          "nickname": "",
          "pid": "341000"
        }, {
          "code": "341023",
          "alevel": 3,

          "name": "黟县",
          "nickname": "",
          "pid": "341000"
        }, {
          "code": "341024",
          "alevel": 3,

          "name": "祁门县",
          "nickname": "",
          "pid": "341000"
        }],
        "name": "黄山市",
        "nickname": "",
        "pid": "340000"
      }, {
        "code": "341100",
        "alevel": 2,
        "sub": [{
          "code": "341101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "341100"
        }, {
          "code": "341102",
          "alevel": 3,

          "name": "琅琊区",
          "nickname": "",
          "pid": "341100"
        }, {
          "code": "341103",
          "alevel": 3,

          "name": "南谯区",
          "nickname": "",
          "pid": "341100"
        }, {
          "code": "341122",
          "alevel": 3,

          "name": "来安县",
          "nickname": "",
          "pid": "341100"
        }, {
          "code": "341124",
          "alevel": 3,

          "name": "全椒县",
          "nickname": "",
          "pid": "341100"
        }, {
          "code": "341125",
          "alevel": 3,

          "name": "定远县",
          "nickname": "",
          "pid": "341100"
        }, {
          "code": "341126",
          "alevel": 3,

          "name": "凤阳县",
          "nickname": "",
          "pid": "341100"
        }, {
          "code": "341181",
          "alevel": 3,

          "name": "天长市",
          "nickname": "",
          "pid": "341100"
        }, {
          "code": "341182",
          "alevel": 3,

          "name": "明光市",
          "nickname": "",
          "pid": "341100"
        }],
        "name": "滁州市",
        "nickname": "",
        "pid": "340000"
      }, {
        "code": "341200",
        "alevel": 2,
        "sub": [{
          "code": "341201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "341200"
        }, {
          "code": "341202",
          "alevel": 3,

          "name": "颍州区",
          "nickname": "",
          "pid": "341200"
        }, {
          "code": "341203",
          "alevel": 3,

          "name": "颍东区",
          "nickname": "",
          "pid": "341200"
        }, {
          "code": "341204",
          "alevel": 3,

          "name": "颍泉区",
          "nickname": "",
          "pid": "341200"
        }, {
          "code": "341221",
          "alevel": 3,

          "name": "临泉县",
          "nickname": "",
          "pid": "341200"
        }, {
          "code": "341222",
          "alevel": 3,

          "name": "太和县",
          "nickname": "",
          "pid": "341200"
        }, {
          "code": "341225",
          "alevel": 3,

          "name": "阜南县",
          "nickname": "",
          "pid": "341200"
        }, {
          "code": "341226",
          "alevel": 3,

          "name": "颍上县",
          "nickname": "",
          "pid": "341200"
        }, {
          "code": "341282",
          "alevel": 3,

          "name": "界首市",
          "nickname": "",
          "pid": "341200"
        }],
        "name": "阜阳市",
        "nickname": "",
        "pid": "340000"
      }, {
        "code": "341300",
        "alevel": 2,
        "sub": [{
          "code": "341301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "341300"
        }, {
          "code": "341302",
          "alevel": 3,

          "name": "埇桥区",
          "nickname": "",
          "pid": "341300"
        }, {
          "code": "341321",
          "alevel": 3,

          "name": "砀山县",
          "nickname": "",
          "pid": "341300"
        }, {
          "code": "341322",
          "alevel": 3,

          "name": "萧县",
          "nickname": "",
          "pid": "341300"
        }, {
          "code": "341323",
          "alevel": 3,

          "name": "灵璧县",
          "nickname": "",
          "pid": "341300"
        }, {
          "code": "341324",
          "alevel": 3,

          "name": "泗县",
          "nickname": "",
          "pid": "341300"
        }],
        "name": "宿州市",
        "nickname": "",
        "pid": "340000"
      }, {
        "code": "341500",
        "alevel": 2,
        "sub": [{
          "code": "341501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "341500"
        }, {
          "code": "341502",
          "alevel": 3,

          "name": "金安区",
          "nickname": "",
          "pid": "341500"
        }, {
          "code": "341503",
          "alevel": 3,

          "name": "裕安区",
          "nickname": "",
          "pid": "341500"
        }, {
          "code": "341504",
          "alevel": 3,

          "name": "叶集区",
          "nickname": "",
          "pid": "341500"
        }, {
          "code": "341522",
          "alevel": 3,

          "name": "霍邱县",
          "nickname": "",
          "pid": "341500"
        }, {
          "code": "341523",
          "alevel": 3,

          "name": "舒城县",
          "nickname": "",
          "pid": "341500"
        }, {
          "code": "341524",
          "alevel": 3,

          "name": "金寨县",
          "nickname": "",
          "pid": "341500"
        }, {
          "code": "341525",
          "alevel": 3,

          "name": "霍山县",
          "nickname": "",
          "pid": "341500"
        }],
        "name": "六安市",
        "nickname": "",
        "pid": "340000"
      }, {
        "code": "341600",
        "alevel": 2,
        "sub": [{
          "code": "341601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "341600"
        }, {
          "code": "341602",
          "alevel": 3,

          "name": "谯城区",
          "nickname": "",
          "pid": "341600"
        }, {
          "code": "341621",
          "alevel": 3,

          "name": "涡阳县",
          "nickname": "",
          "pid": "341600"
        }, {
          "code": "341622",
          "alevel": 3,

          "name": "蒙城县",
          "nickname": "",
          "pid": "341600"
        }, {
          "code": "341623",
          "alevel": 3,

          "name": "利辛县",
          "nickname": "",
          "pid": "341600"
        }],
        "name": "亳州市",
        "nickname": "",
        "pid": "340000"
      }, {
        "code": "341700",
        "alevel": 2,
        "sub": [{
          "code": "341701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "341700"
        }, {
          "code": "341702",
          "alevel": 3,

          "name": "贵池区",
          "nickname": "",
          "pid": "341700"
        }, {
          "code": "341721",
          "alevel": 3,

          "name": "东至县",
          "nickname": "",
          "pid": "341700"
        }, {
          "code": "341722",
          "alevel": 3,

          "name": "石台县",
          "nickname": "",
          "pid": "341700"
        }, {
          "code": "341723",
          "alevel": 3,

          "name": "青阳县",
          "nickname": "",
          "pid": "341700"
        }],
        "name": "池州市",
        "nickname": "",
        "pid": "340000"
      }, {
        "code": "341800",
        "alevel": 2,
        "sub": [{
          "code": "341801",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "341800"
        }, {
          "code": "341802",
          "alevel": 3,

          "name": "宣州区",
          "nickname": "",
          "pid": "341800"
        }, {
          "code": "341821",
          "alevel": 3,

          "name": "郎溪县",
          "nickname": "",
          "pid": "341800"
        }, {
          "code": "341822",
          "alevel": 3,

          "name": "广德县",
          "nickname": "",
          "pid": "341800"
        }, {
          "code": "341823",
          "alevel": 3,

          "name": "泾县",
          "nickname": "",
          "pid": "341800"
        }, {
          "code": "341824",
          "alevel": 3,

          "name": "绩溪县",
          "nickname": "",
          "pid": "341800"
        }, {
          "code": "341825",
          "alevel": 3,

          "name": "旌德县",
          "nickname": "",
          "pid": "341800"
        }, {
          "code": "341881",
          "alevel": 3,

          "name": "宁国市",
          "nickname": "",
          "pid": "341800"
        }, {
          "code": "341882",
          "alevel": 3,

          "name": "广德市",
          "nickname": "",
          "pid": "341800"
        }],
        "name": "宣城市",
        "nickname": "",
        "pid": "340000"
      }],
      "name": "安徽省",
      "nickname": "皖",
      "pid": ""
    }, {
      "code": "350000",
      "alevel": 1,
      "sub": [{
        "code": "350100",
        "alevel": 2,
        "sub": [{
          "code": "350101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "350100"
        }, {
          "code": "350102",
          "alevel": 3,

          "name": "鼓楼区",
          "nickname": "",
          "pid": "350100"
        }, {
          "code": "350103",
          "alevel": 3,

          "name": "台江区",
          "nickname": "",
          "pid": "350100"
        }, {
          "code": "350104",
          "alevel": 3,

          "name": "仓山区",
          "nickname": "",
          "pid": "350100"
        }, {
          "code": "350105",
          "alevel": 3,

          "name": "马尾区",
          "nickname": "",
          "pid": "350100"
        }, {
          "code": "350111",
          "alevel": 3,

          "name": "晋安区",
          "nickname": "",
          "pid": "350100"
        }, {
          "code": "350112",
          "alevel": 3,

          "name": "长乐区",
          "nickname": "",
          "pid": "350100"
        }, {
          "code": "350121",
          "alevel": 3,

          "name": "闽侯县",
          "nickname": "",
          "pid": "350100"
        }, {
          "code": "350122",
          "alevel": 3,

          "name": "连江县",
          "nickname": "",
          "pid": "350100"
        }, {
          "code": "350123",
          "alevel": 3,

          "name": "罗源县",
          "nickname": "",
          "pid": "350100"
        }, {
          "code": "350124",
          "alevel": 3,

          "name": "闽清县",
          "nickname": "",
          "pid": "350100"
        }, {
          "code": "350125",
          "alevel": 3,

          "name": "永泰县",
          "nickname": "",
          "pid": "350100"
        }, {
          "code": "350128",
          "alevel": 3,

          "name": "平潭县",
          "nickname": "",
          "pid": "350100"
        }, {
          "code": "350181",
          "alevel": 3,

          "name": "福清市",
          "nickname": "",
          "pid": "350100"
        }, {
          "code": "350182",
          "alevel": 3,

          "name": "长乐市",
          "nickname": "",
          "pid": "350100"
        }],
        "name": "福州市",
        "nickname": "",
        "pid": "350000"
      }, {
        "code": "350200",
        "alevel": 2,
        "sub": [{
          "code": "350201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "350200"
        }, {
          "code": "350203",
          "alevel": 3,

          "name": "思明区",
          "nickname": "",
          "pid": "350200"
        }, {
          "code": "350205",
          "alevel": 3,

          "name": "海沧区",
          "nickname": "",
          "pid": "350200"
        }, {
          "code": "350206",
          "alevel": 3,

          "name": "湖里区",
          "nickname": "",
          "pid": "350200"
        }, {
          "code": "350211",
          "alevel": 3,

          "name": "集美区",
          "nickname": "",
          "pid": "350200"
        }, {
          "code": "350212",
          "alevel": 3,

          "name": "同安区",
          "nickname": "",
          "pid": "350200"
        }, {
          "code": "350213",
          "alevel": 3,

          "name": "翔安区",
          "nickname": "",
          "pid": "350200"
        }],
        "name": "厦门市",
        "nickname": "",
        "pid": "350000"
      }, {
        "code": "350300",
        "alevel": 2,
        "sub": [{
          "code": "350301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "350300"
        }, {
          "code": "350302",
          "alevel": 3,

          "name": "城厢区",
          "nickname": "",
          "pid": "350300"
        }, {
          "code": "350303",
          "alevel": 3,

          "name": "涵江区",
          "nickname": "",
          "pid": "350300"
        }, {
          "code": "350304",
          "alevel": 3,

          "name": "荔城区",
          "nickname": "",
          "pid": "350300"
        }, {
          "code": "350305",
          "alevel": 3,

          "name": "秀屿区",
          "nickname": "",
          "pid": "350300"
        }, {
          "code": "350322",
          "alevel": 3,

          "name": "仙游县",
          "nickname": "",
          "pid": "350300"
        }],
        "name": "莆田市",
        "nickname": "",
        "pid": "350000"
      }, {
        "code": "350400",
        "alevel": 2,
        "sub": [{
          "code": "350401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "350400"
        }, {
          "code": "350402",
          "alevel": 3,

          "name": "梅列区",
          "nickname": "",
          "pid": "350400"
        }, {
          "code": "350403",
          "alevel": 3,

          "name": "三元区",
          "nickname": "",
          "pid": "350400"
        }, {
          "code": "350421",
          "alevel": 3,

          "name": "明溪县",
          "nickname": "",
          "pid": "350400"
        }, {
          "code": "350423",
          "alevel": 3,

          "name": "清流县",
          "nickname": "",
          "pid": "350400"
        }, {
          "code": "350424",
          "alevel": 3,

          "name": "宁化县",
          "nickname": "",
          "pid": "350400"
        }, {
          "code": "350425",
          "alevel": 3,

          "name": "大田县",
          "nickname": "",
          "pid": "350400"
        }, {
          "code": "350426",
          "alevel": 3,

          "name": "尤溪县",
          "nickname": "",
          "pid": "350400"
        }, {
          "code": "350427",
          "alevel": 3,

          "name": "沙县",
          "nickname": "",
          "pid": "350400"
        }, {
          "code": "350428",
          "alevel": 3,

          "name": "将乐县",
          "nickname": "",
          "pid": "350400"
        }, {
          "code": "350429",
          "alevel": 3,

          "name": "泰宁县",
          "nickname": "",
          "pid": "350400"
        }, {
          "code": "350430",
          "alevel": 3,

          "name": "建宁县",
          "nickname": "",
          "pid": "350400"
        }, {
          "code": "350481",
          "alevel": 3,

          "name": "永安市",
          "nickname": "",
          "pid": "350400"
        }],
        "name": "三明市",
        "nickname": "",
        "pid": "350000"
      }, {
        "code": "350500",
        "alevel": 2,
        "sub": [{
          "code": "350501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "350500"
        }, {
          "code": "350502",
          "alevel": 3,

          "name": "鲤城区",
          "nickname": "",
          "pid": "350500"
        }, {
          "code": "350503",
          "alevel": 3,

          "name": "丰泽区",
          "nickname": "",
          "pid": "350500"
        }, {
          "code": "350504",
          "alevel": 3,

          "name": "洛江区",
          "nickname": "",
          "pid": "350500"
        }, {
          "code": "350505",
          "alevel": 3,

          "name": "泉港区",
          "nickname": "",
          "pid": "350500"
        }, {
          "code": "350521",
          "alevel": 3,

          "name": "惠安县",
          "nickname": "",
          "pid": "350500"
        }, {
          "code": "350524",
          "alevel": 3,

          "name": "安溪县",
          "nickname": "",
          "pid": "350500"
        }, {
          "code": "350525",
          "alevel": 3,

          "name": "永春县",
          "nickname": "",
          "pid": "350500"
        }, {
          "code": "350526",
          "alevel": 3,

          "name": "德化县",
          "nickname": "",
          "pid": "350500"
        }, {
          "code": "350527",
          "alevel": 3,

          "name": "金门县",
          "nickname": "",
          "pid": "350500"
        }, {
          "code": "350581",
          "alevel": 3,

          "name": "石狮市",
          "nickname": "",
          "pid": "350500"
        }, {
          "code": "350582",
          "alevel": 3,

          "name": "晋江市",
          "nickname": "",
          "pid": "350500"
        }, {
          "code": "350583",
          "alevel": 3,

          "name": "南安市",
          "nickname": "",
          "pid": "350500"
        }],
        "name": "泉州市",
        "nickname": "",
        "pid": "350000"
      }, {
        "code": "350600",
        "alevel": 2,
        "sub": [{
          "code": "350601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "350600"
        }, {
          "code": "350602",
          "alevel": 3,

          "name": "芗城区",
          "nickname": "",
          "pid": "350600"
        }, {
          "code": "350603",
          "alevel": 3,

          "name": "龙文区",
          "nickname": "",
          "pid": "350600"
        }, {
          "code": "350622",
          "alevel": 3,

          "name": "云霄县",
          "nickname": "",
          "pid": "350600"
        }, {
          "code": "350623",
          "alevel": 3,

          "name": "漳浦县",
          "nickname": "",
          "pid": "350600"
        }, {
          "code": "350624",
          "alevel": 3,

          "name": "诏安县",
          "nickname": "",
          "pid": "350600"
        }, {
          "code": "350625",
          "alevel": 3,

          "name": "长泰县",
          "nickname": "",
          "pid": "350600"
        }, {
          "code": "350626",
          "alevel": 3,

          "name": "东山县",
          "nickname": "",
          "pid": "350600"
        }, {
          "code": "350627",
          "alevel": 3,

          "name": "南靖县",
          "nickname": "",
          "pid": "350600"
        }, {
          "code": "350628",
          "alevel": 3,

          "name": "平和县",
          "nickname": "",
          "pid": "350600"
        }, {
          "code": "350629",
          "alevel": 3,

          "name": "华安县",
          "nickname": "",
          "pid": "350600"
        }, {
          "code": "350681",
          "alevel": 3,

          "name": "龙海市",
          "nickname": "",
          "pid": "350600"
        }],
        "name": "漳州市",
        "nickname": "",
        "pid": "350000"
      }, {
        "code": "350700",
        "alevel": 2,
        "sub": [{
          "code": "350701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "350700"
        }, {
          "code": "350702",
          "alevel": 3,

          "name": "延平区",
          "nickname": "",
          "pid": "350700"
        }, {
          "code": "350703",
          "alevel": 3,

          "name": "建阳区",
          "nickname": "",
          "pid": "350700"
        }, {
          "code": "350721",
          "alevel": 3,

          "name": "顺昌县",
          "nickname": "",
          "pid": "350700"
        }, {
          "code": "350722",
          "alevel": 3,

          "name": "浦城县",
          "nickname": "",
          "pid": "350700"
        }, {
          "code": "350723",
          "alevel": 3,

          "name": "光泽县",
          "nickname": "",
          "pid": "350700"
        }, {
          "code": "350724",
          "alevel": 3,

          "name": "松溪县",
          "nickname": "",
          "pid": "350700"
        }, {
          "code": "350725",
          "alevel": 3,

          "name": "政和县",
          "nickname": "",
          "pid": "350700"
        }, {
          "code": "350781",
          "alevel": 3,

          "name": "邵武市",
          "nickname": "",
          "pid": "350700"
        }, {
          "code": "350782",
          "alevel": 3,

          "name": "武夷山市",
          "nickname": "",
          "pid": "350700"
        }, {
          "code": "350783",
          "alevel": 3,

          "name": "建瓯市",
          "nickname": "",
          "pid": "350700"
        }],
        "name": "南平市",
        "nickname": "",
        "pid": "350000"
      }, {
        "code": "350800",
        "alevel": 2,
        "sub": [{
          "code": "350801",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "350800"
        }, {
          "code": "350802",
          "alevel": 3,

          "name": "新罗区",
          "nickname": "",
          "pid": "350800"
        }, {
          "code": "350803",
          "alevel": 3,

          "name": "永定区",
          "nickname": "",
          "pid": "350800"
        }, {
          "code": "350821",
          "alevel": 3,

          "name": "长汀县",
          "nickname": "",
          "pid": "350800"
        }, {
          "code": "350823",
          "alevel": 3,

          "name": "上杭县",
          "nickname": "",
          "pid": "350800"
        }, {
          "code": "350824",
          "alevel": 3,

          "name": "武平县",
          "nickname": "",
          "pid": "350800"
        }, {
          "code": "350825",
          "alevel": 3,

          "name": "连城县",
          "nickname": "",
          "pid": "350800"
        }, {
          "code": "350881",
          "alevel": 3,

          "name": "漳平市",
          "nickname": "",
          "pid": "350800"
        }],
        "name": "龙岩市",
        "nickname": "",
        "pid": "350000"
      }, {
        "code": "350900",
        "alevel": 2,
        "sub": [{
          "code": "350901",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "350900"
        }, {
          "code": "350902",
          "alevel": 3,

          "name": "蕉城区",
          "nickname": "",
          "pid": "350900"
        }, {
          "code": "350921",
          "alevel": 3,

          "name": "霞浦县",
          "nickname": "",
          "pid": "350900"
        }, {
          "code": "350922",
          "alevel": 3,

          "name": "古田县",
          "nickname": "",
          "pid": "350900"
        }, {
          "code": "350923",
          "alevel": 3,

          "name": "屏南县",
          "nickname": "",
          "pid": "350900"
        }, {
          "code": "350924",
          "alevel": 3,

          "name": "寿宁县",
          "nickname": "",
          "pid": "350900"
        }, {
          "code": "350925",
          "alevel": 3,

          "name": "周宁县",
          "nickname": "",
          "pid": "350900"
        }, {
          "code": "350926",
          "alevel": 3,

          "name": "柘荣县",
          "nickname": "",
          "pid": "350900"
        }, {
          "code": "350981",
          "alevel": 3,

          "name": "福安市",
          "nickname": "",
          "pid": "350900"
        }, {
          "code": "350982",
          "alevel": 3,

          "name": "福鼎市",
          "nickname": "",
          "pid": "350900"
        }],
        "name": "宁德市",
        "nickname": "",
        "pid": "350000"
      }],
      "name": "福建省",
      "nickname": "闽",
      "pid": ""
    }, {
      "code": "360000",
      "alevel": 1,
      "sub": [{
        "code": "360100",
        "alevel": 2,
        "sub": [{
          "code": "360101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "360100"
        }, {
          "code": "360102",
          "alevel": 3,

          "name": "东湖区",
          "nickname": "",
          "pid": "360100"
        }, {
          "code": "360103",
          "alevel": 3,

          "name": "西湖区",
          "nickname": "",
          "pid": "360100"
        }, {
          "code": "360104",
          "alevel": 3,

          "name": "青云谱区",
          "nickname": "",
          "pid": "360100"
        }, {
          "code": "360105",
          "alevel": 3,

          "name": "湾里区",
          "nickname": "",
          "pid": "360100"
        }, {
          "code": "360111",
          "alevel": 3,

          "name": "青山湖区",
          "nickname": "",
          "pid": "360100"
        }, {
          "code": "360112",
          "alevel": 3,

          "name": "新建区",
          "nickname": "",
          "pid": "360100"
        }, {
          "code": "360113",
          "alevel": 3,

          "name": "红谷滩区",
          "nickname": "",
          "pid": "360100"
        }, {
          "code": "360121",
          "alevel": 3,

          "name": "南昌县",
          "nickname": "",
          "pid": "360100"
        }, {
          "code": "360123",
          "alevel": 3,

          "name": "安义县",
          "nickname": "",
          "pid": "360100"
        }, {
          "code": "360124",
          "alevel": 3,

          "name": "进贤县",
          "nickname": "",
          "pid": "360100"
        }],
        "name": "南昌市",
        "nickname": "",
        "pid": "360000"
      }, {
        "code": "360200",
        "alevel": 2,
        "sub": [{
          "code": "360201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "360200"
        }, {
          "code": "360202",
          "alevel": 3,

          "name": "昌江区",
          "nickname": "",
          "pid": "360200"
        }, {
          "code": "360203",
          "alevel": 3,

          "name": "珠山区",
          "nickname": "",
          "pid": "360200"
        }, {
          "code": "360222",
          "alevel": 3,

          "name": "浮梁县",
          "nickname": "",
          "pid": "360200"
        }, {
          "code": "360281",
          "alevel": 3,

          "name": "乐平市",
          "nickname": "",
          "pid": "360200"
        }],
        "name": "景德镇市",
        "nickname": "",
        "pid": "360000"
      }, {
        "code": "360300",
        "alevel": 2,
        "sub": [{
          "code": "360301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "360300"
        }, {
          "code": "360302",
          "alevel": 3,

          "name": "安源区",
          "nickname": "",
          "pid": "360300"
        }, {
          "code": "360313",
          "alevel": 3,

          "name": "湘东区",
          "nickname": "",
          "pid": "360300"
        }, {
          "code": "360321",
          "alevel": 3,

          "name": "莲花县",
          "nickname": "",
          "pid": "360300"
        }, {
          "code": "360322",
          "alevel": 3,

          "name": "上栗县",
          "nickname": "",
          "pid": "360300"
        }, {
          "code": "360323",
          "alevel": 3,

          "name": "芦溪县",
          "nickname": "",
          "pid": "360300"
        }],
        "name": "萍乡市",
        "nickname": "",
        "pid": "360000"
      }, {
        "code": "360400",
        "alevel": 2,
        "sub": [{
          "code": "360401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "360400"
        }, {
          "code": "360402",
          "alevel": 3,

          "name": "濂溪区",
          "nickname": "",
          "pid": "360400"
        }, {
          "code": "360403",
          "alevel": 3,

          "name": "浔阳区",
          "nickname": "",
          "pid": "360400"
        }, {
          "code": "360404",
          "alevel": 3,

          "name": "柴桑区",
          "nickname": "",
          "pid": "360400"
        }, {
          "code": "360421",
          "alevel": 3,

          "name": "九江县",
          "nickname": "",
          "pid": "360400"
        }, {
          "code": "360423",
          "alevel": 3,

          "name": "武宁县",
          "nickname": "",
          "pid": "360400"
        }, {
          "code": "360424",
          "alevel": 3,

          "name": "修水县",
          "nickname": "",
          "pid": "360400"
        }, {
          "code": "360425",
          "alevel": 3,

          "name": "永修县",
          "nickname": "",
          "pid": "360400"
        }, {
          "code": "360426",
          "alevel": 3,

          "name": "德安县",
          "nickname": "",
          "pid": "360400"
        }, {
          "code": "360428",
          "alevel": 3,

          "name": "都昌县",
          "nickname": "",
          "pid": "360400"
        }, {
          "code": "360429",
          "alevel": 3,

          "name": "湖口县",
          "nickname": "",
          "pid": "360400"
        }, {
          "code": "360430",
          "alevel": 3,

          "name": "彭泽县",
          "nickname": "",
          "pid": "360400"
        }, {
          "code": "360481",
          "alevel": 3,

          "name": "瑞昌市",
          "nickname": "",
          "pid": "360400"
        }, {
          "code": "360482",
          "alevel": 3,

          "name": "共青城市",
          "nickname": "",
          "pid": "360400"
        }, {
          "code": "360483",
          "alevel": 3,

          "name": "庐山市",
          "nickname": "",
          "pid": "360400"
        }],
        "name": "九江市",
        "nickname": "",
        "pid": "360000"
      }, {
        "code": "360500",
        "alevel": 2,
        "sub": [{
          "code": "360501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "360500"
        }, {
          "code": "360502",
          "alevel": 3,

          "name": "渝水区",
          "nickname": "",
          "pid": "360500"
        }, {
          "code": "360521",
          "alevel": 3,

          "name": "分宜县",
          "nickname": "",
          "pid": "360500"
        }],
        "name": "新余市",
        "nickname": "",
        "pid": "360000"
      }, {
        "code": "360600",
        "alevel": 2,
        "sub": [{
          "code": "360601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "360600"
        }, {
          "code": "360602",
          "alevel": 3,

          "name": "月湖区",
          "nickname": "",
          "pid": "360600"
        }, {
          "code": "360603",
          "alevel": 3,

          "name": "余江区",
          "nickname": "",
          "pid": "360600"
        }, {
          "code": "360622",
          "alevel": 3,

          "name": "余江县",
          "nickname": "",
          "pid": "360600"
        }, {
          "code": "360681",
          "alevel": 3,

          "name": "贵溪市",
          "nickname": "",
          "pid": "360600"
        }],
        "name": "鹰潭市",
        "nickname": "",
        "pid": "360000"
      }, {
        "code": "360700",
        "alevel": 2,
        "sub": [{
          "code": "360701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "360700"
        }, {
          "code": "360702",
          "alevel": 3,

          "name": "章贡区",
          "nickname": "",
          "pid": "360700"
        }, {
          "code": "360703",
          "alevel": 3,

          "name": "南康区",
          "nickname": "",
          "pid": "360700"
        }, {
          "code": "360704",
          "alevel": 3,

          "name": "赣县区",
          "nickname": "",
          "pid": "360700"
        }, {
          "code": "360721",
          "alevel": 3,

          "name": "赣县",
          "nickname": "",
          "pid": "360700"
        }, {
          "code": "360722",
          "alevel": 3,

          "name": "信丰县",
          "nickname": "",
          "pid": "360700"
        }, {
          "code": "360723",
          "alevel": 3,

          "name": "大余县",
          "nickname": "",
          "pid": "360700"
        }, {
          "code": "360724",
          "alevel": 3,

          "name": "上犹县",
          "nickname": "",
          "pid": "360700"
        }, {
          "code": "360725",
          "alevel": 3,

          "name": "崇义县",
          "nickname": "",
          "pid": "360700"
        }, {
          "code": "360726",
          "alevel": 3,

          "name": "安远县",
          "nickname": "",
          "pid": "360700"
        }, {
          "code": "360727",
          "alevel": 3,

          "name": "龙南县",
          "nickname": "",
          "pid": "360700"
        }, {
          "code": "360728",
          "alevel": 3,

          "name": "定南县",
          "nickname": "",
          "pid": "360700"
        }, {
          "code": "360729",
          "alevel": 3,

          "name": "全南县",
          "nickname": "",
          "pid": "360700"
        }, {
          "code": "360730",
          "alevel": 3,

          "name": "宁都县",
          "nickname": "",
          "pid": "360700"
        }, {
          "code": "360731",
          "alevel": 3,

          "name": "于都县",
          "nickname": "",
          "pid": "360700"
        }, {
          "code": "360732",
          "alevel": 3,

          "name": "兴国县",
          "nickname": "",
          "pid": "360700"
        }, {
          "code": "360733",
          "alevel": 3,

          "name": "会昌县",
          "nickname": "",
          "pid": "360700"
        }, {
          "code": "360734",
          "alevel": 3,

          "name": "寻乌县",
          "nickname": "",
          "pid": "360700"
        }, {
          "code": "360735",
          "alevel": 3,

          "name": "石城县",
          "nickname": "",
          "pid": "360700"
        }, {
          "code": "360781",
          "alevel": 3,

          "name": "瑞金市",
          "nickname": "",
          "pid": "360700"
        }],
        "name": "赣州市",
        "nickname": "",
        "pid": "360000"
      }, {
        "code": "360800",
        "alevel": 2,
        "sub": [{
          "code": "360801",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "360800"
        }, {
          "code": "360802",
          "alevel": 3,

          "name": "吉州区",
          "nickname": "",
          "pid": "360800"
        }, {
          "code": "360803",
          "alevel": 3,

          "name": "青原区",
          "nickname": "",
          "pid": "360800"
        }, {
          "code": "360821",
          "alevel": 3,

          "name": "吉安县",
          "nickname": "",
          "pid": "360800"
        }, {
          "code": "360822",
          "alevel": 3,

          "name": "吉水县",
          "nickname": "",
          "pid": "360800"
        }, {
          "code": "360823",
          "alevel": 3,

          "name": "峡江县",
          "nickname": "",
          "pid": "360800"
        }, {
          "code": "360824",
          "alevel": 3,

          "name": "新干县",
          "nickname": "",
          "pid": "360800"
        }, {
          "code": "360825",
          "alevel": 3,

          "name": "永丰县",
          "nickname": "",
          "pid": "360800"
        }, {
          "code": "360826",
          "alevel": 3,

          "name": "泰和县",
          "nickname": "",
          "pid": "360800"
        }, {
          "code": "360827",
          "alevel": 3,

          "name": "遂川县",
          "nickname": "",
          "pid": "360800"
        }, {
          "code": "360828",
          "alevel": 3,

          "name": "万安县",
          "nickname": "",
          "pid": "360800"
        }, {
          "code": "360829",
          "alevel": 3,

          "name": "安福县",
          "nickname": "",
          "pid": "360800"
        }, {
          "code": "360830",
          "alevel": 3,

          "name": "永新县",
          "nickname": "",
          "pid": "360800"
        }, {
          "code": "360881",
          "alevel": 3,

          "name": "井冈山市",
          "nickname": "",
          "pid": "360800"
        }],
        "name": "吉安市",
        "nickname": "",
        "pid": "360000"
      }, {
        "code": "360900",
        "alevel": 2,
        "sub": [{
          "code": "360901",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "360900"
        }, {
          "code": "360902",
          "alevel": 3,

          "name": "袁州区",
          "nickname": "",
          "pid": "360900"
        }, {
          "code": "360921",
          "alevel": 3,

          "name": "奉新县",
          "nickname": "",
          "pid": "360900"
        }, {
          "code": "360922",
          "alevel": 3,

          "name": "万载县",
          "nickname": "",
          "pid": "360900"
        }, {
          "code": "360923",
          "alevel": 3,

          "name": "上高县",
          "nickname": "",
          "pid": "360900"
        }, {
          "code": "360924",
          "alevel": 3,

          "name": "宜丰县",
          "nickname": "",
          "pid": "360900"
        }, {
          "code": "360925",
          "alevel": 3,

          "name": "靖安县",
          "nickname": "",
          "pid": "360900"
        }, {
          "code": "360926",
          "alevel": 3,

          "name": "铜鼓县",
          "nickname": "",
          "pid": "360900"
        }, {
          "code": "360981",
          "alevel": 3,

          "name": "丰城市",
          "nickname": "",
          "pid": "360900"
        }, {
          "code": "360982",
          "alevel": 3,

          "name": "樟树市",
          "nickname": "",
          "pid": "360900"
        }, {
          "code": "360983",
          "alevel": 3,

          "name": "高安市",
          "nickname": "",
          "pid": "360900"
        }],
        "name": "宜春市",
        "nickname": "",
        "pid": "360000"
      }, {
        "code": "361000",
        "alevel": 2,
        "sub": [{
          "code": "361001",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "361000"
        }, {
          "code": "361002",
          "alevel": 3,

          "name": "临川区",
          "nickname": "",
          "pid": "361000"
        }, {
          "code": "361003",
          "alevel": 3,

          "name": "东乡区",
          "nickname": "",
          "pid": "361000"
        }, {
          "code": "361021",
          "alevel": 3,

          "name": "南城县",
          "nickname": "",
          "pid": "361000"
        }, {
          "code": "361022",
          "alevel": 3,

          "name": "黎川县",
          "nickname": "",
          "pid": "361000"
        }, {
          "code": "361023",
          "alevel": 3,

          "name": "南丰县",
          "nickname": "",
          "pid": "361000"
        }, {
          "code": "361024",
          "alevel": 3,

          "name": "崇仁县",
          "nickname": "",
          "pid": "361000"
        }, {
          "code": "361025",
          "alevel": 3,

          "name": "乐安县",
          "nickname": "",
          "pid": "361000"
        }, {
          "code": "361026",
          "alevel": 3,

          "name": "宜黄县",
          "nickname": "",
          "pid": "361000"
        }, {
          "code": "361027",
          "alevel": 3,

          "name": "金溪县",
          "nickname": "",
          "pid": "361000"
        }, {
          "code": "361028",
          "alevel": 3,

          "name": "资溪县",
          "nickname": "",
          "pid": "361000"
        }, {
          "code": "361029",
          "alevel": 3,

          "name": "东乡县",
          "nickname": "",
          "pid": "361000"
        }, {
          "code": "361030",
          "alevel": 3,

          "name": "广昌县",
          "nickname": "",
          "pid": "361000"
        }],
        "name": "抚州市",
        "nickname": "",
        "pid": "360000"
      }, {
        "code": "361100",
        "alevel": 2,
        "sub": [{
          "code": "361101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "361100"
        }, {
          "code": "361102",
          "alevel": 3,

          "name": "信州区",
          "nickname": "",
          "pid": "361100"
        }, {
          "code": "361103",
          "alevel": 3,

          "name": "广丰区",
          "nickname": "",
          "pid": "361100"
        }, {
          "code": "361104",
          "alevel": 3,

          "name": "广信区",
          "nickname": "",
          "pid": "361100"
        }, {
          "code": "361121",
          "alevel": 3,

          "name": "上饶县",
          "nickname": "",
          "pid": "361100"
        }, {
          "code": "361123",
          "alevel": 3,

          "name": "玉山县",
          "nickname": "",
          "pid": "361100"
        }, {
          "code": "361124",
          "alevel": 3,

          "name": "铅山县",
          "nickname": "",
          "pid": "361100"
        }, {
          "code": "361125",
          "alevel": 3,

          "name": "横峰县",
          "nickname": "",
          "pid": "361100"
        }, {
          "code": "361126",
          "alevel": 3,

          "name": "弋阳县",
          "nickname": "",
          "pid": "361100"
        }, {
          "code": "361127",
          "alevel": 3,

          "name": "余干县",
          "nickname": "",
          "pid": "361100"
        }, {
          "code": "361128",
          "alevel": 3,

          "name": "鄱阳县",
          "nickname": "",
          "pid": "361100"
        }, {
          "code": "361129",
          "alevel": 3,

          "name": "万年县",
          "nickname": "",
          "pid": "361100"
        }, {
          "code": "361130",
          "alevel": 3,

          "name": "婺源县",
          "nickname": "",
          "pid": "361100"
        }, {
          "code": "361181",
          "alevel": 3,

          "name": "德兴市",
          "nickname": "",
          "pid": "361100"
        }],
        "name": "上饶市",
        "nickname": "",
        "pid": "360000"
      }],
      "name": "江西省",
      "nickname": "赣",
      "pid": ""
    }, {
      "code": "370000",
      "alevel": 1,
      "sub": [{
        "code": "370100",
        "alevel": 2,
        "sub": [{
          "code": "370101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "370100"
        }, {
          "code": "370102",
          "alevel": 3,

          "name": "历下区",
          "nickname": "",
          "pid": "370100"
        }, {
          "code": "370103",
          "alevel": 3,

          "name": "市中区",
          "nickname": "",
          "pid": "370100"
        }, {
          "code": "370104",
          "alevel": 3,

          "name": "槐荫区",
          "nickname": "",
          "pid": "370100"
        }, {
          "code": "370105",
          "alevel": 3,

          "name": "天桥区",
          "nickname": "",
          "pid": "370100"
        }, {
          "code": "370112",
          "alevel": 3,

          "name": "历城区",
          "nickname": "",
          "pid": "370100"
        }, {
          "code": "370113",
          "alevel": 3,

          "name": "长清区",
          "nickname": "",
          "pid": "370100"
        }, {
          "code": "370114",
          "alevel": 3,

          "name": "章丘区",
          "nickname": "",
          "pid": "370100"
        }, {
          "code": "370115",
          "alevel": 3,

          "name": "济阳区",
          "nickname": "",
          "pid": "370100"
        }, {
          "code": "370116",
          "alevel": 3,

          "name": "莱芜区",
          "nickname": "",
          "pid": "370100"
        }, {
          "code": "370117",
          "alevel": 3,

          "name": "钢城区",
          "nickname": "",
          "pid": "370100"
        }, {
          "code": "370124",
          "alevel": 3,

          "name": "平阴县",
          "nickname": "",
          "pid": "370100"
        }, {
          "code": "370125",
          "alevel": 3,

          "name": "济阳县",
          "nickname": "",
          "pid": "370100"
        }, {
          "code": "370126",
          "alevel": 3,

          "name": "商河县",
          "nickname": "",
          "pid": "370100"
        }, {
          "code": "370181",
          "alevel": 3,

          "name": "章丘市",
          "nickname": "",
          "pid": "370100"
        }],
        "name": "济南市",
        "nickname": "",
        "pid": "370000"
      }, {
        "code": "370200",
        "alevel": 2,
        "sub": [{
          "code": "370201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "370200"
        }, {
          "code": "370202",
          "alevel": 3,

          "name": "市南区",
          "nickname": "",
          "pid": "370200"
        }, {
          "code": "370203",
          "alevel": 3,

          "name": "市北区",
          "nickname": "",
          "pid": "370200"
        }, {
          "code": "370211",
          "alevel": 3,

          "name": "黄岛区",
          "nickname": "",
          "pid": "370200"
        }, {
          "code": "370212",
          "alevel": 3,

          "name": "崂山区",
          "nickname": "",
          "pid": "370200"
        }, {
          "code": "370213",
          "alevel": 3,

          "name": "李沧区",
          "nickname": "",
          "pid": "370200"
        }, {
          "code": "370214",
          "alevel": 3,

          "name": "城阳区",
          "nickname": "",
          "pid": "370200"
        }, {
          "code": "370215",
          "alevel": 3,

          "name": "即墨区",
          "nickname": "",
          "pid": "370200"
        }, {
          "code": "370281",
          "alevel": 3,

          "name": "胶州市",
          "nickname": "",
          "pid": "370200"
        }, {
          "code": "370282",
          "alevel": 3,

          "name": "即墨市",
          "nickname": "",
          "pid": "370200"
        }, {
          "code": "370283",
          "alevel": 3,

          "name": "平度市",
          "nickname": "",
          "pid": "370200"
        }, {
          "code": "370285",
          "alevel": 3,

          "name": "莱西市",
          "nickname": "",
          "pid": "370200"
        }],
        "name": "青岛市",
        "nickname": "",
        "pid": "370000"
      }, {
        "code": "370300",
        "alevel": 2,
        "sub": [{
          "code": "370301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "370300"
        }, {
          "code": "370302",
          "alevel": 3,

          "name": "淄川区",
          "nickname": "",
          "pid": "370300"
        }, {
          "code": "370303",
          "alevel": 3,

          "name": "张店区",
          "nickname": "",
          "pid": "370300"
        }, {
          "code": "370304",
          "alevel": 3,

          "name": "博山区",
          "nickname": "",
          "pid": "370300"
        }, {
          "code": "370305",
          "alevel": 3,

          "name": "临淄区",
          "nickname": "",
          "pid": "370300"
        }, {
          "code": "370306",
          "alevel": 3,

          "name": "周村区",
          "nickname": "",
          "pid": "370300"
        }, {
          "code": "370321",
          "alevel": 3,

          "name": "桓台县",
          "nickname": "",
          "pid": "370300"
        }, {
          "code": "370322",
          "alevel": 3,

          "name": "高青县",
          "nickname": "",
          "pid": "370300"
        }, {
          "code": "370323",
          "alevel": 3,

          "name": "沂源县",
          "nickname": "",
          "pid": "370300"
        }],
        "name": "淄博市",
        "nickname": "",
        "pid": "370000"
      }, {
        "code": "370400",
        "alevel": 2,
        "sub": [{
          "code": "370401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "370400"
        }, {
          "code": "370402",
          "alevel": 3,

          "name": "市中区",
          "nickname": "",
          "pid": "370400"
        }, {
          "code": "370403",
          "alevel": 3,

          "name": "薛城区",
          "nickname": "",
          "pid": "370400"
        }, {
          "code": "370404",
          "alevel": 3,

          "name": "峄城区",
          "nickname": "",
          "pid": "370400"
        }, {
          "code": "370405",
          "alevel": 3,

          "name": "台儿庄区",
          "nickname": "",
          "pid": "370400"
        }, {
          "code": "370406",
          "alevel": 3,

          "name": "山亭区",
          "nickname": "",
          "pid": "370400"
        }, {
          "code": "370481",
          "alevel": 3,

          "name": "滕州市",
          "nickname": "",
          "pid": "370400"
        }],
        "name": "枣庄市",
        "nickname": "",
        "pid": "370000"
      }, {
        "code": "370500",
        "alevel": 2,
        "sub": [{
          "code": "370501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "370500"
        }, {
          "code": "370502",
          "alevel": 3,

          "name": "东营区",
          "nickname": "",
          "pid": "370500"
        }, {
          "code": "370503",
          "alevel": 3,

          "name": "河口区",
          "nickname": "",
          "pid": "370500"
        }, {
          "code": "370505",
          "alevel": 3,

          "name": "垦利区",
          "nickname": "",
          "pid": "370500"
        }, {
          "code": "370522",
          "alevel": 3,

          "name": "利津县",
          "nickname": "",
          "pid": "370500"
        }, {
          "code": "370523",
          "alevel": 3,

          "name": "广饶县",
          "nickname": "",
          "pid": "370500"
        }],
        "name": "东营市",
        "nickname": "",
        "pid": "370000"
      }, {
        "code": "370600",
        "alevel": 2,
        "sub": [{
          "code": "370601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "370600"
        }, {
          "code": "370602",
          "alevel": 3,

          "name": "芝罘区",
          "nickname": "",
          "pid": "370600"
        }, {
          "code": "370611",
          "alevel": 3,

          "name": "福山区",
          "nickname": "",
          "pid": "370600"
        }, {
          "code": "370612",
          "alevel": 3,

          "name": "牟平区",
          "nickname": "",
          "pid": "370600"
        }, {
          "code": "370613",
          "alevel": 3,

          "name": "莱山区",
          "nickname": "",
          "pid": "370600"
        }, {
          "code": "370634",
          "alevel": 3,

          "name": "长岛县",
          "nickname": "",
          "pid": "370600"
        }, {
          "code": "370681",
          "alevel": 3,

          "name": "龙口市",
          "nickname": "",
          "pid": "370600"
        }, {
          "code": "370682",
          "alevel": 3,

          "name": "莱阳市",
          "nickname": "",
          "pid": "370600"
        }, {
          "code": "370683",
          "alevel": 3,

          "name": "莱州市",
          "nickname": "",
          "pid": "370600"
        }, {
          "code": "370684",
          "alevel": 3,

          "name": "蓬莱市",
          "nickname": "",
          "pid": "370600"
        }, {
          "code": "370685",
          "alevel": 3,

          "name": "招远市",
          "nickname": "",
          "pid": "370600"
        }, {
          "code": "370686",
          "alevel": 3,

          "name": "栖霞市",
          "nickname": "",
          "pid": "370600"
        }, {
          "code": "370687",
          "alevel": 3,

          "name": "海阳市",
          "nickname": "",
          "pid": "370600"
        }],
        "name": "烟台市",
        "nickname": "",
        "pid": "370000"
      }, {
        "code": "370700",
        "alevel": 2,
        "sub": [{
          "code": "370701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "370700"
        }, {
          "code": "370702",
          "alevel": 3,

          "name": "潍城区",
          "nickname": "",
          "pid": "370700"
        }, {
          "code": "370703",
          "alevel": 3,

          "name": "寒亭区",
          "nickname": "",
          "pid": "370700"
        }, {
          "code": "370704",
          "alevel": 3,

          "name": "坊子区",
          "nickname": "",
          "pid": "370700"
        }, {
          "code": "370705",
          "alevel": 3,

          "name": "奎文区",
          "nickname": "",
          "pid": "370700"
        }, {
          "code": "370724",
          "alevel": 3,

          "name": "临朐县",
          "nickname": "",
          "pid": "370700"
        }, {
          "code": "370725",
          "alevel": 3,

          "name": "昌乐县",
          "nickname": "",
          "pid": "370700"
        }, {
          "code": "370781",
          "alevel": 3,

          "name": "青州市",
          "nickname": "",
          "pid": "370700"
        }, {
          "code": "370782",
          "alevel": 3,

          "name": "诸城市",
          "nickname": "",
          "pid": "370700"
        }, {
          "code": "370783",
          "alevel": 3,

          "name": "寿光市",
          "nickname": "",
          "pid": "370700"
        }, {
          "code": "370784",
          "alevel": 3,

          "name": "安丘市",
          "nickname": "",
          "pid": "370700"
        }, {
          "code": "370785",
          "alevel": 3,

          "name": "高密市",
          "nickname": "",
          "pid": "370700"
        }, {
          "code": "370786",
          "alevel": 3,

          "name": "昌邑市",
          "nickname": "",
          "pid": "370700"
        }],
        "name": "潍坊市",
        "nickname": "",
        "pid": "370000"
      }, {
        "code": "370800",
        "alevel": 2,
        "sub": [{
          "code": "370801",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "370800"
        }, {
          "code": "370811",
          "alevel": 3,

          "name": "任城区",
          "nickname": "",
          "pid": "370800"
        }, {
          "code": "370812",
          "alevel": 3,

          "name": "兖州区",
          "nickname": "",
          "pid": "370800"
        }, {
          "code": "370826",
          "alevel": 3,

          "name": "微山县",
          "nickname": "",
          "pid": "370800"
        }, {
          "code": "370827",
          "alevel": 3,

          "name": "鱼台县",
          "nickname": "",
          "pid": "370800"
        }, {
          "code": "370828",
          "alevel": 3,

          "name": "金乡县",
          "nickname": "",
          "pid": "370800"
        }, {
          "code": "370829",
          "alevel": 3,

          "name": "嘉祥县",
          "nickname": "",
          "pid": "370800"
        }, {
          "code": "370830",
          "alevel": 3,

          "name": "汶上县",
          "nickname": "",
          "pid": "370800"
        }, {
          "code": "370831",
          "alevel": 3,

          "name": "泗水县",
          "nickname": "",
          "pid": "370800"
        }, {
          "code": "370832",
          "alevel": 3,

          "name": "梁山县",
          "nickname": "",
          "pid": "370800"
        }, {
          "code": "370881",
          "alevel": 3,

          "name": "曲阜市",
          "nickname": "",
          "pid": "370800"
        }, {
          "code": "370883",
          "alevel": 3,

          "name": "邹城市",
          "nickname": "",
          "pid": "370800"
        }],
        "name": "济宁市",
        "nickname": "",
        "pid": "370000"
      }, {
        "code": "370900",
        "alevel": 2,
        "sub": [{
          "code": "370901",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "370900"
        }, {
          "code": "370902",
          "alevel": 3,

          "name": "泰山区",
          "nickname": "",
          "pid": "370900"
        }, {
          "code": "370911",
          "alevel": 3,

          "name": "岱岳区",
          "nickname": "",
          "pid": "370900"
        }, {
          "code": "370921",
          "alevel": 3,

          "name": "宁阳县",
          "nickname": "",
          "pid": "370900"
        }, {
          "code": "370923",
          "alevel": 3,

          "name": "东平县",
          "nickname": "",
          "pid": "370900"
        }, {
          "code": "370982",
          "alevel": 3,

          "name": "新泰市",
          "nickname": "",
          "pid": "370900"
        }, {
          "code": "370983",
          "alevel": 3,

          "name": "肥城市",
          "nickname": "",
          "pid": "370900"
        }],
        "name": "泰安市",
        "nickname": "",
        "pid": "370000"
      }, {
        "code": "371000",
        "alevel": 2,
        "sub": [{
          "code": "371001",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "371000"
        }, {
          "code": "371002",
          "alevel": 3,

          "name": "环翠区",
          "nickname": "",
          "pid": "371000"
        }, {
          "code": "371003",
          "alevel": 3,

          "name": "文登区",
          "nickname": "",
          "pid": "371000"
        }, {
          "code": "371082",
          "alevel": 3,

          "name": "荣成市",
          "nickname": "",
          "pid": "371000"
        }, {
          "code": "371083",
          "alevel": 3,

          "name": "乳山市",
          "nickname": "",
          "pid": "371000"
        }],
        "name": "威海市",
        "nickname": "",
        "pid": "370000"
      }, {
        "code": "371100",
        "alevel": 2,
        "sub": [{
          "code": "371101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "371100"
        }, {
          "code": "371102",
          "alevel": 3,

          "name": "东港区",
          "nickname": "",
          "pid": "371100"
        }, {
          "code": "371103",
          "alevel": 3,

          "name": "岚山区",
          "nickname": "",
          "pid": "371100"
        }, {
          "code": "371121",
          "alevel": 3,

          "name": "五莲县",
          "nickname": "",
          "pid": "371100"
        }, {
          "code": "371122",
          "alevel": 3,

          "name": "莒县",
          "nickname": "",
          "pid": "371100"
        }],
        "name": "日照市",
        "nickname": "",
        "pid": "370000"
      }, {
        "code": "371200",
        "alevel": 2,
        "sub": [{
          "code": "371201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "371200"
        }, {
          "code": "371202",
          "alevel": 3,

          "name": "莱城区",
          "nickname": "",
          "pid": "371200"
        }, {
          "code": "371203",
          "alevel": 3,

          "name": "钢城区",
          "nickname": "",
          "pid": "371200"
        }],
        "name": "莱芜市",
        "nickname": "",
        "pid": "370000"
      }, {
        "code": "371300",
        "alevel": 2,
        "sub": [{
          "code": "371301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "371300"
        }, {
          "code": "371302",
          "alevel": 3,

          "name": "兰山区",
          "nickname": "",
          "pid": "371300"
        }, {
          "code": "371311",
          "alevel": 3,

          "name": "罗庄区",
          "nickname": "",
          "pid": "371300"
        }, {
          "code": "371312",
          "alevel": 3,

          "name": "河东区",
          "nickname": "",
          "pid": "371300"
        }, {
          "code": "371321",
          "alevel": 3,

          "name": "沂南县",
          "nickname": "",
          "pid": "371300"
        }, {
          "code": "371322",
          "alevel": 3,

          "name": "郯城县",
          "nickname": "",
          "pid": "371300"
        }, {
          "code": "371323",
          "alevel": 3,

          "name": "沂水县",
          "nickname": "",
          "pid": "371300"
        }, {
          "code": "371324",
          "alevel": 3,

          "name": "兰陵县",
          "nickname": "",
          "pid": "371300"
        }, {
          "code": "371325",
          "alevel": 3,

          "name": "费县",
          "nickname": "",
          "pid": "371300"
        }, {
          "code": "371326",
          "alevel": 3,

          "name": "平邑县",
          "nickname": "",
          "pid": "371300"
        }, {
          "code": "371327",
          "alevel": 3,

          "name": "莒南县",
          "nickname": "",
          "pid": "371300"
        }, {
          "code": "371328",
          "alevel": 3,

          "name": "蒙阴县",
          "nickname": "",
          "pid": "371300"
        }, {
          "code": "371329",
          "alevel": 3,

          "name": "临沭县",
          "nickname": "",
          "pid": "371300"
        }],
        "name": "临沂市",
        "nickname": "",
        "pid": "370000"
      }, {
        "code": "371400",
        "alevel": 2,
        "sub": [{
          "code": "371401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "371400"
        }, {
          "code": "371402",
          "alevel": 3,

          "name": "德城区",
          "nickname": "",
          "pid": "371400"
        }, {
          "code": "371403",
          "alevel": 3,

          "name": "陵城区",
          "nickname": "",
          "pid": "371400"
        }, {
          "code": "371422",
          "alevel": 3,

          "name": "宁津县",
          "nickname": "",
          "pid": "371400"
        }, {
          "code": "371423",
          "alevel": 3,

          "name": "庆云县",
          "nickname": "",
          "pid": "371400"
        }, {
          "code": "371424",
          "alevel": 3,

          "name": "临邑县",
          "nickname": "",
          "pid": "371400"
        }, {
          "code": "371425",
          "alevel": 3,

          "name": "齐河县",
          "nickname": "",
          "pid": "371400"
        }, {
          "code": "371426",
          "alevel": 3,

          "name": "平原县",
          "nickname": "",
          "pid": "371400"
        }, {
          "code": "371427",
          "alevel": 3,

          "name": "夏津县",
          "nickname": "",
          "pid": "371400"
        }, {
          "code": "371428",
          "alevel": 3,

          "name": "武城县",
          "nickname": "",
          "pid": "371400"
        }, {
          "code": "371481",
          "alevel": 3,

          "name": "乐陵市",
          "nickname": "",
          "pid": "371400"
        }, {
          "code": "371482",
          "alevel": 3,

          "name": "禹城市",
          "nickname": "",
          "pid": "371400"
        }],
        "name": "德州市",
        "nickname": "",
        "pid": "370000"
      }, {
        "code": "371500",
        "alevel": 2,
        "sub": [{
          "code": "371501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "371500"
        }, {
          "code": "371502",
          "alevel": 3,

          "name": "东昌府区",
          "nickname": "",
          "pid": "371500"
        }, {
          "code": "371503",
          "alevel": 3,

          "name": "茌平区",
          "nickname": "",
          "pid": "371500"
        }, {
          "code": "371521",
          "alevel": 3,

          "name": "阳谷县",
          "nickname": "",
          "pid": "371500"
        }, {
          "code": "371522",
          "alevel": 3,

          "name": "莘县",
          "nickname": "",
          "pid": "371500"
        }, {
          "code": "371523",
          "alevel": 3,

          "name": "茌平县",
          "nickname": "",
          "pid": "371500"
        }, {
          "code": "371524",
          "alevel": 3,

          "name": "东阿县",
          "nickname": "",
          "pid": "371500"
        }, {
          "code": "371525",
          "alevel": 3,

          "name": "冠县",
          "nickname": "",
          "pid": "371500"
        }, {
          "code": "371526",
          "alevel": 3,

          "name": "高唐县",
          "nickname": "",
          "pid": "371500"
        }, {
          "code": "371581",
          "alevel": 3,

          "name": "临清市",
          "nickname": "",
          "pid": "371500"
        }],
        "name": "聊城市",
        "nickname": "",
        "pid": "370000"
      }, {
        "code": "371600",
        "alevel": 2,
        "sub": [{
          "code": "371601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "371600"
        }, {
          "code": "371602",
          "alevel": 3,

          "name": "滨城区",
          "nickname": "",
          "pid": "371600"
        }, {
          "code": "371603",
          "alevel": 3,

          "name": "沾化区",
          "nickname": "",
          "pid": "371600"
        }, {
          "code": "371621",
          "alevel": 3,

          "name": "惠民县",
          "nickname": "",
          "pid": "371600"
        }, {
          "code": "371622",
          "alevel": 3,

          "name": "阳信县",
          "nickname": "",
          "pid": "371600"
        }, {
          "code": "371623",
          "alevel": 3,

          "name": "无棣县",
          "nickname": "",
          "pid": "371600"
        }, {
          "code": "371625",
          "alevel": 3,

          "name": "博兴县",
          "nickname": "",
          "pid": "371600"
        }, {
          "code": "371626",
          "alevel": 3,

          "name": "邹平县",
          "nickname": "",
          "pid": "371600"
        }, {
          "code": "371681",
          "alevel": 3,

          "name": "邹平市",
          "nickname": "",
          "pid": "371600"
        }],
        "name": "滨州市",
        "nickname": "",
        "pid": "370000"
      }, {
        "code": "371700",
        "alevel": 2,
        "sub": [{
          "code": "371701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "371700"
        }, {
          "code": "371702",
          "alevel": 3,

          "name": "牡丹区",
          "nickname": "",
          "pid": "371700"
        }, {
          "code": "371703",
          "alevel": 3,

          "name": "定陶区",
          "nickname": "",
          "pid": "371700"
        }, {
          "code": "371721",
          "alevel": 3,

          "name": "曹县",
          "nickname": "",
          "pid": "371700"
        }, {
          "code": "371722",
          "alevel": 3,

          "name": "单县",
          "nickname": "",
          "pid": "371700"
        }, {
          "code": "371723",
          "alevel": 3,

          "name": "成武县",
          "nickname": "",
          "pid": "371700"
        }, {
          "code": "371724",
          "alevel": 3,

          "name": "巨野县",
          "nickname": "",
          "pid": "371700"
        }, {
          "code": "371725",
          "alevel": 3,

          "name": "郓城县",
          "nickname": "",
          "pid": "371700"
        }, {
          "code": "371726",
          "alevel": 3,

          "name": "鄄城县",
          "nickname": "",
          "pid": "371700"
        }, {
          "code": "371728",
          "alevel": 3,

          "name": "东明县",
          "nickname": "",
          "pid": "371700"
        }],
        "name": "菏泽市",
        "nickname": "",
        "pid": "370000"
      }],
      "name": "山东省",
      "nickname": "鲁",
      "pid": ""
    }, {
      "code": "410000",
      "alevel": 1,
      "sub": [{
        "code": "410100",
        "alevel": 2,
        "sub": [{
          "code": "410101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "410100"
        }, {
          "code": "410102",
          "alevel": 3,

          "name": "中原区",
          "nickname": "",
          "pid": "410100"
        }, {
          "code": "410103",
          "alevel": 3,

          "name": "二七区",
          "nickname": "",
          "pid": "410100"
        }, {
          "code": "410104",
          "alevel": 3,

          "name": "管城回族区",
          "nickname": "",
          "pid": "410100"
        }, {
          "code": "410105",
          "alevel": 3,

          "name": "金水区",
          "nickname": "",
          "pid": "410100"
        }, {
          "code": "410106",
          "alevel": 3,

          "name": "上街区",
          "nickname": "",
          "pid": "410100"
        }, {
          "code": "410108",
          "alevel": 3,

          "name": "惠济区",
          "nickname": "",
          "pid": "410100"
        }, {
          "code": "410122",
          "alevel": 3,

          "name": "中牟县",
          "nickname": "",
          "pid": "410100"
        }, {
          "code": "410181",
          "alevel": 3,

          "name": "巩义市",
          "nickname": "",
          "pid": "410100"
        }, {
          "code": "410182",
          "alevel": 3,

          "name": "荥阳市",
          "nickname": "",
          "pid": "410100"
        }, {
          "code": "410183",
          "alevel": 3,

          "name": "新密市",
          "nickname": "",
          "pid": "410100"
        }, {
          "code": "410184",
          "alevel": 3,

          "name": "新郑市",
          "nickname": "",
          "pid": "410100"
        }, {
          "code": "410185",
          "alevel": 3,

          "name": "登封市",
          "nickname": "",
          "pid": "410100"
        }],
        "name": "郑州市",
        "nickname": "",
        "pid": "410000"
      }, {
        "code": "410200",
        "alevel": 2,
        "sub": [{
          "code": "410201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "410200"
        }, {
          "code": "410202",
          "alevel": 3,

          "name": "龙亭区",
          "nickname": "",
          "pid": "410200"
        }, {
          "code": "410203",
          "alevel": 3,

          "name": "顺河回族区",
          "nickname": "",
          "pid": "410200"
        }, {
          "code": "410204",
          "alevel": 3,

          "name": "鼓楼区",
          "nickname": "",
          "pid": "410200"
        }, {
          "code": "410205",
          "alevel": 3,

          "name": "禹王台区",
          "nickname": "",
          "pid": "410200"
        }, {
          "code": "410211",
          "alevel": 3,

          "name": "金明区",
          "nickname": "",
          "pid": "410200"
        }, {
          "code": "410212",
          "alevel": 3,

          "name": "祥符区",
          "nickname": "",
          "pid": "410200"
        }, {
          "code": "410221",
          "alevel": 3,

          "name": "杞县",
          "nickname": "",
          "pid": "410200"
        }, {
          "code": "410222",
          "alevel": 3,

          "name": "通许县",
          "nickname": "",
          "pid": "410200"
        }, {
          "code": "410223",
          "alevel": 3,

          "name": "尉氏县",
          "nickname": "",
          "pid": "410200"
        }, {
          "code": "410225",
          "alevel": 3,

          "name": "兰考县",
          "nickname": "",
          "pid": "410200"
        }],
        "name": "开封市",
        "nickname": "",
        "pid": "410000"
      }, {
        "code": "410300",
        "alevel": 2,
        "sub": [{
          "code": "410301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "410300"
        }, {
          "code": "410302",
          "alevel": 3,

          "name": "老城区",
          "nickname": "",
          "pid": "410300"
        }, {
          "code": "410303",
          "alevel": 3,

          "name": "西工区",
          "nickname": "",
          "pid": "410300"
        }, {
          "code": "410304",
          "alevel": 3,

          "name": "瀍河回族区",
          "nickname": "",
          "pid": "410300"
        }, {
          "code": "410305",
          "alevel": 3,

          "name": "涧西区",
          "nickname": "",
          "pid": "410300"
        }, {
          "code": "410306",
          "alevel": 3,

          "name": "吉利区",
          "nickname": "",
          "pid": "410300"
        }, {
          "code": "410311",
          "alevel": 3,

          "name": "洛龙区",
          "nickname": "",
          "pid": "410300"
        }, {
          "code": "410322",
          "alevel": 3,

          "name": "孟津县",
          "nickname": "",
          "pid": "410300"
        }, {
          "code": "410323",
          "alevel": 3,

          "name": "新安县",
          "nickname": "",
          "pid": "410300"
        }, {
          "code": "410324",
          "alevel": 3,

          "name": "栾川县",
          "nickname": "",
          "pid": "410300"
        }, {
          "code": "410325",
          "alevel": 3,

          "name": "嵩县",
          "nickname": "",
          "pid": "410300"
        }, {
          "code": "410326",
          "alevel": 3,

          "name": "汝阳县",
          "nickname": "",
          "pid": "410300"
        }, {
          "code": "410327",
          "alevel": 3,

          "name": "宜阳县",
          "nickname": "",
          "pid": "410300"
        }, {
          "code": "410328",
          "alevel": 3,

          "name": "洛宁县",
          "nickname": "",
          "pid": "410300"
        }, {
          "code": "410329",
          "alevel": 3,

          "name": "伊川县",
          "nickname": "",
          "pid": "410300"
        }, {
          "code": "410381",
          "alevel": 3,

          "name": "偃师市",
          "nickname": "",
          "pid": "410300"
        }],
        "name": "洛阳市",
        "nickname": "",
        "pid": "410000"
      }, {
        "code": "410400",
        "alevel": 2,
        "sub": [{
          "code": "410401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "410400"
        }, {
          "code": "410402",
          "alevel": 3,

          "name": "新华区",
          "nickname": "",
          "pid": "410400"
        }, {
          "code": "410403",
          "alevel": 3,

          "name": "卫东区",
          "nickname": "",
          "pid": "410400"
        }, {
          "code": "410404",
          "alevel": 3,

          "name": "石龙区",
          "nickname": "",
          "pid": "410400"
        }, {
          "code": "410411",
          "alevel": 3,

          "name": "湛河区",
          "nickname": "",
          "pid": "410400"
        }, {
          "code": "410421",
          "alevel": 3,

          "name": "宝丰县",
          "nickname": "",
          "pid": "410400"
        }, {
          "code": "410422",
          "alevel": 3,

          "name": "叶县",
          "nickname": "",
          "pid": "410400"
        }, {
          "code": "410423",
          "alevel": 3,

          "name": "鲁山县",
          "nickname": "",
          "pid": "410400"
        }, {
          "code": "410425",
          "alevel": 3,

          "name": "郏县",
          "nickname": "",
          "pid": "410400"
        }, {
          "code": "410481",
          "alevel": 3,

          "name": "舞钢市",
          "nickname": "",
          "pid": "410400"
        }, {
          "code": "410482",
          "alevel": 3,

          "name": "汝州市",
          "nickname": "",
          "pid": "410400"
        }],
        "name": "平顶山市",
        "nickname": "",
        "pid": "410000"
      }, {
        "code": "410500",
        "alevel": 2,
        "sub": [{
          "code": "410501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "410500"
        }, {
          "code": "410502",
          "alevel": 3,

          "name": "文峰区",
          "nickname": "",
          "pid": "410500"
        }, {
          "code": "410503",
          "alevel": 3,

          "name": "北关区",
          "nickname": "",
          "pid": "410500"
        }, {
          "code": "410505",
          "alevel": 3,

          "name": "殷都区",
          "nickname": "",
          "pid": "410500"
        }, {
          "code": "410506",
          "alevel": 3,

          "name": "龙安区",
          "nickname": "",
          "pid": "410500"
        }, {
          "code": "410522",
          "alevel": 3,

          "name": "安阳县",
          "nickname": "",
          "pid": "410500"
        }, {
          "code": "410523",
          "alevel": 3,

          "name": "汤阴县",
          "nickname": "",
          "pid": "410500"
        }, {
          "code": "410526",
          "alevel": 3,

          "name": "滑县",
          "nickname": "",
          "pid": "410500"
        }, {
          "code": "410527",
          "alevel": 3,

          "name": "内黄县",
          "nickname": "",
          "pid": "410500"
        }, {
          "code": "410581",
          "alevel": 3,

          "name": "林州市",
          "nickname": "",
          "pid": "410500"
        }],
        "name": "安阳市",
        "nickname": "",
        "pid": "410000"
      }, {
        "code": "410600",
        "alevel": 2,
        "sub": [{
          "code": "410601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "410600"
        }, {
          "code": "410602",
          "alevel": 3,

          "name": "鹤山区",
          "nickname": "",
          "pid": "410600"
        }, {
          "code": "410603",
          "alevel": 3,

          "name": "山城区",
          "nickname": "",
          "pid": "410600"
        }, {
          "code": "410611",
          "alevel": 3,

          "name": "淇滨区",
          "nickname": "",
          "pid": "410600"
        }, {
          "code": "410621",
          "alevel": 3,

          "name": "浚县",
          "nickname": "",
          "pid": "410600"
        }, {
          "code": "410622",
          "alevel": 3,

          "name": "淇县",
          "nickname": "",
          "pid": "410600"
        }],
        "name": "鹤壁市",
        "nickname": "",
        "pid": "410000"
      }, {
        "code": "410700",
        "alevel": 2,
        "sub": [{
          "code": "410701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "410700"
        }, {
          "code": "410702",
          "alevel": 3,

          "name": "红旗区",
          "nickname": "",
          "pid": "410700"
        }, {
          "code": "410703",
          "alevel": 3,

          "name": "卫滨区",
          "nickname": "",
          "pid": "410700"
        }, {
          "code": "410704",
          "alevel": 3,

          "name": "凤泉区",
          "nickname": "",
          "pid": "410700"
        }, {
          "code": "410711",
          "alevel": 3,

          "name": "牧野区",
          "nickname": "",
          "pid": "410700"
        }, {
          "code": "410721",
          "alevel": 3,

          "name": "新乡县",
          "nickname": "",
          "pid": "410700"
        }, {
          "code": "410724",
          "alevel": 3,

          "name": "获嘉县",
          "nickname": "",
          "pid": "410700"
        }, {
          "code": "410725",
          "alevel": 3,

          "name": "原阳县",
          "nickname": "",
          "pid": "410700"
        }, {
          "code": "410726",
          "alevel": 3,

          "name": "延津县",
          "nickname": "",
          "pid": "410700"
        }, {
          "code": "410727",
          "alevel": 3,

          "name": "封丘县",
          "nickname": "",
          "pid": "410700"
        }, {
          "code": "410728",
          "alevel": 3,

          "name": "长垣县",
          "nickname": "",
          "pid": "410700"
        }, {
          "code": "410781",
          "alevel": 3,

          "name": "卫辉市",
          "nickname": "",
          "pid": "410700"
        }, {
          "code": "410782",
          "alevel": 3,

          "name": "辉县市",
          "nickname": "",
          "pid": "410700"
        }, {
          "code": "410783",
          "alevel": 3,

          "name": "长垣市",
          "nickname": "",
          "pid": "410700"
        }],
        "name": "新乡市",
        "nickname": "",
        "pid": "410000"
      }, {
        "code": "410800",
        "alevel": 2,
        "sub": [{
          "code": "410801",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "410800"
        }, {
          "code": "410802",
          "alevel": 3,

          "name": "解放区",
          "nickname": "",
          "pid": "410800"
        }, {
          "code": "410803",
          "alevel": 3,

          "name": "中站区",
          "nickname": "",
          "pid": "410800"
        }, {
          "code": "410804",
          "alevel": 3,

          "name": "马村区",
          "nickname": "",
          "pid": "410800"
        }, {
          "code": "410811",
          "alevel": 3,

          "name": "山阳区",
          "nickname": "",
          "pid": "410800"
        }, {
          "code": "410821",
          "alevel": 3,

          "name": "修武县",
          "nickname": "",
          "pid": "410800"
        }, {
          "code": "410822",
          "alevel": 3,

          "name": "博爱县",
          "nickname": "",
          "pid": "410800"
        }, {
          "code": "410823",
          "alevel": 3,

          "name": "武陟县",
          "nickname": "",
          "pid": "410800"
        }, {
          "code": "410825",
          "alevel": 3,

          "name": "温县",
          "nickname": "",
          "pid": "410800"
        }, {
          "code": "410882",
          "alevel": 3,

          "name": "沁阳市",
          "nickname": "",
          "pid": "410800"
        }, {
          "code": "410883",
          "alevel": 3,

          "name": "孟州市",
          "nickname": "",
          "pid": "410800"
        }],
        "name": "焦作市",
        "nickname": "",
        "pid": "410000"
      }, {
        "code": "410900",
        "alevel": 2,
        "sub": [{
          "code": "410901",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "410900"
        }, {
          "code": "410902",
          "alevel": 3,

          "name": "华龙区",
          "nickname": "",
          "pid": "410900"
        }, {
          "code": "410922",
          "alevel": 3,

          "name": "清丰县",
          "nickname": "",
          "pid": "410900"
        }, {
          "code": "410923",
          "alevel": 3,

          "name": "南乐县",
          "nickname": "",
          "pid": "410900"
        }, {
          "code": "410926",
          "alevel": 3,

          "name": "范县",
          "nickname": "",
          "pid": "410900"
        }, {
          "code": "410927",
          "alevel": 3,

          "name": "台前县",
          "nickname": "",
          "pid": "410900"
        }, {
          "code": "410928",
          "alevel": 3,

          "name": "濮阳县",
          "nickname": "",
          "pid": "410900"
        }],
        "name": "濮阳市",
        "nickname": "",
        "pid": "410000"
      }, {
        "code": "411000",
        "alevel": 2,
        "sub": [{
          "code": "411001",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "411000"
        }, {
          "code": "411002",
          "alevel": 3,

          "name": "魏都区",
          "nickname": "",
          "pid": "411000"
        }, {
          "code": "411003",
          "alevel": 3,

          "name": "建安区",
          "nickname": "",
          "pid": "411000"
        }, {
          "code": "411023",
          "alevel": 3,

          "name": "许昌县",
          "nickname": "",
          "pid": "411000"
        }, {
          "code": "411024",
          "alevel": 3,

          "name": "鄢陵县",
          "nickname": "",
          "pid": "411000"
        }, {
          "code": "411025",
          "alevel": 3,

          "name": "襄城县",
          "nickname": "",
          "pid": "411000"
        }, {
          "code": "411081",
          "alevel": 3,

          "name": "禹州市",
          "nickname": "",
          "pid": "411000"
        }, {
          "code": "411082",
          "alevel": 3,

          "name": "长葛市",
          "nickname": "",
          "pid": "411000"
        }],
        "name": "许昌市",
        "nickname": "",
        "pid": "410000"
      }, {
        "code": "411100",
        "alevel": 2,
        "sub": [{
          "code": "411101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "411100"
        }, {
          "code": "411102",
          "alevel": 3,

          "name": "源汇区",
          "nickname": "",
          "pid": "411100"
        }, {
          "code": "411103",
          "alevel": 3,

          "name": "郾城区",
          "nickname": "",
          "pid": "411100"
        }, {
          "code": "411104",
          "alevel": 3,

          "name": "召陵区",
          "nickname": "",
          "pid": "411100"
        }, {
          "code": "411121",
          "alevel": 3,

          "name": "舞阳县",
          "nickname": "",
          "pid": "411100"
        }, {
          "code": "411122",
          "alevel": 3,

          "name": "临颍县",
          "nickname": "",
          "pid": "411100"
        }],
        "name": "漯河市",
        "nickname": "",
        "pid": "410000"
      }, {
        "code": "411200",
        "alevel": 2,
        "sub": [{
          "code": "411201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "411200"
        }, {
          "code": "411202",
          "alevel": 3,

          "name": "湖滨区",
          "nickname": "",
          "pid": "411200"
        }, {
          "code": "411203",
          "alevel": 3,

          "name": "陕州区",
          "nickname": "",
          "pid": "411200"
        }, {
          "code": "411221",
          "alevel": 3,

          "name": "渑池县",
          "nickname": "",
          "pid": "411200"
        }, {
          "code": "411224",
          "alevel": 3,

          "name": "卢氏县",
          "nickname": "",
          "pid": "411200"
        }, {
          "code": "411281",
          "alevel": 3,

          "name": "义马市",
          "nickname": "",
          "pid": "411200"
        }, {
          "code": "411282",
          "alevel": 3,

          "name": "灵宝市",
          "nickname": "",
          "pid": "411200"
        }],
        "name": "三门峡市",
        "nickname": "",
        "pid": "410000"
      }, {
        "code": "411300",
        "alevel": 2,
        "sub": [{
          "code": "411301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "411300"
        }, {
          "code": "411302",
          "alevel": 3,

          "name": "宛城区",
          "nickname": "",
          "pid": "411300"
        }, {
          "code": "411303",
          "alevel": 3,

          "name": "卧龙区",
          "nickname": "",
          "pid": "411300"
        }, {
          "code": "411321",
          "alevel": 3,

          "name": "南召县",
          "nickname": "",
          "pid": "411300"
        }, {
          "code": "411322",
          "alevel": 3,

          "name": "方城县",
          "nickname": "",
          "pid": "411300"
        }, {
          "code": "411323",
          "alevel": 3,

          "name": "西峡县",
          "nickname": "",
          "pid": "411300"
        }, {
          "code": "411324",
          "alevel": 3,

          "name": "镇平县",
          "nickname": "",
          "pid": "411300"
        }, {
          "code": "411325",
          "alevel": 3,

          "name": "内乡县",
          "nickname": "",
          "pid": "411300"
        }, {
          "code": "411326",
          "alevel": 3,

          "name": "淅川县",
          "nickname": "",
          "pid": "411300"
        }, {
          "code": "411327",
          "alevel": 3,

          "name": "社旗县",
          "nickname": "",
          "pid": "411300"
        }, {
          "code": "411328",
          "alevel": 3,

          "name": "唐河县",
          "nickname": "",
          "pid": "411300"
        }, {
          "code": "411329",
          "alevel": 3,

          "name": "新野县",
          "nickname": "",
          "pid": "411300"
        }, {
          "code": "411330",
          "alevel": 3,

          "name": "桐柏县",
          "nickname": "",
          "pid": "411300"
        }, {
          "code": "411381",
          "alevel": 3,

          "name": "邓州市",
          "nickname": "",
          "pid": "411300"
        }],
        "name": "南阳市",
        "nickname": "",
        "pid": "410000"
      }, {
        "code": "411400",
        "alevel": 2,
        "sub": [{
          "code": "411401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "411400"
        }, {
          "code": "411402",
          "alevel": 3,

          "name": "梁园区",
          "nickname": "",
          "pid": "411400"
        }, {
          "code": "411403",
          "alevel": 3,

          "name": "睢阳区",
          "nickname": "",
          "pid": "411400"
        }, {
          "code": "411421",
          "alevel": 3,

          "name": "民权县",
          "nickname": "",
          "pid": "411400"
        }, {
          "code": "411422",
          "alevel": 3,

          "name": "睢县",
          "nickname": "",
          "pid": "411400"
        }, {
          "code": "411423",
          "alevel": 3,

          "name": "宁陵县",
          "nickname": "",
          "pid": "411400"
        }, {
          "code": "411424",
          "alevel": 3,

          "name": "柘城县",
          "nickname": "",
          "pid": "411400"
        }, {
          "code": "411425",
          "alevel": 3,

          "name": "虞城县",
          "nickname": "",
          "pid": "411400"
        }, {
          "code": "411426",
          "alevel": 3,

          "name": "夏邑县",
          "nickname": "",
          "pid": "411400"
        }, {
          "code": "411481",
          "alevel": 3,

          "name": "永城市",
          "nickname": "",
          "pid": "411400"
        }],
        "name": "商丘市",
        "nickname": "",
        "pid": "410000"
      }, {
        "code": "411500",
        "alevel": 2,
        "sub": [{
          "code": "411501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "411500"
        }, {
          "code": "411502",
          "alevel": 3,

          "name": "浉河区",
          "nickname": "",
          "pid": "411500"
        }, {
          "code": "411503",
          "alevel": 3,

          "name": "平桥区",
          "nickname": "",
          "pid": "411500"
        }, {
          "code": "411521",
          "alevel": 3,

          "name": "罗山县",
          "nickname": "",
          "pid": "411500"
        }, {
          "code": "411522",
          "alevel": 3,

          "name": "光山县",
          "nickname": "",
          "pid": "411500"
        }, {
          "code": "411523",
          "alevel": 3,

          "name": "新县",
          "nickname": "",
          "pid": "411500"
        }, {
          "code": "411524",
          "alevel": 3,

          "name": "商城县",
          "nickname": "",
          "pid": "411500"
        }, {
          "code": "411525",
          "alevel": 3,

          "name": "固始县",
          "nickname": "",
          "pid": "411500"
        }, {
          "code": "411526",
          "alevel": 3,

          "name": "潢川县",
          "nickname": "",
          "pid": "411500"
        }, {
          "code": "411527",
          "alevel": 3,

          "name": "淮滨县",
          "nickname": "",
          "pid": "411500"
        }, {
          "code": "411528",
          "alevel": 3,

          "name": "息县",
          "nickname": "",
          "pid": "411500"
        }],
        "name": "信阳市",
        "nickname": "",
        "pid": "410000"
      }, {
        "code": "411600",
        "alevel": 2,
        "sub": [{
          "code": "411601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "411600"
        }, {
          "code": "411602",
          "alevel": 3,

          "name": "川汇区",
          "nickname": "",
          "pid": "411600"
        }, {
          "code": "411603",
          "alevel": 3,

          "name": "淮阳区",
          "nickname": "",
          "pid": "411600"
        }, {
          "code": "411621",
          "alevel": 3,

          "name": "扶沟县",
          "nickname": "",
          "pid": "411600"
        }, {
          "code": "411622",
          "alevel": 3,

          "name": "西华县",
          "nickname": "",
          "pid": "411600"
        }, {
          "code": "411623",
          "alevel": 3,

          "name": "商水县",
          "nickname": "",
          "pid": "411600"
        }, {
          "code": "411624",
          "alevel": 3,

          "name": "沈丘县",
          "nickname": "",
          "pid": "411600"
        }, {
          "code": "411625",
          "alevel": 3,

          "name": "郸城县",
          "nickname": "",
          "pid": "411600"
        }, {
          "code": "411626",
          "alevel": 3,

          "name": "淮阳县",
          "nickname": "",
          "pid": "411600"
        }, {
          "code": "411627",
          "alevel": 3,

          "name": "太康县",
          "nickname": "",
          "pid": "411600"
        }, {
          "code": "411628",
          "alevel": 3,

          "name": "鹿邑县",
          "nickname": "",
          "pid": "411600"
        }, {
          "code": "411681",
          "alevel": 3,

          "name": "项城市",
          "nickname": "",
          "pid": "411600"
        }],
        "name": "周口市",
        "nickname": "",
        "pid": "410000"
      }, {
        "code": "411700",
        "alevel": 2,
        "sub": [{
          "code": "411701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "411700"
        }, {
          "code": "411702",
          "alevel": 3,

          "name": "驿城区",
          "nickname": "",
          "pid": "411700"
        }, {
          "code": "411721",
          "alevel": 3,

          "name": "西平县",
          "nickname": "",
          "pid": "411700"
        }, {
          "code": "411722",
          "alevel": 3,

          "name": "上蔡县",
          "nickname": "",
          "pid": "411700"
        }, {
          "code": "411723",
          "alevel": 3,

          "name": "平舆县",
          "nickname": "",
          "pid": "411700"
        }, {
          "code": "411724",
          "alevel": 3,

          "name": "正阳县",
          "nickname": "",
          "pid": "411700"
        }, {
          "code": "411725",
          "alevel": 3,

          "name": "确山县",
          "nickname": "",
          "pid": "411700"
        }, {
          "code": "411726",
          "alevel": 3,

          "name": "泌阳县",
          "nickname": "",
          "pid": "411700"
        }, {
          "code": "411727",
          "alevel": 3,

          "name": "汝南县",
          "nickname": "",
          "pid": "411700"
        }, {
          "code": "411728",
          "alevel": 3,

          "name": "遂平县",
          "nickname": "",
          "pid": "411700"
        }, {
          "code": "411729",
          "alevel": 3,

          "name": "新蔡县",
          "nickname": "",
          "pid": "411700"
        }],
        "name": "驻马店市",
        "nickname": "",
        "pid": "410000"
      }, {
        "code": "419000",
        "alevel": 2,
        "sub": [{
          "code": "419001",
          "alevel": 3,

          "name": "济源市",
          "nickname": "",
          "pid": "419000"
        }],
        "name": "省直辖县级行政区划",
        "nickname": "",
        "pid": "410000"
      }],
      "name": "河南省",
      "nickname": "豫",
      "pid": ""
    }, {
      "code": "420000",
      "alevel": 1,
      "sub": [{
        "code": "420100",
        "alevel": 2,
        "sub": [{
          "code": "420101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "420100"
        }, {
          "code": "420102",
          "alevel": 3,

          "name": "江岸区",
          "nickname": "",
          "pid": "420100"
        }, {
          "code": "420103",
          "alevel": 3,

          "name": "江汉区",
          "nickname": "",
          "pid": "420100"
        }, {
          "code": "420104",
          "alevel": 3,

          "name": "硚口区",
          "nickname": "",
          "pid": "420100"
        }, {
          "code": "420105",
          "alevel": 3,

          "name": "汉阳区",
          "nickname": "",
          "pid": "420100"
        }, {
          "code": "420106",
          "alevel": 3,

          "name": "武昌区",
          "nickname": "",
          "pid": "420100"
        }, {
          "code": "420107",
          "alevel": 3,

          "name": "青山区",
          "nickname": "",
          "pid": "420100"
        }, {
          "code": "420111",
          "alevel": 3,

          "name": "洪山区",
          "nickname": "",
          "pid": "420100"
        }, {
          "code": "420112",
          "alevel": 3,

          "name": "东西湖区",
          "nickname": "",
          "pid": "420100"
        }, {
          "code": "420113",
          "alevel": 3,

          "name": "汉南区",
          "nickname": "",
          "pid": "420100"
        }, {
          "code": "420114",
          "alevel": 3,

          "name": "蔡甸区",
          "nickname": "",
          "pid": "420100"
        }, {
          "code": "420115",
          "alevel": 3,

          "name": "江夏区",
          "nickname": "",
          "pid": "420100"
        }, {
          "code": "420116",
          "alevel": 3,

          "name": "黄陂区",
          "nickname": "",
          "pid": "420100"
        }, {
          "code": "420117",
          "alevel": 3,

          "name": "新洲区",
          "nickname": "",
          "pid": "420100"
        }],
        "name": "武汉市",
        "nickname": "",
        "pid": "420000"
      }, {
        "code": "420200",
        "alevel": 2,
        "sub": [{
          "code": "420201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "420200"
        }, {
          "code": "420202",
          "alevel": 3,

          "name": "黄石港区",
          "nickname": "",
          "pid": "420200"
        }, {
          "code": "420203",
          "alevel": 3,

          "name": "西塞山区",
          "nickname": "",
          "pid": "420200"
        }, {
          "code": "420204",
          "alevel": 3,

          "name": "下陆区",
          "nickname": "",
          "pid": "420200"
        }, {
          "code": "420205",
          "alevel": 3,

          "name": "铁山区",
          "nickname": "",
          "pid": "420200"
        }, {
          "code": "420222",
          "alevel": 3,

          "name": "阳新县",
          "nickname": "",
          "pid": "420200"
        }, {
          "code": "420281",
          "alevel": 3,

          "name": "大冶市",
          "nickname": "",
          "pid": "420200"
        }],
        "name": "黄石市",
        "nickname": "",
        "pid": "420000"
      }, {
        "code": "420300",
        "alevel": 2,
        "sub": [{
          "code": "420301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "420300"
        }, {
          "code": "420302",
          "alevel": 3,

          "name": "茅箭区",
          "nickname": "",
          "pid": "420300"
        }, {
          "code": "420303",
          "alevel": 3,

          "name": "张湾区",
          "nickname": "",
          "pid": "420300"
        }, {
          "code": "420304",
          "alevel": 3,

          "name": "郧阳区",
          "nickname": "",
          "pid": "420300"
        }, {
          "code": "420322",
          "alevel": 3,

          "name": "郧西县",
          "nickname": "",
          "pid": "420300"
        }, {
          "code": "420323",
          "alevel": 3,

          "name": "竹山县",
          "nickname": "",
          "pid": "420300"
        }, {
          "code": "420324",
          "alevel": 3,

          "name": "竹溪县",
          "nickname": "",
          "pid": "420300"
        }, {
          "code": "420325",
          "alevel": 3,

          "name": "房县",
          "nickname": "",
          "pid": "420300"
        }, {
          "code": "420381",
          "alevel": 3,

          "name": "丹江口市",
          "nickname": "",
          "pid": "420300"
        }],
        "name": "十堰市",
        "nickname": "",
        "pid": "420000"
      }, {
        "code": "420500",
        "alevel": 2,
        "sub": [{
          "code": "420501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "420500"
        }, {
          "code": "420502",
          "alevel": 3,

          "name": "西陵区",
          "nickname": "",
          "pid": "420500"
        }, {
          "code": "420503",
          "alevel": 3,

          "name": "伍家岗区",
          "nickname": "",
          "pid": "420500"
        }, {
          "code": "420504",
          "alevel": 3,

          "name": "点军区",
          "nickname": "",
          "pid": "420500"
        }, {
          "code": "420505",
          "alevel": 3,

          "name": "猇亭区",
          "nickname": "",
          "pid": "420500"
        }, {
          "code": "420506",
          "alevel": 3,

          "name": "夷陵区",
          "nickname": "",
          "pid": "420500"
        }, {
          "code": "420525",
          "alevel": 3,

          "name": "远安县",
          "nickname": "",
          "pid": "420500"
        }, {
          "code": "420526",
          "alevel": 3,

          "name": "兴山县",
          "nickname": "",
          "pid": "420500"
        }, {
          "code": "420527",
          "alevel": 3,

          "name": "秭归县",
          "nickname": "",
          "pid": "420500"
        }, {
          "code": "420528",
          "alevel": 3,

          "name": "长阳土家族自治县",
          "nickname": "",
          "pid": "420500"
        }, {
          "code": "420529",
          "alevel": 3,

          "name": "五峰土家族自治县",
          "nickname": "",
          "pid": "420500"
        }, {
          "code": "420581",
          "alevel": 3,

          "name": "宜都市",
          "nickname": "",
          "pid": "420500"
        }, {
          "code": "420582",
          "alevel": 3,

          "name": "当阳市",
          "nickname": "",
          "pid": "420500"
        }, {
          "code": "420583",
          "alevel": 3,

          "name": "枝江市",
          "nickname": "",
          "pid": "420500"
        }],
        "name": "宜昌市",
        "nickname": "",
        "pid": "420000"
      }, {
        "code": "420600",
        "alevel": 2,
        "sub": [{
          "code": "420601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "420600"
        }, {
          "code": "420602",
          "alevel": 3,

          "name": "襄城区",
          "nickname": "",
          "pid": "420600"
        }, {
          "code": "420606",
          "alevel": 3,

          "name": "樊城区",
          "nickname": "",
          "pid": "420600"
        }, {
          "code": "420607",
          "alevel": 3,

          "name": "襄州区",
          "nickname": "",
          "pid": "420600"
        }, {
          "code": "420624",
          "alevel": 3,

          "name": "南漳县",
          "nickname": "",
          "pid": "420600"
        }, {
          "code": "420625",
          "alevel": 3,

          "name": "谷城县",
          "nickname": "",
          "pid": "420600"
        }, {
          "code": "420626",
          "alevel": 3,

          "name": "保康县",
          "nickname": "",
          "pid": "420600"
        }, {
          "code": "420682",
          "alevel": 3,

          "name": "老河口市",
          "nickname": "",
          "pid": "420600"
        }, {
          "code": "420683",
          "alevel": 3,

          "name": "枣阳市",
          "nickname": "",
          "pid": "420600"
        }, {
          "code": "420684",
          "alevel": 3,

          "name": "宜城市",
          "nickname": "",
          "pid": "420600"
        }],
        "name": "襄阳市",
        "nickname": "",
        "pid": "420000"
      }, {
        "code": "420700",
        "alevel": 2,
        "sub": [{
          "code": "420701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "420700"
        }, {
          "code": "420702",
          "alevel": 3,

          "name": "梁子湖区",
          "nickname": "",
          "pid": "420700"
        }, {
          "code": "420703",
          "alevel": 3,

          "name": "华容区",
          "nickname": "",
          "pid": "420700"
        }, {
          "code": "420704",
          "alevel": 3,

          "name": "鄂城区",
          "nickname": "",
          "pid": "420700"
        }],
        "name": "鄂州市",
        "nickname": "",
        "pid": "420000"
      }, {
        "code": "420800",
        "alevel": 2,
        "sub": [{
          "code": "420801",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "420800"
        }, {
          "code": "420802",
          "alevel": 3,

          "name": "东宝区",
          "nickname": "",
          "pid": "420800"
        }, {
          "code": "420804",
          "alevel": 3,

          "name": "掇刀区",
          "nickname": "",
          "pid": "420800"
        }, {
          "code": "420821",
          "alevel": 3,

          "name": "京山县",
          "nickname": "",
          "pid": "420800"
        }, {
          "code": "420822",
          "alevel": 3,

          "name": "沙洋县",
          "nickname": "",
          "pid": "420800"
        }, {
          "code": "420881",
          "alevel": 3,

          "name": "钟祥市",
          "nickname": "",
          "pid": "420800"
        }, {
          "code": "420882",
          "alevel": 3,

          "name": "京山市",
          "nickname": "",
          "pid": "420800"
        }],
        "name": "荆门市",
        "nickname": "",
        "pid": "420000"
      }, {
        "code": "420900",
        "alevel": 2,
        "sub": [{
          "code": "420901",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "420900"
        }, {
          "code": "420902",
          "alevel": 3,

          "name": "孝南区",
          "nickname": "",
          "pid": "420900"
        }, {
          "code": "420921",
          "alevel": 3,

          "name": "孝昌县",
          "nickname": "",
          "pid": "420900"
        }, {
          "code": "420922",
          "alevel": 3,

          "name": "大悟县",
          "nickname": "",
          "pid": "420900"
        }, {
          "code": "420923",
          "alevel": 3,

          "name": "云梦县",
          "nickname": "",
          "pid": "420900"
        }, {
          "code": "420981",
          "alevel": 3,

          "name": "应城市",
          "nickname": "",
          "pid": "420900"
        }, {
          "code": "420982",
          "alevel": 3,

          "name": "安陆市",
          "nickname": "",
          "pid": "420900"
        }, {
          "code": "420984",
          "alevel": 3,

          "name": "汉川市",
          "nickname": "",
          "pid": "420900"
        }],
        "name": "孝感市",
        "nickname": "",
        "pid": "420000"
      }, {
        "code": "421000",
        "alevel": 2,
        "sub": [{
          "code": "421001",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "421000"
        }, {
          "code": "421002",
          "alevel": 3,

          "name": "沙市区",
          "nickname": "",
          "pid": "421000"
        }, {
          "code": "421003",
          "alevel": 3,

          "name": "荆州区",
          "nickname": "",
          "pid": "421000"
        }, {
          "code": "421022",
          "alevel": 3,

          "name": "公安县",
          "nickname": "",
          "pid": "421000"
        }, {
          "code": "421023",
          "alevel": 3,

          "name": "监利县",
          "nickname": "",
          "pid": "421000"
        }, {
          "code": "421024",
          "alevel": 3,

          "name": "江陵县",
          "nickname": "",
          "pid": "421000"
        }, {
          "code": "421081",
          "alevel": 3,

          "name": "石首市",
          "nickname": "",
          "pid": "421000"
        }, {
          "code": "421083",
          "alevel": 3,

          "name": "洪湖市",
          "nickname": "",
          "pid": "421000"
        }, {
          "code": "421087",
          "alevel": 3,

          "name": "松滋市",
          "nickname": "",
          "pid": "421000"
        }],
        "name": "荆州市",
        "nickname": "",
        "pid": "420000"
      }, {
        "code": "421100",
        "alevel": 2,
        "sub": [{
          "code": "421101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "421100"
        }, {
          "code": "421102",
          "alevel": 3,

          "name": "黄州区",
          "nickname": "",
          "pid": "421100"
        }, {
          "code": "421121",
          "alevel": 3,

          "name": "团风县",
          "nickname": "",
          "pid": "421100"
        }, {
          "code": "421122",
          "alevel": 3,

          "name": "红安县",
          "nickname": "",
          "pid": "421100"
        }, {
          "code": "421123",
          "alevel": 3,

          "name": "罗田县",
          "nickname": "",
          "pid": "421100"
        }, {
          "code": "421124",
          "alevel": 3,

          "name": "英山县",
          "nickname": "",
          "pid": "421100"
        }, {
          "code": "421125",
          "alevel": 3,

          "name": "浠水县",
          "nickname": "",
          "pid": "421100"
        }, {
          "code": "421126",
          "alevel": 3,

          "name": "蕲春县",
          "nickname": "",
          "pid": "421100"
        }, {
          "code": "421127",
          "alevel": 3,

          "name": "黄梅县",
          "nickname": "",
          "pid": "421100"
        }, {
          "code": "421181",
          "alevel": 3,

          "name": "麻城市",
          "nickname": "",
          "pid": "421100"
        }, {
          "code": "421182",
          "alevel": 3,

          "name": "武穴市",
          "nickname": "",
          "pid": "421100"
        }],
        "name": "黄冈市",
        "nickname": "",
        "pid": "420000"
      }, {
        "code": "421200",
        "alevel": 2,
        "sub": [{
          "code": "421201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "421200"
        }, {
          "code": "421202",
          "alevel": 3,

          "name": "咸安区",
          "nickname": "",
          "pid": "421200"
        }, {
          "code": "421221",
          "alevel": 3,

          "name": "嘉鱼县",
          "nickname": "",
          "pid": "421200"
        }, {
          "code": "421222",
          "alevel": 3,

          "name": "通城县",
          "nickname": "",
          "pid": "421200"
        }, {
          "code": "421223",
          "alevel": 3,

          "name": "崇阳县",
          "nickname": "",
          "pid": "421200"
        }, {
          "code": "421224",
          "alevel": 3,

          "name": "通山县",
          "nickname": "",
          "pid": "421200"
        }, {
          "code": "421281",
          "alevel": 3,

          "name": "赤壁市",
          "nickname": "",
          "pid": "421200"
        }],
        "name": "咸宁市",
        "nickname": "",
        "pid": "420000"
      }, {
        "code": "421300",
        "alevel": 2,
        "sub": [{
          "code": "421301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "421300"
        }, {
          "code": "421303",
          "alevel": 3,

          "name": "曾都区",
          "nickname": "",
          "pid": "421300"
        }, {
          "code": "421321",
          "alevel": 3,

          "name": "随县",
          "nickname": "",
          "pid": "421300"
        }, {
          "code": "421381",
          "alevel": 3,

          "name": "广水市",
          "nickname": "",
          "pid": "421300"
        }],
        "name": "随州市",
        "nickname": "",
        "pid": "420000"
      }, {
        "code": "422800",
        "alevel": 2,
        "sub": [{
          "code": "422801",
          "alevel": 3,

          "name": "恩施市",
          "nickname": "",
          "pid": "422800"
        }, {
          "code": "422802",
          "alevel": 3,

          "name": "利川市",
          "nickname": "",
          "pid": "422800"
        }, {
          "code": "422822",
          "alevel": 3,

          "name": "建始县",
          "nickname": "",
          "pid": "422800"
        }, {
          "code": "422823",
          "alevel": 3,

          "name": "巴东县",
          "nickname": "",
          "pid": "422800"
        }, {
          "code": "422825",
          "alevel": 3,

          "name": "宣恩县",
          "nickname": "",
          "pid": "422800"
        }, {
          "code": "422826",
          "alevel": 3,

          "name": "咸丰县",
          "nickname": "",
          "pid": "422800"
        }, {
          "code": "422827",
          "alevel": 3,

          "name": "来凤县",
          "nickname": "",
          "pid": "422800"
        }, {
          "code": "422828",
          "alevel": 3,

          "name": "鹤峰县",
          "nickname": "",
          "pid": "422800"
        }],
        "name": "恩施土家族苗族自治州",
        "nickname": "",
        "pid": "420000"
      }, {
        "code": "429000",
        "alevel": 2,
        "sub": [{
          "code": "429004",
          "alevel": 3,

          "name": "仙桃市",
          "nickname": "",
          "pid": "429000"
        }, {
          "code": "429005",
          "alevel": 3,

          "name": "潜江市",
          "nickname": "",
          "pid": "429000"
        }, {
          "code": "429006",
          "alevel": 3,

          "name": "天门市",
          "nickname": "",
          "pid": "429000"
        }, {
          "code": "429021",
          "alevel": 3,

          "name": "神农架林区",
          "nickname": "",
          "pid": "429000"
        }],
        "name": "省直辖县级行政区划",
        "nickname": "",
        "pid": "420000"
      }],
      "name": "湖北省",
      "nickname": "鄂",
      "pid": ""
    }, {
      "code": "430000",
      "alevel": 1,
      "sub": [{
        "code": "430100",
        "alevel": 2,
        "sub": [{
          "code": "430101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "430100"
        }, {
          "code": "430102",
          "alevel": 3,

          "name": "芙蓉区",
          "nickname": "",
          "pid": "430100"
        }, {
          "code": "430103",
          "alevel": 3,

          "name": "天心区",
          "nickname": "",
          "pid": "430100"
        }, {
          "code": "430104",
          "alevel": 3,

          "name": "岳麓区",
          "nickname": "",
          "pid": "430100"
        }, {
          "code": "430105",
          "alevel": 3,

          "name": "开福区",
          "nickname": "",
          "pid": "430100"
        }, {
          "code": "430111",
          "alevel": 3,

          "name": "雨花区",
          "nickname": "",
          "pid": "430100"
        }, {
          "code": "430112",
          "alevel": 3,

          "name": "望城区",
          "nickname": "",
          "pid": "430100"
        }, {
          "code": "430121",
          "alevel": 3,

          "name": "长沙县",
          "nickname": "",
          "pid": "430100"
        }, {
          "code": "430124",
          "alevel": 3,

          "name": "宁乡县",
          "nickname": "",
          "pid": "430100"
        }, {
          "code": "430181",
          "alevel": 3,

          "name": "浏阳市",
          "nickname": "",
          "pid": "430100"
        }, {
          "code": "430182",
          "alevel": 3,

          "name": "宁乡市",
          "nickname": "",
          "pid": "430100"
        }],
        "name": "长沙市",
        "nickname": "",
        "pid": "430000"
      }, {
        "code": "430200",
        "alevel": 2,
        "sub": [{
          "code": "430201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "430200"
        }, {
          "code": "430202",
          "alevel": 3,

          "name": "荷塘区",
          "nickname": "",
          "pid": "430200"
        }, {
          "code": "430203",
          "alevel": 3,

          "name": "芦淞区",
          "nickname": "",
          "pid": "430200"
        }, {
          "code": "430204",
          "alevel": 3,

          "name": "石峰区",
          "nickname": "",
          "pid": "430200"
        }, {
          "code": "430211",
          "alevel": 3,

          "name": "天元区",
          "nickname": "",
          "pid": "430200"
        }, {
          "code": "430212",
          "alevel": 3,

          "name": "渌口区",
          "nickname": "",
          "pid": "430200"
        }, {
          "code": "430221",
          "alevel": 3,

          "name": "株洲县",
          "nickname": "",
          "pid": "430200"
        }, {
          "code": "430223",
          "alevel": 3,

          "name": "攸县",
          "nickname": "",
          "pid": "430200"
        }, {
          "code": "430224",
          "alevel": 3,

          "name": "茶陵县",
          "nickname": "",
          "pid": "430200"
        }, {
          "code": "430225",
          "alevel": 3,

          "name": "炎陵县",
          "nickname": "",
          "pid": "430200"
        }, {
          "code": "430281",
          "alevel": 3,

          "name": "醴陵市",
          "nickname": "",
          "pid": "430200"
        }],
        "name": "株洲市",
        "nickname": "",
        "pid": "430000"
      }, {
        "code": "430300",
        "alevel": 2,
        "sub": [{
          "code": "430301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "430300"
        }, {
          "code": "430302",
          "alevel": 3,

          "name": "雨湖区",
          "nickname": "",
          "pid": "430300"
        }, {
          "code": "430304",
          "alevel": 3,

          "name": "岳塘区",
          "nickname": "",
          "pid": "430300"
        }, {
          "code": "430321",
          "alevel": 3,

          "name": "湘潭县",
          "nickname": "",
          "pid": "430300"
        }, {
          "code": "430381",
          "alevel": 3,

          "name": "湘乡市",
          "nickname": "",
          "pid": "430300"
        }, {
          "code": "430382",
          "alevel": 3,

          "name": "韶山市",
          "nickname": "",
          "pid": "430300"
        }],
        "name": "湘潭市",
        "nickname": "",
        "pid": "430000"
      }, {
        "code": "430400",
        "alevel": 2,
        "sub": [{
          "code": "430401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "430400"
        }, {
          "code": "430405",
          "alevel": 3,

          "name": "珠晖区",
          "nickname": "",
          "pid": "430400"
        }, {
          "code": "430406",
          "alevel": 3,

          "name": "雁峰区",
          "nickname": "",
          "pid": "430400"
        }, {
          "code": "430407",
          "alevel": 3,

          "name": "石鼓区",
          "nickname": "",
          "pid": "430400"
        }, {
          "code": "430408",
          "alevel": 3,

          "name": "蒸湘区",
          "nickname": "",
          "pid": "430400"
        }, {
          "code": "430412",
          "alevel": 3,

          "name": "南岳区",
          "nickname": "",
          "pid": "430400"
        }, {
          "code": "430421",
          "alevel": 3,

          "name": "衡阳县",
          "nickname": "",
          "pid": "430400"
        }, {
          "code": "430422",
          "alevel": 3,

          "name": "衡南县",
          "nickname": "",
          "pid": "430400"
        }, {
          "code": "430423",
          "alevel": 3,

          "name": "衡山县",
          "nickname": "",
          "pid": "430400"
        }, {
          "code": "430424",
          "alevel": 3,

          "name": "衡东县",
          "nickname": "",
          "pid": "430400"
        }, {
          "code": "430426",
          "alevel": 3,

          "name": "祁东县",
          "nickname": "",
          "pid": "430400"
        }, {
          "code": "430481",
          "alevel": 3,

          "name": "耒阳市",
          "nickname": "",
          "pid": "430400"
        }, {
          "code": "430482",
          "alevel": 3,

          "name": "常宁市",
          "nickname": "",
          "pid": "430400"
        }],
        "name": "衡阳市",
        "nickname": "",
        "pid": "430000"
      }, {
        "code": "430500",
        "alevel": 2,
        "sub": [{
          "code": "430501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "430500"
        }, {
          "code": "430502",
          "alevel": 3,

          "name": "双清区",
          "nickname": "",
          "pid": "430500"
        }, {
          "code": "430503",
          "alevel": 3,

          "name": "大祥区",
          "nickname": "",
          "pid": "430500"
        }, {
          "code": "430511",
          "alevel": 3,

          "name": "北塔区",
          "nickname": "",
          "pid": "430500"
        }, {
          "code": "430521",
          "alevel": 3,

          "name": "邵东县",
          "nickname": "",
          "pid": "430500"
        }, {
          "code": "430522",
          "alevel": 3,

          "name": "新邵县",
          "nickname": "",
          "pid": "430500"
        }, {
          "code": "430523",
          "alevel": 3,

          "name": "邵阳县",
          "nickname": "",
          "pid": "430500"
        }, {
          "code": "430524",
          "alevel": 3,

          "name": "隆回县",
          "nickname": "",
          "pid": "430500"
        }, {
          "code": "430525",
          "alevel": 3,

          "name": "洞口县",
          "nickname": "",
          "pid": "430500"
        }, {
          "code": "430527",
          "alevel": 3,

          "name": "绥宁县",
          "nickname": "",
          "pid": "430500"
        }, {
          "code": "430528",
          "alevel": 3,

          "name": "新宁县",
          "nickname": "",
          "pid": "430500"
        }, {
          "code": "430529",
          "alevel": 3,

          "name": "城步苗族自治县",
          "nickname": "",
          "pid": "430500"
        }, {
          "code": "430581",
          "alevel": 3,

          "name": "武冈市",
          "nickname": "",
          "pid": "430500"
        }, {
          "code": "430582",
          "alevel": 3,

          "name": "邵东市",
          "nickname": "",
          "pid": "430500"
        }],
        "name": "邵阳市",
        "nickname": "",
        "pid": "430000"
      }, {
        "code": "430600",
        "alevel": 2,
        "sub": [{
          "code": "430601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "430600"
        }, {
          "code": "430602",
          "alevel": 3,

          "name": "岳阳楼区",
          "nickname": "",
          "pid": "430600"
        }, {
          "code": "430603",
          "alevel": 3,

          "name": "云溪区",
          "nickname": "",
          "pid": "430600"
        }, {
          "code": "430611",
          "alevel": 3,

          "name": "君山区",
          "nickname": "",
          "pid": "430600"
        }, {
          "code": "430621",
          "alevel": 3,

          "name": "岳阳县",
          "nickname": "",
          "pid": "430600"
        }, {
          "code": "430623",
          "alevel": 3,

          "name": "华容县",
          "nickname": "",
          "pid": "430600"
        }, {
          "code": "430624",
          "alevel": 3,

          "name": "湘阴县",
          "nickname": "",
          "pid": "430600"
        }, {
          "code": "430626",
          "alevel": 3,

          "name": "平江县",
          "nickname": "",
          "pid": "430600"
        }, {
          "code": "430681",
          "alevel": 3,

          "name": "汨罗市",
          "nickname": "",
          "pid": "430600"
        }, {
          "code": "430682",
          "alevel": 3,

          "name": "临湘市",
          "nickname": "",
          "pid": "430600"
        }],
        "name": "岳阳市",
        "nickname": "",
        "pid": "430000"
      }, {
        "code": "430700",
        "alevel": 2,
        "sub": [{
          "code": "430701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "430700"
        }, {
          "code": "430702",
          "alevel": 3,

          "name": "武陵区",
          "nickname": "",
          "pid": "430700"
        }, {
          "code": "430703",
          "alevel": 3,

          "name": "鼎城区",
          "nickname": "",
          "pid": "430700"
        }, {
          "code": "430721",
          "alevel": 3,

          "name": "安乡县",
          "nickname": "",
          "pid": "430700"
        }, {
          "code": "430722",
          "alevel": 3,

          "name": "汉寿县",
          "nickname": "",
          "pid": "430700"
        }, {
          "code": "430723",
          "alevel": 3,

          "name": "澧县",
          "nickname": "",
          "pid": "430700"
        }, {
          "code": "430724",
          "alevel": 3,

          "name": "临澧县",
          "nickname": "",
          "pid": "430700"
        }, {
          "code": "430725",
          "alevel": 3,

          "name": "桃源县",
          "nickname": "",
          "pid": "430700"
        }, {
          "code": "430726",
          "alevel": 3,

          "name": "石门县",
          "nickname": "",
          "pid": "430700"
        }, {
          "code": "430781",
          "alevel": 3,

          "name": "津市市",
          "nickname": "",
          "pid": "430700"
        }],
        "name": "常德市",
        "nickname": "",
        "pid": "430000"
      }, {
        "code": "430800",
        "alevel": 2,
        "sub": [{
          "code": "430801",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "430800"
        }, {
          "code": "430802",
          "alevel": 3,

          "name": "永定区",
          "nickname": "",
          "pid": "430800"
        }, {
          "code": "430811",
          "alevel": 3,

          "name": "武陵源区",
          "nickname": "",
          "pid": "430800"
        }, {
          "code": "430821",
          "alevel": 3,

          "name": "慈利县",
          "nickname": "",
          "pid": "430800"
        }, {
          "code": "430822",
          "alevel": 3,

          "name": "桑植县",
          "nickname": "",
          "pid": "430800"
        }],
        "name": "张家界市",
        "nickname": "",
        "pid": "430000"
      }, {
        "code": "430900",
        "alevel": 2,
        "sub": [{
          "code": "430901",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "430900"
        }, {
          "code": "430902",
          "alevel": 3,

          "name": "资阳区",
          "nickname": "",
          "pid": "430900"
        }, {
          "code": "430903",
          "alevel": 3,

          "name": "赫山区",
          "nickname": "",
          "pid": "430900"
        }, {
          "code": "430921",
          "alevel": 3,

          "name": "南县",
          "nickname": "",
          "pid": "430900"
        }, {
          "code": "430922",
          "alevel": 3,

          "name": "桃江县",
          "nickname": "",
          "pid": "430900"
        }, {
          "code": "430923",
          "alevel": 3,

          "name": "安化县",
          "nickname": "",
          "pid": "430900"
        }, {
          "code": "430981",
          "alevel": 3,

          "name": "沅江市",
          "nickname": "",
          "pid": "430900"
        }],
        "name": "益阳市",
        "nickname": "",
        "pid": "430000"
      }, {
        "code": "431000",
        "alevel": 2,
        "sub": [{
          "code": "431001",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "431000"
        }, {
          "code": "431002",
          "alevel": 3,

          "name": "北湖区",
          "nickname": "",
          "pid": "431000"
        }, {
          "code": "431003",
          "alevel": 3,

          "name": "苏仙区",
          "nickname": "",
          "pid": "431000"
        }, {
          "code": "431021",
          "alevel": 3,

          "name": "桂阳县",
          "nickname": "",
          "pid": "431000"
        }, {
          "code": "431022",
          "alevel": 3,

          "name": "宜章县",
          "nickname": "",
          "pid": "431000"
        }, {
          "code": "431023",
          "alevel": 3,

          "name": "永兴县",
          "nickname": "",
          "pid": "431000"
        }, {
          "code": "431024",
          "alevel": 3,

          "name": "嘉禾县",
          "nickname": "",
          "pid": "431000"
        }, {
          "code": "431025",
          "alevel": 3,

          "name": "临武县",
          "nickname": "",
          "pid": "431000"
        }, {
          "code": "431026",
          "alevel": 3,

          "name": "汝城县",
          "nickname": "",
          "pid": "431000"
        }, {
          "code": "431027",
          "alevel": 3,

          "name": "桂东县",
          "nickname": "",
          "pid": "431000"
        }, {
          "code": "431028",
          "alevel": 3,

          "name": "安仁县",
          "nickname": "",
          "pid": "431000"
        }, {
          "code": "431081",
          "alevel": 3,

          "name": "资兴市",
          "nickname": "",
          "pid": "431000"
        }],
        "name": "郴州市",
        "nickname": "",
        "pid": "430000"
      }, {
        "code": "431100",
        "alevel": 2,
        "sub": [{
          "code": "431101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "431100"
        }, {
          "code": "431102",
          "alevel": 3,

          "name": "零陵区",
          "nickname": "",
          "pid": "431100"
        }, {
          "code": "431103",
          "alevel": 3,

          "name": "冷水滩区",
          "nickname": "",
          "pid": "431100"
        }, {
          "code": "431121",
          "alevel": 3,

          "name": "祁阳县",
          "nickname": "",
          "pid": "431100"
        }, {
          "code": "431122",
          "alevel": 3,

          "name": "东安县",
          "nickname": "",
          "pid": "431100"
        }, {
          "code": "431123",
          "alevel": 3,

          "name": "双牌县",
          "nickname": "",
          "pid": "431100"
        }, {
          "code": "431124",
          "alevel": 3,

          "name": "道县",
          "nickname": "",
          "pid": "431100"
        }, {
          "code": "431125",
          "alevel": 3,

          "name": "江永县",
          "nickname": "",
          "pid": "431100"
        }, {
          "code": "431126",
          "alevel": 3,

          "name": "宁远县",
          "nickname": "",
          "pid": "431100"
        }, {
          "code": "431127",
          "alevel": 3,

          "name": "蓝山县",
          "nickname": "",
          "pid": "431100"
        }, {
          "code": "431128",
          "alevel": 3,

          "name": "新田县",
          "nickname": "",
          "pid": "431100"
        }, {
          "code": "431129",
          "alevel": 3,

          "name": "江华瑶族自治县",
          "nickname": "",
          "pid": "431100"
        }],
        "name": "永州市",
        "nickname": "",
        "pid": "430000"
      }, {
        "code": "431200",
        "alevel": 2,
        "sub": [{
          "code": "431201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "431200"
        }, {
          "code": "431202",
          "alevel": 3,

          "name": "鹤城区",
          "nickname": "",
          "pid": "431200"
        }, {
          "code": "431221",
          "alevel": 3,

          "name": "中方县",
          "nickname": "",
          "pid": "431200"
        }, {
          "code": "431222",
          "alevel": 3,

          "name": "沅陵县",
          "nickname": "",
          "pid": "431200"
        }, {
          "code": "431223",
          "alevel": 3,

          "name": "辰溪县",
          "nickname": "",
          "pid": "431200"
        }, {
          "code": "431224",
          "alevel": 3,

          "name": "溆浦县",
          "nickname": "",
          "pid": "431200"
        }, {
          "code": "431225",
          "alevel": 3,

          "name": "会同县",
          "nickname": "",
          "pid": "431200"
        }, {
          "code": "431226",
          "alevel": 3,

          "name": "麻阳苗族自治县",
          "nickname": "",
          "pid": "431200"
        }, {
          "code": "431227",
          "alevel": 3,

          "name": "新晃侗族自治县",
          "nickname": "",
          "pid": "431200"
        }, {
          "code": "431228",
          "alevel": 3,

          "name": "芷江侗族自治县",
          "nickname": "",
          "pid": "431200"
        }, {
          "code": "431229",
          "alevel": 3,

          "name": "靖州苗族侗族自治县",
          "nickname": "",
          "pid": "431200"
        }, {
          "code": "431230",
          "alevel": 3,

          "name": "通道侗族自治县",
          "nickname": "",
          "pid": "431200"
        }, {
          "code": "431281",
          "alevel": 3,

          "name": "洪江市",
          "nickname": "",
          "pid": "431200"
        }],
        "name": "怀化市",
        "nickname": "",
        "pid": "430000"
      }, {
        "code": "431300",
        "alevel": 2,
        "sub": [{
          "code": "431301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "431300"
        }, {
          "code": "431302",
          "alevel": 3,

          "name": "娄星区",
          "nickname": "",
          "pid": "431300"
        }, {
          "code": "431321",
          "alevel": 3,

          "name": "双峰县",
          "nickname": "",
          "pid": "431300"
        }, {
          "code": "431322",
          "alevel": 3,

          "name": "新化县",
          "nickname": "",
          "pid": "431300"
        }, {
          "code": "431381",
          "alevel": 3,

          "name": "冷水江市",
          "nickname": "",
          "pid": "431300"
        }, {
          "code": "431382",
          "alevel": 3,

          "name": "涟源市",
          "nickname": "",
          "pid": "431300"
        }],
        "name": "娄底市",
        "nickname": "",
        "pid": "430000"
      }, {
        "code": "433100",
        "alevel": 2,
        "sub": [{
          "code": "433101",
          "alevel": 3,

          "name": "吉首市",
          "nickname": "",
          "pid": "433100"
        }, {
          "code": "433122",
          "alevel": 3,

          "name": "泸溪县",
          "nickname": "",
          "pid": "433100"
        }, {
          "code": "433123",
          "alevel": 3,

          "name": "凤凰县",
          "nickname": "",
          "pid": "433100"
        }, {
          "code": "433124",
          "alevel": 3,

          "name": "花垣县",
          "nickname": "",
          "pid": "433100"
        }, {
          "code": "433125",
          "alevel": 3,

          "name": "保靖县",
          "nickname": "",
          "pid": "433100"
        }, {
          "code": "433126",
          "alevel": 3,

          "name": "古丈县",
          "nickname": "",
          "pid": "433100"
        }, {
          "code": "433127",
          "alevel": 3,

          "name": "永顺县",
          "nickname": "",
          "pid": "433100"
        }, {
          "code": "433130",
          "alevel": 3,

          "name": "龙山县",
          "nickname": "",
          "pid": "433100"
        }],
        "name": "湘西土家族苗族自治州",
        "nickname": "",
        "pid": "430000"
      }],
      "name": "湖南省",
      "nickname": "湘",
      "pid": ""
    }, {
      "code": "440000",
      "alevel": 1,
      "sub": [{
        "code": "440100",
        "alevel": 2,
        "sub": [{
          "code": "440101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "440100"
        }, {
          "code": "440103",
          "alevel": 3,

          "name": "荔湾区",
          "nickname": "",
          "pid": "440100"
        }, {
          "code": "440104",
          "alevel": 3,

          "name": "越秀区",
          "nickname": "",
          "pid": "440100"
        }, {
          "code": "440105",
          "alevel": 3,

          "name": "海珠区",
          "nickname": "",
          "pid": "440100"
        }, {
          "code": "440106",
          "alevel": 3,

          "name": "天河区",
          "nickname": "",
          "pid": "440100"
        }, {
          "code": "440111",
          "alevel": 3,

          "name": "白云区",
          "nickname": "",
          "pid": "440100"
        }, {
          "code": "440112",
          "alevel": 3,

          "name": "黄埔区",
          "nickname": "",
          "pid": "440100"
        }, {
          "code": "440113",
          "alevel": 3,

          "name": "番禺区",
          "nickname": "",
          "pid": "440100"
        }, {
          "code": "440114",
          "alevel": 3,

          "name": "花都区",
          "nickname": "",
          "pid": "440100"
        }, {
          "code": "440115",
          "alevel": 3,

          "name": "南沙区",
          "nickname": "",
          "pid": "440100"
        }, {
          "code": "440117",
          "alevel": 3,

          "name": "从化区",
          "nickname": "",
          "pid": "440100"
        }, {
          "code": "440118",
          "alevel": 3,

          "name": "增城区",
          "nickname": "",
          "pid": "440100"
        }],
        "name": "广州市",
        "nickname": "",
        "pid": "440000"
      }, {
        "code": "440200",
        "alevel": 2,
        "sub": [{
          "code": "440201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "440200"
        }, {
          "code": "440203",
          "alevel": 3,

          "name": "武江区",
          "nickname": "",
          "pid": "440200"
        }, {
          "code": "440204",
          "alevel": 3,

          "name": "浈江区",
          "nickname": "",
          "pid": "440200"
        }, {
          "code": "440205",
          "alevel": 3,

          "name": "曲江区",
          "nickname": "",
          "pid": "440200"
        }, {
          "code": "440222",
          "alevel": 3,

          "name": "始兴县",
          "nickname": "",
          "pid": "440200"
        }, {
          "code": "440224",
          "alevel": 3,

          "name": "仁化县",
          "nickname": "",
          "pid": "440200"
        }, {
          "code": "440229",
          "alevel": 3,

          "name": "翁源县",
          "nickname": "",
          "pid": "440200"
        }, {
          "code": "440232",
          "alevel": 3,

          "name": "乳源瑶族自治县",
          "nickname": "",
          "pid": "440200"
        }, {
          "code": "440233",
          "alevel": 3,

          "name": "新丰县",
          "nickname": "",
          "pid": "440200"
        }, {
          "code": "440281",
          "alevel": 3,

          "name": "乐昌市",
          "nickname": "",
          "pid": "440200"
        }, {
          "code": "440282",
          "alevel": 3,

          "name": "南雄市",
          "nickname": "",
          "pid": "440200"
        }],
        "name": "韶关市",
        "nickname": "",
        "pid": "440000"
      }, {
        "code": "440300",
        "alevel": 2,
        "sub": [{
          "code": "440301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "440300"
        }, {
          "code": "440303",
          "alevel": 3,

          "name": "罗湖区",
          "nickname": "",
          "pid": "440300"
        }, {
          "code": "440304",
          "alevel": 3,

          "name": "福田区",
          "nickname": "",
          "pid": "440300"
        }, {
          "code": "440305",
          "alevel": 3,

          "name": "南山区",
          "nickname": "",
          "pid": "440300"
        }, {
          "code": "440306",
          "alevel": 3,

          "name": "宝安区",
          "nickname": "",
          "pid": "440300"
        }, {
          "code": "440307",
          "alevel": 3,

          "name": "龙岗区",
          "nickname": "",
          "pid": "440300"
        }, {
          "code": "440308",
          "alevel": 3,

          "name": "盐田区",
          "nickname": "",
          "pid": "440300"
        }, {
          "code": "440309",
          "alevel": 3,

          "name": "龙华区",
          "nickname": "",
          "pid": "440300"
        }, {
          "code": "440310",
          "alevel": 3,

          "name": "坪山区",
          "nickname": "",
          "pid": "440300"
        }, {
          "code": "440311",
          "alevel": 3,

          "name": "光明区",
          "nickname": "",
          "pid": "440300"
        }],
        "name": "深圳市",
        "nickname": "",
        "pid": "440000"
      }, {
        "code": "440400",
        "alevel": 2,
        "sub": [{
          "code": "440401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "440400"
        }, {
          "code": "440402",
          "alevel": 3,

          "name": "香洲区",
          "nickname": "",
          "pid": "440400"
        }, {
          "code": "440403",
          "alevel": 3,

          "name": "斗门区",
          "nickname": "",
          "pid": "440400"
        }, {
          "code": "440404",
          "alevel": 3,

          "name": "金湾区",
          "nickname": "",
          "pid": "440400"
        }],
        "name": "珠海市",
        "nickname": "",
        "pid": "440000"
      }, {
        "code": "440500",
        "alevel": 2,
        "sub": [{
          "code": "440501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "440500"
        }, {
          "code": "440507",
          "alevel": 3,

          "name": "龙湖区",
          "nickname": "",
          "pid": "440500"
        }, {
          "code": "440511",
          "alevel": 3,

          "name": "金平区",
          "nickname": "",
          "pid": "440500"
        }, {
          "code": "440512",
          "alevel": 3,

          "name": "濠江区",
          "nickname": "",
          "pid": "440500"
        }, {
          "code": "440513",
          "alevel": 3,

          "name": "潮阳区",
          "nickname": "",
          "pid": "440500"
        }, {
          "code": "440514",
          "alevel": 3,

          "name": "潮南区",
          "nickname": "",
          "pid": "440500"
        }, {
          "code": "440515",
          "alevel": 3,

          "name": "澄海区",
          "nickname": "",
          "pid": "440500"
        }, {
          "code": "440523",
          "alevel": 3,

          "name": "南澳县",
          "nickname": "",
          "pid": "440500"
        }],
        "name": "汕头市",
        "nickname": "",
        "pid": "440000"
      }, {
        "code": "440600",
        "alevel": 2,
        "sub": [{
          "code": "440601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "440600"
        }, {
          "code": "440604",
          "alevel": 3,

          "name": "禅城区",
          "nickname": "",
          "pid": "440600"
        }, {
          "code": "440605",
          "alevel": 3,

          "name": "南海区",
          "nickname": "",
          "pid": "440600"
        }, {
          "code": "440606",
          "alevel": 3,

          "name": "顺德区",
          "nickname": "",
          "pid": "440600"
        }, {
          "code": "440607",
          "alevel": 3,

          "name": "三水区",
          "nickname": "",
          "pid": "440600"
        }, {
          "code": "440608",
          "alevel": 3,

          "name": "高明区",
          "nickname": "",
          "pid": "440600"
        }],
        "name": "佛山市",
        "nickname": "",
        "pid": "440000"
      }, {
        "code": "440700",
        "alevel": 2,
        "sub": [{
          "code": "440701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "440700"
        }, {
          "code": "440703",
          "alevel": 3,

          "name": "蓬江区",
          "nickname": "",
          "pid": "440700"
        }, {
          "code": "440704",
          "alevel": 3,

          "name": "江海区",
          "nickname": "",
          "pid": "440700"
        }, {
          "code": "440705",
          "alevel": 3,

          "name": "新会区",
          "nickname": "",
          "pid": "440700"
        }, {
          "code": "440781",
          "alevel": 3,

          "name": "台山市",
          "nickname": "",
          "pid": "440700"
        }, {
          "code": "440783",
          "alevel": 3,

          "name": "开平市",
          "nickname": "",
          "pid": "440700"
        }, {
          "code": "440784",
          "alevel": 3,

          "name": "鹤山市",
          "nickname": "",
          "pid": "440700"
        }, {
          "code": "440785",
          "alevel": 3,

          "name": "恩平市",
          "nickname": "",
          "pid": "440700"
        }],
        "name": "江门市",
        "nickname": "",
        "pid": "440000"
      }, {
        "code": "440800",
        "alevel": 2,
        "sub": [{
          "code": "440801",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "440800"
        }, {
          "code": "440802",
          "alevel": 3,

          "name": "赤坎区",
          "nickname": "",
          "pid": "440800"
        }, {
          "code": "440803",
          "alevel": 3,

          "name": "霞山区",
          "nickname": "",
          "pid": "440800"
        }, {
          "code": "440804",
          "alevel": 3,

          "name": "坡头区",
          "nickname": "",
          "pid": "440800"
        }, {
          "code": "440811",
          "alevel": 3,

          "name": "麻章区",
          "nickname": "",
          "pid": "440800"
        }, {
          "code": "440823",
          "alevel": 3,

          "name": "遂溪县",
          "nickname": "",
          "pid": "440800"
        }, {
          "code": "440825",
          "alevel": 3,

          "name": "徐闻县",
          "nickname": "",
          "pid": "440800"
        }, {
          "code": "440881",
          "alevel": 3,

          "name": "廉江市",
          "nickname": "",
          "pid": "440800"
        }, {
          "code": "440882",
          "alevel": 3,

          "name": "雷州市",
          "nickname": "",
          "pid": "440800"
        }, {
          "code": "440883",
          "alevel": 3,

          "name": "吴川市",
          "nickname": "",
          "pid": "440800"
        }],
        "name": "湛江市",
        "nickname": "",
        "pid": "440000"
      }, {
        "code": "440900",
        "alevel": 2,
        "sub": [{
          "code": "440901",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "440900"
        }, {
          "code": "440902",
          "alevel": 3,

          "name": "茂南区",
          "nickname": "",
          "pid": "440900"
        }, {
          "code": "440904",
          "alevel": 3,

          "name": "电白区",
          "nickname": "",
          "pid": "440900"
        }, {
          "code": "440981",
          "alevel": 3,

          "name": "高州市",
          "nickname": "",
          "pid": "440900"
        }, {
          "code": "440982",
          "alevel": 3,

          "name": "化州市",
          "nickname": "",
          "pid": "440900"
        }, {
          "code": "440983",
          "alevel": 3,

          "name": "信宜市",
          "nickname": "",
          "pid": "440900"
        }],
        "name": "茂名市",
        "nickname": "",
        "pid": "440000"
      }, {
        "code": "441200",
        "alevel": 2,
        "sub": [{
          "code": "441201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "441200"
        }, {
          "code": "441202",
          "alevel": 3,

          "name": "端州区",
          "nickname": "",
          "pid": "441200"
        }, {
          "code": "441203",
          "alevel": 3,

          "name": "鼎湖区",
          "nickname": "",
          "pid": "441200"
        }, {
          "code": "441204",
          "alevel": 3,

          "name": "高要区",
          "nickname": "",
          "pid": "441200"
        }, {
          "code": "441223",
          "alevel": 3,

          "name": "广宁县",
          "nickname": "",
          "pid": "441200"
        }, {
          "code": "441224",
          "alevel": 3,

          "name": "怀集县",
          "nickname": "",
          "pid": "441200"
        }, {
          "code": "441225",
          "alevel": 3,

          "name": "封开县",
          "nickname": "",
          "pid": "441200"
        }, {
          "code": "441226",
          "alevel": 3,

          "name": "德庆县",
          "nickname": "",
          "pid": "441200"
        }, {
          "code": "441284",
          "alevel": 3,

          "name": "四会市",
          "nickname": "",
          "pid": "441200"
        }],
        "name": "肇庆市",
        "nickname": "",
        "pid": "440000"
      }, {
        "code": "441300",
        "alevel": 2,
        "sub": [{
          "code": "441301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "441300"
        }, {
          "code": "441302",
          "alevel": 3,

          "name": "惠城区",
          "nickname": "",
          "pid": "441300"
        }, {
          "code": "441303",
          "alevel": 3,

          "name": "惠阳区",
          "nickname": "",
          "pid": "441300"
        }, {
          "code": "441322",
          "alevel": 3,

          "name": "博罗县",
          "nickname": "",
          "pid": "441300"
        }, {
          "code": "441323",
          "alevel": 3,

          "name": "惠东县",
          "nickname": "",
          "pid": "441300"
        }, {
          "code": "441324",
          "alevel": 3,

          "name": "龙门县",
          "nickname": "",
          "pid": "441300"
        }],
        "name": "惠州市",
        "nickname": "",
        "pid": "440000"
      }, {
        "code": "441400",
        "alevel": 2,
        "sub": [{
          "code": "441401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "441400"
        }, {
          "code": "441402",
          "alevel": 3,

          "name": "梅江区",
          "nickname": "",
          "pid": "441400"
        }, {
          "code": "441403",
          "alevel": 3,

          "name": "梅县区",
          "nickname": "",
          "pid": "441400"
        }, {
          "code": "441422",
          "alevel": 3,

          "name": "大埔县",
          "nickname": "",
          "pid": "441400"
        }, {
          "code": "441423",
          "alevel": 3,

          "name": "丰顺县",
          "nickname": "",
          "pid": "441400"
        }, {
          "code": "441424",
          "alevel": 3,

          "name": "五华县",
          "nickname": "",
          "pid": "441400"
        }, {
          "code": "441426",
          "alevel": 3,

          "name": "平远县",
          "nickname": "",
          "pid": "441400"
        }, {
          "code": "441427",
          "alevel": 3,

          "name": "蕉岭县",
          "nickname": "",
          "pid": "441400"
        }, {
          "code": "441481",
          "alevel": 3,

          "name": "兴宁市",
          "nickname": "",
          "pid": "441400"
        }],
        "name": "梅州市",
        "nickname": "",
        "pid": "440000"
      }, {
        "code": "441500",
        "alevel": 2,
        "sub": [{
          "code": "441501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "441500"
        }, {
          "code": "441502",
          "alevel": 3,

          "name": "城区",
          "nickname": "",
          "pid": "441500"
        }, {
          "code": "441521",
          "alevel": 3,

          "name": "海丰县",
          "nickname": "",
          "pid": "441500"
        }, {
          "code": "441523",
          "alevel": 3,

          "name": "陆河县",
          "nickname": "",
          "pid": "441500"
        }, {
          "code": "441581",
          "alevel": 3,

          "name": "陆丰市",
          "nickname": "",
          "pid": "441500"
        }],
        "name": "汕尾市",
        "nickname": "",
        "pid": "440000"
      }, {
        "code": "441600",
        "alevel": 2,
        "sub": [{
          "code": "441601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "441600"
        }, {
          "code": "441602",
          "alevel": 3,

          "name": "源城区",
          "nickname": "",
          "pid": "441600"
        }, {
          "code": "441621",
          "alevel": 3,

          "name": "紫金县",
          "nickname": "",
          "pid": "441600"
        }, {
          "code": "441622",
          "alevel": 3,

          "name": "龙川县",
          "nickname": "",
          "pid": "441600"
        }, {
          "code": "441623",
          "alevel": 3,

          "name": "连平县",
          "nickname": "",
          "pid": "441600"
        }, {
          "code": "441624",
          "alevel": 3,

          "name": "和平县",
          "nickname": "",
          "pid": "441600"
        }, {
          "code": "441625",
          "alevel": 3,

          "name": "东源县",
          "nickname": "",
          "pid": "441600"
        }],
        "name": "河源市",
        "nickname": "",
        "pid": "440000"
      }, {
        "code": "441700",
        "alevel": 2,
        "sub": [{
          "code": "441701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "441700"
        }, {
          "code": "441702",
          "alevel": 3,

          "name": "江城区",
          "nickname": "",
          "pid": "441700"
        }, {
          "code": "441704",
          "alevel": 3,

          "name": "阳东区",
          "nickname": "",
          "pid": "441700"
        }, {
          "code": "441721",
          "alevel": 3,

          "name": "阳西县",
          "nickname": "",
          "pid": "441700"
        }, {
          "code": "441781",
          "alevel": 3,

          "name": "阳春市",
          "nickname": "",
          "pid": "441700"
        }],
        "name": "阳江市",
        "nickname": "",
        "pid": "440000"
      }, {
        "code": "441800",
        "alevel": 2,
        "sub": [{
          "code": "441801",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "441800"
        }, {
          "code": "441802",
          "alevel": 3,

          "name": "清城区",
          "nickname": "",
          "pid": "441800"
        }, {
          "code": "441803",
          "alevel": 3,

          "name": "清新区",
          "nickname": "",
          "pid": "441800"
        }, {
          "code": "441821",
          "alevel": 3,

          "name": "佛冈县",
          "nickname": "",
          "pid": "441800"
        }, {
          "code": "441823",
          "alevel": 3,

          "name": "阳山县",
          "nickname": "",
          "pid": "441800"
        }, {
          "code": "441825",
          "alevel": 3,

          "name": "连山壮族瑶族自治县",
          "nickname": "",
          "pid": "441800"
        }, {
          "code": "441826",
          "alevel": 3,

          "name": "连南瑶族自治县",
          "nickname": "",
          "pid": "441800"
        }, {
          "code": "441881",
          "alevel": 3,

          "name": "英德市",
          "nickname": "",
          "pid": "441800"
        }, {
          "code": "441882",
          "alevel": 3,

          "name": "连州市",
          "nickname": "",
          "pid": "441800"
        }],
        "name": "清远市",
        "nickname": "",
        "pid": "440000"
      }, {
        "code": "441900",
        "alevel": 2,

        "name": "东莞市",
        "nickname": "",
        "pid": "440000"
      }, {
        "code": "442000",
        "alevel": 2,

        "name": "中山市",
        "nickname": "",
        "pid": "440000"
      }, {
        "code": "445100",
        "alevel": 2,
        "sub": [{
          "code": "445101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "445100"
        }, {
          "code": "445102",
          "alevel": 3,

          "name": "湘桥区",
          "nickname": "",
          "pid": "445100"
        }, {
          "code": "445103",
          "alevel": 3,

          "name": "潮安区",
          "nickname": "",
          "pid": "445100"
        }, {
          "code": "445122",
          "alevel": 3,

          "name": "饶平县",
          "nickname": "",
          "pid": "445100"
        }],
        "name": "潮州市",
        "nickname": "",
        "pid": "440000"
      }, {
        "code": "445200",
        "alevel": 2,
        "sub": [{
          "code": "445201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "445200"
        }, {
          "code": "445202",
          "alevel": 3,

          "name": "榕城区",
          "nickname": "",
          "pid": "445200"
        }, {
          "code": "445203",
          "alevel": 3,

          "name": "揭东区",
          "nickname": "",
          "pid": "445200"
        }, {
          "code": "445222",
          "alevel": 3,

          "name": "揭西县",
          "nickname": "",
          "pid": "445200"
        }, {
          "code": "445224",
          "alevel": 3,

          "name": "惠来县",
          "nickname": "",
          "pid": "445200"
        }, {
          "code": "445281",
          "alevel": 3,

          "name": "普宁市",
          "nickname": "",
          "pid": "445200"
        }],
        "name": "揭阳市",
        "nickname": "",
        "pid": "440000"
      }, {
        "code": "445300",
        "alevel": 2,
        "sub": [{
          "code": "445301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "445300"
        }, {
          "code": "445302",
          "alevel": 3,

          "name": "云城区",
          "nickname": "",
          "pid": "445300"
        }, {
          "code": "445303",
          "alevel": 3,

          "name": "云安区",
          "nickname": "",
          "pid": "445300"
        }, {
          "code": "445321",
          "alevel": 3,

          "name": "新兴县",
          "nickname": "",
          "pid": "445300"
        }, {
          "code": "445322",
          "alevel": 3,

          "name": "郁南县",
          "nickname": "",
          "pid": "445300"
        }, {
          "code": "445381",
          "alevel": 3,

          "name": "罗定市",
          "nickname": "",
          "pid": "445300"
        }],
        "name": "云浮市",
        "nickname": "",
        "pid": "440000"
      }],
      "name": "广东省",
      "nickname": "粤",
      "pid": ""
    }, {
      "code": "450000",
      "alevel": 1,
      "sub": [{
        "code": "450100",
        "alevel": 2,
        "sub": [{
          "code": "450101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "450100"
        }, {
          "code": "450102",
          "alevel": 3,

          "name": "兴宁区",
          "nickname": "",
          "pid": "450100"
        }, {
          "code": "450103",
          "alevel": 3,

          "name": "青秀区",
          "nickname": "",
          "pid": "450100"
        }, {
          "code": "450105",
          "alevel": 3,

          "name": "江南区",
          "nickname": "",
          "pid": "450100"
        }, {
          "code": "450107",
          "alevel": 3,

          "name": "西乡塘区",
          "nickname": "",
          "pid": "450100"
        }, {
          "code": "450108",
          "alevel": 3,

          "name": "良庆区",
          "nickname": "",
          "pid": "450100"
        }, {
          "code": "450109",
          "alevel": 3,

          "name": "邕宁区",
          "nickname": "",
          "pid": "450100"
        }, {
          "code": "450110",
          "alevel": 3,

          "name": "武鸣区",
          "nickname": "",
          "pid": "450100"
        }, {
          "code": "450123",
          "alevel": 3,

          "name": "隆安县",
          "nickname": "",
          "pid": "450100"
        }, {
          "code": "450124",
          "alevel": 3,

          "name": "马山县",
          "nickname": "",
          "pid": "450100"
        }, {
          "code": "450125",
          "alevel": 3,

          "name": "上林县",
          "nickname": "",
          "pid": "450100"
        }, {
          "code": "450126",
          "alevel": 3,

          "name": "宾阳县",
          "nickname": "",
          "pid": "450100"
        }, {
          "code": "450127",
          "alevel": 3,

          "name": "横县",
          "nickname": "",
          "pid": "450100"
        }],
        "name": "南宁市",
        "nickname": "",
        "pid": "450000"
      }, {
        "code": "450200",
        "alevel": 2,
        "sub": [{
          "code": "450201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "450200"
        }, {
          "code": "450202",
          "alevel": 3,

          "name": "城中区",
          "nickname": "",
          "pid": "450200"
        }, {
          "code": "450203",
          "alevel": 3,

          "name": "鱼峰区",
          "nickname": "",
          "pid": "450200"
        }, {
          "code": "450204",
          "alevel": 3,

          "name": "柳南区",
          "nickname": "",
          "pid": "450200"
        }, {
          "code": "450205",
          "alevel": 3,

          "name": "柳北区",
          "nickname": "",
          "pid": "450200"
        }, {
          "code": "450206",
          "alevel": 3,

          "name": "柳江区",
          "nickname": "",
          "pid": "450200"
        }, {
          "code": "450222",
          "alevel": 3,

          "name": "柳城县",
          "nickname": "",
          "pid": "450200"
        }, {
          "code": "450223",
          "alevel": 3,

          "name": "鹿寨县",
          "nickname": "",
          "pid": "450200"
        }, {
          "code": "450224",
          "alevel": 3,

          "name": "融安县",
          "nickname": "",
          "pid": "450200"
        }, {
          "code": "450225",
          "alevel": 3,

          "name": "融水苗族自治县",
          "nickname": "",
          "pid": "450200"
        }, {
          "code": "450226",
          "alevel": 3,

          "name": "三江侗族自治县",
          "nickname": "",
          "pid": "450200"
        }],
        "name": "柳州市",
        "nickname": "",
        "pid": "450000"
      }, {
        "code": "450300",
        "alevel": 2,
        "sub": [{
          "code": "450301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "450300"
        }, {
          "code": "450302",
          "alevel": 3,

          "name": "秀峰区",
          "nickname": "",
          "pid": "450300"
        }, {
          "code": "450303",
          "alevel": 3,

          "name": "叠彩区",
          "nickname": "",
          "pid": "450300"
        }, {
          "code": "450304",
          "alevel": 3,

          "name": "象山区",
          "nickname": "",
          "pid": "450300"
        }, {
          "code": "450305",
          "alevel": 3,

          "name": "七星区",
          "nickname": "",
          "pid": "450300"
        }, {
          "code": "450311",
          "alevel": 3,

          "name": "雁山区",
          "nickname": "",
          "pid": "450300"
        }, {
          "code": "450312",
          "alevel": 3,

          "name": "临桂区",
          "nickname": "",
          "pid": "450300"
        }, {
          "code": "450321",
          "alevel": 3,

          "name": "阳朔县",
          "nickname": "",
          "pid": "450300"
        }, {
          "code": "450323",
          "alevel": 3,

          "name": "灵川县",
          "nickname": "",
          "pid": "450300"
        }, {
          "code": "450324",
          "alevel": 3,

          "name": "全州县",
          "nickname": "",
          "pid": "450300"
        }, {
          "code": "450325",
          "alevel": 3,

          "name": "兴安县",
          "nickname": "",
          "pid": "450300"
        }, {
          "code": "450326",
          "alevel": 3,

          "name": "永福县",
          "nickname": "",
          "pid": "450300"
        }, {
          "code": "450327",
          "alevel": 3,

          "name": "灌阳县",
          "nickname": "",
          "pid": "450300"
        }, {
          "code": "450328",
          "alevel": 3,

          "name": "龙胜各族自治县",
          "nickname": "",
          "pid": "450300"
        }, {
          "code": "450329",
          "alevel": 3,

          "name": "资源县",
          "nickname": "",
          "pid": "450300"
        }, {
          "code": "450330",
          "alevel": 3,

          "name": "平乐县",
          "nickname": "",
          "pid": "450300"
        }, {
          "code": "450331",
          "alevel": 3,

          "name": "荔浦县",
          "nickname": "",
          "pid": "450300"
        }, {
          "code": "450332",
          "alevel": 3,

          "name": "恭城瑶族自治县",
          "nickname": "",
          "pid": "450300"
        }, {
          "code": "450381",
          "alevel": 3,

          "name": "荔浦市",
          "nickname": "",
          "pid": "450300"
        }],
        "name": "桂林市",
        "nickname": "",
        "pid": "450000"
      }, {
        "code": "450400",
        "alevel": 2,
        "sub": [{
          "code": "450401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "450400"
        }, {
          "code": "450403",
          "alevel": 3,

          "name": "万秀区",
          "nickname": "",
          "pid": "450400"
        }, {
          "code": "450405",
          "alevel": 3,

          "name": "长洲区",
          "nickname": "",
          "pid": "450400"
        }, {
          "code": "450406",
          "alevel": 3,

          "name": "龙圩区",
          "nickname": "",
          "pid": "450400"
        }, {
          "code": "450421",
          "alevel": 3,

          "name": "苍梧县",
          "nickname": "",
          "pid": "450400"
        }, {
          "code": "450422",
          "alevel": 3,

          "name": "藤县",
          "nickname": "",
          "pid": "450400"
        }, {
          "code": "450423",
          "alevel": 3,

          "name": "蒙山县",
          "nickname": "",
          "pid": "450400"
        }, {
          "code": "450481",
          "alevel": 3,

          "name": "岑溪市",
          "nickname": "",
          "pid": "450400"
        }],
        "name": "梧州市",
        "nickname": "",
        "pid": "450000"
      }, {
        "code": "450500",
        "alevel": 2,
        "sub": [{
          "code": "450501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "450500"
        }, {
          "code": "450502",
          "alevel": 3,

          "name": "海城区",
          "nickname": "",
          "pid": "450500"
        }, {
          "code": "450503",
          "alevel": 3,

          "name": "银海区",
          "nickname": "",
          "pid": "450500"
        }, {
          "code": "450512",
          "alevel": 3,

          "name": "铁山港区",
          "nickname": "",
          "pid": "450500"
        }, {
          "code": "450521",
          "alevel": 3,

          "name": "合浦县",
          "nickname": "",
          "pid": "450500"
        }],
        "name": "北海市",
        "nickname": "",
        "pid": "450000"
      }, {
        "code": "450600",
        "alevel": 2,
        "sub": [{
          "code": "450601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "450600"
        }, {
          "code": "450602",
          "alevel": 3,

          "name": "港口区",
          "nickname": "",
          "pid": "450600"
        }, {
          "code": "450603",
          "alevel": 3,

          "name": "防城区",
          "nickname": "",
          "pid": "450600"
        }, {
          "code": "450621",
          "alevel": 3,

          "name": "上思县",
          "nickname": "",
          "pid": "450600"
        }, {
          "code": "450681",
          "alevel": 3,

          "name": "东兴市",
          "nickname": "",
          "pid": "450600"
        }],
        "name": "防城港市",
        "nickname": "",
        "pid": "450000"
      }, {
        "code": "450700",
        "alevel": 2,
        "sub": [{
          "code": "450701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "450700"
        }, {
          "code": "450702",
          "alevel": 3,

          "name": "钦南区",
          "nickname": "",
          "pid": "450700"
        }, {
          "code": "450703",
          "alevel": 3,

          "name": "钦北区",
          "nickname": "",
          "pid": "450700"
        }, {
          "code": "450721",
          "alevel": 3,

          "name": "灵山县",
          "nickname": "",
          "pid": "450700"
        }, {
          "code": "450722",
          "alevel": 3,

          "name": "浦北县",
          "nickname": "",
          "pid": "450700"
        }],
        "name": "钦州市",
        "nickname": "",
        "pid": "450000"
      }, {
        "code": "450800",
        "alevel": 2,
        "sub": [{
          "code": "450801",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "450800"
        }, {
          "code": "450802",
          "alevel": 3,

          "name": "港北区",
          "nickname": "",
          "pid": "450800"
        }, {
          "code": "450803",
          "alevel": 3,

          "name": "港南区",
          "nickname": "",
          "pid": "450800"
        }, {
          "code": "450804",
          "alevel": 3,

          "name": "覃塘区",
          "nickname": "",
          "pid": "450800"
        }, {
          "code": "450821",
          "alevel": 3,

          "name": "平南县",
          "nickname": "",
          "pid": "450800"
        }, {
          "code": "450881",
          "alevel": 3,

          "name": "桂平市",
          "nickname": "",
          "pid": "450800"
        }],
        "name": "贵港市",
        "nickname": "",
        "pid": "450000"
      }, {
        "code": "450900",
        "alevel": 2,
        "sub": [{
          "code": "450901",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "450900"
        }, {
          "code": "450902",
          "alevel": 3,

          "name": "玉州区",
          "nickname": "",
          "pid": "450900"
        }, {
          "code": "450903",
          "alevel": 3,

          "name": "福绵区",
          "nickname": "",
          "pid": "450900"
        }, {
          "code": "450921",
          "alevel": 3,

          "name": "容县",
          "nickname": "",
          "pid": "450900"
        }, {
          "code": "450922",
          "alevel": 3,

          "name": "陆川县",
          "nickname": "",
          "pid": "450900"
        }, {
          "code": "450923",
          "alevel": 3,

          "name": "博白县",
          "nickname": "",
          "pid": "450900"
        }, {
          "code": "450924",
          "alevel": 3,

          "name": "兴业县",
          "nickname": "",
          "pid": "450900"
        }, {
          "code": "450981",
          "alevel": 3,

          "name": "北流市",
          "nickname": "",
          "pid": "450900"
        }],
        "name": "玉林市",
        "nickname": "",
        "pid": "450000"
      }, {
        "code": "451000",
        "alevel": 2,
        "sub": [{
          "code": "451001",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "451000"
        }, {
          "code": "451002",
          "alevel": 3,

          "name": "右江区",
          "nickname": "",
          "pid": "451000"
        }, {
          "code": "451003",
          "alevel": 3,

          "name": "田阳区",
          "nickname": "",
          "pid": "451000"
        }, {
          "code": "451021",
          "alevel": 3,

          "name": "田阳县",
          "nickname": "",
          "pid": "451000"
        }, {
          "code": "451022",
          "alevel": 3,

          "name": "田东县",
          "nickname": "",
          "pid": "451000"
        }, {
          "code": "451023",
          "alevel": 3,

          "name": "平果县",
          "nickname": "",
          "pid": "451000"
        }, {
          "code": "451024",
          "alevel": 3,

          "name": "德保县",
          "nickname": "",
          "pid": "451000"
        }, {
          "code": "451026",
          "alevel": 3,

          "name": "那坡县",
          "nickname": "",
          "pid": "451000"
        }, {
          "code": "451027",
          "alevel": 3,

          "name": "凌云县",
          "nickname": "",
          "pid": "451000"
        }, {
          "code": "451028",
          "alevel": 3,

          "name": "乐业县",
          "nickname": "",
          "pid": "451000"
        }, {
          "code": "451029",
          "alevel": 3,

          "name": "田林县",
          "nickname": "",
          "pid": "451000"
        }, {
          "code": "451030",
          "alevel": 3,

          "name": "西林县",
          "nickname": "",
          "pid": "451000"
        }, {
          "code": "451031",
          "alevel": 3,

          "name": "隆林各族自治县",
          "nickname": "",
          "pid": "451000"
        }, {
          "code": "451081",
          "alevel": 3,

          "name": "靖西市",
          "nickname": "",
          "pid": "451000"
        }, {
          "code": "451082",
          "alevel": 3,

          "name": "平果市",
          "nickname": "",
          "pid": "451000"
        }],
        "name": "百色市",
        "nickname": "",
        "pid": "450000"
      }, {
        "code": "451100",
        "alevel": 2,
        "sub": [{
          "code": "451101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "451100"
        }, {
          "code": "451102",
          "alevel": 3,

          "name": "八步区",
          "nickname": "",
          "pid": "451100"
        }, {
          "code": "451103",
          "alevel": 3,

          "name": "平桂区",
          "nickname": "",
          "pid": "451100"
        }, {
          "code": "451121",
          "alevel": 3,

          "name": "昭平县",
          "nickname": "",
          "pid": "451100"
        }, {
          "code": "451122",
          "alevel": 3,

          "name": "钟山县",
          "nickname": "",
          "pid": "451100"
        }, {
          "code": "451123",
          "alevel": 3,

          "name": "富川瑶族自治县",
          "nickname": "",
          "pid": "451100"
        }],
        "name": "贺州市",
        "nickname": "",
        "pid": "450000"
      }, {
        "code": "451200",
        "alevel": 2,
        "sub": [{
          "code": "451201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "451200"
        }, {
          "code": "451202",
          "alevel": 3,

          "name": "金城江区",
          "nickname": "",
          "pid": "451200"
        }, {
          "code": "451203",
          "alevel": 3,

          "name": "宜州区",
          "nickname": "",
          "pid": "451200"
        }, {
          "code": "451221",
          "alevel": 3,

          "name": "南丹县",
          "nickname": "",
          "pid": "451200"
        }, {
          "code": "451222",
          "alevel": 3,

          "name": "天峨县",
          "nickname": "",
          "pid": "451200"
        }, {
          "code": "451223",
          "alevel": 3,

          "name": "凤山县",
          "nickname": "",
          "pid": "451200"
        }, {
          "code": "451224",
          "alevel": 3,

          "name": "东兰县",
          "nickname": "",
          "pid": "451200"
        }, {
          "code": "451225",
          "alevel": 3,

          "name": "罗城仫佬族自治县",
          "nickname": "",
          "pid": "451200"
        }, {
          "code": "451226",
          "alevel": 3,

          "name": "环江毛南族自治县",
          "nickname": "",
          "pid": "451200"
        }, {
          "code": "451227",
          "alevel": 3,

          "name": "巴马瑶族自治县",
          "nickname": "",
          "pid": "451200"
        }, {
          "code": "451228",
          "alevel": 3,

          "name": "都安瑶族自治县",
          "nickname": "",
          "pid": "451200"
        }, {
          "code": "451229",
          "alevel": 3,

          "name": "大化瑶族自治县",
          "nickname": "",
          "pid": "451200"
        }, {
          "code": "451281",
          "alevel": 3,

          "name": "宜州市",
          "nickname": "",
          "pid": "451200"
        }],
        "name": "河池市",
        "nickname": "",
        "pid": "450000"
      }, {
        "code": "451300",
        "alevel": 2,
        "sub": [{
          "code": "451301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "451300"
        }, {
          "code": "451302",
          "alevel": 3,

          "name": "兴宾区",
          "nickname": "",
          "pid": "451300"
        }, {
          "code": "451321",
          "alevel": 3,

          "name": "忻城县",
          "nickname": "",
          "pid": "451300"
        }, {
          "code": "451322",
          "alevel": 3,

          "name": "象州县",
          "nickname": "",
          "pid": "451300"
        }, {
          "code": "451323",
          "alevel": 3,

          "name": "武宣县",
          "nickname": "",
          "pid": "451300"
        }, {
          "code": "451324",
          "alevel": 3,

          "name": "金秀瑶族自治县",
          "nickname": "",
          "pid": "451300"
        }, {
          "code": "451381",
          "alevel": 3,

          "name": "合山市",
          "nickname": "",
          "pid": "451300"
        }],
        "name": "来宾市",
        "nickname": "",
        "pid": "450000"
      }, {
        "code": "451400",
        "alevel": 2,
        "sub": [{
          "code": "451401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "451400"
        }, {
          "code": "451402",
          "alevel": 3,

          "name": "江州区",
          "nickname": "",
          "pid": "451400"
        }, {
          "code": "451421",
          "alevel": 3,

          "name": "扶绥县",
          "nickname": "",
          "pid": "451400"
        }, {
          "code": "451422",
          "alevel": 3,

          "name": "宁明县",
          "nickname": "",
          "pid": "451400"
        }, {
          "code": "451423",
          "alevel": 3,

          "name": "龙州县",
          "nickname": "",
          "pid": "451400"
        }, {
          "code": "451424",
          "alevel": 3,

          "name": "大新县",
          "nickname": "",
          "pid": "451400"
        }, {
          "code": "451425",
          "alevel": 3,

          "name": "天等县",
          "nickname": "",
          "pid": "451400"
        }, {
          "code": "451481",
          "alevel": 3,

          "name": "凭祥市",
          "nickname": "",
          "pid": "451400"
        }],
        "name": "崇左市",
        "nickname": "",
        "pid": "450000"
      }],
      "name": "广西壮族自治区",
      "nickname": "桂",
      "pid": ""
    }, {
      "code": "460000",
      "alevel": 1,
      "sub": [{
        "code": "460100",
        "alevel": 2,
        "sub": [{
          "code": "460101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "460100"
        }, {
          "code": "460105",
          "alevel": 3,

          "name": "秀英区",
          "nickname": "",
          "pid": "460100"
        }, {
          "code": "460106",
          "alevel": 3,

          "name": "龙华区",
          "nickname": "",
          "pid": "460100"
        }, {
          "code": "460107",
          "alevel": 3,

          "name": "琼山区",
          "nickname": "",
          "pid": "460100"
        }, {
          "code": "460108",
          "alevel": 3,

          "name": "美兰区",
          "nickname": "",
          "pid": "460100"
        }],
        "name": "海口市",
        "nickname": "",
        "pid": "460000"
      }, {
        "code": "460200",
        "alevel": 2,
        "sub": [{
          "code": "460201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "460200"
        }, {
          "code": "460202",
          "alevel": 3,

          "name": "海棠区",
          "nickname": "",
          "pid": "460200"
        }, {
          "code": "460203",
          "alevel": 3,

          "name": "吉阳区",
          "nickname": "",
          "pid": "460200"
        }, {
          "code": "460204",
          "alevel": 3,

          "name": "天涯区",
          "nickname": "",
          "pid": "460200"
        }, {
          "code": "460205",
          "alevel": 3,

          "name": "崖州区",
          "nickname": "",
          "pid": "460200"
        }],
        "name": "三亚市",
        "nickname": "",
        "pid": "460000"
      }, {
        "code": "460300",
        "alevel": 2,

        "name": "三沙市",
        "nickname": "",
        "pid": "460000"
      }, {
        "code": "460400",
        "alevel": 2,

        "name": "儋州市",
        "nickname": "",
        "pid": "460000"
      }, {
        "code": "469000",
        "alevel": 2,
        "sub": [{
          "code": "469001",
          "alevel": 3,

          "name": "五指山市",
          "nickname": "",
          "pid": "469000"
        }, {
          "code": "469002",
          "alevel": 3,

          "name": "琼海市",
          "nickname": "",
          "pid": "469000"
        }, {
          "code": "469005",
          "alevel": 3,

          "name": "文昌市",
          "nickname": "",
          "pid": "469000"
        }, {
          "code": "469006",
          "alevel": 3,

          "name": "万宁市",
          "nickname": "",
          "pid": "469000"
        }, {
          "code": "469007",
          "alevel": 3,

          "name": "东方市",
          "nickname": "",
          "pid": "469000"
        }, {
          "code": "469021",
          "alevel": 3,

          "name": "定安县",
          "nickname": "",
          "pid": "469000"
        }, {
          "code": "469022",
          "alevel": 3,

          "name": "屯昌县",
          "nickname": "",
          "pid": "469000"
        }, {
          "code": "469023",
          "alevel": 3,

          "name": "澄迈县",
          "nickname": "",
          "pid": "469000"
        }, {
          "code": "469024",
          "alevel": 3,

          "name": "临高县",
          "nickname": "",
          "pid": "469000"
        }, {
          "code": "469025",
          "alevel": 3,

          "name": "白沙黎族自治县",
          "nickname": "",
          "pid": "469000"
        }, {
          "code": "469026",
          "alevel": 3,

          "name": "昌江黎族自治县",
          "nickname": "",
          "pid": "469000"
        }, {
          "code": "469027",
          "alevel": 3,

          "name": "乐东黎族自治县",
          "nickname": "",
          "pid": "469000"
        }, {
          "code": "469028",
          "alevel": 3,

          "name": "陵水黎族自治县",
          "nickname": "",
          "pid": "469000"
        }, {
          "code": "469029",
          "alevel": 3,

          "name": "保亭黎族苗族自治县",
          "nickname": "",
          "pid": "469000"
        }, {
          "code": "469030",
          "alevel": 3,

          "name": "琼中黎族苗族自治县",
          "nickname": "",
          "pid": "469000"
        }],
        "name": "省直辖县级行政区划",
        "nickname": "",
        "pid": "460000"
      }],
      "name": "海南省",
      "nickname": "琼",
      "pid": ""
    }, {
      "code": "500000",
      "alevel": 1,
      "sub": [{
        "code": "500100",
        "alevel": 2,
        "sub": [{
          "code": "500101",
          "alevel": 3,

          "name": "万州区",
          "nickname": "",
          "pid": "500100"
        }, {
          "code": "500102",
          "alevel": 3,

          "name": "涪陵区",
          "nickname": "",
          "pid": "500100"
        }, {
          "code": "500103",
          "alevel": 3,

          "name": "渝中区",
          "nickname": "",
          "pid": "500100"
        }, {
          "code": "500104",
          "alevel": 3,

          "name": "大渡口区",
          "nickname": "",
          "pid": "500100"
        }, {
          "code": "500105",
          "alevel": 3,

          "name": "江北区",
          "nickname": "",
          "pid": "500100"
        }, {
          "code": "500106",
          "alevel": 3,

          "name": "沙坪坝区",
          "nickname": "",
          "pid": "500100"
        }, {
          "code": "500107",
          "alevel": 3,

          "name": "九龙坡区",
          "nickname": "",
          "pid": "500100"
        }, {
          "code": "500108",
          "alevel": 3,

          "name": "南岸区",
          "nickname": "",
          "pid": "500100"
        }, {
          "code": "500109",
          "alevel": 3,

          "name": "北碚区",
          "nickname": "",
          "pid": "500100"
        }, {
          "code": "500110",
          "alevel": 3,

          "name": "綦江区",
          "nickname": "",
          "pid": "500100"
        }, {
          "code": "500111",
          "alevel": 3,

          "name": "大足区",
          "nickname": "",
          "pid": "500100"
        }, {
          "code": "500112",
          "alevel": 3,

          "name": "渝北区",
          "nickname": "",
          "pid": "500100"
        }, {
          "code": "500113",
          "alevel": 3,

          "name": "巴南区",
          "nickname": "",
          "pid": "500100"
        }, {
          "code": "500114",
          "alevel": 3,

          "name": "黔江区",
          "nickname": "",
          "pid": "500100"
        }, {
          "code": "500115",
          "alevel": 3,

          "name": "长寿区",
          "nickname": "",
          "pid": "500100"
        }, {
          "code": "500116",
          "alevel": 3,

          "name": "江津区",
          "nickname": "",
          "pid": "500100"
        }, {
          "code": "500117",
          "alevel": 3,

          "name": "合川区",
          "nickname": "",
          "pid": "500100"
        }, {
          "code": "500118",
          "alevel": 3,

          "name": "永川区",
          "nickname": "",
          "pid": "500100"
        }, {
          "code": "500119",
          "alevel": 3,

          "name": "南川区",
          "nickname": "",
          "pid": "500100"
        }, {
          "code": "500120",
          "alevel": 3,

          "name": "璧山区",
          "nickname": "",
          "pid": "500100"
        }, {
          "code": "500151",
          "alevel": 3,

          "name": "铜梁区",
          "nickname": "",
          "pid": "500100"
        }, {
          "code": "500152",
          "alevel": 3,

          "name": "潼南区",
          "nickname": "",
          "pid": "500100"
        }, {
          "code": "500153",
          "alevel": 3,

          "name": "荣昌区",
          "nickname": "",
          "pid": "500100"
        }, {
          "code": "500154",
          "alevel": 3,

          "name": "开州区",
          "nickname": "",
          "pid": "500100"
        }, {
          "code": "500155",
          "alevel": 3,

          "name": "梁平区",
          "nickname": "",
          "pid": "500100"
        }, {
          "code": "500156",
          "alevel": 3,

          "name": "武隆区",
          "nickname": "",
          "pid": "500100"
        }],
        "name": "重庆市",
        "nickname": "",
        "pid": "500000"
      }, {
        "code": "500200",
        "alevel": 2,
        "name": "县",
        "nickname": "",
        "pid": "500000",
        "sub":[
          {
            "code": "500228",
            "alevel": 3,

            "name": "梁平县",
            "nickname": "",
            "pid": "500100"
          }, {
            "code": "500229",
            "alevel": 3,

            "name": "城口县",
            "nickname": "",
            "pid": "500100"
          }, {
            "code": "500230",
            "alevel": 3,

            "name": "丰都县",
            "nickname": "",
            "pid": "500100"
          }, {
            "code": "500231",
            "alevel": 3,

            "name": "垫江县",
            "nickname": "",
            "pid": "500100"
          }, {
            "code": "500232",
            "alevel": 3,

            "name": "武隆县",
            "nickname": "",
            "pid": "500100"
          }, {
            "code": "500233",
            "alevel": 3,

            "name": "忠县",
            "nickname": "",
            "pid": "500100"
          }, {
            "code": "500235",
            "alevel": 3,

            "name": "云阳县",
            "nickname": "",
            "pid": "500100"
          }, {
            "code": "500236",
            "alevel": 3,

            "name": "奉节县",
            "nickname": "",
            "pid": "500100"
          }, {
            "code": "500237",
            "alevel": 3,

            "name": "巫山县",
            "nickname": "",
            "pid": "500100"
          }, {
            "code": "500238",
            "alevel": 3,

            "name": "巫溪县",
            "nickname": "",
            "pid": "500100"
          }, {
            "code": "500240",
            "alevel": 3,

            "name": "石柱土家族自治县",
            "nickname": "",
            "pid": "500100"
          }, {
            "code": "500241",
            "alevel": 3,

            "name": "秀山土家族苗族自治县",
            "nickname": "",
            "pid": "500100"
          }, {
            "code": "500242",
            "alevel": 3,

            "name": "酉阳土家族苗族自治县",
            "nickname": "",
            "pid": "500100"
          }, {
            "code": "500243",
            "alevel": 3,

            "name": "彭水苗族土家族自治县",
            "nickname": "",
            "pid": "500100"
          }
        ]
      }],
      "name": "重庆市",
      "nickname": "渝",
      "pid": ""
    }, {
      "code": "510000",
      "alevel": 1,
      "sub": [{
        "code": "510100",
        "alevel": 2,
        "sub": [{
          "code": "510101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "510100"
        }, {
          "code": "510104",
          "alevel": 3,

          "name": "锦江区",
          "nickname": "",
          "pid": "510100"
        }, {
          "code": "510105",
          "alevel": 3,

          "name": "青羊区",
          "nickname": "",
          "pid": "510100"
        }, {
          "code": "510106",
          "alevel": 3,

          "name": "金牛区",
          "nickname": "",
          "pid": "510100"
        }, {
          "code": "510107",
          "alevel": 3,

          "name": "武侯区",
          "nickname": "",
          "pid": "510100"
        }, {
          "code": "510108",
          "alevel": 3,

          "name": "成华区",
          "nickname": "",
          "pid": "510100"
        }, {
          "code": "510112",
          "alevel": 3,

          "name": "龙泉驿区",
          "nickname": "",
          "pid": "510100"
        }, {
          "code": "510113",
          "alevel": 3,

          "name": "青白江区",
          "nickname": "",
          "pid": "510100"
        }, {
          "code": "510114",
          "alevel": 3,

          "name": "新都区",
          "nickname": "",
          "pid": "510100"
        }, {
          "code": "510115",
          "alevel": 3,

          "name": "温江区",
          "nickname": "",
          "pid": "510100"
        }, {
          "code": "510116",
          "alevel": 3,

          "name": "双流区",
          "nickname": "",
          "pid": "510100"
        }, {
          "code": "510117",
          "alevel": 3,

          "name": "郫都区",
          "nickname": "",
          "pid": "510100"
        }, {
          "code": "510121",
          "alevel": 3,

          "name": "金堂县",
          "nickname": "",
          "pid": "510100"
        }, {
          "code": "510124",
          "alevel": 3,

          "name": "郫县",
          "nickname": "",
          "pid": "510100"
        }, {
          "code": "510129",
          "alevel": 3,

          "name": "大邑县",
          "nickname": "",
          "pid": "510100"
        }, {
          "code": "510131",
          "alevel": 3,

          "name": "蒲江县",
          "nickname": "",
          "pid": "510100"
        }, {
          "code": "510132",
          "alevel": 3,

          "name": "新津县",
          "nickname": "",
          "pid": "510100"
        }, {
          "code": "510181",
          "alevel": 3,

          "name": "都江堰市",
          "nickname": "",
          "pid": "510100"
        }, {
          "code": "510182",
          "alevel": 3,

          "name": "彭州市",
          "nickname": "",
          "pid": "510100"
        }, {
          "code": "510183",
          "alevel": 3,

          "name": "邛崃市",
          "nickname": "",
          "pid": "510100"
        }, {
          "code": "510184",
          "alevel": 3,

          "name": "崇州市",
          "nickname": "",
          "pid": "510100"
        }, {
          "code": "510185",
          "alevel": 3,

          "name": "简阳市",
          "nickname": "",
          "pid": "510100"
        }],
        "name": "成都市",
        "nickname": "",
        "pid": "510000"
      }, {
        "code": "510300",
        "alevel": 2,
        "sub": [{
          "code": "510301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "510300"
        }, {
          "code": "510302",
          "alevel": 3,

          "name": "自流井区",
          "nickname": "",
          "pid": "510300"
        }, {
          "code": "510303",
          "alevel": 3,

          "name": "贡井区",
          "nickname": "",
          "pid": "510300"
        }, {
          "code": "510304",
          "alevel": 3,

          "name": "大安区",
          "nickname": "",
          "pid": "510300"
        }, {
          "code": "510311",
          "alevel": 3,

          "name": "沿滩区",
          "nickname": "",
          "pid": "510300"
        }, {
          "code": "510321",
          "alevel": 3,

          "name": "荣县",
          "nickname": "",
          "pid": "510300"
        }, {
          "code": "510322",
          "alevel": 3,

          "name": "富顺县",
          "nickname": "",
          "pid": "510300"
        }],
        "name": "自贡市",
        "nickname": "",
        "pid": "510000"
      }, {
        "code": "510400",
        "alevel": 2,
        "sub": [{
          "code": "510401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "510400"
        }, {
          "code": "510402",
          "alevel": 3,

          "name": "东区",
          "nickname": "",
          "pid": "510400"
        }, {
          "code": "510403",
          "alevel": 3,

          "name": "西区",
          "nickname": "",
          "pid": "510400"
        }, {
          "code": "510411",
          "alevel": 3,

          "name": "仁和区",
          "nickname": "",
          "pid": "510400"
        }, {
          "code": "510421",
          "alevel": 3,

          "name": "米易县",
          "nickname": "",
          "pid": "510400"
        }, {
          "code": "510422",
          "alevel": 3,

          "name": "盐边县",
          "nickname": "",
          "pid": "510400"
        }],
        "name": "攀枝花市",
        "nickname": "",
        "pid": "510000"
      }, {
        "code": "510500",
        "alevel": 2,
        "sub": [{
          "code": "510501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "510500"
        }, {
          "code": "510502",
          "alevel": 3,

          "name": "江阳区",
          "nickname": "",
          "pid": "510500"
        }, {
          "code": "510503",
          "alevel": 3,

          "name": "纳溪区",
          "nickname": "",
          "pid": "510500"
        }, {
          "code": "510504",
          "alevel": 3,

          "name": "龙马潭区",
          "nickname": "",
          "pid": "510500"
        }, {
          "code": "510521",
          "alevel": 3,

          "name": "泸县",
          "nickname": "",
          "pid": "510500"
        }, {
          "code": "510522",
          "alevel": 3,

          "name": "合江县",
          "nickname": "",
          "pid": "510500"
        }, {
          "code": "510524",
          "alevel": 3,

          "name": "叙永县",
          "nickname": "",
          "pid": "510500"
        }, {
          "code": "510525",
          "alevel": 3,

          "name": "古蔺县",
          "nickname": "",
          "pid": "510500"
        }],
        "name": "泸州市",
        "nickname": "",
        "pid": "510000"
      }, {
        "code": "510600",
        "alevel": 2,
        "sub": [{
          "code": "510601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "510600"
        }, {
          "code": "510603",
          "alevel": 3,

          "name": "旌阳区",
          "nickname": "",
          "pid": "510600"
        }, {
          "code": "510604",
          "alevel": 3,

          "name": "罗江区",
          "nickname": "",
          "pid": "510600"
        }, {
          "code": "510623",
          "alevel": 3,

          "name": "中江县",
          "nickname": "",
          "pid": "510600"
        }, {
          "code": "510626",
          "alevel": 3,

          "name": "罗江县",
          "nickname": "",
          "pid": "510600"
        }, {
          "code": "510681",
          "alevel": 3,

          "name": "广汉市",
          "nickname": "",
          "pid": "510600"
        }, {
          "code": "510682",
          "alevel": 3,

          "name": "什邡市",
          "nickname": "",
          "pid": "510600"
        }, {
          "code": "510683",
          "alevel": 3,

          "name": "绵竹市",
          "nickname": "",
          "pid": "510600"
        }],
        "name": "德阳市",
        "nickname": "",
        "pid": "510000"
      }, {
        "code": "510700",
        "alevel": 2,
        "sub": [{
          "code": "510701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "510700"
        }, {
          "code": "510703",
          "alevel": 3,

          "name": "涪城区",
          "nickname": "",
          "pid": "510700"
        }, {
          "code": "510704",
          "alevel": 3,

          "name": "游仙区",
          "nickname": "",
          "pid": "510700"
        }, {
          "code": "510705",
          "alevel": 3,

          "name": "安州区",
          "nickname": "",
          "pid": "510700"
        }, {
          "code": "510722",
          "alevel": 3,

          "name": "三台县",
          "nickname": "",
          "pid": "510700"
        }, {
          "code": "510723",
          "alevel": 3,

          "name": "盐亭县",
          "nickname": "",
          "pid": "510700"
        }, {
          "code": "510725",
          "alevel": 3,

          "name": "梓潼县",
          "nickname": "",
          "pid": "510700"
        }, {
          "code": "510726",
          "alevel": 3,

          "name": "北川羌族自治县",
          "nickname": "",
          "pid": "510700"
        }, {
          "code": "510727",
          "alevel": 3,

          "name": "平武县",
          "nickname": "",
          "pid": "510700"
        }, {
          "code": "510781",
          "alevel": 3,

          "name": "江油市",
          "nickname": "",
          "pid": "510700"
        }],
        "name": "绵阳市",
        "nickname": "",
        "pid": "510000"
      }, {
        "code": "510800",
        "alevel": 2,
        "sub": [{
          "code": "510801",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "510800"
        }, {
          "code": "510802",
          "alevel": 3,

          "name": "利州区",
          "nickname": "",
          "pid": "510800"
        }, {
          "code": "510811",
          "alevel": 3,

          "name": "昭化区",
          "nickname": "",
          "pid": "510800"
        }, {
          "code": "510812",
          "alevel": 3,

          "name": "朝天区",
          "nickname": "",
          "pid": "510800"
        }, {
          "code": "510821",
          "alevel": 3,

          "name": "旺苍县",
          "nickname": "",
          "pid": "510800"
        }, {
          "code": "510822",
          "alevel": 3,

          "name": "青川县",
          "nickname": "",
          "pid": "510800"
        }, {
          "code": "510823",
          "alevel": 3,

          "name": "剑阁县",
          "nickname": "",
          "pid": "510800"
        }, {
          "code": "510824",
          "alevel": 3,

          "name": "苍溪县",
          "nickname": "",
          "pid": "510800"
        }],
        "name": "广元市",
        "nickname": "",
        "pid": "510000"
      }, {
        "code": "510900",
        "alevel": 2,
        "sub": [{
          "code": "510901",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "510900"
        }, {
          "code": "510903",
          "alevel": 3,

          "name": "船山区",
          "nickname": "",
          "pid": "510900"
        }, {
          "code": "510904",
          "alevel": 3,

          "name": "安居区",
          "nickname": "",
          "pid": "510900"
        }, {
          "code": "510921",
          "alevel": 3,

          "name": "蓬溪县",
          "nickname": "",
          "pid": "510900"
        }, {
          "code": "510922",
          "alevel": 3,

          "name": "射洪县",
          "nickname": "",
          "pid": "510900"
        }, {
          "code": "510923",
          "alevel": 3,

          "name": "大英县",
          "nickname": "",
          "pid": "510900"
        }, {
          "code": "510981",
          "alevel": 3,

          "name": "射洪市",
          "nickname": "",
          "pid": "510900"
        }],
        "name": "遂宁市",
        "nickname": "",
        "pid": "510000"
      }, {
        "code": "511000",
        "alevel": 2,
        "sub": [{
          "code": "511001",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "511000"
        }, {
          "code": "511002",
          "alevel": 3,

          "name": "市中区",
          "nickname": "",
          "pid": "511000"
        }, {
          "code": "511011",
          "alevel": 3,

          "name": "东兴区",
          "nickname": "",
          "pid": "511000"
        }, {
          "code": "511024",
          "alevel": 3,

          "name": "威远县",
          "nickname": "",
          "pid": "511000"
        }, {
          "code": "511025",
          "alevel": 3,

          "name": "资中县",
          "nickname": "",
          "pid": "511000"
        }, {
          "code": "511028",
          "alevel": 3,

          "name": "隆昌县",
          "nickname": "",
          "pid": "511000"
        }, {
          "code": "511083",
          "alevel": 3,

          "name": "隆昌市",
          "nickname": "",
          "pid": "511000"
        }],
        "name": "内江市",
        "nickname": "",
        "pid": "510000"
      }, {
        "code": "511100",
        "alevel": 2,
        "sub": [{
          "code": "511101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "511100"
        }, {
          "code": "511102",
          "alevel": 3,

          "name": "市中区",
          "nickname": "",
          "pid": "511100"
        }, {
          "code": "511111",
          "alevel": 3,

          "name": "沙湾区",
          "nickname": "",
          "pid": "511100"
        }, {
          "code": "511112",
          "alevel": 3,

          "name": "五通桥区",
          "nickname": "",
          "pid": "511100"
        }, {
          "code": "511113",
          "alevel": 3,

          "name": "金口河区",
          "nickname": "",
          "pid": "511100"
        }, {
          "code": "511123",
          "alevel": 3,

          "name": "犍为县",
          "nickname": "",
          "pid": "511100"
        }, {
          "code": "511124",
          "alevel": 3,

          "name": "井研县",
          "nickname": "",
          "pid": "511100"
        }, {
          "code": "511126",
          "alevel": 3,

          "name": "夹江县",
          "nickname": "",
          "pid": "511100"
        }, {
          "code": "511129",
          "alevel": 3,

          "name": "沐川县",
          "nickname": "",
          "pid": "511100"
        }, {
          "code": "511132",
          "alevel": 3,

          "name": "峨边彝族自治县",
          "nickname": "",
          "pid": "511100"
        }, {
          "code": "511133",
          "alevel": 3,

          "name": "马边彝族自治县",
          "nickname": "",
          "pid": "511100"
        }, {
          "code": "511181",
          "alevel": 3,

          "name": "峨眉山市",
          "nickname": "",
          "pid": "511100"
        }],
        "name": "乐山市",
        "nickname": "",
        "pid": "510000"
      }, {
        "code": "511300",
        "alevel": 2,
        "sub": [{
          "code": "511301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "511300"
        }, {
          "code": "511302",
          "alevel": 3,

          "name": "顺庆区",
          "nickname": "",
          "pid": "511300"
        }, {
          "code": "511303",
          "alevel": 3,

          "name": "高坪区",
          "nickname": "",
          "pid": "511300"
        }, {
          "code": "511304",
          "alevel": 3,

          "name": "嘉陵区",
          "nickname": "",
          "pid": "511300"
        }, {
          "code": "511321",
          "alevel": 3,

          "name": "南部县",
          "nickname": "",
          "pid": "511300"
        }, {
          "code": "511322",
          "alevel": 3,

          "name": "营山县",
          "nickname": "",
          "pid": "511300"
        }, {
          "code": "511323",
          "alevel": 3,

          "name": "蓬安县",
          "nickname": "",
          "pid": "511300"
        }, {
          "code": "511324",
          "alevel": 3,

          "name": "仪陇县",
          "nickname": "",
          "pid": "511300"
        }, {
          "code": "511325",
          "alevel": 3,

          "name": "西充县",
          "nickname": "",
          "pid": "511300"
        }, {
          "code": "511381",
          "alevel": 3,

          "name": "阆中市",
          "nickname": "",
          "pid": "511300"
        }],
        "name": "南充市",
        "nickname": "",
        "pid": "510000"
      }, {
        "code": "511400",
        "alevel": 2,
        "sub": [{
          "code": "511401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "511400"
        }, {
          "code": "511402",
          "alevel": 3,

          "name": "东坡区",
          "nickname": "",
          "pid": "511400"
        }, {
          "code": "511403",
          "alevel": 3,

          "name": "彭山区",
          "nickname": "",
          "pid": "511400"
        }, {
          "code": "511421",
          "alevel": 3,

          "name": "仁寿县",
          "nickname": "",
          "pid": "511400"
        }, {
          "code": "511423",
          "alevel": 3,

          "name": "洪雅县",
          "nickname": "",
          "pid": "511400"
        }, {
          "code": "511424",
          "alevel": 3,

          "name": "丹棱县",
          "nickname": "",
          "pid": "511400"
        }, {
          "code": "511425",
          "alevel": 3,

          "name": "青神县",
          "nickname": "",
          "pid": "511400"
        }],
        "name": "眉山市",
        "nickname": "",
        "pid": "510000"
      }, {
        "code": "511500",
        "alevel": 2,
        "sub": [{
          "code": "511501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "511500"
        }, {
          "code": "511502",
          "alevel": 3,

          "name": "翠屏区",
          "nickname": "",
          "pid": "511500"
        }, {
          "code": "511503",
          "alevel": 3,

          "name": "南溪区",
          "nickname": "",
          "pid": "511500"
        }, {
          "code": "511504",
          "alevel": 3,

          "name": "叙州区",
          "nickname": "",
          "pid": "511500"
        }, {
          "code": "511521",
          "alevel": 3,

          "name": "宜宾县",
          "nickname": "",
          "pid": "511500"
        }, {
          "code": "511523",
          "alevel": 3,

          "name": "江安县",
          "nickname": "",
          "pid": "511500"
        }, {
          "code": "511524",
          "alevel": 3,

          "name": "长宁县",
          "nickname": "",
          "pid": "511500"
        }, {
          "code": "511525",
          "alevel": 3,

          "name": "高县",
          "nickname": "",
          "pid": "511500"
        }, {
          "code": "511526",
          "alevel": 3,

          "name": "珙县",
          "nickname": "",
          "pid": "511500"
        }, {
          "code": "511527",
          "alevel": 3,

          "name": "筠连县",
          "nickname": "",
          "pid": "511500"
        }, {
          "code": "511528",
          "alevel": 3,

          "name": "兴文县",
          "nickname": "",
          "pid": "511500"
        }, {
          "code": "511529",
          "alevel": 3,

          "name": "屏山县",
          "nickname": "",
          "pid": "511500"
        }],
        "name": "宜宾市",
        "nickname": "",
        "pid": "510000"
      }, {
        "code": "511600",
        "alevel": 2,
        "sub": [{
          "code": "511601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "511600"
        }, {
          "code": "511602",
          "alevel": 3,

          "name": "广安区",
          "nickname": "",
          "pid": "511600"
        }, {
          "code": "511603",
          "alevel": 3,

          "name": "前锋区",
          "nickname": "",
          "pid": "511600"
        }, {
          "code": "511621",
          "alevel": 3,

          "name": "岳池县",
          "nickname": "",
          "pid": "511600"
        }, {
          "code": "511622",
          "alevel": 3,

          "name": "武胜县",
          "nickname": "",
          "pid": "511600"
        }, {
          "code": "511623",
          "alevel": 3,

          "name": "邻水县",
          "nickname": "",
          "pid": "511600"
        }, {
          "code": "511681",
          "alevel": 3,

          "name": "华蓥市",
          "nickname": "",
          "pid": "511600"
        }],
        "name": "广安市",
        "nickname": "",
        "pid": "510000"
      }, {
        "code": "511700",
        "alevel": 2,
        "sub": [{
          "code": "511701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "511700"
        }, {
          "code": "511702",
          "alevel": 3,

          "name": "通川区",
          "nickname": "",
          "pid": "511700"
        }, {
          "code": "511703",
          "alevel": 3,

          "name": "达川区",
          "nickname": "",
          "pid": "511700"
        }, {
          "code": "511722",
          "alevel": 3,

          "name": "宣汉县",
          "nickname": "",
          "pid": "511700"
        }, {
          "code": "511723",
          "alevel": 3,

          "name": "开江县",
          "nickname": "",
          "pid": "511700"
        }, {
          "code": "511724",
          "alevel": 3,

          "name": "大竹县",
          "nickname": "",
          "pid": "511700"
        }, {
          "code": "511725",
          "alevel": 3,

          "name": "渠县",
          "nickname": "",
          "pid": "511700"
        }, {
          "code": "511781",
          "alevel": 3,

          "name": "万源市",
          "nickname": "",
          "pid": "511700"
        }],
        "name": "达州市",
        "nickname": "",
        "pid": "510000"
      }, {
        "code": "511800",
        "alevel": 2,
        "sub": [{
          "code": "511801",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "511800"
        }, {
          "code": "511802",
          "alevel": 3,

          "name": "雨城区",
          "nickname": "",
          "pid": "511800"
        }, {
          "code": "511803",
          "alevel": 3,

          "name": "名山区",
          "nickname": "",
          "pid": "511800"
        }, {
          "code": "511822",
          "alevel": 3,

          "name": "荥经县",
          "nickname": "",
          "pid": "511800"
        }, {
          "code": "511823",
          "alevel": 3,

          "name": "汉源县",
          "nickname": "",
          "pid": "511800"
        }, {
          "code": "511824",
          "alevel": 3,

          "name": "石棉县",
          "nickname": "",
          "pid": "511800"
        }, {
          "code": "511825",
          "alevel": 3,

          "name": "天全县",
          "nickname": "",
          "pid": "511800"
        }, {
          "code": "511826",
          "alevel": 3,

          "name": "芦山县",
          "nickname": "",
          "pid": "511800"
        }, {
          "code": "511827",
          "alevel": 3,

          "name": "宝兴县",
          "nickname": "",
          "pid": "511800"
        }],
        "name": "雅安市",
        "nickname": "",
        "pid": "510000"
      }, {
        "code": "511900",
        "alevel": 2,
        "sub": [{
          "code": "511901",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "511900"
        }, {
          "code": "511902",
          "alevel": 3,

          "name": "巴州区",
          "nickname": "",
          "pid": "511900"
        }, {
          "code": "511903",
          "alevel": 3,

          "name": "恩阳区",
          "nickname": "",
          "pid": "511900"
        }, {
          "code": "511921",
          "alevel": 3,

          "name": "通江县",
          "nickname": "",
          "pid": "511900"
        }, {
          "code": "511922",
          "alevel": 3,

          "name": "南江县",
          "nickname": "",
          "pid": "511900"
        }, {
          "code": "511923",
          "alevel": 3,

          "name": "平昌县",
          "nickname": "",
          "pid": "511900"
        }],
        "name": "巴中市",
        "nickname": "",
        "pid": "510000"
      }, {
        "code": "512000",
        "alevel": 2,
        "sub": [{
          "code": "512001",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "512000"
        }, {
          "code": "512002",
          "alevel": 3,

          "name": "雁江区",
          "nickname": "",
          "pid": "512000"
        }, {
          "code": "512021",
          "alevel": 3,

          "name": "安岳县",
          "nickname": "",
          "pid": "512000"
        }, {
          "code": "512022",
          "alevel": 3,

          "name": "乐至县",
          "nickname": "",
          "pid": "512000"
        }],
        "name": "资阳市",
        "nickname": "",
        "pid": "510000"
      }, {
        "code": "513200",
        "alevel": 2,
        "sub": [{
          "code": "513201",
          "alevel": 3,

          "name": "马尔康市",
          "nickname": "",
          "pid": "513200"
        }, {
          "code": "513221",
          "alevel": 3,

          "name": "汶川县",
          "nickname": "",
          "pid": "513200"
        }, {
          "code": "513222",
          "alevel": 3,

          "name": "理县",
          "nickname": "",
          "pid": "513200"
        }, {
          "code": "513223",
          "alevel": 3,

          "name": "茂县",
          "nickname": "",
          "pid": "513200"
        }, {
          "code": "513224",
          "alevel": 3,

          "name": "松潘县",
          "nickname": "",
          "pid": "513200"
        }, {
          "code": "513225",
          "alevel": 3,

          "name": "九寨沟县",
          "nickname": "",
          "pid": "513200"
        }, {
          "code": "513226",
          "alevel": 3,

          "name": "金川县",
          "nickname": "",
          "pid": "513200"
        }, {
          "code": "513227",
          "alevel": 3,

          "name": "小金县",
          "nickname": "",
          "pid": "513200"
        }, {
          "code": "513228",
          "alevel": 3,

          "name": "黑水县",
          "nickname": "",
          "pid": "513200"
        }, {
          "code": "513230",
          "alevel": 3,

          "name": "壤塘县",
          "nickname": "",
          "pid": "513200"
        }, {
          "code": "513231",
          "alevel": 3,

          "name": "阿坝县",
          "nickname": "",
          "pid": "513200"
        }, {
          "code": "513232",
          "alevel": 3,

          "name": "若尔盖县",
          "nickname": "",
          "pid": "513200"
        }, {
          "code": "513233",
          "alevel": 3,

          "name": "红原县",
          "nickname": "",
          "pid": "513200"
        }],
        "name": "阿坝藏族羌族自治州",
        "nickname": "",
        "pid": "510000"
      }, {
        "code": "513300",
        "alevel": 2,
        "sub": [{
          "code": "513301",
          "alevel": 3,

          "name": "康定市",
          "nickname": "",
          "pid": "513300"
        }, {
          "code": "513322",
          "alevel": 3,

          "name": "泸定县",
          "nickname": "",
          "pid": "513300"
        }, {
          "code": "513323",
          "alevel": 3,

          "name": "丹巴县",
          "nickname": "",
          "pid": "513300"
        }, {
          "code": "513324",
          "alevel": 3,

          "name": "九龙县",
          "nickname": "",
          "pid": "513300"
        }, {
          "code": "513325",
          "alevel": 3,

          "name": "雅江县",
          "nickname": "",
          "pid": "513300"
        }, {
          "code": "513326",
          "alevel": 3,

          "name": "道孚县",
          "nickname": "",
          "pid": "513300"
        }, {
          "code": "513327",
          "alevel": 3,

          "name": "炉霍县",
          "nickname": "",
          "pid": "513300"
        }, {
          "code": "513328",
          "alevel": 3,

          "name": "甘孜县",
          "nickname": "",
          "pid": "513300"
        }, {
          "code": "513329",
          "alevel": 3,

          "name": "新龙县",
          "nickname": "",
          "pid": "513300"
        }, {
          "code": "513330",
          "alevel": 3,

          "name": "德格县",
          "nickname": "",
          "pid": "513300"
        }, {
          "code": "513331",
          "alevel": 3,

          "name": "白玉县",
          "nickname": "",
          "pid": "513300"
        }, {
          "code": "513332",
          "alevel": 3,

          "name": "石渠县",
          "nickname": "",
          "pid": "513300"
        }, {
          "code": "513333",
          "alevel": 3,

          "name": "色达县",
          "nickname": "",
          "pid": "513300"
        }, {
          "code": "513334",
          "alevel": 3,

          "name": "理塘县",
          "nickname": "",
          "pid": "513300"
        }, {
          "code": "513335",
          "alevel": 3,

          "name": "巴塘县",
          "nickname": "",
          "pid": "513300"
        }, {
          "code": "513336",
          "alevel": 3,

          "name": "乡城县",
          "nickname": "",
          "pid": "513300"
        }, {
          "code": "513337",
          "alevel": 3,

          "name": "稻城县",
          "nickname": "",
          "pid": "513300"
        }, {
          "code": "513338",
          "alevel": 3,

          "name": "得荣县",
          "nickname": "",
          "pid": "513300"
        }],
        "name": "甘孜藏族自治州",
        "nickname": "",
        "pid": "510000"
      }, {
        "code": "513400",
        "alevel": 2,
        "sub": [{
          "code": "513401",
          "alevel": 3,

          "name": "西昌市",
          "nickname": "",
          "pid": "513400"
        }, {
          "code": "513422",
          "alevel": 3,

          "name": "木里藏族自治县",
          "nickname": "",
          "pid": "513400"
        }, {
          "code": "513423",
          "alevel": 3,

          "name": "盐源县",
          "nickname": "",
          "pid": "513400"
        }, {
          "code": "513424",
          "alevel": 3,

          "name": "德昌县",
          "nickname": "",
          "pid": "513400"
        }, {
          "code": "513425",
          "alevel": 3,

          "name": "会理县",
          "nickname": "",
          "pid": "513400"
        }, {
          "code": "513426",
          "alevel": 3,

          "name": "会东县",
          "nickname": "",
          "pid": "513400"
        }, {
          "code": "513427",
          "alevel": 3,

          "name": "宁南县",
          "nickname": "",
          "pid": "513400"
        }, {
          "code": "513428",
          "alevel": 3,

          "name": "普格县",
          "nickname": "",
          "pid": "513400"
        }, {
          "code": "513429",
          "alevel": 3,

          "name": "布拖县",
          "nickname": "",
          "pid": "513400"
        }, {
          "code": "513430",
          "alevel": 3,

          "name": "金阳县",
          "nickname": "",
          "pid": "513400"
        }, {
          "code": "513431",
          "alevel": 3,

          "name": "昭觉县",
          "nickname": "",
          "pid": "513400"
        }, {
          "code": "513432",
          "alevel": 3,

          "name": "喜德县",
          "nickname": "",
          "pid": "513400"
        }, {
          "code": "513433",
          "alevel": 3,

          "name": "冕宁县",
          "nickname": "",
          "pid": "513400"
        }, {
          "code": "513434",
          "alevel": 3,

          "name": "越西县",
          "nickname": "",
          "pid": "513400"
        }, {
          "code": "513435",
          "alevel": 3,

          "name": "甘洛县",
          "nickname": "",
          "pid": "513400"
        }, {
          "code": "513436",
          "alevel": 3,

          "name": "美姑县",
          "nickname": "",
          "pid": "513400"
        }, {
          "code": "513437",
          "alevel": 3,

          "name": "雷波县",
          "nickname": "",
          "pid": "513400"
        }],
        "name": "凉山彝族自治州",
        "nickname": "",
        "pid": "510000"
      }],
      "name": "四川省",
      "nickname": "川、蜀",
      "pid": ""
    }, {
      "code": "520000",
      "alevel": 1,
      "sub": [{
        "code": "520100",
        "alevel": 2,
        "sub": [{
          "code": "520101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "520100"
        }, {
          "code": "520102",
          "alevel": 3,

          "name": "南明区",
          "nickname": "",
          "pid": "520100"
        }, {
          "code": "520103",
          "alevel": 3,

          "name": "云岩区",
          "nickname": "",
          "pid": "520100"
        }, {
          "code": "520111",
          "alevel": 3,

          "name": "花溪区",
          "nickname": "",
          "pid": "520100"
        }, {
          "code": "520112",
          "alevel": 3,

          "name": "乌当区",
          "nickname": "",
          "pid": "520100"
        }, {
          "code": "520113",
          "alevel": 3,

          "name": "白云区",
          "nickname": "",
          "pid": "520100"
        }, {
          "code": "520115",
          "alevel": 3,

          "name": "观山湖区",
          "nickname": "",
          "pid": "520100"
        }, {
          "code": "520121",
          "alevel": 3,

          "name": "开阳县",
          "nickname": "",
          "pid": "520100"
        }, {
          "code": "520122",
          "alevel": 3,

          "name": "息烽县",
          "nickname": "",
          "pid": "520100"
        }, {
          "code": "520123",
          "alevel": 3,

          "name": "修文县",
          "nickname": "",
          "pid": "520100"
        }, {
          "code": "520181",
          "alevel": 3,

          "name": "清镇市",
          "nickname": "",
          "pid": "520100"
        }],
        "name": "贵阳市",
        "nickname": "",
        "pid": "520000"
      }, {
        "code": "520200",
        "alevel": 2,
        "sub": [{
          "code": "520201",
          "alevel": 3,

          "name": "钟山区",
          "nickname": "",
          "pid": "520200"
        }, {
          "code": "520203",
          "alevel": 3,

          "name": "六枝特区",
          "nickname": "",
          "pid": "520200"
        }, {
          "code": "520221",
          "alevel": 3,

          "name": "水城县",
          "nickname": "",
          "pid": "520200"
        }, {
          "code": "520222",
          "alevel": 3,

          "name": "盘县",
          "nickname": "",
          "pid": "520200"
        }, {
          "code": "520281",
          "alevel": 3,

          "name": "盘州市",
          "nickname": "",
          "pid": "520200"
        }],
        "name": "六盘水市",
        "nickname": "",
        "pid": "520000"
      }, {
        "code": "520300",
        "alevel": 2,
        "sub": [{
          "code": "520301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "520300"
        }, {
          "code": "520302",
          "alevel": 3,

          "name": "红花岗区",
          "nickname": "",
          "pid": "520300"
        }, {
          "code": "520303",
          "alevel": 3,

          "name": "汇川区",
          "nickname": "",
          "pid": "520300"
        }, {
          "code": "520304",
          "alevel": 3,

          "name": "播州区",
          "nickname": "",
          "pid": "520300"
        }, {
          "code": "520322",
          "alevel": 3,

          "name": "桐梓县",
          "nickname": "",
          "pid": "520300"
        }, {
          "code": "520323",
          "alevel": 3,

          "name": "绥阳县",
          "nickname": "",
          "pid": "520300"
        }, {
          "code": "520324",
          "alevel": 3,

          "name": "正安县",
          "nickname": "",
          "pid": "520300"
        }, {
          "code": "520325",
          "alevel": 3,

          "name": "道真仡佬族苗族自治县",
          "nickname": "",
          "pid": "520300"
        }, {
          "code": "520326",
          "alevel": 3,

          "name": "务川仡佬族苗族自治县",
          "nickname": "",
          "pid": "520300"
        }, {
          "code": "520327",
          "alevel": 3,

          "name": "凤冈县",
          "nickname": "",
          "pid": "520300"
        }, {
          "code": "520328",
          "alevel": 3,

          "name": "湄潭县",
          "nickname": "",
          "pid": "520300"
        }, {
          "code": "520329",
          "alevel": 3,

          "name": "余庆县",
          "nickname": "",
          "pid": "520300"
        }, {
          "code": "520330",
          "alevel": 3,

          "name": "习水县",
          "nickname": "",
          "pid": "520300"
        }, {
          "code": "520381",
          "alevel": 3,

          "name": "赤水市",
          "nickname": "",
          "pid": "520300"
        }, {
          "code": "520382",
          "alevel": 3,

          "name": "仁怀市",
          "nickname": "",
          "pid": "520300"
        }],
        "name": "遵义市",
        "nickname": "",
        "pid": "520000"
      }, {
        "code": "520400",
        "alevel": 2,
        "sub": [{
          "code": "520401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "520400"
        }, {
          "code": "520402",
          "alevel": 3,

          "name": "西秀区",
          "nickname": "",
          "pid": "520400"
        }, {
          "code": "520403",
          "alevel": 3,

          "name": "平坝区",
          "nickname": "",
          "pid": "520400"
        }, {
          "code": "520422",
          "alevel": 3,

          "name": "普定县",
          "nickname": "",
          "pid": "520400"
        }, {
          "code": "520423",
          "alevel": 3,

          "name": "镇宁布依族苗族自治县",
          "nickname": "",
          "pid": "520400"
        }, {
          "code": "520424",
          "alevel": 3,

          "name": "关岭布依族苗族自治县",
          "nickname": "",
          "pid": "520400"
        }, {
          "code": "520425",
          "alevel": 3,

          "name": "紫云苗族布依族自治县",
          "nickname": "",
          "pid": "520400"
        }],
        "name": "安顺市",
        "nickname": "",
        "pid": "520000"
      }, {
        "code": "520500",
        "alevel": 2,
        "sub": [{
          "code": "520501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "520500"
        }, {
          "code": "520502",
          "alevel": 3,

          "name": "七星关区",
          "nickname": "",
          "pid": "520500"
        }, {
          "code": "520521",
          "alevel": 3,

          "name": "大方县",
          "nickname": "",
          "pid": "520500"
        }, {
          "code": "520522",
          "alevel": 3,

          "name": "黔西县",
          "nickname": "",
          "pid": "520500"
        }, {
          "code": "520523",
          "alevel": 3,

          "name": "金沙县",
          "nickname": "",
          "pid": "520500"
        }, {
          "code": "520524",
          "alevel": 3,

          "name": "织金县",
          "nickname": "",
          "pid": "520500"
        }, {
          "code": "520525",
          "alevel": 3,

          "name": "纳雍县",
          "nickname": "",
          "pid": "520500"
        }, {
          "code": "520526",
          "alevel": 3,

          "name": "威宁彝族回族苗族自治县",
          "nickname": "",
          "pid": "520500"
        }, {
          "code": "520527",
          "alevel": 3,

          "name": "赫章县",
          "nickname": "",
          "pid": "520500"
        }],
        "name": "毕节市",
        "nickname": "",
        "pid": "520000"
      }, {
        "code": "520600",
        "alevel": 2,
        "sub": [{
          "code": "520601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "520600"
        }, {
          "code": "520602",
          "alevel": 3,

          "name": "碧江区",
          "nickname": "",
          "pid": "520600"
        }, {
          "code": "520603",
          "alevel": 3,

          "name": "万山区",
          "nickname": "",
          "pid": "520600"
        }, {
          "code": "520621",
          "alevel": 3,

          "name": "江口县",
          "nickname": "",
          "pid": "520600"
        }, {
          "code": "520622",
          "alevel": 3,

          "name": "玉屏侗族自治县",
          "nickname": "",
          "pid": "520600"
        }, {
          "code": "520623",
          "alevel": 3,

          "name": "石阡县",
          "nickname": "",
          "pid": "520600"
        }, {
          "code": "520624",
          "alevel": 3,

          "name": "思南县",
          "nickname": "",
          "pid": "520600"
        }, {
          "code": "520625",
          "alevel": 3,

          "name": "印江土家族苗族自治县",
          "nickname": "",
          "pid": "520600"
        }, {
          "code": "520626",
          "alevel": 3,

          "name": "德江县",
          "nickname": "",
          "pid": "520600"
        }, {
          "code": "520627",
          "alevel": 3,

          "name": "沿河土家族自治县",
          "nickname": "",
          "pid": "520600"
        }, {
          "code": "520628",
          "alevel": 3,

          "name": "松桃苗族自治县",
          "nickname": "",
          "pid": "520600"
        }],
        "name": "铜仁市",
        "nickname": "",
        "pid": "520000"
      }, {
        "code": "522300",
        "alevel": 2,
        "sub": [{
          "code": "522301",
          "alevel": 3,

          "name": "兴义市",
          "nickname": "",
          "pid": "522300"
        }, {
          "code": "522302",
          "alevel": 3,

          "name": "兴仁市",
          "nickname": "",
          "pid": "522300"
        }, {
          "code": "522322",
          "alevel": 3,

          "name": "兴仁县",
          "nickname": "",
          "pid": "522300"
        }, {
          "code": "522323",
          "alevel": 3,

          "name": "普安县",
          "nickname": "",
          "pid": "522300"
        }, {
          "code": "522324",
          "alevel": 3,

          "name": "晴隆县",
          "nickname": "",
          "pid": "522300"
        }, {
          "code": "522325",
          "alevel": 3,

          "name": "贞丰县",
          "nickname": "",
          "pid": "522300"
        }, {
          "code": "522326",
          "alevel": 3,

          "name": "望谟县",
          "nickname": "",
          "pid": "522300"
        }, {
          "code": "522327",
          "alevel": 3,

          "name": "册亨县",
          "nickname": "",
          "pid": "522300"
        }, {
          "code": "522328",
          "alevel": 3,

          "name": "安龙县",
          "nickname": "",
          "pid": "522300"
        }],
        "name": "黔西南布依族苗族自治州",
        "nickname": "",
        "pid": "520000"
      }, {
        "code": "522600",
        "alevel": 2,
        "sub": [{
          "code": "522601",
          "alevel": 3,

          "name": "凯里市",
          "nickname": "",
          "pid": "522600"
        }, {
          "code": "522622",
          "alevel": 3,

          "name": "黄平县",
          "nickname": "",
          "pid": "522600"
        }, {
          "code": "522623",
          "alevel": 3,

          "name": "施秉县",
          "nickname": "",
          "pid": "522600"
        }, {
          "code": "522624",
          "alevel": 3,

          "name": "三穗县",
          "nickname": "",
          "pid": "522600"
        }, {
          "code": "522625",
          "alevel": 3,

          "name": "镇远县",
          "nickname": "",
          "pid": "522600"
        }, {
          "code": "522626",
          "alevel": 3,

          "name": "岑巩县",
          "nickname": "",
          "pid": "522600"
        }, {
          "code": "522627",
          "alevel": 3,

          "name": "天柱县",
          "nickname": "",
          "pid": "522600"
        }, {
          "code": "522628",
          "alevel": 3,

          "name": "锦屏县",
          "nickname": "",
          "pid": "522600"
        }, {
          "code": "522629",
          "alevel": 3,

          "name": "剑河县",
          "nickname": "",
          "pid": "522600"
        }, {
          "code": "522630",
          "alevel": 3,

          "name": "台江县",
          "nickname": "",
          "pid": "522600"
        }, {
          "code": "522631",
          "alevel": 3,

          "name": "黎平县",
          "nickname": "",
          "pid": "522600"
        }, {
          "code": "522632",
          "alevel": 3,

          "name": "榕江县",
          "nickname": "",
          "pid": "522600"
        }, {
          "code": "522633",
          "alevel": 3,

          "name": "从江县",
          "nickname": "",
          "pid": "522600"
        }, {
          "code": "522634",
          "alevel": 3,

          "name": "雷山县",
          "nickname": "",
          "pid": "522600"
        }, {
          "code": "522635",
          "alevel": 3,

          "name": "麻江县",
          "nickname": "",
          "pid": "522600"
        }, {
          "code": "522636",
          "alevel": 3,

          "name": "丹寨县",
          "nickname": "",
          "pid": "522600"
        }],
        "name": "黔东南苗族侗族自治州",
        "nickname": "",
        "pid": "520000"
      }, {
        "code": "522700",
        "alevel": 2,
        "sub": [{
          "code": "522701",
          "alevel": 3,

          "name": "都匀市",
          "nickname": "",
          "pid": "522700"
        }, {
          "code": "522702",
          "alevel": 3,

          "name": "福泉市",
          "nickname": "",
          "pid": "522700"
        }, {
          "code": "522722",
          "alevel": 3,

          "name": "荔波县",
          "nickname": "",
          "pid": "522700"
        }, {
          "code": "522723",
          "alevel": 3,

          "name": "贵定县",
          "nickname": "",
          "pid": "522700"
        }, {
          "code": "522725",
          "alevel": 3,

          "name": "瓮安县",
          "nickname": "",
          "pid": "522700"
        }, {
          "code": "522726",
          "alevel": 3,

          "name": "独山县",
          "nickname": "",
          "pid": "522700"
        }, {
          "code": "522727",
          "alevel": 3,

          "name": "平塘县",
          "nickname": "",
          "pid": "522700"
        }, {
          "code": "522728",
          "alevel": 3,

          "name": "罗甸县",
          "nickname": "",
          "pid": "522700"
        }, {
          "code": "522729",
          "alevel": 3,

          "name": "长顺县",
          "nickname": "",
          "pid": "522700"
        }, {
          "code": "522730",
          "alevel": 3,

          "name": "龙里县",
          "nickname": "",
          "pid": "522700"
        }, {
          "code": "522731",
          "alevel": 3,

          "name": "惠水县",
          "nickname": "",
          "pid": "522700"
        }, {
          "code": "522732",
          "alevel": 3,

          "name": "三都水族自治县",
          "nickname": "",
          "pid": "522700"
        }],
        "name": "黔南布依族苗族自治州",
        "nickname": "",
        "pid": "520000"
      }],
      "name": "贵州省",
      "nickname": "黔、贵",
      "pid": ""
    }, {
      "code": "530000",
      "alevel": 1,
      "sub": [{
        "code": "530100",
        "alevel": 2,
        "sub": [{
          "code": "530101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "530100"
        }, {
          "code": "530102",
          "alevel": 3,

          "name": "五华区",
          "nickname": "",
          "pid": "530100"
        }, {
          "code": "530103",
          "alevel": 3,

          "name": "盘龙区",
          "nickname": "",
          "pid": "530100"
        }, {
          "code": "530111",
          "alevel": 3,

          "name": "官渡区",
          "nickname": "",
          "pid": "530100"
        }, {
          "code": "530112",
          "alevel": 3,

          "name": "西山区",
          "nickname": "",
          "pid": "530100"
        }, {
          "code": "530113",
          "alevel": 3,

          "name": "东川区",
          "nickname": "",
          "pid": "530100"
        }, {
          "code": "530114",
          "alevel": 3,

          "name": "呈贡区",
          "nickname": "",
          "pid": "530100"
        }, {
          "code": "530115",
          "alevel": 3,

          "name": "晋宁区",
          "nickname": "",
          "pid": "530100"
        }, {
          "code": "530122",
          "alevel": 3,

          "name": "晋宁县",
          "nickname": "",
          "pid": "530100"
        }, {
          "code": "530124",
          "alevel": 3,

          "name": "富民县",
          "nickname": "",
          "pid": "530100"
        }, {
          "code": "530125",
          "alevel": 3,

          "name": "宜良县",
          "nickname": "",
          "pid": "530100"
        }, {
          "code": "530126",
          "alevel": 3,

          "name": "石林彝族自治县",
          "nickname": "",
          "pid": "530100"
        }, {
          "code": "530127",
          "alevel": 3,

          "name": "嵩明县",
          "nickname": "",
          "pid": "530100"
        }, {
          "code": "530128",
          "alevel": 3,

          "name": "禄劝彝族苗族自治县",
          "nickname": "",
          "pid": "530100"
        }, {
          "code": "530129",
          "alevel": 3,

          "name": "寻甸回族彝族自治县",
          "nickname": "",
          "pid": "530100"
        }, {
          "code": "530181",
          "alevel": 3,

          "name": "安宁市",
          "nickname": "",
          "pid": "530100"
        }],
        "name": "昆明市",
        "nickname": "",
        "pid": "530000"
      }, {
        "code": "530300",
        "alevel": 2,
        "sub": [{
          "code": "530301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "530300"
        }, {
          "code": "530302",
          "alevel": 3,

          "name": "麒麟区",
          "nickname": "",
          "pid": "530300"
        }, {
          "code": "530303",
          "alevel": 3,

          "name": "沾益区",
          "nickname": "",
          "pid": "530300"
        }, {
          "code": "530304",
          "alevel": 3,

          "name": "马龙区",
          "nickname": "",
          "pid": "530300"
        }, {
          "code": "530321",
          "alevel": 3,

          "name": "马龙县",
          "nickname": "",
          "pid": "530300"
        }, {
          "code": "530322",
          "alevel": 3,

          "name": "陆良县",
          "nickname": "",
          "pid": "530300"
        }, {
          "code": "530323",
          "alevel": 3,

          "name": "师宗县",
          "nickname": "",
          "pid": "530300"
        }, {
          "code": "530324",
          "alevel": 3,

          "name": "罗平县",
          "nickname": "",
          "pid": "530300"
        }, {
          "code": "530325",
          "alevel": 3,

          "name": "富源县",
          "nickname": "",
          "pid": "530300"
        }, {
          "code": "530326",
          "alevel": 3,

          "name": "会泽县",
          "nickname": "",
          "pid": "530300"
        }, {
          "code": "530381",
          "alevel": 3,

          "name": "宣威市",
          "nickname": "",
          "pid": "530300"
        }],
        "name": "曲靖市",
        "nickname": "",
        "pid": "530000"
      }, {
        "code": "530400",
        "alevel": 2,
        "sub": [{
          "code": "530401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "530400"
        }, {
          "code": "530402",
          "alevel": 3,

          "name": "红塔区",
          "nickname": "",
          "pid": "530400"
        }, {
          "code": "530403",
          "alevel": 3,

          "name": "江川区",
          "nickname": "",
          "pid": "530400"
        }, {
          "code": "530422",
          "alevel": 3,

          "name": "澄江县",
          "nickname": "",
          "pid": "530400"
        }, {
          "code": "530423",
          "alevel": 3,

          "name": "通海县",
          "nickname": "",
          "pid": "530400"
        }, {
          "code": "530424",
          "alevel": 3,

          "name": "华宁县",
          "nickname": "",
          "pid": "530400"
        }, {
          "code": "530425",
          "alevel": 3,

          "name": "易门县",
          "nickname": "",
          "pid": "530400"
        }, {
          "code": "530426",
          "alevel": 3,

          "name": "峨山彝族自治县",
          "nickname": "",
          "pid": "530400"
        }, {
          "code": "530427",
          "alevel": 3,

          "name": "新平彝族傣族自治县",
          "nickname": "",
          "pid": "530400"
        }, {
          "code": "530428",
          "alevel": 3,

          "name": "元江哈尼族彝族傣族自治县",
          "nickname": "",
          "pid": "530400"
        }, {
          "code": "530481",
          "alevel": 3,

          "name": "澄江市",
          "nickname": "",
          "pid": "530400"
        }],
        "name": "玉溪市",
        "nickname": "",
        "pid": "530000"
      }, {
        "code": "530500",
        "alevel": 2,
        "sub": [{
          "code": "530501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "530500"
        }, {
          "code": "530502",
          "alevel": 3,

          "name": "隆阳区",
          "nickname": "",
          "pid": "530500"
        }, {
          "code": "530521",
          "alevel": 3,

          "name": "施甸县",
          "nickname": "",
          "pid": "530500"
        }, {
          "code": "530523",
          "alevel": 3,

          "name": "龙陵县",
          "nickname": "",
          "pid": "530500"
        }, {
          "code": "530524",
          "alevel": 3,

          "name": "昌宁县",
          "nickname": "",
          "pid": "530500"
        }, {
          "code": "530581",
          "alevel": 3,

          "name": "腾冲市",
          "nickname": "",
          "pid": "530500"
        }],
        "name": "保山市",
        "nickname": "",
        "pid": "530000"
      }, {
        "code": "530600",
        "alevel": 2,
        "sub": [{
          "code": "530601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "530600"
        }, {
          "code": "530602",
          "alevel": 3,

          "name": "昭阳区",
          "nickname": "",
          "pid": "530600"
        }, {
          "code": "530621",
          "alevel": 3,

          "name": "鲁甸县",
          "nickname": "",
          "pid": "530600"
        }, {
          "code": "530622",
          "alevel": 3,

          "name": "巧家县",
          "nickname": "",
          "pid": "530600"
        }, {
          "code": "530623",
          "alevel": 3,

          "name": "盐津县",
          "nickname": "",
          "pid": "530600"
        }, {
          "code": "530624",
          "alevel": 3,

          "name": "大关县",
          "nickname": "",
          "pid": "530600"
        }, {
          "code": "530625",
          "alevel": 3,

          "name": "永善县",
          "nickname": "",
          "pid": "530600"
        }, {
          "code": "530626",
          "alevel": 3,

          "name": "绥江县",
          "nickname": "",
          "pid": "530600"
        }, {
          "code": "530627",
          "alevel": 3,

          "name": "镇雄县",
          "nickname": "",
          "pid": "530600"
        }, {
          "code": "530628",
          "alevel": 3,

          "name": "彝良县",
          "nickname": "",
          "pid": "530600"
        }, {
          "code": "530629",
          "alevel": 3,

          "name": "威信县",
          "nickname": "",
          "pid": "530600"
        }, {
          "code": "530630",
          "alevel": 3,

          "name": "水富县",
          "nickname": "",
          "pid": "530600"
        }, {
          "code": "530681",
          "alevel": 3,

          "name": "水富市",
          "nickname": "",
          "pid": "530600"
        }],
        "name": "昭通市",
        "nickname": "",
        "pid": "530000"
      }, {
        "code": "530700",
        "alevel": 2,
        "sub": [{
          "code": "530701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "530700"
        }, {
          "code": "530702",
          "alevel": 3,

          "name": "古城区",
          "nickname": "",
          "pid": "530700"
        }, {
          "code": "530721",
          "alevel": 3,

          "name": "玉龙纳西族自治县",
          "nickname": "",
          "pid": "530700"
        }, {
          "code": "530722",
          "alevel": 3,

          "name": "永胜县",
          "nickname": "",
          "pid": "530700"
        }, {
          "code": "530723",
          "alevel": 3,

          "name": "华坪县",
          "nickname": "",
          "pid": "530700"
        }, {
          "code": "530724",
          "alevel": 3,

          "name": "宁蒗彝族自治县",
          "nickname": "",
          "pid": "530700"
        }],
        "name": "丽江市",
        "nickname": "",
        "pid": "530000"
      }, {
        "code": "530800",
        "alevel": 2,
        "sub": [{
          "code": "530801",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "530800"
        }, {
          "code": "530802",
          "alevel": 3,

          "name": "思茅区",
          "nickname": "",
          "pid": "530800"
        }, {
          "code": "530821",
          "alevel": 3,

          "name": "宁洱哈尼族彝族自治县",
          "nickname": "",
          "pid": "530800"
        }, {
          "code": "530822",
          "alevel": 3,

          "name": "墨江哈尼族自治县",
          "nickname": "",
          "pid": "530800"
        }, {
          "code": "530823",
          "alevel": 3,

          "name": "景东彝族自治县",
          "nickname": "",
          "pid": "530800"
        }, {
          "code": "530824",
          "alevel": 3,

          "name": "景谷傣族彝族自治县",
          "nickname": "",
          "pid": "530800"
        }, {
          "code": "530825",
          "alevel": 3,

          "name": "镇沅彝族哈尼族拉祜族自治县",
          "nickname": "",
          "pid": "530800"
        }, {
          "code": "530826",
          "alevel": 3,

          "name": "江城哈尼族彝族自治县",
          "nickname": "",
          "pid": "530800"
        }, {
          "code": "530827",
          "alevel": 3,

          "name": "孟连傣族拉祜族佤族自治县",
          "nickname": "",
          "pid": "530800"
        }, {
          "code": "530828",
          "alevel": 3,

          "name": "澜沧拉祜族自治县",
          "nickname": "",
          "pid": "530800"
        }, {
          "code": "530829",
          "alevel": 3,

          "name": "西盟佤族自治县",
          "nickname": "",
          "pid": "530800"
        }],
        "name": "普洱市",
        "nickname": "",
        "pid": "530000"
      }, {
        "code": "530900",
        "alevel": 2,
        "sub": [{
          "code": "530901",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "530900"
        }, {
          "code": "530902",
          "alevel": 3,

          "name": "临翔区",
          "nickname": "",
          "pid": "530900"
        }, {
          "code": "530921",
          "alevel": 3,

          "name": "凤庆县",
          "nickname": "",
          "pid": "530900"
        }, {
          "code": "530922",
          "alevel": 3,

          "name": "云县",
          "nickname": "",
          "pid": "530900"
        }, {
          "code": "530923",
          "alevel": 3,

          "name": "永德县",
          "nickname": "",
          "pid": "530900"
        }, {
          "code": "530924",
          "alevel": 3,

          "name": "镇康县",
          "nickname": "",
          "pid": "530900"
        }, {
          "code": "530925",
          "alevel": 3,

          "name": "双江拉祜族佤族布朗族傣族自治县",
          "nickname": "",
          "pid": "530900"
        }, {
          "code": "530926",
          "alevel": 3,

          "name": "耿马傣族佤族自治县",
          "nickname": "",
          "pid": "530900"
        }, {
          "code": "530927",
          "alevel": 3,

          "name": "沧源佤族自治县",
          "nickname": "",
          "pid": "530900"
        }],
        "name": "临沧市",
        "nickname": "",
        "pid": "530000"
      }, {
        "code": "532300",
        "alevel": 2,
        "sub": [{
          "code": "532301",
          "alevel": 3,

          "name": "楚雄市",
          "nickname": "",
          "pid": "532300"
        }, {
          "code": "532322",
          "alevel": 3,

          "name": "双柏县",
          "nickname": "",
          "pid": "532300"
        }, {
          "code": "532323",
          "alevel": 3,

          "name": "牟定县",
          "nickname": "",
          "pid": "532300"
        }, {
          "code": "532324",
          "alevel": 3,

          "name": "南华县",
          "nickname": "",
          "pid": "532300"
        }, {
          "code": "532325",
          "alevel": 3,

          "name": "姚安县",
          "nickname": "",
          "pid": "532300"
        }, {
          "code": "532326",
          "alevel": 3,

          "name": "大姚县",
          "nickname": "",
          "pid": "532300"
        }, {
          "code": "532327",
          "alevel": 3,

          "name": "永仁县",
          "nickname": "",
          "pid": "532300"
        }, {
          "code": "532328",
          "alevel": 3,

          "name": "元谋县",
          "nickname": "",
          "pid": "532300"
        }, {
          "code": "532329",
          "alevel": 3,

          "name": "武定县",
          "nickname": "",
          "pid": "532300"
        }, {
          "code": "532331",
          "alevel": 3,

          "name": "禄丰县",
          "nickname": "",
          "pid": "532300"
        }],
        "name": "楚雄彝族自治州",
        "nickname": "",
        "pid": "530000"
      }, {
        "code": "532500",
        "alevel": 2,
        "sub": [{
          "code": "532501",
          "alevel": 3,

          "name": "个旧市",
          "nickname": "",
          "pid": "532500"
        }, {
          "code": "532502",
          "alevel": 3,

          "name": "开远市",
          "nickname": "",
          "pid": "532500"
        }, {
          "code": "532503",
          "alevel": 3,

          "name": "蒙自市",
          "nickname": "",
          "pid": "532500"
        }, {
          "code": "532504",
          "alevel": 3,

          "name": "弥勒市",
          "nickname": "",
          "pid": "532500"
        }, {
          "code": "532523",
          "alevel": 3,

          "name": "屏边苗族自治县",
          "nickname": "",
          "pid": "532500"
        }, {
          "code": "532524",
          "alevel": 3,

          "name": "建水县",
          "nickname": "",
          "pid": "532500"
        }, {
          "code": "532525",
          "alevel": 3,

          "name": "石屏县",
          "nickname": "",
          "pid": "532500"
        }, {
          "code": "532527",
          "alevel": 3,

          "name": "泸西县",
          "nickname": "",
          "pid": "532500"
        }, {
          "code": "532528",
          "alevel": 3,

          "name": "元阳县",
          "nickname": "",
          "pid": "532500"
        }, {
          "code": "532529",
          "alevel": 3,

          "name": "红河县",
          "nickname": "",
          "pid": "532500"
        }, {
          "code": "532530",
          "alevel": 3,

          "name": "金平苗族瑶族傣族自治县",
          "nickname": "",
          "pid": "532500"
        }, {
          "code": "532531",
          "alevel": 3,

          "name": "绿春县",
          "nickname": "",
          "pid": "532500"
        }, {
          "code": "532532",
          "alevel": 3,

          "name": "河口瑶族自治县",
          "nickname": "",
          "pid": "532500"
        }],
        "name": "红河哈尼族彝族自治州",
        "nickname": "",
        "pid": "530000"
      }, {
        "code": "532600",
        "alevel": 2,
        "sub": [{
          "code": "532601",
          "alevel": 3,

          "name": "文山市",
          "nickname": "",
          "pid": "532600"
        }, {
          "code": "532622",
          "alevel": 3,

          "name": "砚山县",
          "nickname": "",
          "pid": "532600"
        }, {
          "code": "532623",
          "alevel": 3,

          "name": "西畴县",
          "nickname": "",
          "pid": "532600"
        }, {
          "code": "532624",
          "alevel": 3,

          "name": "麻栗坡县",
          "nickname": "",
          "pid": "532600"
        }, {
          "code": "532625",
          "alevel": 3,

          "name": "马关县",
          "nickname": "",
          "pid": "532600"
        }, {
          "code": "532626",
          "alevel": 3,

          "name": "丘北县",
          "nickname": "",
          "pid": "532600"
        }, {
          "code": "532627",
          "alevel": 3,

          "name": "广南县",
          "nickname": "",
          "pid": "532600"
        }, {
          "code": "532628",
          "alevel": 3,

          "name": "富宁县",
          "nickname": "",
          "pid": "532600"
        }],
        "name": "文山壮族苗族自治州",
        "nickname": "",
        "pid": "530000"
      }, {
        "code": "532800",
        "alevel": 2,
        "sub": [{
          "code": "532801",
          "alevel": 3,

          "name": "景洪市",
          "nickname": "",
          "pid": "532800"
        }, {
          "code": "532822",
          "alevel": 3,

          "name": "勐海县",
          "nickname": "",
          "pid": "532800"
        }, {
          "code": "532823",
          "alevel": 3,

          "name": "勐腊县",
          "nickname": "",
          "pid": "532800"
        }],
        "name": "西双版纳傣族自治州",
        "nickname": "",
        "pid": "530000"
      }, {
        "code": "532900",
        "alevel": 2,
        "sub": [{
          "code": "532901",
          "alevel": 3,

          "name": "大理市",
          "nickname": "",
          "pid": "532900"
        }, {
          "code": "532922",
          "alevel": 3,

          "name": "漾濞彝族自治县",
          "nickname": "",
          "pid": "532900"
        }, {
          "code": "532923",
          "alevel": 3,

          "name": "祥云县",
          "nickname": "",
          "pid": "532900"
        }, {
          "code": "532924",
          "alevel": 3,

          "name": "宾川县",
          "nickname": "",
          "pid": "532900"
        }, {
          "code": "532925",
          "alevel": 3,

          "name": "弥渡县",
          "nickname": "",
          "pid": "532900"
        }, {
          "code": "532926",
          "alevel": 3,

          "name": "南涧彝族自治县",
          "nickname": "",
          "pid": "532900"
        }, {
          "code": "532927",
          "alevel": 3,

          "name": "巍山彝族回族自治县",
          "nickname": "",
          "pid": "532900"
        }, {
          "code": "532928",
          "alevel": 3,

          "name": "永平县",
          "nickname": "",
          "pid": "532900"
        }, {
          "code": "532929",
          "alevel": 3,

          "name": "云龙县",
          "nickname": "",
          "pid": "532900"
        }, {
          "code": "532930",
          "alevel": 3,

          "name": "洱源县",
          "nickname": "",
          "pid": "532900"
        }, {
          "code": "532931",
          "alevel": 3,

          "name": "剑川县",
          "nickname": "",
          "pid": "532900"
        }, {
          "code": "532932",
          "alevel": 3,

          "name": "鹤庆县",
          "nickname": "",
          "pid": "532900"
        }],
        "name": "大理白族自治州",
        "nickname": "",
        "pid": "530000"
      }, {
        "code": "533100",
        "alevel": 2,
        "sub": [{
          "code": "533102",
          "alevel": 3,

          "name": "瑞丽市",
          "nickname": "",
          "pid": "533100"
        }, {
          "code": "533103",
          "alevel": 3,

          "name": "芒市",
          "nickname": "",
          "pid": "533100"
        }, {
          "code": "533122",
          "alevel": 3,

          "name": "梁河县",
          "nickname": "",
          "pid": "533100"
        }, {
          "code": "533123",
          "alevel": 3,

          "name": "盈江县",
          "nickname": "",
          "pid": "533100"
        }, {
          "code": "533124",
          "alevel": 3,

          "name": "陇川县",
          "nickname": "",
          "pid": "533100"
        }],
        "name": "德宏傣族景颇族自治州",
        "nickname": "",
        "pid": "530000"
      }, {
        "code": "533300",
        "alevel": 2,
        "sub": [{
          "code": "533301",
          "alevel": 3,

          "name": "泸水市",
          "nickname": "",
          "pid": "533300"
        }, {
          "code": "533323",
          "alevel": 3,

          "name": "福贡县",
          "nickname": "",
          "pid": "533300"
        }, {
          "code": "533324",
          "alevel": 3,

          "name": "贡山独龙族怒族自治县",
          "nickname": "",
          "pid": "533300"
        }, {
          "code": "533325",
          "alevel": 3,

          "name": "兰坪白族普米族自治县",
          "nickname": "",
          "pid": "533300"
        }],
        "name": "怒江傈僳族自治州",
        "nickname": "",
        "pid": "530000"
      }, {
        "code": "533400",
        "alevel": 2,
        "sub": [{
          "code": "533401",
          "alevel": 3,

          "name": "香格里拉市",
          "nickname": "",
          "pid": "533400"
        }, {
          "code": "533422",
          "alevel": 3,

          "name": "德钦县",
          "nickname": "",
          "pid": "533400"
        }, {
          "code": "533423",
          "alevel": 3,

          "name": "维西傈僳族自治县",
          "nickname": "",
          "pid": "533400"
        }],
        "name": "迪庆藏族自治州",
        "nickname": "",
        "pid": "530000"
      }],
      "name": "云南省",
      "nickname": "滇、云",
      "pid": ""
    }, {
      "code": "540000",
      "alevel": 1,
      "sub": [{
        "code": "540100",
        "alevel": 2,
        "sub": [{
          "code": "540101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "540100"
        }, {
          "code": "540102",
          "alevel": 3,

          "name": "城关区",
          "nickname": "",
          "pid": "540100"
        }, {
          "code": "540103",
          "alevel": 3,

          "name": "堆龙德庆区",
          "nickname": "",
          "pid": "540100"
        }, {
          "code": "540104",
          "alevel": 3,

          "name": "达孜区",
          "nickname": "",
          "pid": "540100"
        }, {
          "code": "540121",
          "alevel": 3,

          "name": "林周县",
          "nickname": "",
          "pid": "540100"
        }, {
          "code": "540122",
          "alevel": 3,

          "name": "当雄县",
          "nickname": "",
          "pid": "540100"
        }, {
          "code": "540123",
          "alevel": 3,

          "name": "尼木县",
          "nickname": "",
          "pid": "540100"
        }, {
          "code": "540124",
          "alevel": 3,

          "name": "曲水县",
          "nickname": "",
          "pid": "540100"
        }, {
          "code": "540126",
          "alevel": 3,

          "name": "达孜县",
          "nickname": "",
          "pid": "540100"
        }, {
          "code": "540127",
          "alevel": 3,

          "name": "墨竹工卡县",
          "nickname": "",
          "pid": "540100"
        }],
        "name": "拉萨市",
        "nickname": "",
        "pid": "540000"
      }, {
        "code": "540200",
        "alevel": 2,
        "sub": [{
          "code": "540202",
          "alevel": 3,

          "name": "桑珠孜区",
          "nickname": "",
          "pid": "540200"
        }, {
          "code": "540221",
          "alevel": 3,

          "name": "南木林县",
          "nickname": "",
          "pid": "540200"
        }, {
          "code": "540222",
          "alevel": 3,

          "name": "江孜县",
          "nickname": "",
          "pid": "540200"
        }, {
          "code": "540223",
          "alevel": 3,

          "name": "定日县",
          "nickname": "",
          "pid": "540200"
        }, {
          "code": "540224",
          "alevel": 3,

          "name": "萨迦县",
          "nickname": "",
          "pid": "540200"
        }, {
          "code": "540225",
          "alevel": 3,

          "name": "拉孜县",
          "nickname": "",
          "pid": "540200"
        }, {
          "code": "540226",
          "alevel": 3,

          "name": "昂仁县",
          "nickname": "",
          "pid": "540200"
        }, {
          "code": "540227",
          "alevel": 3,

          "name": "谢通门县",
          "nickname": "",
          "pid": "540200"
        }, {
          "code": "540228",
          "alevel": 3,

          "name": "白朗县",
          "nickname": "",
          "pid": "540200"
        }, {
          "code": "540229",
          "alevel": 3,

          "name": "仁布县",
          "nickname": "",
          "pid": "540200"
        }, {
          "code": "540230",
          "alevel": 3,

          "name": "康马县",
          "nickname": "",
          "pid": "540200"
        }, {
          "code": "540231",
          "alevel": 3,

          "name": "定结县",
          "nickname": "",
          "pid": "540200"
        }, {
          "code": "540232",
          "alevel": 3,

          "name": "仲巴县",
          "nickname": "",
          "pid": "540200"
        }, {
          "code": "540233",
          "alevel": 3,

          "name": "亚东县",
          "nickname": "",
          "pid": "540200"
        }, {
          "code": "540234",
          "alevel": 3,

          "name": "吉隆县",
          "nickname": "",
          "pid": "540200"
        }, {
          "code": "540235",
          "alevel": 3,

          "name": "聂拉木县",
          "nickname": "",
          "pid": "540200"
        }, {
          "code": "540236",
          "alevel": 3,

          "name": "萨嘎县",
          "nickname": "",
          "pid": "540200"
        }, {
          "code": "540237",
          "alevel": 3,

          "name": "岗巴县",
          "nickname": "",
          "pid": "540200"
        }],
        "name": "日喀则市",
        "nickname": "",
        "pid": "540000"
      }, {
        "code": "540300",
        "alevel": 2,
        "sub": [{
          "code": "540302",
          "alevel": 3,

          "name": "卡若区",
          "nickname": "",
          "pid": "540300"
        }, {
          "code": "540321",
          "alevel": 3,

          "name": "江达县",
          "nickname": "",
          "pid": "540300"
        }, {
          "code": "540322",
          "alevel": 3,

          "name": "贡觉县",
          "nickname": "",
          "pid": "540300"
        }, {
          "code": "540323",
          "alevel": 3,

          "name": "类乌齐县",
          "nickname": "",
          "pid": "540300"
        }, {
          "code": "540324",
          "alevel": 3,

          "name": "丁青县",
          "nickname": "",
          "pid": "540300"
        }, {
          "code": "540325",
          "alevel": 3,

          "name": "察雅县",
          "nickname": "",
          "pid": "540300"
        }, {
          "code": "540326",
          "alevel": 3,

          "name": "八宿县",
          "nickname": "",
          "pid": "540300"
        }, {
          "code": "540327",
          "alevel": 3,

          "name": "左贡县",
          "nickname": "",
          "pid": "540300"
        }, {
          "code": "540328",
          "alevel": 3,

          "name": "芒康县",
          "nickname": "",
          "pid": "540300"
        }, {
          "code": "540329",
          "alevel": 3,

          "name": "洛隆县",
          "nickname": "",
          "pid": "540300"
        }, {
          "code": "540330",
          "alevel": 3,

          "name": "边坝县",
          "nickname": "",
          "pid": "540300"
        }],
        "name": "昌都市",
        "nickname": "",
        "pid": "540000"
      }, {
        "code": "540400",
        "alevel": 2,
        "sub": [{
          "code": "540402",
          "alevel": 3,

          "name": "巴宜区",
          "nickname": "",
          "pid": "540400"
        }, {
          "code": "540421",
          "alevel": 3,

          "name": "工布江达县",
          "nickname": "",
          "pid": "540400"
        }, {
          "code": "540422",
          "alevel": 3,

          "name": "米林县",
          "nickname": "",
          "pid": "540400"
        }, {
          "code": "540423",
          "alevel": 3,

          "name": "墨脱县",
          "nickname": "",
          "pid": "540400"
        }, {
          "code": "540424",
          "alevel": 3,

          "name": "波密县",
          "nickname": "",
          "pid": "540400"
        }, {
          "code": "540425",
          "alevel": 3,

          "name": "察隅县",
          "nickname": "",
          "pid": "540400"
        }, {
          "code": "540426",
          "alevel": 3,

          "name": "朗县",
          "nickname": "",
          "pid": "540400"
        }],
        "name": "林芝市",
        "nickname": "",
        "pid": "540000"
      }, {
        "code": "540500",
        "alevel": 2,
        "sub": [{
          "code": "540501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "540500"
        }, {
          "code": "540502",
          "alevel": 3,

          "name": "乃东区",
          "nickname": "",
          "pid": "540500"
        }, {
          "code": "540521",
          "alevel": 3,

          "name": "扎囊县",
          "nickname": "",
          "pid": "540500"
        }, {
          "code": "540522",
          "alevel": 3,

          "name": "贡嘎县",
          "nickname": "",
          "pid": "540500"
        }, {
          "code": "540523",
          "alevel": 3,

          "name": "桑日县",
          "nickname": "",
          "pid": "540500"
        }, {
          "code": "540524",
          "alevel": 3,

          "name": "琼结县",
          "nickname": "",
          "pid": "540500"
        }, {
          "code": "540525",
          "alevel": 3,

          "name": "曲松县",
          "nickname": "",
          "pid": "540500"
        }, {
          "code": "540526",
          "alevel": 3,

          "name": "措美县",
          "nickname": "",
          "pid": "540500"
        }, {
          "code": "540527",
          "alevel": 3,

          "name": "洛扎县",
          "nickname": "",
          "pid": "540500"
        }, {
          "code": "540528",
          "alevel": 3,

          "name": "加查县",
          "nickname": "",
          "pid": "540500"
        }, {
          "code": "540529",
          "alevel": 3,

          "name": "隆子县",
          "nickname": "",
          "pid": "540500"
        }, {
          "code": "540530",
          "alevel": 3,

          "name": "错那县",
          "nickname": "",
          "pid": "540500"
        }, {
          "code": "540531",
          "alevel": 3,

          "name": "浪卡子县",
          "nickname": "",
          "pid": "540500"
        }],
        "name": "山南市",
        "nickname": "",
        "pid": "540000"
      }, {
        "code": "540600",
        "alevel": 2,
        "sub": [{
          "code": "540602",
          "alevel": 3,

          "name": "色尼区",
          "nickname": "",
          "pid": "540600"
        }, {
          "code": "540621",
          "alevel": 3,

          "name": "嘉黎县",
          "nickname": "",
          "pid": "540600"
        }, {
          "code": "540622",
          "alevel": 3,

          "name": "比如县",
          "nickname": "",
          "pid": "540600"
        }, {
          "code": "540623",
          "alevel": 3,

          "name": "聂荣县",
          "nickname": "",
          "pid": "540600"
        }, {
          "code": "540624",
          "alevel": 3,

          "name": "安多县",
          "nickname": "",
          "pid": "540600"
        }, {
          "code": "540625",
          "alevel": 3,

          "name": "申扎县",
          "nickname": "",
          "pid": "540600"
        }, {
          "code": "540626",
          "alevel": 3,

          "name": "索县",
          "nickname": "",
          "pid": "540600"
        }, {
          "code": "540627",
          "alevel": 3,

          "name": "班戈县",
          "nickname": "",
          "pid": "540600"
        }, {
          "code": "540628",
          "alevel": 3,

          "name": "巴青县",
          "nickname": "",
          "pid": "540600"
        }, {
          "code": "540629",
          "alevel": 3,

          "name": "尼玛县",
          "nickname": "",
          "pid": "540600"
        }, {
          "code": "540630",
          "alevel": 3,

          "name": "双湖县",
          "nickname": "",
          "pid": "540600"
        }],
        "name": "那曲市",
        "nickname": "",
        "pid": "540000"
      }, {
        "code": "542400",
        "alevel": 2,
        "sub": [{
          "code": "542421",
          "alevel": 3,

          "name": "那曲县",
          "nickname": "",
          "pid": "542400"
        }, {
          "code": "542422",
          "alevel": 3,

          "name": "嘉黎县",
          "nickname": "",
          "pid": "542400"
        }, {
          "code": "542423",
          "alevel": 3,

          "name": "比如县",
          "nickname": "",
          "pid": "542400"
        }, {
          "code": "542424",
          "alevel": 3,

          "name": "聂荣县",
          "nickname": "",
          "pid": "542400"
        }, {
          "code": "542425",
          "alevel": 3,

          "name": "安多县",
          "nickname": "",
          "pid": "542400"
        }, {
          "code": "542426",
          "alevel": 3,

          "name": "申扎县",
          "nickname": "",
          "pid": "542400"
        }, {
          "code": "542427",
          "alevel": 3,

          "name": "索县",
          "nickname": "",
          "pid": "542400"
        }, {
          "code": "542428",
          "alevel": 3,

          "name": "班戈县",
          "nickname": "",
          "pid": "542400"
        }, {
          "code": "542429",
          "alevel": 3,

          "name": "巴青县",
          "nickname": "",
          "pid": "542400"
        }, {
          "code": "542430",
          "alevel": 3,

          "name": "尼玛县",
          "nickname": "",
          "pid": "542400"
        }, {
          "code": "542431",
          "alevel": 3,

          "name": "双湖县",
          "nickname": "",
          "pid": "542400"
        }],
        "name": "那曲地区",
        "nickname": "",
        "pid": "540000"
      }, {
        "code": "542500",
        "alevel": 2,
        "sub": [{
          "code": "542521",
          "alevel": 3,

          "name": "普兰县",
          "nickname": "",
          "pid": "542500"
        }, {
          "code": "542522",
          "alevel": 3,

          "name": "札达县",
          "nickname": "",
          "pid": "542500"
        }, {
          "code": "542523",
          "alevel": 3,

          "name": "噶尔县",
          "nickname": "",
          "pid": "542500"
        }, {
          "code": "542524",
          "alevel": 3,

          "name": "日土县",
          "nickname": "",
          "pid": "542500"
        }, {
          "code": "542525",
          "alevel": 3,

          "name": "革吉县",
          "nickname": "",
          "pid": "542500"
        }, {
          "code": "542526",
          "alevel": 3,

          "name": "改则县",
          "nickname": "",
          "pid": "542500"
        }, {
          "code": "542527",
          "alevel": 3,

          "name": "措勤县",
          "nickname": "",
          "pid": "542500"
        }],
        "name": "阿里地区",
        "nickname": "",
        "pid": "540000"
      }],
      "name": "西藏自治区",
      "nickname": "藏",
      "pid": ""
    }, {
      "code": "610000",
      "alevel": 1,
      "sub": [{
        "code": "610100",
        "alevel": 2,
        "sub": [{
          "code": "610101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "610100"
        }, {
          "code": "610102",
          "alevel": 3,

          "name": "新城区",
          "nickname": "",
          "pid": "610100"
        }, {
          "code": "610103",
          "alevel": 3,

          "name": "碑林区",
          "nickname": "",
          "pid": "610100"
        }, {
          "code": "610104",
          "alevel": 3,

          "name": "莲湖区",
          "nickname": "",
          "pid": "610100"
        }, {
          "code": "610111",
          "alevel": 3,

          "name": "灞桥区",
          "nickname": "",
          "pid": "610100"
        }, {
          "code": "610112",
          "alevel": 3,

          "name": "未央区",
          "nickname": "",
          "pid": "610100"
        }, {
          "code": "610113",
          "alevel": 3,

          "name": "雁塔区",
          "nickname": "",
          "pid": "610100"
        }, {
          "code": "610114",
          "alevel": 3,

          "name": "阎良区",
          "nickname": "",
          "pid": "610100"
        }, {
          "code": "610115",
          "alevel": 3,

          "name": "临潼区",
          "nickname": "",
          "pid": "610100"
        }, {
          "code": "610116",
          "alevel": 3,

          "name": "长安区",
          "nickname": "",
          "pid": "610100"
        }, {
          "code": "610117",
          "alevel": 3,

          "name": "高陵区",
          "nickname": "",
          "pid": "610100"
        }, {
          "code": "610118",
          "alevel": 3,

          "name": "鄠邑区",
          "nickname": "",
          "pid": "610100"
        }, {
          "code": "610122",
          "alevel": 3,

          "name": "蓝田县",
          "nickname": "",
          "pid": "610100"
        }, {
          "code": "610124",
          "alevel": 3,

          "name": "周至县",
          "nickname": "",
          "pid": "610100"
        }, {
          "code": "610125",
          "alevel": 3,

          "name": "户县",
          "nickname": "",
          "pid": "610100"
        }],
        "name": "西安市",
        "nickname": "",
        "pid": "610000"
      }, {
        "code": "610200",
        "alevel": 2,
        "sub": [{
          "code": "610201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "610200"
        }, {
          "code": "610202",
          "alevel": 3,

          "name": "王益区",
          "nickname": "",
          "pid": "610200"
        }, {
          "code": "610203",
          "alevel": 3,

          "name": "印台区",
          "nickname": "",
          "pid": "610200"
        }, {
          "code": "610204",
          "alevel": 3,

          "name": "耀州区",
          "nickname": "",
          "pid": "610200"
        }, {
          "code": "610222",
          "alevel": 3,

          "name": "宜君县",
          "nickname": "",
          "pid": "610200"
        }],
        "name": "铜川市",
        "nickname": "",
        "pid": "610000"
      }, {
        "code": "610300",
        "alevel": 2,
        "sub": [{
          "code": "610301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "610300"
        }, {
          "code": "610302",
          "alevel": 3,

          "name": "渭滨区",
          "nickname": "",
          "pid": "610300"
        }, {
          "code": "610303",
          "alevel": 3,

          "name": "金台区",
          "nickname": "",
          "pid": "610300"
        }, {
          "code": "610304",
          "alevel": 3,

          "name": "陈仓区",
          "nickname": "",
          "pid": "610300"
        }, {
          "code": "610322",
          "alevel": 3,

          "name": "凤翔县",
          "nickname": "",
          "pid": "610300"
        }, {
          "code": "610323",
          "alevel": 3,

          "name": "岐山县",
          "nickname": "",
          "pid": "610300"
        }, {
          "code": "610324",
          "alevel": 3,

          "name": "扶风县",
          "nickname": "",
          "pid": "610300"
        }, {
          "code": "610326",
          "alevel": 3,

          "name": "眉县",
          "nickname": "",
          "pid": "610300"
        }, {
          "code": "610327",
          "alevel": 3,

          "name": "陇县",
          "nickname": "",
          "pid": "610300"
        }, {
          "code": "610328",
          "alevel": 3,

          "name": "千阳县",
          "nickname": "",
          "pid": "610300"
        }, {
          "code": "610329",
          "alevel": 3,

          "name": "麟游县",
          "nickname": "",
          "pid": "610300"
        }, {
          "code": "610330",
          "alevel": 3,

          "name": "凤县",
          "nickname": "",
          "pid": "610300"
        }, {
          "code": "610331",
          "alevel": 3,

          "name": "太白县",
          "nickname": "",
          "pid": "610300"
        }],
        "name": "宝鸡市",
        "nickname": "",
        "pid": "610000"
      }, {
        "code": "610400",
        "alevel": 2,
        "sub": [{
          "code": "610401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "610400"
        }, {
          "code": "610402",
          "alevel": 3,

          "name": "秦都区",
          "nickname": "",
          "pid": "610400"
        }, {
          "code": "610403",
          "alevel": 3,

          "name": "杨陵区",
          "nickname": "",
          "pid": "610400"
        }, {
          "code": "610404",
          "alevel": 3,

          "name": "渭城区",
          "nickname": "",
          "pid": "610400"
        }, {
          "code": "610422",
          "alevel": 3,

          "name": "三原县",
          "nickname": "",
          "pid": "610400"
        }, {
          "code": "610423",
          "alevel": 3,

          "name": "泾阳县",
          "nickname": "",
          "pid": "610400"
        }, {
          "code": "610424",
          "alevel": 3,

          "name": "乾县",
          "nickname": "",
          "pid": "610400"
        }, {
          "code": "610425",
          "alevel": 3,

          "name": "礼泉县",
          "nickname": "",
          "pid": "610400"
        }, {
          "code": "610426",
          "alevel": 3,

          "name": "永寿县",
          "nickname": "",
          "pid": "610400"
        }, {
          "code": "610427",
          "alevel": 3,

          "name": "彬县",
          "nickname": "",
          "pid": "610400"
        }, {
          "code": "610428",
          "alevel": 3,

          "name": "长武县",
          "nickname": "",
          "pid": "610400"
        }, {
          "code": "610429",
          "alevel": 3,

          "name": "旬邑县",
          "nickname": "",
          "pid": "610400"
        }, {
          "code": "610430",
          "alevel": 3,

          "name": "淳化县",
          "nickname": "",
          "pid": "610400"
        }, {
          "code": "610431",
          "alevel": 3,

          "name": "武功县",
          "nickname": "",
          "pid": "610400"
        }, {
          "code": "610481",
          "alevel": 3,

          "name": "兴平市",
          "nickname": "",
          "pid": "610400"
        }, {
          "code": "610482",
          "alevel": 3,

          "name": "彬州市",
          "nickname": "",
          "pid": "610400"
        }],
        "name": "咸阳市",
        "nickname": "",
        "pid": "610000"
      }, {
        "code": "610500",
        "alevel": 2,
        "sub": [{
          "code": "610501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "610500"
        }, {
          "code": "610502",
          "alevel": 3,

          "name": "临渭区",
          "nickname": "",
          "pid": "610500"
        }, {
          "code": "610503",
          "alevel": 3,

          "name": "华州区",
          "nickname": "",
          "pid": "610500"
        }, {
          "code": "610522",
          "alevel": 3,

          "name": "潼关县",
          "nickname": "",
          "pid": "610500"
        }, {
          "code": "610523",
          "alevel": 3,

          "name": "大荔县",
          "nickname": "",
          "pid": "610500"
        }, {
          "code": "610524",
          "alevel": 3,

          "name": "合阳县",
          "nickname": "",
          "pid": "610500"
        }, {
          "code": "610525",
          "alevel": 3,

          "name": "澄城县",
          "nickname": "",
          "pid": "610500"
        }, {
          "code": "610526",
          "alevel": 3,

          "name": "蒲城县",
          "nickname": "",
          "pid": "610500"
        }, {
          "code": "610527",
          "alevel": 3,

          "name": "白水县",
          "nickname": "",
          "pid": "610500"
        }, {
          "code": "610528",
          "alevel": 3,

          "name": "富平县",
          "nickname": "",
          "pid": "610500"
        }, {
          "code": "610581",
          "alevel": 3,

          "name": "韩城市",
          "nickname": "",
          "pid": "610500"
        }, {
          "code": "610582",
          "alevel": 3,

          "name": "华阴市",
          "nickname": "",
          "pid": "610500"
        }],
        "name": "渭南市",
        "nickname": "",
        "pid": "610000"
      }, {
        "code": "610600",
        "alevel": 2,
        "sub": [{
          "code": "610601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "610600"
        }, {
          "code": "610602",
          "alevel": 3,

          "name": "宝塔区",
          "nickname": "",
          "pid": "610600"
        }, {
          "code": "610603",
          "alevel": 3,

          "name": "安塞区",
          "nickname": "",
          "pid": "610600"
        }, {
          "code": "610621",
          "alevel": 3,

          "name": "延长县",
          "nickname": "",
          "pid": "610600"
        }, {
          "code": "610622",
          "alevel": 3,

          "name": "延川县",
          "nickname": "",
          "pid": "610600"
        }, {
          "code": "610623",
          "alevel": 3,

          "name": "子长县",
          "nickname": "",
          "pid": "610600"
        }, {
          "code": "610625",
          "alevel": 3,

          "name": "志丹县",
          "nickname": "",
          "pid": "610600"
        }, {
          "code": "610626",
          "alevel": 3,

          "name": "吴起县",
          "nickname": "",
          "pid": "610600"
        }, {
          "code": "610627",
          "alevel": 3,

          "name": "甘泉县",
          "nickname": "",
          "pid": "610600"
        }, {
          "code": "610628",
          "alevel": 3,

          "name": "富县",
          "nickname": "",
          "pid": "610600"
        }, {
          "code": "610629",
          "alevel": 3,

          "name": "洛川县",
          "nickname": "",
          "pid": "610600"
        }, {
          "code": "610630",
          "alevel": 3,

          "name": "宜川县",
          "nickname": "",
          "pid": "610600"
        }, {
          "code": "610631",
          "alevel": 3,

          "name": "黄龙县",
          "nickname": "",
          "pid": "610600"
        }, {
          "code": "610632",
          "alevel": 3,

          "name": "黄陵县",
          "nickname": "",
          "pid": "610600"
        }, {
          "code": "610681",
          "alevel": 3,

          "name": "子长市",
          "nickname": "",
          "pid": "610600"
        }],
        "name": "延安市",
        "nickname": "",
        "pid": "610000"
      }, {
        "code": "610700",
        "alevel": 2,
        "sub": [{
          "code": "610701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "610700"
        }, {
          "code": "610702",
          "alevel": 3,

          "name": "汉台区",
          "nickname": "",
          "pid": "610700"
        }, {
          "code": "610703",
          "alevel": 3,

          "name": "南郑区",
          "nickname": "",
          "pid": "610700"
        }, {
          "code": "610721",
          "alevel": 3,

          "name": "南郑县",
          "nickname": "",
          "pid": "610700"
        }, {
          "code": "610722",
          "alevel": 3,

          "name": "城固县",
          "nickname": "",
          "pid": "610700"
        }, {
          "code": "610723",
          "alevel": 3,

          "name": "洋县",
          "nickname": "",
          "pid": "610700"
        }, {
          "code": "610724",
          "alevel": 3,

          "name": "西乡县",
          "nickname": "",
          "pid": "610700"
        }, {
          "code": "610725",
          "alevel": 3,

          "name": "勉县",
          "nickname": "",
          "pid": "610700"
        }, {
          "code": "610726",
          "alevel": 3,

          "name": "宁强县",
          "nickname": "",
          "pid": "610700"
        }, {
          "code": "610727",
          "alevel": 3,

          "name": "略阳县",
          "nickname": "",
          "pid": "610700"
        }, {
          "code": "610728",
          "alevel": 3,

          "name": "镇巴县",
          "nickname": "",
          "pid": "610700"
        }, {
          "code": "610729",
          "alevel": 3,

          "name": "留坝县",
          "nickname": "",
          "pid": "610700"
        }, {
          "code": "610730",
          "alevel": 3,

          "name": "佛坪县",
          "nickname": "",
          "pid": "610700"
        }],
        "name": "汉中市",
        "nickname": "",
        "pid": "610000"
      }, {
        "code": "610800",
        "alevel": 2,
        "sub": [{
          "code": "610801",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "610800"
        }, {
          "code": "610802",
          "alevel": 3,

          "name": "榆阳区",
          "nickname": "",
          "pid": "610800"
        }, {
          "code": "610803",
          "alevel": 3,

          "name": "横山区",
          "nickname": "",
          "pid": "610800"
        }, {
          "code": "610821",
          "alevel": 3,

          "name": "神木县",
          "nickname": "",
          "pid": "610800"
        }, {
          "code": "610822",
          "alevel": 3,

          "name": "府谷县",
          "nickname": "",
          "pid": "610800"
        }, {
          "code": "610824",
          "alevel": 3,

          "name": "靖边县",
          "nickname": "",
          "pid": "610800"
        }, {
          "code": "610825",
          "alevel": 3,

          "name": "定边县",
          "nickname": "",
          "pid": "610800"
        }, {
          "code": "610826",
          "alevel": 3,

          "name": "绥德县",
          "nickname": "",
          "pid": "610800"
        }, {
          "code": "610827",
          "alevel": 3,

          "name": "米脂县",
          "nickname": "",
          "pid": "610800"
        }, {
          "code": "610828",
          "alevel": 3,

          "name": "佳县",
          "nickname": "",
          "pid": "610800"
        }, {
          "code": "610829",
          "alevel": 3,

          "name": "吴堡县",
          "nickname": "",
          "pid": "610800"
        }, {
          "code": "610830",
          "alevel": 3,

          "name": "清涧县",
          "nickname": "",
          "pid": "610800"
        }, {
          "code": "610831",
          "alevel": 3,

          "name": "子洲县",
          "nickname": "",
          "pid": "610800"
        }, {
          "code": "610881",
          "alevel": 3,

          "name": "神木市",
          "nickname": "",
          "pid": "610800"
        }],
        "name": "榆林市",
        "nickname": "",
        "pid": "610000"
      }, {
        "code": "610900",
        "alevel": 2,
        "sub": [{
          "code": "610901",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "610900"
        }, {
          "code": "610902",
          "alevel": 3,

          "name": "汉滨区",
          "nickname": "",
          "pid": "610900"
        }, {
          "code": "610921",
          "alevel": 3,

          "name": "汉阴县",
          "nickname": "",
          "pid": "610900"
        }, {
          "code": "610922",
          "alevel": 3,

          "name": "石泉县",
          "nickname": "",
          "pid": "610900"
        }, {
          "code": "610923",
          "alevel": 3,

          "name": "宁陕县",
          "nickname": "",
          "pid": "610900"
        }, {
          "code": "610924",
          "alevel": 3,

          "name": "紫阳县",
          "nickname": "",
          "pid": "610900"
        }, {
          "code": "610925",
          "alevel": 3,

          "name": "岚皋县",
          "nickname": "",
          "pid": "610900"
        }, {
          "code": "610926",
          "alevel": 3,

          "name": "平利县",
          "nickname": "",
          "pid": "610900"
        }, {
          "code": "610927",
          "alevel": 3,

          "name": "镇坪县",
          "nickname": "",
          "pid": "610900"
        }, {
          "code": "610928",
          "alevel": 3,

          "name": "旬阳县",
          "nickname": "",
          "pid": "610900"
        }, {
          "code": "610929",
          "alevel": 3,

          "name": "白河县",
          "nickname": "",
          "pid": "610900"
        }],
        "name": "安康市",
        "nickname": "",
        "pid": "610000"
      }, {
        "code": "611000",
        "alevel": 2,
        "sub": [{
          "code": "611001",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "611000"
        }, {
          "code": "611002",
          "alevel": 3,

          "name": "商州区",
          "nickname": "",
          "pid": "611000"
        }, {
          "code": "611021",
          "alevel": 3,

          "name": "洛南县",
          "nickname": "",
          "pid": "611000"
        }, {
          "code": "611022",
          "alevel": 3,

          "name": "丹凤县",
          "nickname": "",
          "pid": "611000"
        }, {
          "code": "611023",
          "alevel": 3,

          "name": "商南县",
          "nickname": "",
          "pid": "611000"
        }, {
          "code": "611024",
          "alevel": 3,

          "name": "山阳县",
          "nickname": "",
          "pid": "611000"
        }, {
          "code": "611025",
          "alevel": 3,

          "name": "镇安县",
          "nickname": "",
          "pid": "611000"
        }, {
          "code": "611026",
          "alevel": 3,

          "name": "柞水县",
          "nickname": "",
          "pid": "611000"
        }],
        "name": "商洛市",
        "nickname": "",
        "pid": "610000"
      }],
      "name": "陕西省",
      "nickname": "陕、秦",
      "pid": ""
    }, {
      "code": "620000",
      "alevel": 1,
      "sub": [{
        "code": "620100",
        "alevel": 2,
        "sub": [{
          "code": "620101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "620100"
        }, {
          "code": "620102",
          "alevel": 3,

          "name": "城关区",
          "nickname": "",
          "pid": "620100"
        }, {
          "code": "620103",
          "alevel": 3,

          "name": "七里河区",
          "nickname": "",
          "pid": "620100"
        }, {
          "code": "620104",
          "alevel": 3,

          "name": "西固区",
          "nickname": "",
          "pid": "620100"
        }, {
          "code": "620105",
          "alevel": 3,

          "name": "安宁区",
          "nickname": "",
          "pid": "620100"
        }, {
          "code": "620111",
          "alevel": 3,

          "name": "红古区",
          "nickname": "",
          "pid": "620100"
        }, {
          "code": "620121",
          "alevel": 3,

          "name": "永登县",
          "nickname": "",
          "pid": "620100"
        }, {
          "code": "620122",
          "alevel": 3,

          "name": "皋兰县",
          "nickname": "",
          "pid": "620100"
        }, {
          "code": "620123",
          "alevel": 3,

          "name": "榆中县",
          "nickname": "",
          "pid": "620100"
        }],
        "name": "兰州市",
        "nickname": "",
        "pid": "620000"
      }, {
        "code": "620200",
        "alevel": 2,
        "sub": [{
          "code": "620201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "620200"
        }],
        "name": "嘉峪关市",
        "nickname": "",
        "pid": "620000"
      }, {
        "code": "620300",
        "alevel": 2,
        "sub": [{
          "code": "620301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "620300"
        }, {
          "code": "620302",
          "alevel": 3,

          "name": "金川区",
          "nickname": "",
          "pid": "620300"
        }, {
          "code": "620321",
          "alevel": 3,

          "name": "永昌县",
          "nickname": "",
          "pid": "620300"
        }],
        "name": "金昌市",
        "nickname": "",
        "pid": "620000"
      }, {
        "code": "620400",
        "alevel": 2,
        "sub": [{
          "code": "620401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "620400"
        }, {
          "code": "620402",
          "alevel": 3,

          "name": "白银区",
          "nickname": "",
          "pid": "620400"
        }, {
          "code": "620403",
          "alevel": 3,

          "name": "平川区",
          "nickname": "",
          "pid": "620400"
        }, {
          "code": "620421",
          "alevel": 3,

          "name": "靖远县",
          "nickname": "",
          "pid": "620400"
        }, {
          "code": "620422",
          "alevel": 3,

          "name": "会宁县",
          "nickname": "",
          "pid": "620400"
        }, {
          "code": "620423",
          "alevel": 3,

          "name": "景泰县",
          "nickname": "",
          "pid": "620400"
        }],
        "name": "白银市",
        "nickname": "",
        "pid": "620000"
      }, {
        "code": "620500",
        "alevel": 2,
        "sub": [{
          "code": "620501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "620500"
        }, {
          "code": "620502",
          "alevel": 3,

          "name": "秦州区",
          "nickname": "",
          "pid": "620500"
        }, {
          "code": "620503",
          "alevel": 3,

          "name": "麦积区",
          "nickname": "",
          "pid": "620500"
        }, {
          "code": "620521",
          "alevel": 3,

          "name": "清水县",
          "nickname": "",
          "pid": "620500"
        }, {
          "code": "620522",
          "alevel": 3,

          "name": "秦安县",
          "nickname": "",
          "pid": "620500"
        }, {
          "code": "620523",
          "alevel": 3,

          "name": "甘谷县",
          "nickname": "",
          "pid": "620500"
        }, {
          "code": "620524",
          "alevel": 3,

          "name": "武山县",
          "nickname": "",
          "pid": "620500"
        }, {
          "code": "620525",
          "alevel": 3,

          "name": "张家川回族自治县",
          "nickname": "",
          "pid": "620500"
        }],
        "name": "天水市",
        "nickname": "",
        "pid": "620000"
      }, {
        "code": "620600",
        "alevel": 2,
        "sub": [{
          "code": "620601",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "620600"
        }, {
          "code": "620602",
          "alevel": 3,

          "name": "凉州区",
          "nickname": "",
          "pid": "620600"
        }, {
          "code": "620621",
          "alevel": 3,

          "name": "民勤县",
          "nickname": "",
          "pid": "620600"
        }, {
          "code": "620622",
          "alevel": 3,

          "name": "古浪县",
          "nickname": "",
          "pid": "620600"
        }, {
          "code": "620623",
          "alevel": 3,

          "name": "天祝藏族自治县",
          "nickname": "",
          "pid": "620600"
        }],
        "name": "武威市",
        "nickname": "",
        "pid": "620000"
      }, {
        "code": "620700",
        "alevel": 2,
        "sub": [{
          "code": "620701",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "620700"
        }, {
          "code": "620702",
          "alevel": 3,

          "name": "甘州区",
          "nickname": "",
          "pid": "620700"
        }, {
          "code": "620721",
          "alevel": 3,

          "name": "肃南裕固族自治县",
          "nickname": "",
          "pid": "620700"
        }, {
          "code": "620722",
          "alevel": 3,

          "name": "民乐县",
          "nickname": "",
          "pid": "620700"
        }, {
          "code": "620723",
          "alevel": 3,

          "name": "临泽县",
          "nickname": "",
          "pid": "620700"
        }, {
          "code": "620724",
          "alevel": 3,

          "name": "高台县",
          "nickname": "",
          "pid": "620700"
        }, {
          "code": "620725",
          "alevel": 3,

          "name": "山丹县",
          "nickname": "",
          "pid": "620700"
        }],
        "name": "张掖市",
        "nickname": "",
        "pid": "620000"
      }, {
        "code": "620800",
        "alevel": 2,
        "sub": [{
          "code": "620801",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "620800"
        }, {
          "code": "620802",
          "alevel": 3,

          "name": "崆峒区",
          "nickname": "",
          "pid": "620800"
        }, {
          "code": "620821",
          "alevel": 3,

          "name": "泾川县",
          "nickname": "",
          "pid": "620800"
        }, {
          "code": "620822",
          "alevel": 3,

          "name": "灵台县",
          "nickname": "",
          "pid": "620800"
        }, {
          "code": "620823",
          "alevel": 3,

          "name": "崇信县",
          "nickname": "",
          "pid": "620800"
        }, {
          "code": "620824",
          "alevel": 3,

          "name": "华亭县",
          "nickname": "",
          "pid": "620800"
        }, {
          "code": "620825",
          "alevel": 3,

          "name": "庄浪县",
          "nickname": "",
          "pid": "620800"
        }, {
          "code": "620826",
          "alevel": 3,

          "name": "静宁县",
          "nickname": "",
          "pid": "620800"
        }, {
          "code": "620881",
          "alevel": 3,

          "name": "华亭市",
          "nickname": "",
          "pid": "620800"
        }],
        "name": "平凉市",
        "nickname": "",
        "pid": "620000"
      }, {
        "code": "620900",
        "alevel": 2,
        "sub": [{
          "code": "620901",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "620900"
        }, {
          "code": "620902",
          "alevel": 3,

          "name": "肃州区",
          "nickname": "",
          "pid": "620900"
        }, {
          "code": "620921",
          "alevel": 3,

          "name": "金塔县",
          "nickname": "",
          "pid": "620900"
        }, {
          "code": "620922",
          "alevel": 3,

          "name": "瓜州县",
          "nickname": "",
          "pid": "620900"
        }, {
          "code": "620923",
          "alevel": 3,

          "name": "肃北蒙古族自治县",
          "nickname": "",
          "pid": "620900"
        }, {
          "code": "620924",
          "alevel": 3,

          "name": "阿克塞哈萨克族自治县",
          "nickname": "",
          "pid": "620900"
        }, {
          "code": "620981",
          "alevel": 3,

          "name": "玉门市",
          "nickname": "",
          "pid": "620900"
        }, {
          "code": "620982",
          "alevel": 3,

          "name": "敦煌市",
          "nickname": "",
          "pid": "620900"
        }],
        "name": "酒泉市",
        "nickname": "",
        "pid": "620000"
      }, {
        "code": "621000",
        "alevel": 2,
        "sub": [{
          "code": "621001",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "621000"
        }, {
          "code": "621002",
          "alevel": 3,

          "name": "西峰区",
          "nickname": "",
          "pid": "621000"
        }, {
          "code": "621021",
          "alevel": 3,

          "name": "庆城县",
          "nickname": "",
          "pid": "621000"
        }, {
          "code": "621022",
          "alevel": 3,

          "name": "环县",
          "nickname": "",
          "pid": "621000"
        }, {
          "code": "621023",
          "alevel": 3,

          "name": "华池县",
          "nickname": "",
          "pid": "621000"
        }, {
          "code": "621024",
          "alevel": 3,

          "name": "合水县",
          "nickname": "",
          "pid": "621000"
        }, {
          "code": "621025",
          "alevel": 3,

          "name": "正宁县",
          "nickname": "",
          "pid": "621000"
        }, {
          "code": "621026",
          "alevel": 3,

          "name": "宁县",
          "nickname": "",
          "pid": "621000"
        }, {
          "code": "621027",
          "alevel": 3,

          "name": "镇原县",
          "nickname": "",
          "pid": "621000"
        }],
        "name": "庆阳市",
        "nickname": "",
        "pid": "620000"
      }, {
        "code": "621100",
        "alevel": 2,
        "sub": [{
          "code": "621101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "621100"
        }, {
          "code": "621102",
          "alevel": 3,

          "name": "安定区",
          "nickname": "",
          "pid": "621100"
        }, {
          "code": "621121",
          "alevel": 3,

          "name": "通渭县",
          "nickname": "",
          "pid": "621100"
        }, {
          "code": "621122",
          "alevel": 3,

          "name": "陇西县",
          "nickname": "",
          "pid": "621100"
        }, {
          "code": "621123",
          "alevel": 3,

          "name": "渭源县",
          "nickname": "",
          "pid": "621100"
        }, {
          "code": "621124",
          "alevel": 3,

          "name": "临洮县",
          "nickname": "",
          "pid": "621100"
        }, {
          "code": "621125",
          "alevel": 3,

          "name": "漳县",
          "nickname": "",
          "pid": "621100"
        }, {
          "code": "621126",
          "alevel": 3,

          "name": "岷县",
          "nickname": "",
          "pid": "621100"
        }],
        "name": "定西市",
        "nickname": "",
        "pid": "620000"
      }, {
        "code": "621200",
        "alevel": 2,
        "sub": [{
          "code": "621201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "621200"
        }, {
          "code": "621202",
          "alevel": 3,

          "name": "武都区",
          "nickname": "",
          "pid": "621200"
        }, {
          "code": "621221",
          "alevel": 3,

          "name": "成县",
          "nickname": "",
          "pid": "621200"
        }, {
          "code": "621222",
          "alevel": 3,

          "name": "文县",
          "nickname": "",
          "pid": "621200"
        }, {
          "code": "621223",
          "alevel": 3,

          "name": "宕昌县",
          "nickname": "",
          "pid": "621200"
        }, {
          "code": "621224",
          "alevel": 3,

          "name": "康县",
          "nickname": "",
          "pid": "621200"
        }, {
          "code": "621225",
          "alevel": 3,

          "name": "西和县",
          "nickname": "",
          "pid": "621200"
        }, {
          "code": "621226",
          "alevel": 3,

          "name": "礼县",
          "nickname": "",
          "pid": "621200"
        }, {
          "code": "621227",
          "alevel": 3,

          "name": "徽县",
          "nickname": "",
          "pid": "621200"
        }, {
          "code": "621228",
          "alevel": 3,

          "name": "两当县",
          "nickname": "",
          "pid": "621200"
        }],
        "name": "陇南市",
        "nickname": "",
        "pid": "620000"
      }, {
        "code": "622900",
        "alevel": 2,
        "sub": [{
          "code": "622901",
          "alevel": 3,

          "name": "临夏市",
          "nickname": "",
          "pid": "622900"
        }, {
          "code": "622921",
          "alevel": 3,

          "name": "临夏县",
          "nickname": "",
          "pid": "622900"
        }, {
          "code": "622922",
          "alevel": 3,

          "name": "康乐县",
          "nickname": "",
          "pid": "622900"
        }, {
          "code": "622923",
          "alevel": 3,

          "name": "永靖县",
          "nickname": "",
          "pid": "622900"
        }, {
          "code": "622924",
          "alevel": 3,

          "name": "广河县",
          "nickname": "",
          "pid": "622900"
        }, {
          "code": "622925",
          "alevel": 3,

          "name": "和政县",
          "nickname": "",
          "pid": "622900"
        }, {
          "code": "622926",
          "alevel": 3,

          "name": "东乡族自治县",
          "nickname": "",
          "pid": "622900"
        }, {
          "code": "622927",
          "alevel": 3,

          "name": "积石山保安族东乡族撒拉族自治县",
          "nickname": "",
          "pid": "622900"
        }],
        "name": "临夏回族自治州",
        "nickname": "",
        "pid": "620000"
      }, {
        "code": "623000",
        "alevel": 2,
        "sub": [{
          "code": "623001",
          "alevel": 3,

          "name": "合作市",
          "nickname": "",
          "pid": "623000"
        }, {
          "code": "623021",
          "alevel": 3,

          "name": "临潭县",
          "nickname": "",
          "pid": "623000"
        }, {
          "code": "623022",
          "alevel": 3,

          "name": "卓尼县",
          "nickname": "",
          "pid": "623000"
        }, {
          "code": "623023",
          "alevel": 3,

          "name": "舟曲县",
          "nickname": "",
          "pid": "623000"
        }, {
          "code": "623024",
          "alevel": 3,

          "name": "迭部县",
          "nickname": "",
          "pid": "623000"
        }, {
          "code": "623025",
          "alevel": 3,

          "name": "玛曲县",
          "nickname": "",
          "pid": "623000"
        }, {
          "code": "623026",
          "alevel": 3,

          "name": "碌曲县",
          "nickname": "",
          "pid": "623000"
        }, {
          "code": "623027",
          "alevel": 3,

          "name": "夏河县",
          "nickname": "",
          "pid": "623000"
        }],
        "name": "甘南藏族自治州",
        "nickname": "",
        "pid": "620000"
      }],
      "name": "甘肃省",
      "nickname": "甘、陇",
      "pid": ""
    }, {
      "code": "630000",
      "alevel": 1,
      "sub": [{
        "code": "630100",
        "alevel": 2,
        "sub": [{
          "code": "630101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "630100"
        }, {
          "code": "630102",
          "alevel": 3,

          "name": "城东区",
          "nickname": "",
          "pid": "630100"
        }, {
          "code": "630103",
          "alevel": 3,

          "name": "城中区",
          "nickname": "",
          "pid": "630100"
        }, {
          "code": "630104",
          "alevel": 3,

          "name": "城西区",
          "nickname": "",
          "pid": "630100"
        }, {
          "code": "630105",
          "alevel": 3,

          "name": "城北区",
          "nickname": "",
          "pid": "630100"
        }, {
          "code": "630106",
          "alevel": 3,

          "name": "湟中区",
          "nickname": "",
          "pid": "630100"
        }, {
          "code": "630121",
          "alevel": 3,

          "name": "大通回族土族自治县",
          "nickname": "",
          "pid": "630100"
        }, {
          "code": "630122",
          "alevel": 3,

          "name": "湟中县",
          "nickname": "",
          "pid": "630100"
        }, {
          "code": "630123",
          "alevel": 3,

          "name": "湟源县",
          "nickname": "",
          "pid": "630100"
        }],
        "name": "西宁市",
        "nickname": "",
        "pid": "630000"
      }, {
        "code": "630200",
        "alevel": 2,
        "sub": [{
          "code": "630202",
          "alevel": 3,

          "name": "乐都区",
          "nickname": "",
          "pid": "630200"
        }, {
          "code": "630203",
          "alevel": 3,

          "name": "平安区",
          "nickname": "",
          "pid": "630200"
        }, {
          "code": "630222",
          "alevel": 3,

          "name": "民和回族土族自治县",
          "nickname": "",
          "pid": "630200"
        }, {
          "code": "630223",
          "alevel": 3,

          "name": "互助土族自治县",
          "nickname": "",
          "pid": "630200"
        }, {
          "code": "630224",
          "alevel": 3,

          "name": "化隆回族自治县",
          "nickname": "",
          "pid": "630200"
        }, {
          "code": "630225",
          "alevel": 3,

          "name": "循化撒拉族自治县",
          "nickname": "",
          "pid": "630200"
        }],
        "name": "海东市",
        "nickname": "",
        "pid": "630000"
      }, {
        "code": "632200",
        "alevel": 2,
        "sub": [{
          "code": "632221",
          "alevel": 3,

          "name": "门源回族自治县",
          "nickname": "",
          "pid": "632200"
        }, {
          "code": "632222",
          "alevel": 3,

          "name": "祁连县",
          "nickname": "",
          "pid": "632200"
        }, {
          "code": "632223",
          "alevel": 3,

          "name": "海晏县",
          "nickname": "",
          "pid": "632200"
        }, {
          "code": "632224",
          "alevel": 3,

          "name": "刚察县",
          "nickname": "",
          "pid": "632200"
        }],
        "name": "海北藏族自治州",
        "nickname": "",
        "pid": "630000"
      }, {
        "code": "632300",
        "alevel": 2,
        "sub": [{
          "code": "632321",
          "alevel": 3,

          "name": "同仁县",
          "nickname": "",
          "pid": "632300"
        }, {
          "code": "632322",
          "alevel": 3,

          "name": "尖扎县",
          "nickname": "",
          "pid": "632300"
        }, {
          "code": "632323",
          "alevel": 3,

          "name": "泽库县",
          "nickname": "",
          "pid": "632300"
        }, {
          "code": "632324",
          "alevel": 3,

          "name": "河南蒙古族自治县",
          "nickname": "",
          "pid": "632300"
        }],
        "name": "黄南藏族自治州",
        "nickname": "",
        "pid": "630000"
      }, {
        "code": "632500",
        "alevel": 2,
        "sub": [{
          "code": "632521",
          "alevel": 3,

          "name": "共和县",
          "nickname": "",
          "pid": "632500"
        }, {
          "code": "632522",
          "alevel": 3,

          "name": "同德县",
          "nickname": "",
          "pid": "632500"
        }, {
          "code": "632523",
          "alevel": 3,

          "name": "贵德县",
          "nickname": "",
          "pid": "632500"
        }, {
          "code": "632524",
          "alevel": 3,

          "name": "兴海县",
          "nickname": "",
          "pid": "632500"
        }, {
          "code": "632525",
          "alevel": 3,

          "name": "贵南县",
          "nickname": "",
          "pid": "632500"
        }],
        "name": "海南藏族自治州",
        "nickname": "",
        "pid": "630000"
      }, {
        "code": "632600",
        "alevel": 2,
        "sub": [{
          "code": "632621",
          "alevel": 3,

          "name": "玛沁县",
          "nickname": "",
          "pid": "632600"
        }, {
          "code": "632622",
          "alevel": 3,

          "name": "班玛县",
          "nickname": "",
          "pid": "632600"
        }, {
          "code": "632623",
          "alevel": 3,

          "name": "甘德县",
          "nickname": "",
          "pid": "632600"
        }, {
          "code": "632624",
          "alevel": 3,

          "name": "达日县",
          "nickname": "",
          "pid": "632600"
        }, {
          "code": "632625",
          "alevel": 3,

          "name": "久治县",
          "nickname": "",
          "pid": "632600"
        }, {
          "code": "632626",
          "alevel": 3,

          "name": "玛多县",
          "nickname": "",
          "pid": "632600"
        }],
        "name": "果洛藏族自治州",
        "nickname": "",
        "pid": "630000"
      }, {
        "code": "632700",
        "alevel": 2,
        "sub": [{
          "code": "632701",
          "alevel": 3,

          "name": "玉树市",
          "nickname": "",
          "pid": "632700"
        }, {
          "code": "632722",
          "alevel": 3,

          "name": "杂多县",
          "nickname": "",
          "pid": "632700"
        }, {
          "code": "632723",
          "alevel": 3,

          "name": "称多县",
          "nickname": "",
          "pid": "632700"
        }, {
          "code": "632724",
          "alevel": 3,

          "name": "治多县",
          "nickname": "",
          "pid": "632700"
        }, {
          "code": "632725",
          "alevel": 3,

          "name": "囊谦县",
          "nickname": "",
          "pid": "632700"
        }, {
          "code": "632726",
          "alevel": 3,

          "name": "曲麻莱县",
          "nickname": "",
          "pid": "632700"
        }],
        "name": "玉树藏族自治州",
        "nickname": "",
        "pid": "630000"
      }, {
        "code": "632800",
        "alevel": 2,
        "sub": [{
          "code": "632801",
          "alevel": 3,

          "name": "格尔木市",
          "nickname": "",
          "pid": "632800"
        }, {
          "code": "632802",
          "alevel": 3,

          "name": "德令哈市",
          "nickname": "",
          "pid": "632800"
        }, {
          "code": "632803",
          "alevel": 3,

          "name": "茫崖市",
          "nickname": "",
          "pid": "632800"
        }, {
          "code": "632821",
          "alevel": 3,

          "name": "乌兰县",
          "nickname": "",
          "pid": "632800"
        }, {
          "code": "632822",
          "alevel": 3,

          "name": "都兰县",
          "nickname": "",
          "pid": "632800"
        }, {
          "code": "632823",
          "alevel": 3,

          "name": "天峻县",
          "nickname": "",
          "pid": "632800"
        }],
        "name": "海西蒙古族藏族自治州",
        "nickname": "",
        "pid": "630000"
      }],
      "name": "青海省",
      "nickname": "青",
      "pid": ""
    }, {
      "code": "640000",
      "alevel": 1,
      "sub": [{
        "code": "640100",
        "alevel": 2,
        "sub": [{
          "code": "640101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "640100"
        }, {
          "code": "640104",
          "alevel": 3,

          "name": "兴庆区",
          "nickname": "",
          "pid": "640100"
        }, {
          "code": "640105",
          "alevel": 3,

          "name": "西夏区",
          "nickname": "",
          "pid": "640100"
        }, {
          "code": "640106",
          "alevel": 3,

          "name": "金凤区",
          "nickname": "",
          "pid": "640100"
        }, {
          "code": "640121",
          "alevel": 3,

          "name": "永宁县",
          "nickname": "",
          "pid": "640100"
        }, {
          "code": "640122",
          "alevel": 3,

          "name": "贺兰县",
          "nickname": "",
          "pid": "640100"
        }, {
          "code": "640181",
          "alevel": 3,

          "name": "灵武市",
          "nickname": "",
          "pid": "640100"
        }],
        "name": "银川市",
        "nickname": "",
        "pid": "640000"
      }, {
        "code": "640200",
        "alevel": 2,
        "sub": [{
          "code": "640201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "640200"
        }, {
          "code": "640202",
          "alevel": 3,

          "name": "大武口区",
          "nickname": "",
          "pid": "640200"
        }, {
          "code": "640205",
          "alevel": 3,

          "name": "惠农区",
          "nickname": "",
          "pid": "640200"
        }, {
          "code": "640221",
          "alevel": 3,

          "name": "平罗县",
          "nickname": "",
          "pid": "640200"
        }],
        "name": "石嘴山市",
        "nickname": "",
        "pid": "640000"
      }, {
        "code": "640300",
        "alevel": 2,
        "sub": [{
          "code": "640301",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "640300"
        }, {
          "code": "640302",
          "alevel": 3,

          "name": "利通区",
          "nickname": "",
          "pid": "640300"
        }, {
          "code": "640303",
          "alevel": 3,

          "name": "红寺堡区",
          "nickname": "",
          "pid": "640300"
        }, {
          "code": "640323",
          "alevel": 3,

          "name": "盐池县",
          "nickname": "",
          "pid": "640300"
        }, {
          "code": "640324",
          "alevel": 3,

          "name": "同心县",
          "nickname": "",
          "pid": "640300"
        }, {
          "code": "640381",
          "alevel": 3,

          "name": "青铜峡市",
          "nickname": "",
          "pid": "640300"
        }],
        "name": "吴忠市",
        "nickname": "",
        "pid": "640000"
      }, {
        "code": "640400",
        "alevel": 2,
        "sub": [{
          "code": "640401",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "640400"
        }, {
          "code": "640402",
          "alevel": 3,

          "name": "原州区",
          "nickname": "",
          "pid": "640400"
        }, {
          "code": "640422",
          "alevel": 3,

          "name": "西吉县",
          "nickname": "",
          "pid": "640400"
        }, {
          "code": "640423",
          "alevel": 3,

          "name": "隆德县",
          "nickname": "",
          "pid": "640400"
        }, {
          "code": "640424",
          "alevel": 3,

          "name": "泾源县",
          "nickname": "",
          "pid": "640400"
        }, {
          "code": "640425",
          "alevel": 3,

          "name": "彭阳县",
          "nickname": "",
          "pid": "640400"
        }],
        "name": "固原市",
        "nickname": "",
        "pid": "640000"
      }, {
        "code": "640500",
        "alevel": 2,
        "sub": [{
          "code": "640501",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "640500"
        }, {
          "code": "640502",
          "alevel": 3,

          "name": "沙坡头区",
          "nickname": "",
          "pid": "640500"
        }, {
          "code": "640521",
          "alevel": 3,

          "name": "中宁县",
          "nickname": "",
          "pid": "640500"
        }, {
          "code": "640522",
          "alevel": 3,

          "name": "海原县",
          "nickname": "",
          "pid": "640500"
        }],
        "name": "中卫市",
        "nickname": "",
        "pid": "640000"
      }],
      "name": "宁夏回族自治区",
      "nickname": "宁",
      "pid": ""
    }, {
      "code": "650000",
      "alevel": 1,
      "sub": [{
        "code": "650100",
        "alevel": 2,
        "sub": [{
          "code": "650101",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "650100"
        }, {
          "code": "650102",
          "alevel": 3,

          "name": "天山区",
          "nickname": "",
          "pid": "650100"
        }, {
          "code": "650103",
          "alevel": 3,

          "name": "沙依巴克区",
          "nickname": "",
          "pid": "650100"
        }, {
          "code": "650104",
          "alevel": 3,

          "name": "新市区",
          "nickname": "",
          "pid": "650100"
        }, {
          "code": "650105",
          "alevel": 3,

          "name": "水磨沟区",
          "nickname": "",
          "pid": "650100"
        }, {
          "code": "650106",
          "alevel": 3,

          "name": "头屯河区",
          "nickname": "",
          "pid": "650100"
        }, {
          "code": "650107",
          "alevel": 3,

          "name": "达坂城区",
          "nickname": "",
          "pid": "650100"
        }, {
          "code": "650109",
          "alevel": 3,

          "name": "米东区",
          "nickname": "",
          "pid": "650100"
        }, {
          "code": "650121",
          "alevel": 3,

          "name": "乌鲁木齐县",
          "nickname": "",
          "pid": "650100"
        }],
        "name": "乌鲁木齐市",
        "nickname": "",
        "pid": "650000"
      }, {
        "code": "650200",
        "alevel": 2,
        "sub": [{
          "code": "650201",
          "alevel": 3,

          "name": "市辖区",
          "nickname": "",
          "pid": "650200"
        }, {
          "code": "650202",
          "alevel": 3,

          "name": "独山子区",
          "nickname": "",
          "pid": "650200"
        }, {
          "code": "650203",
          "alevel": 3,

          "name": "克拉玛依区",
          "nickname": "",
          "pid": "650200"
        }, {
          "code": "650204",
          "alevel": 3,

          "name": "白碱滩区",
          "nickname": "",
          "pid": "650200"
        }, {
          "code": "650205",
          "alevel": 3,

          "name": "乌尔禾区",
          "nickname": "",
          "pid": "650200"
        }],
        "name": "克拉玛依市",
        "nickname": "",
        "pid": "650000"
      }, {
        "code": "650400",
        "alevel": 2,
        "sub": [{
          "code": "650402",
          "alevel": 3,

          "name": "高昌区",
          "nickname": "",
          "pid": "650400"
        }, {
          "code": "650421",
          "alevel": 3,

          "name": "鄯善县",
          "nickname": "",
          "pid": "650400"
        }, {
          "code": "650422",
          "alevel": 3,

          "name": "托克逊县",
          "nickname": "",
          "pid": "650400"
        }],
        "name": "吐鲁番市",
        "nickname": "",
        "pid": "650000"
      }, {
        "code": "650500",
        "alevel": 2,
        "sub": [{
          "code": "650502",
          "alevel": 3,

          "name": "伊州区",
          "nickname": "",
          "pid": "650500"
        }, {
          "code": "650521",
          "alevel": 3,

          "name": "巴里坤哈萨克自治县",
          "nickname": "",
          "pid": "650500"
        }, {
          "code": "650522",
          "alevel": 3,

          "name": "伊吾县",
          "nickname": "",
          "pid": "650500"
        }],
        "name": "哈密市",
        "nickname": "",
        "pid": "650000"
      }, {
        "code": "652300",
        "alevel": 2,
        "sub": [{
          "code": "652301",
          "alevel": 3,

          "name": "昌吉市",
          "nickname": "",
          "pid": "652300"
        }, {
          "code": "652302",
          "alevel": 3,

          "name": "阜康市",
          "nickname": "",
          "pid": "652300"
        }, {
          "code": "652323",
          "alevel": 3,

          "name": "呼图壁县",
          "nickname": "",
          "pid": "652300"
        }, {
          "code": "652324",
          "alevel": 3,

          "name": "玛纳斯县",
          "nickname": "",
          "pid": "652300"
        }, {
          "code": "652325",
          "alevel": 3,

          "name": "奇台县",
          "nickname": "",
          "pid": "652300"
        }, {
          "code": "652327",
          "alevel": 3,

          "name": "吉木萨尔县",
          "nickname": "",
          "pid": "652300"
        }, {
          "code": "652328",
          "alevel": 3,

          "name": "木垒哈萨克自治县",
          "nickname": "",
          "pid": "652300"
        }],
        "name": "昌吉回族自治州",
        "nickname": "",
        "pid": "650000"
      }, {
        "code": "652700",
        "alevel": 2,
        "sub": [{
          "code": "652701",
          "alevel": 3,

          "name": "博乐市",
          "nickname": "",
          "pid": "652700"
        }, {
          "code": "652702",
          "alevel": 3,

          "name": "阿拉山口市",
          "nickname": "",
          "pid": "652700"
        }, {
          "code": "652722",
          "alevel": 3,

          "name": "精河县",
          "nickname": "",
          "pid": "652700"
        }, {
          "code": "652723",
          "alevel": 3,

          "name": "温泉县",
          "nickname": "",
          "pid": "652700"
        }],
        "name": "博尔塔拉蒙古自治州",
        "nickname": "",
        "pid": "650000"
      }, {
        "code": "652800",
        "alevel": 2,
        "sub": [{
          "code": "652801",
          "alevel": 3,

          "name": "库尔勒市",
          "nickname": "",
          "pid": "652800"
        }, {
          "code": "652822",
          "alevel": 3,

          "name": "轮台县",
          "nickname": "",
          "pid": "652800"
        }, {
          "code": "652823",
          "alevel": 3,

          "name": "尉犁县",
          "nickname": "",
          "pid": "652800"
        }, {
          "code": "652824",
          "alevel": 3,

          "name": "若羌县",
          "nickname": "",
          "pid": "652800"
        }, {
          "code": "652825",
          "alevel": 3,

          "name": "且末县",
          "nickname": "",
          "pid": "652800"
        }, {
          "code": "652826",
          "alevel": 3,

          "name": "焉耆回族自治县",
          "nickname": "",
          "pid": "652800"
        }, {
          "code": "652827",
          "alevel": 3,

          "name": "和静县",
          "nickname": "",
          "pid": "652800"
        }, {
          "code": "652828",
          "alevel": 3,

          "name": "和硕县",
          "nickname": "",
          "pid": "652800"
        }, {
          "code": "652829",
          "alevel": 3,

          "name": "博湖县",
          "nickname": "",
          "pid": "652800"
        }],
        "name": "巴音郭楞蒙古自治州",
        "nickname": "",
        "pid": "650000"
      }, {
        "code": "652900",
        "alevel": 2,
        "sub": [{
          "code": "652901",
          "alevel": 3,

          "name": "阿克苏市",
          "nickname": "",
          "pid": "652900"
        }, {
          "code": "652902",
          "alevel": 3,

          "name": "库车市",
          "nickname": "",
          "pid": "652900"
        }, {
          "code": "652922",
          "alevel": 3,

          "name": "温宿县",
          "nickname": "",
          "pid": "652900"
        }, {
          "code": "652923",
          "alevel": 3,

          "name": "库车县",
          "nickname": "",
          "pid": "652900"
        }, {
          "code": "652924",
          "alevel": 3,

          "name": "沙雅县",
          "nickname": "",
          "pid": "652900"
        }, {
          "code": "652925",
          "alevel": 3,

          "name": "新和县",
          "nickname": "",
          "pid": "652900"
        }, {
          "code": "652926",
          "alevel": 3,

          "name": "拜城县",
          "nickname": "",
          "pid": "652900"
        }, {
          "code": "652927",
          "alevel": 3,

          "name": "乌什县",
          "nickname": "",
          "pid": "652900"
        }, {
          "code": "652928",
          "alevel": 3,

          "name": "阿瓦提县",
          "nickname": "",
          "pid": "652900"
        }, {
          "code": "652929",
          "alevel": 3,

          "name": "柯坪县",
          "nickname": "",
          "pid": "652900"
        }],
        "name": "阿克苏地区",
        "nickname": "",
        "pid": "650000"
      }, {
        "code": "653000",
        "alevel": 2,
        "sub": [{
          "code": "653001",
          "alevel": 3,

          "name": "阿图什市",
          "nickname": "",
          "pid": "653000"
        }, {
          "code": "653022",
          "alevel": 3,

          "name": "阿克陶县",
          "nickname": "",
          "pid": "653000"
        }, {
          "code": "653023",
          "alevel": 3,

          "name": "阿合奇县",
          "nickname": "",
          "pid": "653000"
        }, {
          "code": "653024",
          "alevel": 3,

          "name": "乌恰县",
          "nickname": "",
          "pid": "653000"
        }],
        "name": "克孜勒苏柯尔克孜自治州",
        "nickname": "",
        "pid": "650000"
      }, {
        "code": "653100",
        "alevel": 2,
        "sub": [{
          "code": "653101",
          "alevel": 3,

          "name": "喀什市",
          "nickname": "",
          "pid": "653100"
        }, {
          "code": "653121",
          "alevel": 3,

          "name": "疏附县",
          "nickname": "",
          "pid": "653100"
        }, {
          "code": "653122",
          "alevel": 3,

          "name": "疏勒县",
          "nickname": "",
          "pid": "653100"
        }, {
          "code": "653123",
          "alevel": 3,

          "name": "英吉沙县",
          "nickname": "",
          "pid": "653100"
        }, {
          "code": "653124",
          "alevel": 3,

          "name": "泽普县",
          "nickname": "",
          "pid": "653100"
        }, {
          "code": "653125",
          "alevel": 3,

          "name": "莎车县",
          "nickname": "",
          "pid": "653100"
        }, {
          "code": "653126",
          "alevel": 3,

          "name": "叶城县",
          "nickname": "",
          "pid": "653100"
        }, {
          "code": "653127",
          "alevel": 3,

          "name": "麦盖提县",
          "nickname": "",
          "pid": "653100"
        }, {
          "code": "653128",
          "alevel": 3,

          "name": "岳普湖县",
          "nickname": "",
          "pid": "653100"
        }, {
          "code": "653129",
          "alevel": 3,

          "name": "伽师县",
          "nickname": "",
          "pid": "653100"
        }, {
          "code": "653130",
          "alevel": 3,

          "name": "巴楚县",
          "nickname": "",
          "pid": "653100"
        }, {
          "code": "653131",
          "alevel": 3,

          "name": "塔什库尔干塔吉克自治县",
          "nickname": "",
          "pid": "653100"
        }],
        "name": "喀什地区",
        "nickname": "",
        "pid": "650000"
      }, {
        "code": "653200",
        "alevel": 2,
        "sub": [{
          "code": "653201",
          "alevel": 3,

          "name": "和田市",
          "nickname": "",
          "pid": "653200"
        }, {
          "code": "653221",
          "alevel": 3,

          "name": "和田县",
          "nickname": "",
          "pid": "653200"
        }, {
          "code": "653222",
          "alevel": 3,

          "name": "墨玉县",
          "nickname": "",
          "pid": "653200"
        }, {
          "code": "653223",
          "alevel": 3,

          "name": "皮山县",
          "nickname": "",
          "pid": "653200"
        }, {
          "code": "653224",
          "alevel": 3,

          "name": "洛浦县",
          "nickname": "",
          "pid": "653200"
        }, {
          "code": "653225",
          "alevel": 3,

          "name": "策勒县",
          "nickname": "",
          "pid": "653200"
        }, {
          "code": "653226",
          "alevel": 3,

          "name": "于田县",
          "nickname": "",
          "pid": "653200"
        }, {
          "code": "653227",
          "alevel": 3,

          "name": "民丰县",
          "nickname": "",
          "pid": "653200"
        }],
        "name": "和田地区",
        "nickname": "",
        "pid": "650000"
      }, {
        "code": "654000",
        "alevel": 2,
        "sub": [{
          "code": "654002",
          "alevel": 3,

          "name": "伊宁市",
          "nickname": "",
          "pid": "654000"
        }, {
          "code": "654003",
          "alevel": 3,

          "name": "奎屯市",
          "nickname": "",
          "pid": "654000"
        }, {
          "code": "654004",
          "alevel": 3,

          "name": "霍尔果斯市",
          "nickname": "",
          "pid": "654000"
        }, {
          "code": "654021",
          "alevel": 3,

          "name": "伊宁县",
          "nickname": "",
          "pid": "654000"
        }, {
          "code": "654022",
          "alevel": 3,

          "name": "察布查尔锡伯自治县",
          "nickname": "",
          "pid": "654000"
        }, {
          "code": "654023",
          "alevel": 3,

          "name": "霍城县",
          "nickname": "",
          "pid": "654000"
        }, {
          "code": "654024",
          "alevel": 3,

          "name": "巩留县",
          "nickname": "",
          "pid": "654000"
        }, {
          "code": "654025",
          "alevel": 3,

          "name": "新源县",
          "nickname": "",
          "pid": "654000"
        }, {
          "code": "654026",
          "alevel": 3,

          "name": "昭苏县",
          "nickname": "",
          "pid": "654000"
        }, {
          "code": "654027",
          "alevel": 3,

          "name": "特克斯县",
          "nickname": "",
          "pid": "654000"
        }, {
          "code": "654028",
          "alevel": 3,

          "name": "尼勒克县",
          "nickname": "",
          "pid": "654000"
        }],
        "name": "伊犁哈萨克自治州",
        "nickname": "",
        "pid": "650000"
      }, {
        "code": "654200",
        "alevel": 2,
        "sub": [{
          "code": "654201",
          "alevel": 3,

          "name": "塔城市",
          "nickname": "",
          "pid": "654200"
        }, {
          "code": "654202",
          "alevel": 3,

          "name": "乌苏市",
          "nickname": "",
          "pid": "654200"
        }, {
          "code": "654221",
          "alevel": 3,

          "name": "额敏县",
          "nickname": "",
          "pid": "654200"
        }, {
          "code": "654223",
          "alevel": 3,

          "name": "沙湾县",
          "nickname": "",
          "pid": "654200"
        }, {
          "code": "654224",
          "alevel": 3,

          "name": "托里县",
          "nickname": "",
          "pid": "654200"
        }, {
          "code": "654225",
          "alevel": 3,

          "name": "裕民县",
          "nickname": "",
          "pid": "654200"
        }, {
          "code": "654226",
          "alevel": 3,

          "name": "和布克赛尔蒙古自治县",
          "nickname": "",
          "pid": "654200"
        }],
        "name": "塔城地区",
        "nickname": "",
        "pid": "650000"
      }, {
        "code": "654300",
        "alevel": 2,
        "sub": [{
          "code": "654301",
          "alevel": 3,

          "name": "阿勒泰市",
          "nickname": "",
          "pid": "654300"
        }, {
          "code": "654321",
          "alevel": 3,

          "name": "布尔津县",
          "nickname": "",
          "pid": "654300"
        }, {
          "code": "654322",
          "alevel": 3,

          "name": "富蕴县",
          "nickname": "",
          "pid": "654300"
        }, {
          "code": "654323",
          "alevel": 3,

          "name": "福海县",
          "nickname": "",
          "pid": "654300"
        }, {
          "code": "654324",
          "alevel": 3,

          "name": "哈巴河县",
          "nickname": "",
          "pid": "654300"
        }, {
          "code": "654325",
          "alevel": 3,

          "name": "青河县",
          "nickname": "",
          "pid": "654300"
        }, {
          "code": "654326",
          "alevel": 3,

          "name": "吉木乃县",
          "nickname": "",
          "pid": "654300"
        }],
        "name": "阿勒泰地区",
        "nickname": "",
        "pid": "650000"
      }, {
        "code": "659000",
        "alevel": 2,
        "sub": [{
          "code": "659001",
          "alevel": 3,

          "name": "石河子市",
          "nickname": "",
          "pid": "659000"
        }, {
          "code": "659002",
          "alevel": 3,

          "name": "阿拉尔市",
          "nickname": "",
          "pid": "659000"
        }, {
          "code": "659003",
          "alevel": 3,

          "name": "图木舒克市",
          "nickname": "",
          "pid": "659000"
        }, {
          "code": "659004",
          "alevel": 3,

          "name": "五家渠市",
          "nickname": "",
          "pid": "659000"
        }, {
          "code": "659006",
          "alevel": 3,
          "name": "铁门关市",
          "nickname": "",
          "pid": "659000"
        }],
        "name": "自治区直辖县级行政区划",
        "nickname": "",
        "pid": "650000"
      }],
      "name": "新疆维吾尔自治区",
      "nickname": "新",
      "pid": ""
    },
    {
      "code": "710000",
      "alevel": 1,
      "sub":[
        {
          "code": "710100",
          "alevel": 2,
          "name": "台北市",
          "sub":[
            {
              "code": "710101",
              "alevel": 3,
              "name": "中正区",
              "nickname": "",
              "pid": "710100"
            },
            {
              "code": "710102",
              "alevel": 3,
              "name": "大同区",
              "nickname": "",
              "pid": "710100"
            },
            {
              "code": "710103",
              "alevel": 3,
              "name": "中山区",
              "nickname": "",
              "pid": "710100"
            },
            {
              "code": "710104",
              "alevel": 3,
              "name": "松山区",
              "nickname": "",
              "pid": "710100"
            },
            {
              "code": "710105",
              "alevel": 3,
              "name": "大安区",
              "nickname": "",
              "pid": "710100"
            },
            {
              "code": "710106",
              "alevel": 3,
              "name": "万华区",
              "nickname": "",
              "pid": "710100"
            },
            {
              "code": "710107",
              "alevel": 3,
              "name": "信义区",
              "nickname": "",
              "pid": "710100"
            },
            {
              "code": "710108",
              "alevel": 3,
              "name": "士林区",
              "nickname": "",
              "pid": "710100"
            },
            {
              "code": "710109",
              "alevel": 3,
              "name": "北投区",
              "nickname": "",
              "pid": "710100"
            },
            {
              "code": "710110",
              "alevel": 3,
              "name": "内湖区",
              "nickname": "",
              "pid": "710100"
            },
            {
              "code": "710111",
              "alevel": 3,
              "name": "南港区",
              "nickname": "",
              "pid": "710100"
            },
            {
              "code": "710112",
              "alevel": 3,
              "name": "文山区",
              "nickname": "",
              "pid": "710100"
            },
            {
              "code": "710199",
              "alevel": 3,
              "name": "其它区",
              "nickname": "",
              "pid": "710100"
            },
          ],
          "nickname": "",
          "pid": "710000"
        },
        {
          "code": "710200",
          "alevel": 2,
          "name": "高雄市",
          "sub":[
            {
              "code": "710201",
              "alevel": 3,
              "name": "新兴区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710202",
              "alevel": 3,
              "name": "前金区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710203",
              "alevel": 3,
              "name": "芩雅区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710204",
              "alevel": 3,
              "name": "盐埕区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710205",
              "alevel": 3,
              "name": "鼓山区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710206",
              "alevel": 3,
              "name": "旗津区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710207",
              "alevel": 3,
              "name": "前镇区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710208",
              "alevel": 3,
              "name": "三民区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710209",
              "alevel": 3,
              "name": "左营区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710210",
              "alevel": 3,
              "name": "楠梓区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710211",
              "alevel": 3,
              "name": "小港区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710241",
              "alevel": 3,
              "name": "苓雅区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710242",
              "alevel": 3,
              "name": "仁武区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710243",
              "alevel": 3,
              "name": "大社区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710244",
              "alevel": 3,
              "name": "冈山区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710245",
              "alevel": 3,
              "name": "路竹区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710246",
              "alevel": 3,
              "name": "阿莲区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710247",
              "alevel": 3,
              "name": "田寮区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710248",
              "alevel": 3,
              "name": "燕巢区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710249",
              "alevel": 3,
              "name": "桥头区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710250",
              "alevel": 3,
              "name": "梓官区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710251",
              "alevel": 3,
              "name": "弥陀区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710252",
              "alevel": 3,
              "name": "永安区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710253",
              "alevel": 3,
              "name": "湖内区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710254",
              "alevel": 3,
              "name": "凤山区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710255",
              "alevel": 3,
              "name": "大寮区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710256",
              "alevel": 3,
              "name": "林园区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710257",
              "alevel": 3,
              "name": "鸟松区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710258",
              "alevel": 3,
              "name": "大树区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710259",
              "alevel": 3,
              "name": "旗山区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710260",
              "alevel": 3,
              "name": "美浓区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710261",
              "alevel": 3,
              "name": "六龟区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710262",
              "alevel": 3,
              "name": "内门区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710263",
              "alevel": 3,
              "name": "杉林区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710264",
              "alevel": 3,
              "name": "甲仙区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710265",
              "alevel": 3,
              "name": "桃源区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710266",
              "alevel": 3,
              "name": "那玛夏区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710267",
              "alevel": 3,
              "name": "茂林区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710268",
              "alevel": 3,
              "name": "茄萣区",
              "nickname": "",
              "pid": "710200"
            },
            {
              "code": "710299",
              "alevel": 3,
              "name": "其它区",
              "nickname": "",
              "pid": "710200"
            }
          ],
          "nickname": "",
          "pid": "710000"
        },
        {
          "code": "710300",
          "alevel": 2,
          "name": "台南市",
          "sub":[
            {
              "code": "710301",
              "alevel": 3,
              "name": "中西区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710302",
              "alevel": 3,
              "name": "东区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710303",
              "alevel": 3,
              "name": "南区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710304",
              "alevel": 3,
              "name": "北区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710305",
              "alevel": 3,
              "name": "安平区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710306",
              "alevel": 3,
              "name": "安南区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710339",
              "alevel": 3,
              "name": "永康区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710340",
              "alevel": 3,
              "name": "归仁区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710341",
              "alevel": 3,
              "name": "新化区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710342",
              "alevel": 3,
              "name": "左镇区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710343",
              "alevel": 3,
              "name": "玉井区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710344",
              "alevel": 3,
              "name": "楠西区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710345",
              "alevel": 3,
              "name": "南化区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710346",
              "alevel": 3,
              "name": "仁德区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710347",
              "alevel": 3,
              "name": "关庙区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710348",
              "alevel": 3,
              "name": "龙崎区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710349",
              "alevel": 3,
              "name": "官田区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710350",
              "alevel": 3,
              "name": "麻豆区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710351",
              "alevel": 3,
              "name": "佳里区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710352",
              "alevel": 3,
              "name": "西港区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710353",
              "alevel": 3,
              "name": "七股区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710354",
              "alevel": 3,
              "name": "将军区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710355",
              "alevel": 3,
              "name": "学甲区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710356",
              "alevel": 3,
              "name": "北门区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710357",
              "alevel": 3,
              "name": "新营区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710358",
              "alevel": 3,
              "name": "后壁区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710359",
              "alevel": 3,
              "name": "白河区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710360",
              "alevel": 3,
              "name": "东山区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710361",
              "alevel": 3,
              "name": "六甲区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710362",
              "alevel": 3,
              "name": "下营区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710363",
              "alevel": 3,
              "name": "柳营区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710364",
              "alevel": 3,
              "name": "盐水区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710365",
              "alevel": 3,
              "name": "善化区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710366",
              "alevel": 3,
              "name": "大内区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710367",
              "alevel": 3,
              "name": "山上区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710368",
              "alevel": 3,
              "name": "新市区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710369",
              "alevel": 3,
              "name": "安定区",
              "nickname": "",
              "pid": "710300"
            },
            {
              "code": "710399",
              "alevel": 3,
              "name": "其它区",
              "nickname": "",
              "pid": "710300"
            },
          ],
          "nickname": "",
          "pid": "710000"
        },
        {
          "code": "710400",
          "alevel": 2,
          "name": "台中市",
          "sub":[
            {
              "code": "710401",
              "alevel": 3,
              "name": "中区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710402",
              "alevel": 3,
              "name": "东区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710403",
              "alevel": 3,
              "name": "南区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710404",
              "alevel": 3,
              "name": "西区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710405",
              "alevel": 3,
              "name": "北区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710406",
              "alevel": 3,
              "name": "北屯区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710407",
              "alevel": 3,
              "name": "西屯区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710408",
              "alevel": 3,
              "name": "南屯区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710431",
              "alevel": 3,
              "name": "太平区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710432",
              "alevel": 3,
              "name": "大里区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710433",
              "alevel": 3,
              "name": "雾峰区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710434",
              "alevel": 3,
              "name": "乌日区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710435",
              "alevel": 3,
              "name": "丰原区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710436",
              "alevel": 3,
              "name": "后里区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710437",
              "alevel": 3,
              "name": "石冈区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710438",
              "alevel": 3,
              "name": "东势区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710439",
              "alevel": 3,
              "name": "和平区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710440",
              "alevel": 3,
              "name": "新社区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710441",
              "alevel": 3,
              "name": "潭子区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710442",
              "alevel": 3,
              "name": "大雅区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710443",
              "alevel": 3,
              "name": "神冈区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710444",
              "alevel": 3,
              "name": "大肚区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710445",
              "alevel": 3,
              "name": "沙鹿区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710446",
              "alevel": 3,
              "name": "龙井区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710447",
              "alevel": 3,
              "name": "梧栖区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710448",
              "alevel": 3,
              "name": "清水区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710449",
              "alevel": 3,
              "name": "大甲区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710450",
              "alevel": 3,
              "name": "外埔区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710451",
              "alevel": 3,
              "name": "大安区",
              "nickname": "",
              "pid": "710400"
            },
            {
              "code": "710499",
              "alevel": 3,
              "name": "其它区",
              "nickname": "",
              "pid": "710400"
            }
          ],
          "nickname": "",
          "pid": "710000"
        },
        {
          "code": "710500",
          "alevel": 2,
          "name": "金门县",
          "sub":[
            {
              "code": "710507",
              "alevel": 3,
              "name": "金沙镇",
              "nickname": "",
              "pid": "710500"
            },
            {
              "code": "710508",
              "alevel": 3,
              "name": "金湖镇",
              "nickname": "",
              "pid": "710500"
            },
            {
              "code": "710509",
              "alevel": 3,
              "name": "金宁乡",
              "nickname": "",
              "pid": "710500"
            },
            {
              "code": "710510",
              "alevel": 3,
              "name": "金城镇",
              "nickname": "",
              "pid": "710500"
            },
            {
              "code": "710511",
              "alevel": 3,
              "name": "烈屿乡",
              "nickname": "",
              "pid": "710500"
            },
            {
              "code": "710512",
              "alevel": 3,
              "name": "乌坵乡",
              "nickname": "",
              "pid": "710500"
            }
          ],
          "nickname": "",
          "pid": "710000"
        },
        {
          "code": "710600",
          "alevel": 2,
          "name": "南投县",
          "sub":[
            {
              "code": "710614",
              "alevel": 3,
              "name": "南投市",
              "nickname": "",
              "pid": "710600"
            },
            {
              "code": "710615",
              "alevel": 3,
              "name": "中寮乡",
              "nickname": "",
              "pid": "710600"
            },
            {
              "code": "710616",
              "alevel": 3,
              "name": "草屯镇",
              "nickname": "",
              "pid": "710600"
            },
            {
              "code": "710617",
              "alevel": 3,
              "name": "国姓乡",
              "nickname": "",
              "pid": "710600"
            },
            {
              "code": "710618",
              "alevel": 3,
              "name": "埔里镇",
              "nickname": "",
              "pid": "710600"
            },
            {
              "code": "710619",
              "alevel": 3,
              "name": "仁爱乡",
              "nickname": "",
              "pid": "710600"
            },
            {
              "code": "710620",
              "alevel": 3,
              "name": "名间乡",
              "nickname": "",
              "pid": "710600"
            },
            {
              "code": "710621",
              "alevel": 3,
              "name": "集集镇",
              "nickname": "",
              "pid": "710600"
            },
            {
              "code": "710622",
              "alevel": 3,
              "name": "水里乡",
              "nickname": "",
              "pid": "710600"
            },
            {
              "code": "710623",
              "alevel": 3,
              "name": "鱼池乡",
              "nickname": "",
              "pid": "710600"
            },
            {
              "code": "710624",
              "alevel": 3,
              "name": "信义乡",
              "nickname": "",
              "pid": "710600"
            },
            {
              "code": "710625",
              "alevel": 3,
              "name": "竹山镇",
              "nickname": "",
              "pid": "710600"
            },
            {
              "code": "710626",
              "alevel": 3,
              "name": "鹿谷乡",
              "nickname": "",
              "pid": "710600"
            },
          ],
          "nickname": "",
          "pid": "710000"
        },
        {
          "code": "710700",
          "alevel": 2,
          "name": "基隆市",
          "sub":[
            {
              "code": "710701",
              "alevel": 3,
              "name": "仁爱区",
              "nickname": "",
              "pid": "710700"
            },
            {
              "code": "710702",
              "alevel": 3,
              "name": "信义区",
              "nickname": "",
              "pid": "710700"
            },
            {
              "code": "710703",
              "alevel": 3,
              "name": "中正区",
              "nickname": "",
              "pid": "710700"
            },
            {
              "code": "710704",
              "alevel": 3,
              "name": "中山区",
              "nickname": "",
              "pid": "710700"
            },
            {
              "code": "710705",
              "alevel": 3,
              "name": "安乐区",
              "nickname": "",
              "pid": "710700"
            },
            {
              "code": "710706",
              "alevel": 3,
              "name": "暖暖区",
              "nickname": "",
              "pid": "710700"
            },
            {
              "code": "710707",
              "alevel": 3,
              "name": "七堵区",
              "nickname": "",
              "pid": "710700"
            },
            {
              "code": "710799",
              "alevel": 3,
              "name": "其它区",
              "nickname": "",
              "pid": "710700"
            }
          ],
          "nickname": "",
          "pid": "710000"
        },
        {
          "code": "710800",
          "alevel": 2,
          "name": "新竹市",
          "sub":[
            {
              "code": "710801",
              "alevel": 3,
              "name": "东区",
              "nickname": "",
              "pid": "710800"
            },
            {
              "code": "710802",
              "alevel": 3,
              "name": "北区",
              "nickname": "",
              "pid": "710800"
            },
            {
              "code": "710803",
              "alevel": 3,
              "name": "香山区",
              "nickname": "",
              "pid": "710800"
            },
            {
              "code": "710899",
              "alevel": 3,
              "name": "其它区",
              "nickname": "",
              "pid": "710800"
            },
          ],
          "nickname": "",
          "pid": "710000"
        },
        {
          "code": "710900",
          "alevel": 2,
          "name": "嘉义市",
          "sub":[
            {
              "code": "711130",
              "alevel": 3,
              "name": "万里区",
              "nickname": "",
              "pid": "710900"
            },
            {
              "code": "710901",
              "alevel": 3,
              "name": "东区",
              "nickname": "",
              "pid": "710900"
            },
            {
              "code": "710902",
              "alevel": 3,
              "name": "西区",
              "nickname": "",
              "pid": "710900"
            },
            {
              "code": "710999",
              "alevel": 3,
              "name": "其它区",
              "nickname": "",
              "pid": "710900"
            },
          ],
          "nickname": "",
          "pid": "710000"
        },
        {
          "code": "711100",
          "alevel": 2,
          "name": "新北市",
          "sub":[
            {
              "code": "711130",
              "alevel": 3,
              "name": "万里区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711132",
              "alevel": 3,
              "name": "板桥区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711133",
              "alevel": 3,
              "name": "汐止区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711134",
              "alevel": 3,
              "name": "深坑区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711135",
              "alevel": 3,
              "name": "石碇区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711136",
              "alevel": 3,
              "name": "瑞芳区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711137",
              "alevel": 3,
              "name": "平溪区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711138",
              "alevel": 3,
              "name": "双溪区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711139",
              "alevel": 3,
              "name": "贡寮区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711140",
              "alevel": 3,
              "name": "新店区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711141",
              "alevel": 3,
              "name": "坪林区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711142",
              "alevel": 3,
              "name": "乌来区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711143",
              "alevel": 3,
              "name": "永和区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711144",
              "alevel": 3,
              "name": "中和区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711145",
              "alevel": 3,
              "name": "土城区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711146",
              "alevel": 3,
              "name": "三峡区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711147",
              "alevel": 3,
              "name": "树林区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711148",
              "alevel": 3,
              "name": "莺歌区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711149",
              "alevel": 3,
              "name": "三重区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711150",
              "alevel": 3,
              "name": "新庄区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711151",
              "alevel": 3,
              "name": "泰山区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711152",
              "alevel": 3,
              "name": "林口区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711153",
              "alevel": 3,
              "name": "芦洲区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711154",
              "alevel": 3,
              "name": "五股区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711155",
              "alevel": 3,
              "name": "八里区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711156",
              "alevel": 3,
              "name": "淡水区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711157",
              "alevel": 3,
              "name": "三芝区",
              "nickname": "",
              "pid": "711100"
            },
            {
              "code": "711158",
              "alevel": 3,
              "name": "石门区",
              "nickname": "",
              "pid": "711100"
            }
          ],
          "nickname": "",
          "pid": "710000"
        },
        {
          "code": "711200",
          "alevel": 2,
          "name": "宜兰县",
          "sub":[
            {
              "code": "711287",
              "alevel": 3,
              "name": "宜兰市",
              "nickname": "",
              "pid": "711200"
            },
            {
              "code": "711288",
              "alevel": 3,
              "name": "头城镇",
              "nickname": "",
              "pid": "711200"
            },
            {
              "code": "711289",
              "alevel": 3,
              "name": "礁溪乡",
              "nickname": "",
              "pid": "711200"
            },
            {
              "code": "711290",
              "alevel": 3,
              "name": "壮围乡",
              "nickname": "",
              "pid": "711200"
            },
            {
              "code": "711291",
              "alevel": 3,
              "name": "员山乡",
              "nickname": "",
              "pid": "711200"
            },
            {
              "code": "711292",
              "alevel": 3,
              "name": "罗东镇",
              "nickname": "",
              "pid": "711200"
            },
            {
              "code": "711293",
              "alevel": 3,
              "name": "三星乡",
              "nickname": "",
              "pid": "711200"
            },
            {
              "code": "711294",
              "alevel": 3,
              "name": "大同乡",
              "nickname": "",
              "pid": "711200"
            },
            {
              "code": "711295",
              "alevel": 3,
              "name": "五结乡",
              "nickname": "",
              "pid": "711200"
            },
            {
              "code": "711296",
              "alevel": 3,
              "name": "冬山乡",
              "nickname": "",
              "pid": "711200"
            },
            {
              "code": "711297",
              "alevel": 3,
              "name": "苏澳镇",
              "nickname": "",
              "pid": "711200"
            },
            {
              "code": "711298",
              "alevel": 3,
              "name": "南澳乡",
              "nickname": "",
              "pid": "711200"
            },
            {
              "code": "711299",
              "alevel": 3,
              "name": "钓鱼台",
              "nickname": "",
              "pid": "711200"
            }
          ],
          "nickname": "",
          "pid": "710000"
        },
        {
          "code": "711300",
          "alevel": 2,
          "name": "新竹县",
          "sub":[
            {
              "code": "711387",
              "alevel": 3,
              "name": "竹北市",
              "nickname": "",
              "pid": "711300"
            },
            {
              "code": "711388",
              "alevel": 3,
              "name": "湖口乡",
              "nickname": "",
              "pid": "711300"
            },
            {
              "code": "711389",
              "alevel": 3,
              "name": "新丰乡",
              "nickname": "",
              "pid": "711300"
            },
            {
              "code": "711390",
              "alevel": 3,
              "name": "新埔镇",
              "nickname": "",
              "pid": "711300"
            },
            {
              "code": "711391",
              "alevel": 3,
              "name": "关西镇",
              "nickname": "",
              "pid": "711300"
            },
            {
              "code": "711392",
              "alevel": 3,
              "name": "芎林乡",
              "nickname": "",
              "pid": "711300"
            },
            {
              "code": "711393",
              "alevel": 3,
              "name": "宝山乡",
              "nickname": "",
              "pid": "711300"
            },
            {
              "code": "711394",
              "alevel": 3,
              "name": "竹东镇",
              "nickname": "",
              "pid": "711300"
            },
            {
              "code": "711395",
              "alevel": 3,
              "name": "五峰乡",
              "nickname": "",
              "pid": "711300"
            },
            {
              "code": "711396",
              "alevel": 3,
              "name": "横山乡",
              "nickname": "",
              "pid": "711300"
            },
            {
              "code": "711397",
              "alevel": 3,
              "name": "尖石乡",
              "nickname": "",
              "pid": "711300"
            },
            {
              "code": "711398",
              "alevel": 3,
              "name": "北埔乡",
              "nickname": "",
              "pid": "711300"
            },
            {
              "code": "711399",
              "alevel": 3,
              "name": "峨眉乡",
              "nickname": "",
              "pid": "711300"
            }
          ],
          "nickname": "",
          "pid": "710000"
        },
        {
          "code": "711400",
          "alevel": 2,
          "name": "桃园市",
          "sub":[
            {
              "code": "711414",
              "alevel": 3,
              "name": "中坜区",
              "nickname": "",
              "pid": "711400"
            },
            {
              "code": "711415",
              "alevel": 3,
              "name": "平镇区",
              "nickname": "",
              "pid": "711400"
            },
            {
              "code": "711417",
              "alevel": 3,
              "name": "杨梅区",
              "nickname": "",
              "pid": "711400"
            },
            {
              "code": "711418",
              "alevel": 3,
              "name": "新屋区",
              "nickname": "",
              "pid": "711400"
            },
            {
              "code": "711419",
              "alevel": 3,
              "name": "观音区",
              "nickname": "",
              "pid": "711400"
            },
            {
              "code": "711420",
              "alevel": 3,
              "name": "桃园区",
              "nickname": "",
              "pid": "711400"
            },
            {
              "code": "711421",
              "alevel": 3,
              "name": "龟山区",
              "nickname": "",
              "pid": "711400"
            },
            {
              "code": "711422",
              "alevel": 3,
              "name": "八德区",
              "nickname": "",
              "pid": "711400"
            },
            {
              "code": "711423",
              "alevel": 3,
              "name": "大溪区",
              "nickname": "",
              "pid": "711400"
            },
            {
              "code": "711425",
              "alevel": 3,
              "name": "大园区",
              "nickname": "",
              "pid": "711400"
            },
            {
              "code": "711426",
              "alevel": 3,
              "name": "芦竹区",
              "nickname": "",
              "pid": "711400"
            },
            {
              "code": "中坜市",
              "alevel": 3,
              "name": "中坜市",
              "nickname": "",
              "pid": "711400"
            },
            {
              "code": "711488",
              "alevel": 3,
              "name": "平镇市",
              "nickname": "",
              "pid": "711400"
            },
            {
              "code": "711489",
              "alevel": 3,
              "name": "龙潭乡",
              "nickname": "",
              "pid": "711400"
            },
            {
              "code": "711490",
              "alevel": 3,
              "name": "杨梅市",
              "nickname": "",
              "pid": "711400"
            },
            {
              "code": "711491",
              "alevel": 3,
              "name": "新屋乡",
              "nickname": "",
              "pid": "711400"
            },
            {
              "code": "711492",
              "alevel": 3,
              "name": "观音乡",
              "nickname": "",
              "pid": "711400"
            },
            {
              "code": "711493",
              "alevel": 3,
              "name": "桃园市",
              "nickname": "",
              "pid": "711400"
            },
            {
              "code": "711494",
              "alevel": 3,
              "name": "龟山乡",
              "nickname": "",
              "pid": "711400"
            },
            {
              "code": "711495",
              "alevel": 3,
              "name": "八德市",
              "nickname": "",
              "pid": "711400"
            },
            {
              "code": "711496",
              "alevel": 3,
              "name": "大溪镇",
              "nickname": "",
              "pid": "711400"
            },
            {
              "code": "711497",
              "alevel": 3,
              "name": "复兴乡",
              "nickname": "",
              "pid": "711400"
            },
            {
              "code": "711498",
              "alevel": 3,
              "name": "大园乡",
              "nickname": "",
              "pid": "711400"
            },
            {
              "code": "711499",
              "alevel": 3,
              "name": "芦竹乡",
              "nickname": "",
              "pid": "711400"
            }
          ],
          "nickname": "",
          "pid": "710000"
        },
        {
          "code": "711500",
          "alevel": 2,
          "name": "苗栗县",
          "sub":[
            {
              "code": "711520",
              "alevel": 3,
              "name": "头份市",
              "nickname": "",
              "pid": "711500"
            },
            {
              "code": "711582",
              "alevel": 3,
              "name": "竹南镇",
              "nickname": "",
              "pid": "711500"
            },
            {
              "code": "711583",
              "alevel": 3,
              "name": "头份镇",
              "nickname": "",
              "pid": "711500"
            },
            {
              "code": "711584",
              "alevel": 3,
              "name": "三湾乡",
              "nickname": "",
              "pid": "711500"
            },
            {
              "code": "711585",
              "alevel": 3,
              "name": "南庄乡",
              "nickname": "",
              "pid": "711500"
            },
            {
              "code": "711586",
              "alevel": 3,
              "name": "狮潭乡",
              "nickname": "",
              "pid": "711500"
            },
            {
              "code": "711587",
              "alevel": 3,
              "name": "后龙镇",
              "nickname": "",
              "pid": "711500"
            },
            {
              "code": "711588",
              "alevel": 3,
              "name": "通霄镇",
              "nickname": "",
              "pid": "711500"
            },
            {
              "code": "711589",
              "alevel": 3,
              "name": "苑里镇",
              "nickname": "",
              "pid": "711500"
            },
            {
              "code": "711590",
              "alevel": 3,
              "name": "苗栗市",
              "nickname": "",
              "pid": "711500"
            },
            {
              "code": "711591",
              "alevel": 3,
              "name": "造桥乡",
              "nickname": "",
              "pid": "711500"
            },
            {
              "code": "711592",
              "alevel": 3,
              "name": "头屋乡",
              "nickname": "",
              "pid": "711500"
            },
            {
              "code": "711593",
              "alevel": 3,
              "name": "公馆乡",
              "nickname": "",
              "pid": "711500"
            },
            {
              "code": "711594",
              "alevel": 3,
              "name": "大湖乡",
              "nickname": "",
              "pid": "711500"
            },
            {
              "code": "711595",
              "alevel": 3,
              "name": "泰安乡",
              "nickname": "",
              "pid": "711500"
            },
            {
              "code": "711596",
              "alevel": 3,
              "name": "铜锣乡",
              "nickname": "",
              "pid": "711500"
            },
            {
              "code": "711597",
              "alevel": 3,
              "name": "三义乡",
              "nickname": "",
              "pid": "711500"
            },
            {
              "code": "711598",
              "alevel": 3,
              "name": "西湖乡",
              "nickname": "",
              "pid": "711500"
            },
            {
              "code": "711599",
              "alevel": 3,
              "name": "卓兰镇",
              "nickname": "",
              "pid": "711500"
            },
          ],
          "nickname": "",
          "pid": "710000"
        },
        {
          "code": "711700",
          "alevel": 2,
          "name": "彰化县",
          "sub":[
            {
              "code": "711736",
              "alevel": 3,
              "name": "员林市",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711774",
              "alevel": 3,
              "name": "彰化市",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711775",
              "alevel": 3,
              "name": "芬园乡",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711776",
              "alevel": 3,
              "name": "花坛乡",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711777",
              "alevel": 3,
              "name": "秀水乡",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711778",
              "alevel": 3,
              "name": "鹿港镇",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711779",
              "alevel": 3,
              "name": "福兴乡",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711780",
              "alevel": 3,
              "name": "线西乡",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711781",
              "alevel": 3,
              "name": "和美镇",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711782",
              "alevel": 3,
              "name": "伸港乡",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711783",
              "alevel": 3,
              "name": "员林镇",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711784",
              "alevel": 3,
              "name": "社头乡",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711785",
              "alevel": 3,
              "name": "永靖乡",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711786",
              "alevel": 3,
              "name": "埔心乡",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711787",
              "alevel": 3,
              "name": "溪湖镇",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711788",
              "alevel": 3,
              "name": "大村乡",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711789",
              "alevel": 3,
              "name": "埔盐乡",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711790",
              "alevel": 3,
              "name": "田中镇",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711791",
              "alevel": 3,
              "name": "北斗镇",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711792",
              "alevel": 3,
              "name": "田尾乡",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711793",
              "alevel": 3,
              "name": "埤头乡",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711794",
              "alevel": 3,
              "name": "溪州乡",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711795",
              "alevel": 3,
              "name": "竹塘乡",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711796",
              "alevel": 3,
              "name": "二林镇",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711797",
              "alevel": 3,
              "name": "大城乡",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711798",
              "alevel": 3,
              "name": "芳苑乡",
              "nickname": "",
              "pid": "711700"
            },
            {
              "code": "711799",
              "alevel": 3,
              "name": "二水乡",
              "nickname": "",
              "pid": "711700"
            },
          ],
          "nickname": "",
          "pid": "710000"
        },
        {
          "code": "711900",
          "alevel": 2,
          "name": "嘉义县",
          "sub":[
            {
              "code": "711982",
              "alevel": 3,
              "name": "番路乡",
              "nickname": "",
              "pid": "711900"
            },
            {
              "code": "711983",
              "alevel": 3,
              "name": "梅山乡",
              "nickname": "",
              "pid": "711900"
            },
            {
              "code": "711984",
              "alevel": 3,
              "name": "竹崎乡",
              "nickname": "",
              "pid": "711900"
            },
            {
              "code": "711985",
              "alevel": 3,
              "name": "阿里山乡",
              "nickname": "",
              "pid": "711900"
            },
            {
              "code": "711986",
              "alevel": 3,
              "name": "中埔乡",
              "nickname": "",
              "pid": "711900"
            },
            {
              "code": "711987",
              "alevel": 3,
              "name": "大埔乡",
              "nickname": "",
              "pid": "711900"
            },
            {
              "code": "711988",
              "alevel": 3,
              "name": "水上乡",
              "nickname": "",
              "pid": "711900"
            },
            {
              "code": "711989",
              "alevel": 3,
              "name": "鹿草乡",
              "nickname": "",
              "pid": "711900"
            },
            {
              "code": "711990",
              "alevel": 3,
              "name": "太保市",
              "nickname": "",
              "pid": "711900"
            },
            {
              "code": "711991",
              "alevel": 3,
              "name": "朴子市",
              "nickname": "",
              "pid": "711900"
            },
            {
              "code": "711992",
              "alevel": 3,
              "name": "东石乡",
              "nickname": "",
              "pid": "711900"
            },
            {
              "code": "711993",
              "alevel": 3,
              "name": "六脚乡",
              "nickname": "",
              "pid": "711900"
            },
            {
              "code": "711994",
              "alevel": 3,
              "name": "新港乡",
              "nickname": "",
              "pid": "711900"
            },
            {
              "code": "711995",
              "alevel": 3,
              "name": "民雄乡",
              "nickname": "",
              "pid": "711900"
            },
            {
              "code": "711996",
              "alevel": 3,
              "name": "大林镇",
              "nickname": "",
              "pid": "711900"
            },
            {
              "code": "711997",
              "alevel": 3,
              "name": "溪口乡",
              "nickname": "",
              "pid": "711900"
            },
            {
              "code": "711998",
              "alevel": 3,
              "name": "义竹乡",
              "nickname": "",
              "pid": "711900"
            },
            {
              "code": "711999",
              "alevel": 3,
              "name": "布袋镇",
              "nickname": "",
              "pid": "711900"
            },
          ],
          "nickname": "",
          "pid": "710000"
        },
        {
          "code": "712100",
          "alevel": 2,
          "name": "云林县",
          "sub":[
            {
              "code": "712180",
              "alevel": 3,
              "name": "斗南镇",
              "nickname": "",
              "pid": "712100"
            },
            {
              "code": "712181",
              "alevel": 3,
              "name": "大埤乡",
              "nickname": "",
              "pid": "712100"
            },
            {
              "code": "712182",
              "alevel": 3,
              "name": "虎尾镇",
              "nickname": "",
              "pid": "712100"
            },
            {
              "code": "712183",
              "alevel": 3,
              "name": "土库镇",
              "nickname": "",
              "pid": "712100"
            },
            {
              "code": "712184",
              "alevel": 3,
              "name": "褒忠乡",
              "nickname": "",
              "pid": "712100"
            },
            {
              "code": "712185",
              "alevel": 3,
              "name": "东势乡",
              "nickname": "",
              "pid": "712100"
            },
            {
              "code": "712186",
              "alevel": 3,
              "name": "台西乡",
              "nickname": "",
              "pid": "712100"
            },
            {
              "code": "712187",
              "alevel": 3,
              "name": "仑背乡",
              "nickname": "",
              "pid": "712100"
            },
            {
              "code": "712188",
              "alevel": 3,
              "name": "麦寮乡",
              "nickname": "",
              "pid": "712100"
            },
            {
              "code": "712189",
              "alevel": 3,
              "name": "斗六市",
              "nickname": "",
              "pid": "712100"
            },
            {
              "code": "712190",
              "alevel": 3,
              "name": "林内乡",
              "nickname": "",
              "pid": "712100"
            },
            {
              "code": "712191",
              "alevel": 3,
              "name": "古坑乡",
              "nickname": "",
              "pid": "712100"
            },
            {
              "code": "712192",
              "alevel": 3,
              "name": "莿桐乡",
              "nickname": "",
              "pid": "712100"
            },
            {
              "code": "712193",
              "alevel": 3,
              "name": "西螺镇",
              "nickname": "",
              "pid": "712100"
            },
            {
              "code": "712194",
              "alevel": 3,
              "name": "二仑乡",
              "nickname": "",
              "pid": "712100"
            },
            {
              "code": "712195",
              "alevel": 3,
              "name": "北港镇",
              "nickname": "",
              "pid": "712100"
            },
            {
              "code": "712196",
              "alevel": 3,
              "name": "水林乡",
              "nickname": "",
              "pid": "712100"
            },
            {
              "code": "712197",
              "alevel": 3,
              "name": "口湖乡",
              "nickname": "",
              "pid": "712100"
            },
            {
              "code": "712198",
              "alevel": 3,
              "name": "四湖乡",
              "nickname": "",
              "pid": "712100"
            },
            {
              "code": "712199",
              "alevel": 3,
              "name": "元长乡",
              "nickname": "",
              "pid": "712100"
            },
          ],
          "nickname": "",
          "pid": "710000"
        },
        {
          "code": "712400",
          "alevel": 2,
          "name": "屏东县",
          "sub":[
            {
              "code": "712484",
              "alevel": 3,
              "name": "莰顶乡",
              "nickname": "",
              "pid": "712400"
            },
            {
              "code": "712485",
              "alevel": 3,
              "name": "新埤乡",
              "nickname": "",
              "pid": "712400"
            },
            {
              "code": "712486",
              "alevel": 3,
              "name": "南州乡",
              "nickname": "",
              "pid": "712400"
            },
            {
              "code": "712484",
              "alevel": 3,
              "name": "莰顶乡",
              "nickname": "",
              "pid": "712400"
            },
            {
              "code": "712487",
              "alevel": 3,
              "name": "林边乡",
              "nickname": "",
              "pid": "712400"
            },
            {
              "code": "712488",
              "alevel": 3,
              "name": "东港镇",
              "nickname": "",
              "pid": "712400"
            },
            {
              "code": "712489",
              "alevel": 3,
              "name": "琉球乡",
              "nickname": "",
              "pid": "712400"
            },
            {
              "code": "712484",
              "alevel": 3,
              "name": "莰顶乡",
              "nickname": "",
              "pid": "712400"
            },
            {
              "code": "712490",
              "alevel": 3,
              "name": "佳冬乡",
              "nickname": "",
              "pid": "712400"
            },
            {
              "code": "712491",
              "alevel": 3,
              "name": "新园乡",
              "nickname": "",
              "pid": "712400"
            },
            {
              "code": "712492",
              "alevel": 3,
              "name": "枋寮乡",
              "nickname": "",
              "pid": "712400"
            },
            {
              "code": "712493",
              "alevel": 3,
              "name": "枋山乡",
              "nickname": "",
              "pid": "712400"
            },
            {
              "code": "712494",
              "alevel": 3,
              "name": "春日乡",
              "nickname": "",
              "pid": "712400"
            },
            {
              "code": "712495",
              "alevel": 3,
              "name": "狮子乡",
              "nickname": "",
              "pid": "712400"
            },
            {
              "code": "712496",
              "alevel": 3,
              "name": "车城乡",
              "nickname": "",
              "pid": "712400"
            },
            {
              "code": "712497",
              "alevel": 3,
              "name": "牡丹乡",
              "nickname": "",
              "pid": "712400"
            },
            {
              "code": "712498",
              "alevel": 3,
              "name": "恒春镇",
              "nickname": "",
              "pid": "712400"
            },
            {
              "code": "712499",
              "alevel": 3,
              "name": "满州乡",
              "nickname": "",
              "pid": "712400"
            }
          ],
          "nickname": "",
          "pid": "710000"
        },
        {
          "code": "712500",
          "alevel": 2,
          "name": "台东县",
          "sub":[
            {
              "code": "712584",
              "alevel": 3,
              "name": "台东市",
              "nickname": "",
              "pid": "712500"
            },
            {
              "code": "712585",
              "alevel": 3,
              "name": "绿岛乡",
              "nickname": "",
              "pid": "712500"
            },
            {
              "code": "712586",
              "alevel": 3,
              "name": "兰屿乡",
              "nickname": "",
              "pid": "712500"
            },
            {
              "code": "712587",
              "alevel": 3,
              "name": "延平乡",
              "nickname": "",
              "pid": "712500"
            },
            {
              "code": "712588",
              "alevel": 3,
              "name": "卑南乡",
              "nickname": "",
              "pid": "712500"
            },
            {
              "code": "712589",
              "alevel": 3,
              "name": "鹿野乡",
              "nickname": "",
              "pid": "712500"
            },
            {
              "code": "712590",
              "alevel": 3,
              "name": "关山镇",
              "nickname": "",
              "pid": "712500"
            },
            {
              "code": "712591",
              "alevel": 3,
              "name": "海端乡",
              "nickname": "",
              "pid": "712500"
            },
            {
              "code": "712592",
              "alevel": 3,
              "name": "池上乡",
              "nickname": "",
              "pid": "712500"
            },
            {
              "code": "712593",
              "alevel": 3,
              "name": "东河乡",
              "nickname": "",
              "pid": "712500"
            },
            {
              "code": "712594",
              "alevel": 3,
              "name": "成功镇",
              "nickname": "",
              "pid": "712500"
            },
            {
              "code": "712595",
              "alevel": 3,
              "name": "长滨乡",
              "nickname": "",
              "pid": "712500"
            },
            {
              "code": "712596",
              "alevel": 3,
              "name": "金峰乡",
              "nickname": "",
              "pid": "712500"
            },
            {
              "code": "712597",
              "alevel": 3,
              "name": "大武乡",
              "nickname": "",
              "pid": "712500"
            },
            {
              "code": "712598",
              "alevel": 3,
              "name": "达仁乡",
              "nickname": "",
              "pid": "712500"
            },
            {
              "code": "712599",
              "alevel": 3,
              "name": "太麻里乡",
              "nickname": "",
              "pid": "712500"
            },
          ],
          "nickname": "",
          "pid": "710000"
        },
        {
          "code": "712600",
          "alevel": 2,
          "name": "花莲县",
          "sub":[
            {
              "code": "712686",
              "alevel": 3,
              "name": "花莲市",
              "nickname": "",
              "pid": "712600"
            },
            {
              "code": "712687",
              "alevel": 3,
              "name": "新城乡",
              "nickname": "",
              "pid": "712600"
            },
            {
              "code": "712688",
              "alevel": 3,
              "name": "太鲁阁",
              "nickname": "",
              "pid": "712600"
            },
            {
              "code": "712689",
              "alevel": 3,
              "name": "秀林乡",
              "nickname": "",
              "pid": "712600"
            },
            {
              "code": "712690",
              "alevel": 3,
              "name": "吉安乡",
              "nickname": "",
              "pid": "712600"
            },
            {
              "code": "712691",
              "alevel": 3,
              "name": "寿丰乡",
              "nickname": "",
              "pid": "712600"
            },
            {
              "code": "712692",
              "alevel": 3,
              "name": "凤林镇",
              "nickname": "",
              "pid": "712600"
            },
            {
              "code": "712693",
              "alevel": 3,
              "name": "光复乡",
              "nickname": "",
              "pid": "712600"
            },
            {
              "code": "712694",
              "alevel": 3,
              "name": "丰滨乡",
              "nickname": "",
              "pid": "712600"
            },
            {
              "code": "712695",
              "alevel": 3,
              "name": "瑞穗乡",
              "nickname": "",
              "pid": "712600"
            },
            {
              "code": "712696",
              "alevel": 3,
              "name": "万荣乡",
              "nickname": "",
              "pid": "712600"
            },
            {
              "code": "712697",
              "alevel": 3,
              "name": "玉里镇",
              "nickname": "",
              "pid": "712600"
            },
            {
              "code": "712698",
              "alevel": 3,
              "name": "卓溪乡",
              "nickname": "",
              "pid": "712600"
            },
            {
              "code": "712699",
              "alevel": 3,
              "name": "富里乡",
              "nickname": "",
              "pid": "712600"
            }
          ],
          "nickname": "",
          "pid": "710000"
        },
        {
          "code": "712700",
          "alevel": 2,
          "name": "澎湖县",
          "sub":[
            {
              "code": "712794",
              "alevel": 3,
              "name": "马公市",
              "nickname": "",
              "pid": "712700"
            },
            {
              "code": "712796",
              "alevel": 3,
              "name": "望安乡",
              "nickname": "",
              "pid": "712700"
            },
            {
              "code": "712797",
              "alevel": 3,
              "name": "七美乡",
              "nickname": "",
              "pid": "712700"
            },
            {
              "code": "712798",
              "alevel": 3,
              "name": "白沙乡",
              "nickname": "",
              "pid": "712700"
            },
            {
              "code": "712799",
              "alevel": 3,
              "name": "湖西乡",
              "nickname": "",
              "pid": "712700"
            }
          ],
          "nickname": "",
          "pid": "710000"
        },
        {
          "code": "712800",
          "alevel": 2,
          "name": "连江县",
          "sub":[
            {
              "code": "712896",
              "alevel": 3,
              "name": "南竿乡",
              "nickname": "",
              "pid": "712800"
            },
            {
              "code": "712897",
              "alevel": 3,
              "name": "北竿乡",
              "nickname": "",
              "pid": "712800"
            },
            {
              "code": "712898",
              "alevel": 3,
              "name": "东引乡",
              "nickname": "",
              "pid": "712800"
            },
            {
              "code": "712899",
              "alevel": 3,
              "name": "莒光乡",
              "nickname": "",
              "pid": "712800"
            }
          ],
          "nickname": "",
          "pid": "710000"
        }
      ],
      "name": "台湾省",
      "nickname": "台",
      "pid": ""
    },
    {
      "code": "810000",
      "alevel": 1,
      "sub":[
        {
          "code": "810100",
          "alevel": 2,
          "name": "香港岛",
          "sub":[
            {
              "code": "810101",
              "alevel": 3,
              "name": "中西区",
              "nickname": "",
              "pid": "810100"
            },
            {
              "code": "810102",
              "alevel": 3,
              "name": "湾仔区",
              "nickname": "",
              "pid": "810100"
            },
            {
              "code": "810103",
              "alevel": 3,
              "name": "东区",
              "nickname": "",
              "pid": "810100"
            },
            {
              "code": "810104",
              "alevel": 3,
              "name": "南区",
              "nickname": "",
              "pid": "810100"
            },
          ],
          "nickname": "",
          "pid": "810000"
        },
        {
          "code": "810200",
          "alevel": 2,
          "name": "九龙",
          "sub":[
            {
              "code": "810201",
              "alevel": 3,
              "name": "九龙城区",
              "nickname": "",
              "pid": "810200"
            },
            {
              "code": "810202",
              "alevel": 3,
              "name": "油尖旺区",
              "nickname": "",
              "pid": "810200"
            },
            {
              "code": "810203",
              "alevel": 3,
              "name": "深水埗区",
              "nickname": "",
              "pid": "810200"
            },
            {
              "code": "810204",
              "alevel": 3,
              "name": "黄大仙区",
              "nickname": "",
              "pid": "810200"
            },
            {
              "code": "810205",
              "alevel": 3,
              "name": "观塘区",
              "nickname": "",
              "pid": "810200"
            },
          ],
          "nickname": "",
          "pid": "810000"
        },
        {
          "code": "810300",
          "alevel": 2,
          "name": "新界",
          "sub":[
            {
              "code": "810301",
              "alevel": 3,
              "name": "北区",
              "nickname": "",
              "pid": "810300"
            },
            {
              "code": "810302",
              "alevel": 3,
              "name": "大埔区",
              "nickname": "",
              "pid": "810300"
            },
            {
              "code": "810303",
              "alevel": 3,
              "name": "沙田区",
              "nickname": "",
              "pid": "810300"
            },
            {
              "code": "810304",
              "alevel": 3,
              "name": "西贡区",
              "nickname": "",
              "pid": "810300"
            },
            {
              "code": "810305",
              "alevel": 3,
              "name": "元朗区",
              "nickname": "",
              "pid": "810300"
            },
            {
              "code": "810306",
              "alevel": 3,
              "name": "屯门区",
              "nickname": "",
              "pid": "810300"
            },
            {
              "code": "810307",
              "alevel": 3,
              "name": "荃湾区",
              "nickname": "",
              "pid": "810300"
            },
            {
              "code": "810308",
              "alevel": 3,
              "name": "葵青区",
              "nickname": "",
              "pid": "810300"
            },
            {
              "code": "810309",
              "alevel": 3,
              "name": "离岛区",
              "nickname": "",
              "pid": "810300"
            },
          ],
          "nickname": "",
          "pid": "810000"
        },
      ],
      "name": "香港特别行政区",
      "nickname": "港",
      "pid": ""
    },
    {
      "code": "820000",
      "alevel": 1,
      "name": "澳门特别行政区",
      "sub":[
        {
          "code": "820100",
          "alevel": 2,
          "name": "澳门半岛",
          "sub":[
            {
              "code": "820102",
              "alevel": 3,
              "name": "花地玛堂区",
              "nickname": "",
              "pid": "820100"
            },
            {
              "code": "820103",
              "alevel": 3,
              "name": "花王堂区",
              "nickname": "",
              "pid": "820100"
            },
            {
              "code": "820104",
              "alevel": 3,
              "name": "望德堂区",
              "nickname": "",
              "pid": "820100"
            },
            {
              "code": "820105",
              "alevel": 3,
              "name": "大堂区",
              "nickname": "",
              "pid": "820100"
            },
            {
              "code": "820106",
              "alevel": 3,
              "name": "风顺堂区",
              "nickname": "",
              "pid": "820100"
            },
          ],
          "nickname": "",
          "pid": "820000"
        },
        {
          "code": "820200",
          "alevel": 2,
          "name": "离岛",
          "sub":[
            {
              "code": "820202",
              "alevel": 3,
              "name": "嘉模堂区",
              "nickname": "",
              "pid": "820200"
            },
            {
              "code": "820203",
              "alevel": 3,
              "name": "路氹填海区",
              "nickname": "",
              "pid": "820200"
            },
            {
              "code": "820204",
              "alevel": 3,
              "name": "圣方济各堂区",
              "nickname": "",
              "pid": "820200"
            }
          ],
          "nickname": "",
          "pid": "820000"
        },
      ],
      "nickname": "澳",
      "pid": ""
    }
  ]
}



//////////////////
// WEBPACK FOOTER
// ./provinceCity.js
// module id = sTig
// module chunks = 50